
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bSweK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jSnXV = parcelRequire("jSnXV");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $iwNka = parcelRequire("iwNka");

parcelRequire("e1iIh");
var $6m7J6 = parcelRequire("6m7J6");


var $bX4Zr = parcelRequire("bX4Zr");


var $35oAA = parcelRequire("35oAA");


var $gsWjA = parcelRequire("gsWjA");


var $g2oof = parcelRequire("g2oof");


var $7QM6o = parcelRequire("7QM6o");


var $3d5UI = parcelRequire("3d5UI");


var $lABjq = parcelRequire("lABjq");


var $9sGCn = parcelRequire("9sGCn");


var $hl1Kw = parcelRequire("hl1Kw");


var $8zMP3 = parcelRequire("8zMP3");


var $6mKj3 = parcelRequire("6mKj3");


var $1Af7Q = parcelRequire("1Af7Q");

const $271996e5cf264d1f$var$ViewPageInternal = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { contentId: contentId, spaceKey: spaceKey, classicComments: classicComments, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { versionOverride: versionOverride } = (0, $35oAA.useViewPageParams)();
    const [t1] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t1;
    (0, $bX4Zr.useViewPagePersistentScrollPosition)(contentId);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
    } else t2 = $[0];
    (0, $42omo.useEffect)($271996e5cf264d1f$var$_temp, t2);
    let contentHeader = null;
    if (contentId && spaceKey) {
        let t3;
        if ($[1] !== contentId || $[2] !== spaceKey || $[3] !== versionOverride) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6m7J6.ContentHeader), {
                spaceKey: spaceKey,
                contentId: contentId,
                versionOverride: versionOverride
            });
            $[1] = contentId;
            $[2] = spaceKey;
            $[3] = versionOverride;
            $[4] = t3;
        } else t3 = $[4];
        contentHeader = t3;
    }
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    let t3;
    let t4;
    if ($[5] !== contentId || $[6] !== createAnalyticsEvent || $[7] !== spaceId) {
        t3 = ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: "ViewPage",
                globalProperty: "AJS.bind"
            }, ()=>{
                window.AJS.bind("createGASv3Event", (_, data)=>{
                    createAnalyticsEvent(data).fire();
                });
            });
            if ((0, $lABjq.pagePublishedState).pageJustPublished) {
                (0, $lABjq.pagePublishedState).pageJustPublished = false;
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "viewed",
                        actionSubject: "pagePublished",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space"
                    }
                }).fire();
            }
            return $271996e5cf264d1f$var$_temp3;
        };
        t4 = [
            createAnalyticsEvent,
            contentId,
            spaceId
        ];
        $[5] = contentId;
        $[6] = createAnalyticsEvent;
        $[7] = spaceId;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[10] !== additionalAnalytics || $[11] !== contentId || $[12] !== createAnalyticsEvent || $[13] !== searchSessionId || $[14] !== spaceId) {
        t5 = ()=>{
            const handleScroll = ()=>{
                const { scrollX: scrollX, scrollY: scrollY, innerWidth: innerWidth, innerHeight: innerHeight } = window;
                const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = document.documentElement;
                const attributes = {
                    scrollX: scrollX,
                    scrollY: scrollY,
                    innerWidth: innerWidth,
                    innerHeight: innerHeight,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    depthX: Math.trunc((scrollX + innerWidth) / scrollWidth * 100) / 100,
                    depthY: Math.trunc((scrollY + innerHeight) / scrollHeight * 100) / 100,
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                };
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "scrolled",
                        actionSubject: "page",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space",
                        attributes: attributes
                    }
                })?.fire();
            };
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(handleScroll, 250);
            const scrollContainer = document.getElementById("AkMainContent") ?? document;
            scrollContainer.addEventListener("scroll", debounceScroll);
            return ()=>{
                scrollContainer.removeEventListener("scroll", debounceScroll);
            };
        };
        t6 = [
            createAnalyticsEvent,
            contentId,
            spaceId,
            searchSessionId,
            additionalAnalytics
        ];
        $[10] = additionalAnalytics;
        $[11] = contentId;
        $[12] = createAnalyticsEvent;
        $[13] = searchSessionId;
        $[14] = spaceId;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[17] !== contentId) {
        t7 = (0, $9sGCn.getCachedPageData)(contentId);
        $[17] = contentId;
        $[18] = t7;
    } else t7 = $[18];
    const cachedPageData = t7;
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
    let t8;
    if ($[19] !== contentId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsWjA.StartViewPageLoad), {
            contentId: contentId
        });
        $[19] = contentId;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Af7Q.LegacyBridgeNext), null);
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== ClassicEditorContextProviderLoader || $[23] !== cachedPageData || $[24] !== children || $[25] !== classicComments || $[26] !== contentHeader || $[27] !== contentId || $[28] !== spaceKey) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g2oof.ViewPageCommon), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentHeader: contentHeader,
            classicComments: classicComments,
            hasPageComments: true,
            hasLabels: true,
            hasReactions: true,
            hasInlineComments: true,
            hasEOPRecs: true,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
            cachedPageData: cachedPageData
        }, children, t9);
        $[22] = ClassicEditorContextProviderLoader;
        $[23] = cachedPageData;
        $[24] = children;
        $[25] = classicComments;
        $[26] = contentHeader;
        $[27] = contentId;
        $[28] = spaceKey;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== t10 || $[31] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t10);
        $[30] = t10;
        $[31] = t8;
        $[32] = t11;
    } else t11 = $[32];
    return t11;
};
const $271996e5cf264d1f$export$767e3006bdbb424a = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "view-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($271996e5cf264d1f$var$ViewPageInternal, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $271996e5cf264d1f$var$_temp() {
    (0, $6mKj3.expVal)("confluence_aa_test", "isEnabled", false);
}
function $271996e5cf264d1f$var$_temp2() {
    window.AJS.bind("createGASv3Event");
}
function $271996e5cf264d1f$var$_temp3() {
    (0, $3d5UI.waitForGlobal)({
        listener: "ViewPage",
        globalProperty: "AJS.unbind"
    }, $271996e5cf264d1f$var$_temp2);
}
module.exports["ViewPage"] = $271996e5cf264d1f$export$767e3006bdbb424a;

});

parcelRegister("iwNka", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $42omo.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hwNSM = parcelRequire("hwNSM");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hwNSM.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("e1iIh", function(module, exports) {
$parcel$export(module.exports, "ContentHeader", () => (parcelRequire("6m7J6")).ContentHeader);

var $6m7J6 = parcelRequire("6m7J6");


});

parcelRegister("6m7J6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $JJ6wk = parcelRequire("JJ6wk");


var $cgsIj = parcelRequire("cgsIj");
var $8MMdp = parcelRequire("8MMdp");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $hFGQl = parcelRequire("hFGQl");


var $jkVM2 = parcelRequire("jkVM2");


var $63EIj = parcelRequire("63EIj");


var $io723 = parcelRequire("io723");


var $foQ4a = parcelRequire("foQ4a");


var $jmjWc = parcelRequire("jmjWc");


var $bFMG7 = parcelRequire("bFMG7");


var $2XV0z = parcelRequire("2XV0z");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bLtXM = parcelRequire("bLtXM");


var $fwwrH = parcelRequire("fwwrH");


var $fiBb3 = parcelRequire("fiBb3");


var $80xNa = parcelRequire("80xNa");


var $5W37o = parcelRequire("5W37o");


var $jbFlk = parcelRequire("jbFlk");


var $4Uc69 = parcelRequire("4Uc69");


var $JHogp = parcelRequire("JHogp");


var $hlP5l = parcelRequire("hlP5l");


var $a3W69 = parcelRequire("a3W69");


const $a6738032862091d5$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTy4w",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("l0bby"))).ContentClassificationTag
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a6738032862091d5$var$SpacedActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a6738032862091d5$var$breadcrumbsAreaWrapper = (0, $ecnYn.xcss)({
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    minWidth: 'fit-content',
    gap: 'space.050',
    overflow: 'hidden',
    [(0, $bWLcG.media).above.xs]: {
        minWidth: '96px'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $a6738032862091d5$var$Metadata = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { shouldDisplayClassification: shouldDisplayClassification, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.shouldDisplayClassification ? "20px" : "30px";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = __cmplp.shouldDisplayClassification ? "-5px" : "0";
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_17u00py": t4,
                "--_p0qxq3": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1n261g80 _c71l1c3y _1svj12g2",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $a6738032862091d5$var$verticalSeparatorStyles = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '16px',
    margin: 'space.075'
});
const $a6738032862091d5$var$rightSideHeaderStyles = (0, $ecnYn.xcss)({
    marginLeft: 'auto',
    alignItems: 'center'
});
const $a6738032862091d5$var$VerticalSeparator = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a6738032862091d5$var$verticalSeparatorStyles
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $a6738032862091d5$var$ContentHeaderContentState = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { contentId: contentId, contentType: contentType } = t0;
    const t1 = contentType ?? "page";
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            contentId: contentId,
            contentType: t1,
            operation: (0, $lfBMY.OperationTypes).UPDATE,
            status: (0, $cD1qu.CURRENT_STATUS)
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)(t2);
    const hasEditPermission = canUpdateContent ?? false;
    if ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) {
        const t3 = contentType ?? "page";
        let t4;
        if ($[3] !== contentId || $[4] !== hasEditPermission || $[5] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: t3,
                isViewMode: true,
                canEdit: hasEditPermission,
                userOffline: false
            });
            $[3] = contentId;
            $[4] = hasEditPermission;
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    let t3;
    if ($[7] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            isDraft: false
        });
        $[7] = contentId;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
$a6738032862091d5$var$SpacedActionItem.displayName = 'SpacedActionItem';
const $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID),
    (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)
];
const $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)
];
const $a6738032862091d5$export$b52a1b6380889dfe = (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { spaceKey: spaceKey, contentId: contentId, actionItems: t1, versionOverride: t2, showMetadataItems: t3 } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const actionItems = t4;
    const versionOverride = t2 === undefined ? null : t2;
    const showMetadataItems = t3 === undefined ? true : t3;
    const [isContentToolsForcedOpen, setIsContentToolsForcedOpen] = (0, $42omo.useState)(false);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    let t5;
    if ($[2] !== contentId || $[3] !== spaceKey) {
        t5 = {
            contentId: contentId,
            spaceKeyOverride: spaceKey,
            contentStatusContext: "current-only"
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t5;
    } else t5 = $[4];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t5);
    const { shouldDisplayClassification: shouldDisplayClassification } = contentClassificationMetadata;
    const { width: width } = (0, $2XV0z.usePageHeightWidthObserver)(false, -37, false);
    let t6;
    if ($[5] !== contentId || $[6] !== shouldDisplayClassification || $[7] !== showMetadataItems || $[8] !== spaceKey || $[9] !== versionOverride || $[10] !== width) {
        t6 = (t7)=>{
            const { contentTitle: contentTitle } = t7;
            const shouldRenderMetadataForPageWidth = ()=>width > 1000;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$breadcrumbsAreaWrapper,
                testId: "breadcrumb"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.Breadcrumbs), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle || ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center"
            }, showMetadataItems && shouldRenderMetadataForPageWidth() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6738032862091d5$var$Metadata, {
                "data-testid": "metadata-wrapper",
                shouldDisplayClassification: shouldDisplayClassification
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Uc69.SystemContentMetadata), {
                key: `metadata-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride,
                excludeIds: $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbFlk.PageMetadataBanner), {
                key: `banner-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride
            }))));
        };
        $[5] = contentId;
        $[6] = shouldDisplayClassification;
        $[7] = showMetadataItems;
        $[8] = spaceKey;
        $[9] = versionOverride;
        $[10] = width;
        $[11] = t6;
    } else t6 = $[11];
    const renderBreadcrumbs = t6;
    let t7;
    if ($[12] !== actionItems || $[13] !== contentClassificationMetadata || $[14] !== contentId || $[15] !== isExternalCollaborator || $[16] !== renderBreadcrumbs || $[17] !== showMetadataItems || $[18] !== spaceKey || $[19] !== versionOverride) {
        t7 = (t8)=>{
            const { contentType: contentType, contentTitle: contentTitle_0, loading: loading, subType: subType, lastModifiedDate: lastModifiedDate, isContentToolsForcedOpen: isContentToolsForcedOpen_0, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0, isArchived: isArchived, isFabricPage: isFabricPage } = t8;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, renderBreadcrumbs({
                contentTitle: contentTitle_0
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                testId: "content-classification-tag"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6738032862091d5$var$ContentClassificationTagLoader, {
                contentId: contentId,
                contentType: contentType || null,
                contentClassificationMetadata: contentClassificationMetadata,
                isEditMode: false
            })), showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5W37o.PageMetadataAtl), {
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$rightSideHeaderStyles
            }, !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bLtXM.ContentHeaderPresence), {
                contentId: contentId,
                contentType: contentType,
                analyticSource: "viewPageScreen"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6738032862091d5$var$VerticalSeparator, null)), !(0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6738032862091d5$var$ContentHeaderContentState, {
                contentId: contentId,
                contentType: contentType
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JHogp.GroupedPageButtons), {
                contentId: contentId,
                version: versionOverride,
                includeSystemIds: $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS,
                spaceKey: spaceKey,
                contentType: contentType,
                contentSubType: subType,
                isExternalCollaborator: isExternalCollaborator,
                lastModifiedDate: lastModifiedDate,
                showEdit: subType !== "live",
                isContentToolsForcedOpen: isContentToolsForcedOpen_0,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0,
                isArchived: isArchived,
                isFabricPage: isFabricPage
            })), actionItems?.map((ActionItem, index)=>{
                const actionItemProps = {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6738032862091d5$var$SpacedActionItem, {
                    "data-testid": "spacedActionItemTestId",
                    key: ActionItem?.displayName || index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ActionItem, {
                    ...actionItemProps,
                    disabled: loading
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTENT_HEADER_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    subType: subType,
                    isFabricPage: isFabricPage,
                    isContentWrapper: false
                }
            }));
        };
        $[12] = actionItems;
        $[13] = contentClassificationMetadata;
        $[14] = contentId;
        $[15] = isExternalCollaborator;
        $[16] = renderBreadcrumbs;
        $[17] = showMetadataItems;
        $[18] = spaceKey;
        $[19] = versionOverride;
        $[20] = t7;
    } else t7 = $[20];
    const renderContentHeader = t7;
    let t8;
    if ($[21] !== contentId || $[22] !== showMetadataItems) {
        t8 = showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            key: `PageSegmentLoadStart-connect-${contentId}`,
            metric: (0, $hlP5l.CONNECT_APP_WEB_FRAGMENT_METRIC)
        });
        $[21] = contentId;
        $[22] = showMetadataItems;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== contentId) {
        t9 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            key: `object-header-${contentId}`,
            id: contentId,
            name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            key: `view-page-header-${contentId}`,
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_CONTENT_HEADER_EXPERIENCE)
        });
        $[24] = contentId;
        $[25] = t9;
    } else t9 = $[25];
    const t10 = versionOverride || null;
    let t11;
    if ($[26] !== contentId || $[27] !== spaceKey || $[28] !== t10) {
        t11 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: t10,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true
        };
        $[26] = contentId;
        $[27] = spaceKey;
        $[28] = t10;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            single: true
        };
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== contentId || $[32] !== isContentToolsForcedOpen || $[33] !== renderContentHeader) {
        t13 = (t14)=>{
            const { loading: loading_0, error: error, data: data } = t14;
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            } else {
                if (!data) return null;
            }
            const contentNode = data?.content?.nodes?.[0];
            const contentType_0 = contentNode?.type;
            const lastModifiedDate_0 = contentNode?.metadata?.lastModifiedDate;
            const subType_0 = contentNode?.subType;
            const contentTitle_1 = contentNode?.title;
            const isFabricPage_0 = (0, $a3W69.checkIsFabricPage)(contentNode);
            const spaceIsThemed = Boolean(data?.space?.theme?.themeKey);
            const isArchived_0 = contentNode?.status === "archived";
            const contentHeader = isFabricPage_0 && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JJ6wk.ContentTypesHeader), {
                contentId: contentId,
                isConvertToFolderHighlighted: isContentToolsForcedOpen,
                setIsConvertToFolderHighlighted: setIsContentToolsForcedOpen
            }) : renderContentHeader({
                contentType: contentType_0,
                contentTitle: contentTitle_1,
                isFabricPage: isFabricPage_0,
                loading: loading_0,
                subType: subType_0,
                lastModifiedDate: lastModifiedDate_0,
                isThemed: spaceIsThemed,
                isContentToolsForcedOpen: isContentToolsForcedOpen,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen,
                isArchived: isArchived_0
            });
            const shouldShowAifcCreateBanner = isFabricPage_0 && (0, $9wGTI.fg)("aifc_create_enabled") && (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.FixedSpaceHeaderContainer), {
                isThemed: spaceIsThemed,
                "data-testid": "content-header-container",
                shouldHavePadding: !isFabricPage_0,
                isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                shouldShowAifcCreateBanner: shouldShowAifcCreateBanner
            }, shouldShowAifcCreateBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                grow: "fill"
            }, contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })) : contentHeader);
        };
        $[31] = contentId;
        $[32] = isContentToolsForcedOpen;
        $[33] = renderContentHeader;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== t11 || $[36] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $fiBb3.ContentHeaderUnifiedQuery),
            variables: t11,
            context: t12
        }, t13);
        $[35] = t11;
        $[36] = t13;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== t14 || $[39] !== t8 || $[40] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t8, t9, t14);
        $[38] = t14;
        $[39] = t8;
        $[40] = t9;
        $[41] = t15;
    } else t15 = $[41];
    return t15;
};
module.exports["ContentHeader"] = $a6738032862091d5$export$b52a1b6380889dfe;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("cgsIj", function(module, exports) {
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


var $8MMdp = parcelRequire("8MMdp");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
const $b7f6794681d506d9$export$8bb26699ba16d6a3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.Breadcrumbs), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.Breadcrumbs), props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["BreadcrumbsNonLoadable"] = $b7f6794681d506d9$export$8bb26699ba16d6a3;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("8MMdp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $6mKj3 = parcelRequire("6mKj3");


var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$hideDuringPdfPrint = null;

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("5bUM9"))).CompanyHubBreadcrumbs
}); // Keep this in sync with entry-points/breadcrumbsConstants.ts
const $6d14bad88596319b$var$BREADCRUMB_HEADER_HEIGHT = 56; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1ji2brd": (0, $7sObp.default)(__cmplp.justifyContent || "space-between")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
                __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
                __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
                __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $7sObp.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    });
});
function $6d14bad88596319b$export$2dc68d50d56fbbd({ contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
            spaceKey: spaceKey
        }));
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)("afm-hide-elements-from-pdf-print", "isEnabled", true) && "_24zuglyw"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== isThemed || $[4] !== shouldHavePadding || $[5] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
            isThemed: isThemed,
            "data-testid": testId,
            isObjectHeaderEnabled: t2,
            shouldHavePadding: shouldHavePadding
        }, children);
        $[2] = children;
        $[3] = isThemed;
        $[4] = shouldHavePadding;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== banner || $[8] !== isFullWidth || $[9] !== isThemed || $[10] !== isTransparent || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
            isThemed: isThemed,
            isFullWidth: isFullWidth,
            isTransparent: isTransparent,
            className: t1
        }, banner, t3);
        $[7] = banner;
        $[8] = isFullWidth;
        $[9] = isThemed;
        $[10] = isTransparent;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        className: (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
        ])
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        shouldHavePadding: shouldHavePadding
    }, children));
};
module.exports["FixedSpaceHeaderContainer"] = $6d14bad88596319b$export$ba9528a5a0141231;
module.exports["Breadcrumbs"] = $6d14bad88596319b$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayout"] = $6d14bad88596319b$export$7d2750c639212b06;
module.exports["FixedSpaceHeaderWithBannerContainer"] = $6d14bad88596319b$export$5adc3a1912461c1e;

});

parcelRegister("5Vf1r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $ghftu = parcelRequire("ghftu");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $bMPhU = parcelRequire("bMPhU");


var $kqIWy = parcelRequire("kqIWy");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bCECL = parcelRequire("bCECL");


var $kM55L = parcelRequire("kM55L");


var $1jQpq = parcelRequire("1jQpq");


var $6mKj3 = parcelRequire("6mKj3");


var $ePiuX = parcelRequire("ePiuX");


var $hzkzq = parcelRequire("hzkzq");


const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("3ty2e"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles = (0, $ecnYn.xcss)({
    flex: '0 0 auto'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$onlySpaceNameTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$dropdownLessContentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $ecnYn.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: t1, showInlineRename: t2, shouldDisableMoveButton: t3, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType } = t0;
    const testId = t1 === undefined ? "breadcrumbs-with-space-name-dropdown" : t1;
    const showInlineRename = t2 === undefined ? false : t2;
    const shouldDisableMoveButton = t3 === undefined ? false : t3;
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    if (error || !spaceData) {
        let t6;
        if ($[2] !== error) {
            t6 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
                error: error
            }));
            $[2] = error;
            $[3] = t6;
        } else t6 = $[3];
        let t7;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null);
            $[4] = t7;
        } else t7 = $[4];
        let t8;
        if ($[5] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t7);
            $[5] = t6;
            $[6] = t8;
        } else t8 = $[6];
        return t8;
    }
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    let T0;
    let renderContentTitle;
    let shouldShowCurrentContentTitle;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== contentId || $[8] !== contentLink || $[9] !== contentTitle || $[10] !== contentType || $[11] !== createAnalyticsEvent || $[12] !== displayMode || $[13] !== experienceTracker || $[14] !== intl || $[15] !== isBreadcrumbsPopupOpen || $[16] !== isModernEmbeddedConfluence || $[17] !== isNetworkDisabled || $[18] !== isSpaceNameLongerThan6Letters || $[19] !== push || $[20] !== shouldDisableMoveButton || $[21] !== showInlineRename || $[22] !== spaceData.alias || $[23] !== spaceHomepageId || $[24] !== spaceKey || $[25] !== spaceName || $[26] !== ssrPlaceholderIdProp || $[27] !== subType || $[28] !== testId) {
        const contentTitleToRender = contentTitle === "" ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
        const shouldOpenDropdown = contentTitleToRender || showInlineRename;
        shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
        let t10;
        if ($[36] !== spaceData.alias || $[37] !== spaceHomepageId || $[38] !== spaceKey) {
            t10 = (0, $hzkzq.buildContentPath)({
                contentType: "page",
                isSpaceOverview: true,
                query: spaceHomepageId ? {
                    [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
                } : undefined,
                spaceAlias: spaceData.alias,
                spaceKey: spaceKey
            });
            $[36] = spaceData.alias;
            $[37] = spaceHomepageId;
            $[38] = spaceKey;
            $[39] = t10;
        } else t10 = $[39];
        const spaceOverviewPath = t10;
        const handleBreadcrumbDropdownTriggerClick = ()=>{
            if (shouldOpenDropdown) {
                if (!isBreadcrumbsPopupOpen) {
                    experienceTracker.start({
                        name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "opened",
                            actionSubject: "breadcrumbsDropdown",
                            source: "breadcrumbs",
                            attributes: {
                                isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                            }
                        }
                    }).fire();
                }
                setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
            } else push(spaceOverviewPath);
        };
        const popupContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
                spaceKey: spaceKey,
                contentId: contentId,
                closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
                spaceOverviewPath: spaceOverviewPath,
                shouldDisableMoveButton: shouldDisableMoveButton,
                contentTitle: contentTitleToRender
            });
        const closeDropdownOnClickOfBreadcrumbItem = ()=>{
            setIsBreadcrumbsPopupOpen(false);
        };
        let t11;
        if ($[40] !== contentId || $[41] !== spaceKey) {
            t11 = ()=>{
                (0, $ePiuX.preloadBreadcrumbsDropdown)({
                    spaceKey: spaceKey,
                    contentId: contentId
                });
            };
            $[40] = contentId;
            $[41] = spaceKey;
            $[42] = t11;
        } else t11 = $[42];
        const preloadBreadcrumbsDropdownOnSpaceNameHover = t11;
        const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                isOpen: isBreadcrumbsPopupOpen,
                onClose: ()=>setIsBreadcrumbsPopupOpen(false),
                placement: "bottom-start",
                content: popupContent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                        id: "breadcrumbs-dropdown-chevron-button",
                        "data-testid": "breadcrumbs-dropdown-chevron-button",
                        disabled: isNetworkDisabled,
                        onClick: handleBreadcrumbDropdownTriggerClick,
                        onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                        ...triggerProps,
                        ...ssrPlaceholderIdProp,
                        className: (0, $gMc0m.default)([
                            "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                            shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                            displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                            displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                            displayMode === "HIDDEN" && "_1e0cglyw"
                        ])
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        alignItems: "center",
                        gap: "space.100"
                    }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                        content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                        hideTooltipOnClick: true
                    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: [
                                $7c978e5ad74fbe60$var$chevronBaseStyles,
                                !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                            ],
                            ...tooltipProps
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)",
                            size: "small"
                        }))), renderSpaceName()))
            }), shouldOpenDropdown && renderSeparator());
        renderContentTitle = ()=>{
            const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: contentLink,
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
                ])
            }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
                ])
            }, contentTitleToRender);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                id: "breadcrumbs-content-title",
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                    isModernEmbeddedConfluence && "_bozgu2gc"
                ])
            }, (contentType === "page" || contentType === "blogpost") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                type: contentType,
                subType: subType,
                color: "var(--ds-text, #292A2E)"
            }), titleElement);
        };
        const renderSpaceName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                id: "breadcrumbs-space-name",
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                    shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                    shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
                ])
            }, spaceName);
        const renderSeparator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                id: "breadcrumbs-separator",
                className: (0, $gMc0m.default)([
                    "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                    !showInlineRename && "_1m0aglyw",
                    displayMode != "FULL" && "_1e0cglyw"
                ])
            }, "/");
        T0 = (0, $bUlM5.default);
        const t12 = showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles;
        if ($[43] !== t12) {
            t6 = [
                $7c978e5ad74fbe60$var$breadcrumbsStyles,
                t12
            ];
            $[43] = t12;
            $[44] = t6;
        } else t6 = $[44];
        t7 = testId;
        t8 = testId;
        t9 = !isModernEmbeddedConfluence && renderPopup();
        $[7] = contentId;
        $[8] = contentLink;
        $[9] = contentTitle;
        $[10] = contentType;
        $[11] = createAnalyticsEvent;
        $[12] = displayMode;
        $[13] = experienceTracker;
        $[14] = intl;
        $[15] = isBreadcrumbsPopupOpen;
        $[16] = isModernEmbeddedConfluence;
        $[17] = isNetworkDisabled;
        $[18] = isSpaceNameLongerThan6Letters;
        $[19] = push;
        $[20] = shouldDisableMoveButton;
        $[21] = showInlineRename;
        $[22] = spaceData.alias;
        $[23] = spaceHomepageId;
        $[24] = spaceKey;
        $[25] = spaceName;
        $[26] = ssrPlaceholderIdProp;
        $[27] = subType;
        $[28] = testId;
        $[29] = T0;
        $[30] = renderContentTitle;
        $[31] = shouldShowCurrentContentTitle;
        $[32] = t6;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
    } else {
        T0 = $[29];
        renderContentTitle = $[30];
        shouldShowCurrentContentTitle = $[31];
        t6 = $[32];
        t7 = $[33];
        t8 = $[34];
        t9 = $[35];
    }
    let t10;
    if ($[45] !== renderContentTitle || $[46] !== shouldShowCurrentContentTitle) {
        t10 = shouldShowCurrentContentTitle && renderContentTitle();
        $[45] = renderContentTitle;
        $[46] = shouldShowCurrentContentTitle;
        $[47] = t10;
    } else t10 = $[47];
    let t11;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
        });
        $[48] = t11;
    } else t11 = $[48];
    let t12;
    if ($[49] !== T0 || $[50] !== t10 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t6,
            testId: t7,
            "data-vc": t8
        }, t9, t10, t11);
        $[49] = T0;
        $[50] = t10;
        $[51] = t6;
        $[52] = t7;
        $[53] = t8;
        $[54] = t9;
        $[55] = t12;
    } else t12 = $[55];
    return t12;
} : ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override'); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const contentTitleToRender = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    }; /* TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788 */ 
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isBreadcrumbsPopupOpen,
            onClose: ()=>setIsBreadcrumbsPopupOpen(false),
            placement: "bottom-start",
            content: popupContent,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                    id: "breadcrumbs-dropdown-chevron-button",
                    "data-testid": "breadcrumbs-dropdown-chevron-button",
                    disabled: isNetworkDisabled,
                    onClick: handleBreadcrumbDropdownTriggerClick,
                    onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                    ...triggerProps,
                    ...ssrPlaceholderIdProp,
                    className: (0, $gMc0m.default)([
                        "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                        shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                        displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                        displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                        displayMode === "HIDDEN" && "_1e0cglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.100"
                }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                    hideTooltipOnClick: true
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: [
                            $7c978e5ad74fbe60$var$chevronBaseStyles,
                            !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                        ],
                        ...tooltipProps
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }))), renderSpaceName()))
        }), shouldOpenDropdown && renderSeparator());
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: contentLink,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
            ])
        }, contentTitleToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $gMc0m.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                isModernEmbeddedConfluence && "_bozgu2gc"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #292A2E)"
        }), titleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $gMc0m.default)([
                "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: [
            $7c978e5ad74fbe60$var$breadcrumbsStyles,
            showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles
        ],
        testId: testId,
        "data-vc": testId
    }, !isModernEmbeddedConfluence && renderPopup(), shouldShowCurrentContentTitle && renderContentTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $h82at.defineMessages)({
    breadcrumbsChevronButtonAriaLabel: {
        id: "breadcrumbs.dropdown.button.chevron.aria-label",
        defaultMessage: "Breadcrumbs"
    },
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});
module.exports["BREADCRUMBS_MODES"] = $7c978e5ad74fbe60$export$14e8342ddf0a4616;
module.exports["BreadcrumbsWithSpaceNameDropdown"] = $7c978e5ad74fbe60$export$c71a066c29807b48;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), t2);
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<b74dcf07c76f428fadc277c7af55376b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const options = t0;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t1;
    if ($[2] !== data) {
        t1 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined;
        $[2] = data;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== error || $[5] !== loading || $[6] !== t1) {
        t2 = {
            loading: loading,
            data: t1,
            error: error
        };
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $h82at.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("cDszO"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("cDszO", function(module, exports) {

let $932f4b4668612a1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $932f4b4668612a1f$var$load("i8eeg"),
    $932f4b4668612a1f$var$load("iFdoJ"),
    $932f4b4668612a1f$var$load("5tmW9"),
    $932f4b4668612a1f$var$load("ajMch"),
    $932f4b4668612a1f$var$load("6wr18"),
    $932f4b4668612a1f$var$load("ffEVr"),
    $932f4b4668612a1f$var$load("kjZZD"),
    $932f4b4668612a1f$var$load("4izLy"),
    $932f4b4668612a1f$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("1jQpq", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $cxu5H = parcelRequire("cxu5H");

const $951eaa69b00dd6e9$export$f183b986124d184 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasModernHeader: hasModernHeader } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    return isEmbeddedConfluence && hasModernHeader;
};
module.exports["useEmbeddedModernHeader"] = $951eaa69b00dd6e9$export$f183b986124d184;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open',
        'rovo'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("ePiuX", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $f4Qot = parcelRequire("f4Qot");

function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $f4Qot.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        }
    });
}
module.exports["preloadBreadcrumbsDropdown"] = $e956eba1dd4bb7db$export$e5d3f19aa88b9c61;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $9wGTI = parcelRequire("9wGTI");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    let single = true;
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch(true)
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client.__isAGGClient === true;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext
    }).then((result)=>{
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
        return {
            ...result,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("f4Qot", function(module, exports) {
/**
 * @generated SignedSource<<57236f8f935c7bdf910c3b9d7d169bce>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4
const $ef0655697d43d9a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContent"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "skipContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "current",
                                "draft",
                                "archived"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v7 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v7 /*: any*/ ,
                                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
            "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
            "metadata": {},
            "name": "BreadcrumbsDropdownContentQuery",
            "operationKind": "query",
            "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
        }
    };
}();
$ef0655697d43d9a3$var$node.hash = "3e4a9d4b445d7d646b220e3bab421884";
var $ef0655697d43d9a3$export$2e2bcd8739ae039 = $ef0655697d43d9a3$var$node;
module.exports["default"] = $ef0655697d43d9a3$export$2e2bcd8739ae039;

});

parcelRegister("hzkzq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') return '#';
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'slide':
            route = (0, $1NBp8.SLIDES_VIEW);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    // Filter out ancestors with null type when experiment is enabled
    ancestors = ancestors.filter((node)=>{
        if (!node) return false;
        if (!node.type && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) return false;
        return true;
    });
    // Filter out ancestors with null id to prevent TypeError from path-to-regexp
    if ((0, $6mKj3.expVal)('confluence_fix_expected_contentid_to_be_string', 'isEnabled', false)) ancestors = ancestors.filter((node)=>node && node.id);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return [
        ...ancestors
    ].reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};
module.exports["buildContentPath"] = $b055c0b5c16164d3$export$6b45500787cf696;
module.exports["filterAncestors"] = $b055c0b5c16164d3$export$d3865786a3f7be67;
module.exports["getEmojiFromPublishedPageProperties"] = $b055c0b5c16164d3$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $b055c0b5c16164d3$export$e1cb12562674727b;
module.exports["getIsTextTruncated"] = $b055c0b5c16164d3$export$52c8bba571728790;

});

parcelRegister("3ty2e", function(module, exports) {

let $287e7b29a365b435$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $287e7b29a365b435$var$load("l8YLV"),
    $287e7b29a365b435$var$load("6wr18"),
    $287e7b29a365b435$var$load("hhss7"),
    $287e7b29a365b435$var$load("ffEVr"),
    $287e7b29a365b435$var$load("7EorR"),
    $287e7b29a365b435$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});

parcelRegister("5bUM9", function(module, exports) {

let $3c7a054721a12b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c7a054721a12b05$var$load("6wr18"),
    $3c7a054721a12b05$var$load("ffEVr"),
    $3c7a054721a12b05$var$load("hhss7"),
    $3c7a054721a12b05$var$load("Wowvf"),
    $3c7a054721a12b05$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("2iPYH"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("2iPYH", function(module, exports) {

let $1ad594f9c5852f6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ad594f9c5852f6e$var$load("kLojH"),
    $1ad594f9c5852f6e$var$load("ivbae"),
    $1ad594f9c5852f6e$var$load("6jGZ7"),
    $1ad594f9c5852f6e$var$load("hhss7"),
    $1ad594f9c5852f6e$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("3FB1d"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("3FB1d", function(module, exports) {

let $2ac1ea897004b042$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ac1ea897004b042$var$load("ivbae"),
    $2ac1ea897004b042$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("io723", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1AtJA = parcelRequire("1AtJA");


var $dZzho = parcelRequire("dZzho");

const $cd95c7f874921f86$export$f11db193fdaffcc9 = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZzho.UFOSegmentLoadStart), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AtJA.Bm3PageSegmentLoadStart), props);
};
module.exports["PageSegmentLoadStart"] = $cd95c7f874921f86$export$f11db193fdaffcc9;

});

parcelRegister("1AtJA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $2994f14f1333f67a$var$noop = ()=>{};
const $2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $2994f14f1333f67a$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $2994f14f1333f67a$export$d807afe46329fe8a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent);
module.exports["Bm3PageSegmentLoadStart"] = $2994f14f1333f67a$export$d807afe46329fe8a;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("dZzho", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $762a25b728d4d734$var$noop = ()=>{};
const $762a25b728d4d734$var$UFOSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $762a25b728d4d734$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY })=>{
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            onComplete();
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $762a25b728d4d734$export$30c533f25ae06bb = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($762a25b728d4d734$var$UFOSegmentLoadStartComponent);
module.exports["UFOSegmentLoadStart"] = $762a25b728d4d734$export$30c533f25ae06bb;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");

const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $42omo.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $42omo.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $42omo.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $42omo.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $42omo.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    let t5;
    if ($[0] !== flagStatus || $[1] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[0] = flagStatus;
        $[1] = submittedClassification;
        $[2] = t5;
    } else t5 = $[2];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: t6,
        onCompleted: t7,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t9 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t8;
        $[6] = t9;
    } else {
        t8 = $[5];
        t9 = $[6];
    }
    const [deleteContentDataClassificationLevel, t10] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: t8,
        onCompleted: t9,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const { loading: deleteLoading } = t10;
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const t11 = contentId ?? "";
    const t12 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
    let t13;
    if ($[7] !== t11 || $[8] !== t12) {
        t13 = {
            contentId: t11,
            lowerCaseContentStatusArray: t12
        };
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const t14 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t15;
    if ($[10] !== shouldSkipQueriesForClassification || $[11] !== t13 || $[12] !== t14) {
        t15 = {
            variables: t13,
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t14
        };
        $[10] = shouldSkipQueriesForClassification;
        $[11] = t13;
        $[12] = t14;
        $[13] = t15;
    } else t15 = $[13];
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, t15);
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t16;
    let t17;
    if ($[14] !== classification || $[15] !== contentId || $[16] !== updatedClassification) {
        t16 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t17 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[14] = classification;
        $[15] = contentId;
        $[16] = updatedClassification;
        $[17] = t16;
        $[18] = t17;
    } else {
        t16 = $[17];
        t17 = $[18];
    }
    (0, $42omo.useEffect)(t16, t17);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t18;
    if ($[19] !== objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted) {
        t18 = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[19] = objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted;
        $[20] = t18;
    } else t18 = $[20];
    const isReclassificationPermitted = t18;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t19 = classificationValue ?? null;
    const t20 = classificationLevelDetails?.source;
    const t21 = classificationLevelDetails?.canManageSpaceSettings;
    const t22 = classificationLevelDetails?.classificationControlSetting;
    const t23 = classificationLevelDetails?.userOverrideSetting;
    let t24;
    if ($[21] !== classificationFeatureEnabled || $[22] !== contentLevelError || $[23] !== contentLevelLoading || $[24] !== contentStatusContext || $[25] !== deleteContentDataClassificationLevel || $[26] !== errorState || $[27] !== flagStatus || $[28] !== hasNoClassification || $[29] !== isReclassificationPermitted || $[30] !== shouldDisplayClassification || $[31] !== spaceDefaultIsOverridden || $[32] !== t19 || $[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23 || $[37] !== updateContentDataClassificationLevel) {
        t24 = {
            classification: t19,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t20,
            canManageSpaceSettings: t21,
            classificationControlSetting: t22,
            userOverrideSetting: t23
        };
        $[21] = classificationFeatureEnabled;
        $[22] = contentLevelError;
        $[23] = contentLevelLoading;
        $[24] = contentStatusContext;
        $[25] = deleteContentDataClassificationLevel;
        $[26] = errorState;
        $[27] = flagStatus;
        $[28] = hasNoClassification;
        $[29] = isReclassificationPermitted;
        $[30] = shouldDisplayClassification;
        $[31] = spaceDefaultIsOverridden;
        $[32] = t19;
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
        $[36] = t23;
        $[37] = updateContentDataClassificationLevel;
        $[38] = t24;
    } else t24 = $[38];
    return t24;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $42omo.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $42omo.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $42omo.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $42omo.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two mutation functions are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: {
            contentId: contentId ?? '',
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
        },
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only'
    });
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete mutation is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from query or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $42omo.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $42omo.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<7ddda2a4b17eec333f90d2ef9c5f2022>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<9d63004e94947b72a82b1d2926f80d5f>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<2762af36e95d767927416a46f16364d8>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("1cYlh", function(module, exports) {

var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $frIzR.c)(5);
    const [errorState, setErrorState] = (0, $42omo.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $42omo.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $42omo.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $42omo.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("2XV0z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $frIzR.c)(9);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $42omo.useState)(0);
    const observerRef = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const unwatchedResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true)
    });
    const interopResult = (0, $jMyy4.useQueryInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        ...options,
        skip: !contentId || (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true)
    });
    const { data: data, error: error, loading: loading } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? unwatchedResult : interopResult;
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<edc256fe5c5e6d649d0fd080ebecc4d6>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c65934a9e331ff8701130392e383f058>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<c4de1f2f464f7c58da863fcc2b8f8310>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<6c06bb421a64deed65b923b9eaef1fcf>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<db055c87cd42b74d8aeb77e7e48c9c82>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<a16e57d7fd38ec5242980bcfc517bf2e>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("2kSdH"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("2kSdH", function(module, exports) {

let $1b3781f6295511f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b3781f6295511f3$var$load("hhss7"),
    $1b3781f6295511f3$var$load("hzVe9")
]).then(()=>parcelRequire('dSB3l'));

});

parcelRegister("fiBb3", function(module, exports) {

var $fxLAA = parcelRequire("fxLAA");

const $23261b803687ce64$export$2b17287e63c772da = (0, $fxLAA.default);
module.exports["ContentHeaderUnifiedQuery"] = $23261b803687ce64$export$2b17287e63c772da;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<bcc0cc0f86df4508427b656c234c29ba>>
 * @relayHash 70098693ba1c82f5876b86639e5e7339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v7 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "title"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "number"
    }, v17 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ 
                    ]
                }
            ]
        }
    ], v18 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v17 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v19 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v22 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v23 = [
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ], v24 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v17 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v25 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v17 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v27 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "message"
    }, v29 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v30 = {
        "kind": "ScalarField",
        "name": "when"
    }, v31 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v32 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "count"
    }, v36 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v38 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": [
                            v14 /*: any*/ ,
                            v15 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v39 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                },
                                v32 /*: any*/ ,
                                v33 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v34 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v23 /*: any*/ 
                        }
                    ]
                },
                v38 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                },
                                v32 /*: any*/ ,
                                v33 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v34 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v39 /*: any*/ 
                        }
                    ]
                },
                v38 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "70098693ba1c82f5876b86639e5e7339",
            "id": "1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "d58bd52d67b335df9d3d40434d235698";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("5W37o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $iqPSe = parcelRequire("iqPSe");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $80koo = parcelRequire("80koo");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $7b4282d7c94dcb09$var$webPanelPageMetadataStyle = {
    verticalAlign: 'top',
    display: 'flex',
    alignItem: 'center',
    flexWrap: 'nowrap'
};
const $7b4282d7c94dcb09$var$WRM_MODULES = [
    /*
 https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-page-banner/browse
 still used for "page-metadata-banner-items"
 https://community.developer.atlassian.com/t/page-metadata-banner-in-custom-theme/12364
 */ 'wr!com.atlassian.confluence.plugins.confluence-page-banner:page-banner-common-resources'
];
class $7b4282d7c94dcb09$export$d55a1c591b25ea6e extends (0, $42omo.PureComponent) {
    handleQueryCompleted(data) {
        const isPanelLoadedAndEmpty = data && data.webPanels && data.webPanels.length === 0;
        this.setState({
            isPanelLoadedAndEmpty: isPanelLoadedAndEmpty
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            contentId: this.props.contentId,
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $7b4282d7c94dcb09$var$webPanelPageMetadataStyle,
            onCompleted: (data)=>this.handleQueryCompleted(data)
        }, ({ panels: panels })=>{
            if (!panels || !panels.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $7b4282d7c94dcb09$var$WRM_MODULES
            }, ()=>panels.map((panel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                        key: panel.completeKey,
                        html: panel.html
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.ATL_PAGE_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(panels)
            }));
        }), this.state.isPanelLoadedAndEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2ook.ConnectAppLoadEnd), {
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            items: (0, $FFoHM.getConnectAppsItems)([])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPanelLoadedAndEmpty: false
        };
    }
}
$7b4282d7c94dcb09$export$d55a1c591b25ea6e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["PageMetadataAtl"] = $7b4282d7c94dcb09$export$d55a1c591b25ea6e;

});

parcelRegister("fh5wq", function(module, exports) {
$parcel$export(module.exports, "ConnectAppLoadEnd", () => (parcelRequire("f2ook")).ConnectAppLoadEnd);
$parcel$export(module.exports, "getConnectAppsItems", () => (parcelRequire("FFoHM")).getConnectAppsItems);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8X9dm = parcelRequire("8X9dm");


var $f2ook = parcelRequire("f2ook");


var $FFoHM = parcelRequire("FFoHM");


var $hB3yw = parcelRequire("hB3yw");


});

parcelRegister("8X9dm", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $FFoHM = parcelRequire("FFoHM");

const $fa75a12a8b648c36$var$actions = {
    updateConnectApps: (props)=>({ setState: setState, getState: getState })=>{
            const { location: location, items: items, isLoaded: isLoaded } = props;
            // Update connectApps when it completed load
            const newState = getState().connectApps.map((data)=>{
                if (data.location === location) return {
                    location: location,
                    items: items,
                    isLoaded: isLoaded
                };
                return data;
            });
            setState({
                connectApps: newState
            });
        },
    resetConnectApps: ()=>({ setState: setState })=>{
            setState({
                connectApps: (0, $FFoHM.generateInitialState)()
            });
        }
};
const $fa75a12a8b648c36$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        connectApps: (0, $FFoHM.generateInitialState)()
    },
    actions: $fa75a12a8b648c36$var$actions,
    name: 'connectAppsState'
});
const $fa75a12a8b648c36$var$getConnectAppsState = (state)=>{
    // Check if all measurable connect apps are loaded
    const isReady = state.connectApps.every((cp)=>{
        return cp.isLoaded === true;
    });
    if (!isReady) return {
        isReady: false,
        data: null
    };
    return {
        isReady: true,
        data: (0, $FFoHM.generateMetricData)(state.connectApps)
    };
};
const $fa75a12a8b648c36$export$582ddccddc369c8 = (0, $9zUhf.createHook)($fa75a12a8b648c36$var$Store, {
    selector: $fa75a12a8b648c36$var$getConnectAppsState
});
module.exports["useConnectAppsState"] = $fa75a12a8b648c36$export$582ddccddc369c8;

});

parcelRegister("FFoHM", function(module, exports) {

var $33OR5 = parcelRequire("33OR5");

const $2c1124407cafc284$export$5e6f85e4321dccd5 = (items, prop = 'completeKey')=>{
    if (!items || !items.length) return [];
    return items.map((item)=>{
        if (!item[prop]) return null;
        return item[prop];
    });
};
const $2c1124407cafc284$export$fe8c27474396e3df = (originalData)=>{
    const isEmpty = originalData.every((cp)=>{
        return cp.items.length === 0;
    });
    if (isEmpty) return null;
    return originalData.reduce((result, data)=>{
        if (data.items?.length) result[data.location] = data.items;
        return result;
    }, {});
};
const $2c1124407cafc284$export$6c48ceb03731fb94 = ()=>{
    return (0, $33OR5.measuredLocations).map((location)=>({
            location: location,
            items: [],
            isLoaded: false
        }));
};
module.exports["getConnectAppsItems"] = $2c1124407cafc284$export$5e6f85e4321dccd5;
module.exports["generateMetricData"] = $2c1124407cafc284$export$fe8c27474396e3df;
module.exports["generateInitialState"] = $2c1124407cafc284$export$6c48ceb03731fb94;

});

parcelRegister("33OR5", function(module, exports) {

var $eSLr0 = parcelRequire("eSLr0");

const $026eb3cae9c12bb0$export$b8794672440f0b1 = [
    (0, $eSLr0.PAGE_METADATA_BANNER),
    (0, $eSLr0.SYSTEM_CONTENT_METADATA),
    (0, $eSLr0.ATL_PAGE_METADATA)
];
const $026eb3cae9c12bb0$export$d18781600a31352 = 'com.atlassian.plugins.atlassian-connect-plugin';
module.exports["measuredLocations"] = $026eb3cae9c12bb0$export$b8794672440f0b1;
module.exports["MEASURE_KEY"] = $026eb3cae9c12bb0$export$d18781600a31352;

});

parcelRegister("f2ook", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $33OR5 = parcelRequire("33OR5");


var $8X9dm = parcelRequire("8X9dm");

const $7be4190af38bf0dd$export$2ed36e453078a2a = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { location: location, items: items } = t0;
    const [, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    let t2;
    if ($[0] !== connectAppsActions || $[1] !== items || $[2] !== location) {
        t1 = ()=>{
            if (location && (0, $33OR5.measuredLocations).indexOf(location) !== -1) {
                const filteredItems = items.filter($7be4190af38bf0dd$var$_temp);
                connectAppsActions.updateConnectApps({
                    location: location,
                    items: filteredItems,
                    isLoaded: true
                });
            }
        };
        t2 = [
            location,
            items,
            connectAppsActions
        ];
        $[0] = connectAppsActions;
        $[1] = items;
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
};
function $7be4190af38bf0dd$var$_temp(item) {
    return item.indexOf((0, $33OR5.MEASURE_KEY)) !== -1;
}
module.exports["ConnectAppLoadEnd"] = $7be4190af38bf0dd$export$2ed36e453078a2a;

});

parcelRegister("hB3yw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2VQ4B = parcelRequire("2VQ4B");


var $8X9dm = parcelRequire("8X9dm");

const $ad90018ec7bbfcf2$export$c67125476ea8583f = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { contentId: contentId, metric: metric } = t0;
    const [connectApps, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    if ($[0] !== connectAppsActions) {
        t1 = ()=>{
            connectAppsActions.resetConnectApps();
        };
        $[0] = connectAppsActions;
        $[1] = t1;
    } else t1 = $[1];
    const onMeasureCompleted = t1;
    if (!connectApps?.isReady) return null;
    if (!connectApps?.data) {
        onMeasureCompleted();
        return null;
    }
    const t2 = connectApps?.data;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            connectApps: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== contentId || $[5] !== metric || $[6] !== onMeasureCompleted || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: contentId,
            metric: metric,
            customData: t3,
            onComplete: onMeasureCompleted
        });
        $[4] = contentId;
        $[5] = metric;
        $[6] = onMeasureCompleted;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};

});

parcelRegister("2VQ4B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $bhXnY = parcelRequire("bhXnY");


var $5EhNr = parcelRequire("5EhNr");

const $010b88689ec70f7f$export$a267cdf45880b07b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5EhNr.UFOSegmentLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhXnY.Bm3PageSegmentLoadEnd), props);
};
module.exports["PageSegmentLoadEnd"] = $010b88689ec70f7f$export$a267cdf45880b07b;

});

parcelRegister("bhXnY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $9bfe2b6f868e7303$var$noop = ()=>{};
const $9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $9bfe2b6f868e7303$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $9bfe2b6f868e7303$export$b20cfab4e3fe23b6 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent);
module.exports["Bm3PageSegmentLoadEnd"] = $9bfe2b6f868e7303$export$b20cfab4e3fe23b6;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("5EhNr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");

const $e32532ca00da3b97$var$noop = ()=>{};
const $e32532ca00da3b97$var$UFOSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $e32532ca00da3b97$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
            (0, $cbc8g.addUFOCustomData)({
                ...finalCustomData,
                ...typeof stopTimeRef.current === 'number' ? {
                    stopTime: stopTimeRef.current
                } : {},
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $e32532ca00da3b97$export$9859c9d857077c0b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e32532ca00da3b97$var$UFOSegmentLoadEndComponent);
module.exports["UFOSegmentLoadEnd"] = $e32532ca00da3b97$export$9859c9d857077c0b;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("jbFlk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $80koo = parcelRequire("80koo");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hFGQl = parcelRequire("hFGQl");


var $asQED = parcelRequire("asQED");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $2196709888d91a8b$var$WRM_MODULES = [
    'wrc!com.atlassian.confluence.plugins.confluence-feature-discovery-plugin',
    'wrc!com.atlassian.confluence.plugins.confluence-jira-metadata:confluence-jira-metadata-resources'
];
class $2196709888d91a8b$export$3977b622b23eae17 extends (0, $42omo.PureComponent) {
    render() {
        const { contentId: contentId, versionOverride: versionOverride } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: versionOverride
        }, ({ webItems: webItems })=>{
            const items = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: webItems,
                id: "page-metadata-banner-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.PAGE_METADATA_BANNER),
                items: (0, $FFoHM.getConnectAppsItems)(webItems)
            }));
            if (webItems.some((item)=>item.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $2196709888d91a8b$var$WRM_MODULES
            }, ()=>items);
            return items;
        }));
    }
}
$2196709888d91a8b$export$3977b622b23eae17.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
};
module.exports["PageMetadataBanner"] = $2196709888d91a8b$export$3977b622b23eae17;

});

parcelRegister("asQED", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2daQU = parcelRequire("2daQU");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $7XPIt = parcelRequire("7XPIt");


var $42cjr = parcelRequire("42cjr");


var $2d38b = parcelRequire("2d38b");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ht0Th = parcelRequire("ht0Th");


var $4aGJ9 = parcelRequire("4aGJ9");


var $hFGQl = parcelRequire("hFGQl");


var $1CpUP = parcelRequire("1CpUP");

const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (props)=>{
    const $ = (0, $frIzR.c)(28);
    const { webItems: webItems, className: className, id: id, webItemClassName: webItemClassName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, ContainerTagName: t0, actions: t1, modifications: t2, disableIcons: t3, noContainer: t4, useBadgeStyles: t5 } = props;
    const ContainerTagName = t0 === undefined ? "div" : t0;
    let t6;
    if ($[0] !== t1) {
        t6 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t6;
    } else t6 = $[1];
    const actions = t6;
    let t7;
    if ($[2] !== t2) {
        t7 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t7;
    } else t7 = $[3];
    const modifications = t7;
    const disableIcons = t3 === undefined ? false : t3;
    const noContainer = t4 === undefined ? false : t4;
    const useBadgeStyles = t5 === undefined ? false : t5;
    let t8;
    if ($[4] !== actions || $[5] !== contentSubType || $[6] !== disableIcons || $[7] !== hideDot || $[8] !== modifications || $[9] !== pageId || $[10] !== source || $[11] !== useBadgeStyles || $[12] !== webItemClassName || $[13] !== webItems) {
        t8 = ()=>webItems.map((webItem)=>{
                const webItemProps = {
                    key: webItem.completeKey,
                    url: webItem.url,
                    id: webItem.id,
                    onClick: webItem.onClick || actions[webItem.moduleKey],
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(webItem.styleClass, webItemClassName, {
                        "with-dot": !hideDot
                    }),
                    params: webItem.params,
                    iconInfo: webItem.icon,
                    label: webItem.label,
                    tooltip: webItem.tooltip,
                    spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                    disableIcon: disableIcons,
                    iconStyle: webItem.iconStyle,
                    addLargerMargin: hideDot,
                    useBylineStyles: hideDot
                };
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps["data-jira-metadata-count"] = -1;
                if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                    if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42cjr.ScheduledStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d38b.DraftStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                }
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                    key: "view-attachments-button"
                });
                if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                    key: "fabric-share"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                    key: "share-and-restrict-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                    contentId: webItem.contentId,
                    contentType: webItem.contentType ?? "page",
                    contentSubType: contentSubType || undefined,
                    source: source
                })));
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
                if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                    key: webItem.completeKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), webItemProps));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), {
                    key: webItem.completeKey,
                    ...webItemProps,
                    useBadgeStyles: useBadgeStyles
                });
            });
        $[4] = actions;
        $[5] = contentSubType;
        $[6] = disableIcons;
        $[7] = hideDot;
        $[8] = modifications;
        $[9] = pageId;
        $[10] = source;
        $[11] = useBadgeStyles;
        $[12] = webItemClassName;
        $[13] = webItems;
        $[14] = t8;
    } else t8 = $[14];
    const renderWebItems = t8;
    if (noContainer) {
        let t9;
        if ($[15] !== renderWebItems) {
            t9 = renderWebItems();
            $[15] = renderWebItems;
            $[16] = t9;
        } else t9 = $[16];
        let t10;
        if ($[17] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9);
            $[17] = t9;
            $[18] = t10;
        } else t10 = $[18];
        return t10;
    }
    const t9 = dataTestId || "web-item-wrapper";
    let t10;
    if ($[19] !== renderWebItems) {
        t10 = renderWebItems();
        $[19] = renderWebItems;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== ContainerTagName || $[22] !== className || $[23] !== dataTestId || $[24] !== id || $[25] !== t10 || $[26] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContainerTagName, {
            className: className,
            id: id,
            "data-test-id": dataTestId,
            "data-testid": t9
        }, t10);
        $[21] = ContainerTagName;
        $[22] = className;
        $[23] = dataTestId;
        $[24] = id;
        $[25] = t10;
        $[26] = t9;
        $[27] = t11;
    } else t11 = $[27];
    return t11;
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["SHARE_BTN_STYLE"] = $27cf6bbb40785c7e$export$392ec14fa63f4ae3;
module.exports["WebItemList"] = $27cf6bbb40785c7e$export$63286b959e8d28b9;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("7XPIt", function(module, exports) {
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $cs1vW = parcelRequire("cs1vW");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $9lz2c = parcelRequire("9lz2c");


var $2UWuP = parcelRequire("2UWuP");


var $jlIaF = parcelRequire("jlIaF");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _4rtxtlke _jq8g1ul9 _14hp1ul9 _43dsazsu _oxk4azsu",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $h82at.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: (0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true) ? (0, $1NBp8.ATTACHMENTS_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        }) : `${0, $jlIaF.CONTEXT_PATH}/pages/viewpageattachments.action?pageId=${contentId}&metadataLink=true`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $cs1vW.default)($5cc628dffabd5f14$export$774c527e91be8e54);
module.exports["ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU"] = $5cc628dffabd5f14$export$6f695b80f23f4114;
module.exports["ViewAttachmentsButton"] = $5cc628dffabd5f14$export$5c9f1ebb6c75cefb;

});

parcelRegister("2UWuP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Asv1P = parcelRequire("Asv1P");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) {
        const wrappedChild = /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            onClick: handleClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: innerRef
        }, wrappedChild);
    }
    return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("42cjr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7f6808c58612208d$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a_lQj",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("bewhN"))).ScheduledStatus
});
module.exports["ScheduledStatus"] = $7f6808c58612208d$export$d10c0abe99daab65;

});

parcelRegister("bewhN", function(module, exports) {

let $82da0bd958976e5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82da0bd958976e5e$var$load("iWKl1").then(()=>parcelRequire('dqNU1'));

});

parcelRegister("2d38b", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $30c96bfad3bb5778$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6vTJj",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("3B1rr"))).DraftStatus
});
module.exports["DraftStatus"] = $30c96bfad3bb5778$export$ad9db10db9173ca8;

});

parcelRegister("3B1rr", function(module, exports) {

let $29e5f210dc44a2b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29e5f210dc44a2b5$var$load("jYr96").then(()=>parcelRequire('1cgZV'));

});

parcelRegister("ht0Th", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const container = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node
};
module.exports["JiraButtonAnalyticsWrapper"] = $cb75d5f0a986326c$export$549130614231f8f4;

});

parcelRegister("1CpUP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $2daQU = parcelRequire("2daQU");


var $5qzNs = parcelRequire("5qzNs");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $bCECL = parcelRequire("bCECL");

function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $12dd715bfa1d104a$var$imageStyles = null;
// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { tooltip: tooltip, children: children } = t0;
    if (tooltip) {
        let t1;
        if ($[0] !== children) {
            t1 = (tooltipProps)=>children(tooltipProps);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1 || $[3] !== tooltip) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltip
            }, t1);
            $[2] = t1;
            $[3] = tooltip;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t1;
    if ($[5] !== children) {
        t1 = children({});
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    let addLargerMargin;
    let classes;
    let icon;
    let id;
    let label;
    let onClick;
    let otherProps;
    let style;
    let tooltip;
    let url;
    let useBadgeStyles;
    let useBylineStyles;
    if ($[0] !== t0) {
        ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps } = t0);
        $[0] = t0;
        $[1] = addLargerMargin;
        $[2] = classes;
        $[3] = icon;
        $[4] = id;
        $[5] = label;
        $[6] = onClick;
        $[7] = otherProps;
        $[8] = style;
        $[9] = tooltip;
        $[10] = url;
        $[11] = useBadgeStyles;
        $[12] = useBylineStyles;
    } else {
        addLargerMargin = $[1];
        classes = $[2];
        icon = $[3];
        id = $[4];
        label = $[5];
        onClick = $[6];
        otherProps = $[7];
        style = $[8];
        tooltip = $[9];
        url = $[10];
        useBadgeStyles = $[11];
        useBylineStyles = $[12];
    }
    let t1;
    if ($[13] !== addLargerMargin || $[14] !== classes || $[15] !== icon || $[16] !== id || $[17] !== label || $[18] !== onClick || $[19] !== otherProps || $[20] !== style || $[21] !== url || $[22] !== useBadgeStyles || $[23] !== useBylineStyles) {
        t1 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                "data-testId": "web-item-link",
                className: (0, $gMc0m.default)([
                    "_2hwxu2gc _vwz4bs82",
                    addLargerMargin && "_2hwx14h2 _vwz41vhj",
                    useBylineStyles && "_syazd34b",
                    useBadgeStyles && "_2rko12b0 _zulp1b66 _1yt41b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _vwz47vkz _2hwxze3t _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _1bnxagmp _1di6fcek _c2waglyw",
                    classes
                ]),
                href: url,
                id: id,
                onClick: onClick,
                style: style,
                ...tooltipProps,
                ...otherProps
            }, icon, typeof label === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: label
                }
            }) : label);
        $[13] = addLargerMargin;
        $[14] = classes;
        $[15] = icon;
        $[16] = id;
        $[17] = label;
        $[18] = onClick;
        $[19] = otherProps;
        $[20] = style;
        $[21] = url;
        $[22] = useBadgeStyles;
        $[23] = useBylineStyles;
        $[24] = t1;
    } else t1 = $[24];
    let t2;
    if ($[25] !== t1 || $[26] !== tooltip) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
            tooltip: tooltip
        }, t1);
        $[25] = t1;
        $[26] = tooltip;
        $[27] = t2;
    } else t2 = $[27];
    return t2;
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
   * classes to use for the component
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * id passed from WebItem
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Icon obj
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $42omo.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $gMc0m.default)([
                "_c71l1osq _4t3i1wug _1e0c1o8l _s7n4nkob _2hwx14y2"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
   * Classnames. Note that WebItem no longer assumes that it should render as a button
   * And as such you may need to explicitly pass the `aui-button` class here.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * id
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Type of the button
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * Contain parameters setted in the descriptor
   */ params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Doesn't render icons when true
   */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * icon information used for absolute images
   */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
    }),
    /**
   * Show spinner instead of an icon if equals true
   */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Icon styles
   */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});
module.exports["WebItem"] = $12dd715bfa1d104a$export$1c46d4b85d455dd4;

});

parcelRegister("4Uc69", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $asQED = parcelRequire("asQED");


var $hFGQl = parcelRequire("hFGQl");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

class $c77793ad2fffc9ee$export$3a0235893ca8c89e extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { excludeIds: excludeIds, contentId: contentId } = this.props;
        if (!excludeIds.includes((0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID))) (0, $fGzMp.getExperienceTracker)().start({
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        });
    }
    render() {
        const { contentId: contentId, versionOverride: versionOverride, excludeIds: excludeIds } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
            version: versionOverride
        }, ({ webItems: webItems })=>{
            let filteredWebItems = webItems;
            if (excludeIds && excludeIds.length) filteredWebItems = filteredWebItems.filter((item)=>!excludeIds.includes(item.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: filteredWebItems,
                id: "system- content-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(filteredWebItems)
            }));
        });
    }
}
$c77793ad2fffc9ee$export$3a0235893ca8c89e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    excludeIds: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string)
};
$c77793ad2fffc9ee$export$3a0235893ca8c89e.defaultProps = {
    excludeIds: []
};
module.exports["SystemContentMetadata"] = $c77793ad2fffc9ee$export$3a0235893ca8c89e;

});

parcelRegister("JHogp", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $fwDOR = parcelRequire("fwDOR");


var $jBnsv = parcelRequire("jBnsv");


var $5EoFB = parcelRequire("5EoFB");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hQBR9 = parcelRequire("hQBR9");


var $lECEN = parcelRequire("lECEN");


var $cxCWb = parcelRequire("cxCWb");


var $D7PHQ = parcelRequire("D7PHQ");


var $bvg6Y = parcelRequire("bvg6Y");


var $2REhP = parcelRequire("2REhP");


var $8HdsQ = parcelRequire("8HdsQ");

parcelRequire("hAnPj");
var $SAFLR = parcelRequire("SAFLR");


var $2pIlF = parcelRequire("2pIlF");


var $9wGTI = parcelRequire("9wGTI");


var $eNjW4 = parcelRequire("eNjW4");


var $8Cofr = parcelRequire("8Cofr");

const $6e3ff5db190a542f$var$StyledWebItemButtonList = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $lECEN.WebItemButtonList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_s7n4nkob",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81cy0 _1kl71uh4 _1e0c1o8l _1bsbt94y _4t3i7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$WebItemsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _p12fuuw1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubType || $[2] !== contentType || $[3] !== isArchived || $[4] !== versionOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$ShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        });
        $[0] = contentId;
        $[1] = contentSubType;
        $[2] = contentType;
        $[3] = isArchived;
        $[4] = versionOverride;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
const $6e3ff5db190a542f$var$ShareAndCopyButtons = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    const t1 = `share-button${isArchived ? "-archived" : ""}`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $jBnsv.INVITE_TO_EDIT_KEY)
        ];
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            display: "flex"
        };
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType) {
        t4 = (t5)=>{
            const { loading: loading, webItems: webItems } = t5;
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
                name: "ShareButtonPlaceholderSpacer",
                hold: (0, $9wGTI.fg)("ufo-manual-experimental-holds-confluence") && loading
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2pIlF.ShareRestrictAndCopyButtonPlaceholder), null)));
            webItems.forEach((item)=>{
                if (item.completeKey === (0, $jBnsv.INVITE_TO_EDIT_KEY)) {
                    item.contentId = contentId;
                    item.contentType = contentType;
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                pageId: contentId,
                webItems: webItems,
                id: "extracted-share-button",
                contentSubType: contentSubType,
                source: "contentHeader"
            });
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== contentId || $[7] !== t1 || $[8] !== t4 || $[9] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$StyledContainer, {
            "data-vc": "share-button-copy-link-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            key: t1,
            tagName: "span",
            contentId: contentId,
            allowedWebItems: t2,
            location: (0, $eSLr0.PAGE_BUTTONS),
            version: versionOverride,
            style: t3,
            renderWhenLoading: true
        }, t4));
        $[6] = contentId;
        $[7] = t1;
        $[8] = t4;
        $[9] = versionOverride;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
$6e3ff5db190a542f$var$ShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    addItem: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
const $6e3ff5db190a542f$export$6955dde08e119b3d = (props)=>{
    const $ = (0, $frIzR.c)(32);
    const { contentId: contentId, versionOverride: versionOverride, isExternalCollaborator: isExternalCollaborator, spaceKey: spaceKey, contentSubType: contentSubType, contentType: contentType, isArchived: isArchived } = props;
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    (0, $hQBR9.useAutomationUrlParamTrigger)();
    let t0;
    if ($[0] !== contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8HdsQ.CommentButtonWrapper), {
            key: contentId,
            contentId: contentId,
            isCommentButtonSSRd: Boolean(window.__SSR_RENDERED__ || undefined)
        });
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== contentId || $[3] !== contentType || $[4] !== isArchived || $[5] !== isLoomDisabled || $[6] !== spaceKey) {
        t1 = !isArchived && !isLoomDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        });
        $[2] = contentId;
        $[3] = contentType;
        $[4] = isArchived;
        $[5] = isLoomDisabled;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    let t3;
    if ($[8] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxCWb.FavouriteButton), {
            key: "favourite-button",
            contentId: contentId,
            useLegacyIcon: true
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvg6Y.WatchDialogWrapper), {
            key: "watch-dialog",
            contentId: contentId,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            componentLocation: (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE
        });
        $[8] = contentId;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    let t4;
    if ($[11] !== contentSubType) {
        t4 = (t5)=>{
            const { webItems: webItems } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$WebItemsContainer, null, !!webItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$StyledBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                webItems: webItems,
                buttonType: "aui-button-subtle",
                contentSubType: contentSubType
            })));
        };
        $[11] = contentSubType;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== contentId || $[14] !== t4 || $[15] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            key: "page-buttons",
            contentId: contentId,
            location: (0, $eSLr0.PAGE_BUTTONS),
            notAllowedWebItems: (0, $8Cofr.FILTERED_WEB_ITEM_KEYS),
            tagName: "span",
            version: versionOverride
        }, t4);
        $[13] = contentId;
        $[14] = t4;
        $[15] = versionOverride;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== contentId || $[18] !== contentSubType || $[19] !== contentType || $[20] !== isArchived || $[21] !== isExternalCollaborator || $[22] !== versionOverride) {
        t6 = !isExternalCollaborator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$StyledBorder, null), isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $SAFLR.RestrictionsDialogTriggerWrapper), {
            triggeredFrom: "fromView",
            contentId: contentId,
            contentSubType: contentSubType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        }));
        $[17] = contentId;
        $[18] = contentSubType;
        $[19] = contentType;
        $[20] = isArchived;
        $[21] = isExternalCollaborator;
        $[22] = versionOverride;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== props || $[25] !== t0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Cofr.GroupedPageButtonsCommon), props, t0, t1, t2, t3, t5, t6);
        $[24] = props;
        $[25] = t0;
        $[26] = t1;
        $[27] = t2;
        $[28] = t3;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    return t7;
};
$6e3ff5db190a542f$export$6955dde08e119b3d.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    headerSticky: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    lastModifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["GroupedPageButtons"] = $6e3ff5db190a542f$export$6955dde08e119b3d;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("lECEN", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $cpjd2 = parcelRequire("cpjd2");


var $asQED = parcelRequire("asQED");

const $fc3b51da62867b20$export$4354248d0b2a76d1 = [
    'wr!confluence.web.resources:querystring',
    'wr!confluence.web.resources:navigator-context',
    'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
];
const $fc3b51da62867b20$export$562269fb9a75cb04 = (props)=>{
    const $ = (0, $frIzR.c)(19);
    const { id: id, webItems: webItems, actions: actions, modifications: modifications, buttonType: buttonType, className: className, disableIcons: disableIcons, contentSubType: contentSubType, source: source } = props;
    let t0;
    if ($[0] !== webItems) {
        t0 = webItems.some($fc3b51da62867b20$var$_temp);
        $[0] = webItems;
        $[1] = t0;
    } else t0 = $[1];
    const needsConnectWRM = t0;
    let t1;
    let t2;
    if ($[2] !== needsConnectWRM) {
        t1 = ()=>{
            if (needsConnectWRM) (0, $cpjd2.requireLegacyWRM)($fc3b51da62867b20$export$4354248d0b2a76d1, $fc3b51da62867b20$var$_temp2, $fc3b51da62867b20$var$_temp3);
        };
        t2 = [
            needsConnectWRM
        ];
        $[2] = needsConnectWRM;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[5] !== className) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))("aui-buttons", className);
        $[5] = className;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== buttonType) {
        t4 = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(buttonType, "aui-button");
        $[7] = buttonType;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== actions || $[10] !== contentSubType || $[11] !== disableIcons || $[12] !== id || $[13] !== modifications || $[14] !== source || $[15] !== t3 || $[16] !== t4 || $[17] !== webItems) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $asQED.WebItemList), {
            dataTestId: "web-item-button-list",
            id: id,
            actions: actions,
            modifications: modifications,
            webItems: webItems,
            className: t3,
            webItemClassName: t4,
            disableIcons: disableIcons,
            contentSubType: contentSubType,
            source: source
        });
        $[9] = actions;
        $[10] = contentSubType;
        $[11] = disableIcons;
        $[12] = id;
        $[13] = modifications;
        $[14] = source;
        $[15] = t3;
        $[16] = t4;
        $[17] = webItems;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
$fc3b51da62867b20$export$562269fb9a75cb04.displayName = 'WebItemButtonList';
$fc3b51da62867b20$export$562269fb9a75cb04.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    buttonType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
function $fc3b51da62867b20$var$_temp(item) {
    return item.completeKey.startsWith("com.atlassian.plugins.atlassian-connect-plugin");
}
function $fc3b51da62867b20$var$_temp2() {}
function $fc3b51da62867b20$var$_temp3() {}
module.exports["WebItemButtonList"] = $fc3b51da62867b20$export$562269fb9a75cb04;

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("5ezCz"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("5ezCz"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $kfYj7 = parcelRequire("kfYj7");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("5ezCz", function(module, exports) {

let $3cf9e42d46e45ca1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3cf9e42d46e45ca1$var$load("l8YLV"),
    $3cf9e42d46e45ca1$var$load("6wr18"),
    $3cf9e42d46e45ca1$var$load("ffEVr"),
    $3cf9e42d46e45ca1$var$load("5dBst"),
    $3cf9e42d46e45ca1$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("D7PHQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $eEA8O = parcelRequire("eEA8O");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $3Wf43 = parcelRequire("3Wf43");


var $5i3ci = parcelRequire("5i3ci");


var $aFmsO = parcelRequire("aFmsO");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $531iT = parcelRequire("531iT");


var $cxQ7E = parcelRequire("cxQ7E");


const $981c6be93b35769c$var$PageHeaderLoomButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Bpphw",
    name: "PageHeaderLoomButtonLoader",
    loader: async ()=>(await (parcelRequire("gtM8p"))).PageHeaderLoomButton,
    loading: ({ isCircle: isCircle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), {
            isCircle: isCircle
        })
});

const $981c6be93b35769c$var$LoomCrossFlowPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J-rGd",
    name: "LoomCrossFlowPopupCardLoader",
    loader: async ()=>(await (parcelRequire("6yLoQ"))).LoomCrossFlowPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
});

const $981c6be93b35769c$var$LoomCrossJoinPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "32FyG",
    name: "LoomCrossJoinPopupCardLoader",
    loader: async ()=>(await (parcelRequire("3h4cG"))).LoomCrossJoinPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
}); /**
     * This touchpoint was previously in the page header, but has now been moved to the comments sidebar.
     * The naming will remain the same to avoid breaking any existing usages of this name.
     */ 
const $981c6be93b35769c$var$ENTRYPOINT_ID = 'loom-confluence-page-header';
const $981c6be93b35769c$var$SOURCE_COMPONENT = 'loomConfluencePageHeader';
const $981c6be93b35769c$var$SOURCE_CONTEXT = 'confluencePageHeaderRecordAVideo';
const $981c6be93b35769c$var$i18n = (0, $h82at.defineMessages)({
    crossJoinEntryPointLabel: {
        id: "page-header-loom-button.crossJoinEntryPointLabel",
        defaultMessage: "Join your team on Loom to record a video"
    },
    crossSellPopupCardDescription: {
        id: "page-header-loom-button.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossSellPopupCardTitle: {
        id: "page-header-loom-button.crossSellPopupCardTitle",
        defaultMessage: "Share your work with video"
    },
    entryPointLabel: {
        id: "page-header-loom-button.entryPointLabel",
        defaultMessage: "Record a Loom video"
    }
});
const $981c6be93b35769c$var$ButtonSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $981c6be93b35769c$var$PageHeaderLoomEntryPointComponent = (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { contentId: contentId, crossSellPopupPlacement: crossSellPopupPlacement, crossSellSpotlightPlacement: crossSellSpotlightPlacement, spaceKey: spaceKey, contentType: contentType, flags: flags, isCircle: t1, testId: testId, source: source, isDisabled: t2 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let entryPointVariant;
    let error;
    let loading;
    if (window.__SSR_RENDERED__ && window.__SSR_LOOM_ENTRY_POINT__) entryPointVariant = window.__SSR_LOOM_ENTRY_POINT__.entryPointVariant;
    const entryPointFromState = (0, $4R3wx.useLoomEntryPointVariant)();
    entryPointVariant = entryPointFromState.entryPointVariant;
    error = entryPointFromState.error;
    loading = entryPointFromState.loading;
    const isEntryPointEnabled = [
        "BETA",
        "CO_USE",
        "CROSS_FLOW",
        "CROSS_JOIN",
        "NONE"
    ].includes(entryPointVariant);
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)($981c6be93b35769c$var$ENTRYPOINT_ID);
    const intl = (0, $1cfRh.default)();
    let t3;
    if ($[0] !== flags) {
        t3 = {
            flags: flags
        };
        $[0] = flags;
        $[1] = t3;
    } else t3 = $[1];
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)(t3);
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== entryPointVariant) {
        t4 = ()=>{
            if (entryPointVariant === "CROSS_JOIN") createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    action: "viewed",
                    name: "createLoomHeaderItem",
                    attributes: {
                        adType: "crossJoin",
                        entrypoint: $981c6be93b35769c$var$ENTRYPOINT_ID,
                        sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = entryPointVariant;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointVariant) {
        t5 = [
            createAnalyticsEvent,
            entryPointVariant
        ];
        $[5] = createAnalyticsEvent;
        $[6] = entryPointVariant;
        $[7] = t5;
    } else t5 = $[7];
    (0, $42omo.useEffect)(t4, t5);
    if (!isEntryPointEnabled) return null;
    if (entryPointVariant === "BETA" || entryPointVariant === "CO_USE") {
        let t6;
        if ($[8] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[8] = intl;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== isDisabled) {
            t7 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false);
            $[10] = isDisabled;
            $[11] = t7;
        } else t7 = $[11];
        let t8;
        if ($[12] !== contentId || $[13] !== contentType || $[14] !== isCircle || $[15] !== source || $[16] !== spaceKey || $[17] !== ssrPlaceholderIdProp || $[18] !== t6 || $[19] !== t7 || $[20] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$PageHeaderLoomButtonLoader, {
                contentId: contentId,
                contentType: contentType,
                dataVC: "loom-button",
                label: t6,
                spaceKey: spaceKey,
                ssrPlaceholderIdProp: ssrPlaceholderIdProp,
                isCircle: isCircle,
                testId: testId,
                source: source,
                isDisabled: t7
            });
            $[12] = contentId;
            $[13] = contentType;
            $[14] = isCircle;
            $[15] = source;
            $[16] = spaceKey;
            $[17] = ssrPlaceholderIdProp;
            $[18] = t6;
            $[19] = t7;
            $[20] = testId;
            $[21] = t8;
        } else t8 = $[21];
        return t8;
    }
    if (error) {
        let t6;
        if ($[22] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[22] = intl;
            $[23] = t6;
        } else t6 = $[23];
        let t7;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== loomEntryPointErrorCallback || $[26] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle",
                "aria-label": t6,
                "data-vc": "loom-button",
                iconAfter: t7,
                onClick: loomEntryPointErrorCallback
            });
            $[25] = loomEntryPointErrorCallback;
            $[26] = t6;
            $[27] = t8;
        } else t8 = $[27];
        return t8;
    }
    if (loading) {
        let t6;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null);
            $[28] = t6;
        } else t6 = $[28];
        return t6;
    }
    if (entryPointVariant === "CROSS_FLOW") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[29] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[29] = intl;
                $[30] = t6;
            } else t6 = $[30];
            let t7;
            if ($[31] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[31] = intl;
                $[32] = t7;
            } else t7 = $[32];
            let t8;
            if ($[33] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
                $[33] = intl;
                $[34] = t8;
            } else t8 = $[34];
            let t9;
            if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[35] = t9;
            } else t9 = $[35];
            let t10;
            if ($[36] !== crossSellPopupPlacement || $[37] !== crossSellSpotlightPlacement || $[38] !== isCircle || $[39] !== isPulseActive || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Wf43.LoomCrossFlowPopupLoader), {
                    description: t6,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    placement: crossSellPopupPlacement,
                    spotlightPlacement: crossSellSpotlightPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                    sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                    title: t7,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive
                });
                $[36] = crossSellPopupPlacement;
                $[37] = crossSellSpotlightPlacement;
                $[38] = isCircle;
                $[39] = isPulseActive;
                $[40] = t6;
                $[41] = t7;
                $[42] = t8;
                $[43] = t10;
            } else t10 = $[43];
            return t10;
        }
        let t6;
        if ($[44] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[44] = intl;
            $[45] = t6;
        } else t6 = $[45];
        let t7;
        if ($[46] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[46] = intl;
            $[47] = t7;
        } else t7 = $[47];
        let t8;
        if ($[48] !== intl || $[49] !== isCircle || $[50] !== ssrPlaceholderIdProp) {
            t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
                    "data-vc": "loom-button",
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    ...ssrPlaceholderIdProp
                })));
            $[48] = intl;
            $[49] = isCircle;
            $[50] = ssrPlaceholderIdProp;
            $[51] = t8;
        } else t8 = $[51];
        let t9;
        if ($[52] !== crossSellPopupPlacement || $[53] !== crossSellSpotlightPlacement || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$LoomCrossFlowPopupCardLoader, {
                description: t6,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                placement: crossSellPopupPlacement,
                spotlightPlacement: crossSellSpotlightPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                title: t7,
                trigger: t8
            });
            $[52] = crossSellPopupPlacement;
            $[53] = crossSellSpotlightPlacement;
            $[54] = t6;
            $[55] = t7;
            $[56] = t8;
            $[57] = t9;
        } else t9 = $[57];
        return t9;
    }
    if (entryPointVariant === "CROSS_JOIN") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[58] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[58] = intl;
                $[59] = t6;
            } else t6 = $[59];
            let t7;
            if ($[60] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[60] = intl;
                $[61] = t7;
            } else t7 = $[61];
            let t8;
            if ($[62] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel);
                $[62] = intl;
                $[63] = t8;
            } else t8 = $[63];
            let t9;
            if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[64] = t9;
            } else t9 = $[64];
            const t10 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined;
            let t11;
            if ($[65] !== crossSellPopupPlacement || $[66] !== isCircle || $[67] !== isPulseActive || $[68] !== t10 || $[69] !== t6 || $[70] !== t7 || $[71] !== t8) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Wf43.LoomCrossJoinPopupLoader), {
                    description: t6,
                    placement: crossSellPopupPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    title: t7,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive,
                    flags: t10,
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                });
                $[65] = crossSellPopupPlacement;
                $[66] = isCircle;
                $[67] = isPulseActive;
                $[68] = t10;
                $[69] = t6;
                $[70] = t7;
                $[71] = t8;
                $[72] = t11;
            } else t11 = $[72];
            return t11;
        }
        let t6;
        if ($[73] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[73] = intl;
            $[74] = t6;
        } else t6 = $[74];
        let t7;
        if ($[75] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[75] = intl;
            $[76] = t7;
        } else t7 = $[76];
        let t8;
        if ($[77] !== intl || $[78] !== isCircle || $[79] !== ssrPlaceholderIdProp) {
            t8 = (href, t9)=>{
                const { onClick: onClick, ...otherTriggerProps } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...otherTriggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
                    "data-vc": "loom-button",
                    href: href,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    rel: "noreferrer",
                    target: "_blank",
                    onClick: onClick,
                    ...ssrPlaceholderIdProp
                })));
            };
            $[77] = intl;
            $[78] = isCircle;
            $[79] = ssrPlaceholderIdProp;
            $[80] = t8;
        } else t8 = $[80];
        const t9 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined;
        let t10;
        if ($[81] !== crossSellPopupPlacement || $[82] !== t6 || $[83] !== t7 || $[84] !== t8 || $[85] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$LoomCrossJoinPopupCardLoader, {
                description: t6,
                placement: crossSellPopupPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                title: t7,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                triggerLink: t8,
                flags: t9,
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
            });
            $[81] = crossSellPopupPlacement;
            $[82] = t6;
            $[83] = t7;
            $[84] = t8;
            $[85] = t9;
            $[86] = t10;
        } else t10 = $[86];
        return t10;
    }
    return null;
};
const $981c6be93b35769c$export$35695746566a3d63 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})((0, $7aRa9.withFlags)($981c6be93b35769c$var$PageHeaderLoomEntryPointComponent));
module.exports["PageHeaderLoomEntryPoint"] = $981c6be93b35769c$export$35695746566a3d63;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");

const $e5ba90f4b97bd7c1$var$i18n = (0, $h82at.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $1cfRh.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("3Wf43", function(module, exports) {

var $gIaMn = parcelRequire("gIaMn");

var $jmjWc = parcelRequire("jmjWc");


var $5Abqh = parcelRequire("5Abqh");


const $98cee705389562e0$export$2a0b2901b6f1e4ac = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "TnkNJ",
    name: "LoomCrossFlowPopupLoader",
    loader: async ()=>(await (parcelRequire("99EAy"))).LoomCrossFlowPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});

const $98cee705389562e0$export$ba53a8d423873260 = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "d4je0",
    name: "LoomCrossJoinPopupLoader",
    loader: async ()=>(await (parcelRequire("4fMfx"))).LoomCrossJoinPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});
module.exports["LoomCrossFlowPopupLoader"] = $98cee705389562e0$export$2a0b2901b6f1e4ac;
module.exports["LoomCrossJoinPopupLoader"] = $98cee705389562e0$export$ba53a8d423873260;

});

parcelRegister("99EAy", function(module, exports) {

let $6aa4705fd826a800$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6aa4705fd826a800$var$load("jOdEL"),
    $6aa4705fd826a800$var$load("6wr18"),
    $6aa4705fd826a800$var$load("eufZR"),
    $6aa4705fd826a800$var$load("j8i2J"),
    $6aa4705fd826a800$var$load("ffEVr"),
    $6aa4705fd826a800$var$load("2DxXe")
]).then(()=>parcelRequire('9cwPn'));

});

parcelRegister("4fMfx", function(module, exports) {

let $318dfd7d8ac1f1a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $318dfd7d8ac1f1a7$var$load("jOdEL"),
    $318dfd7d8ac1f1a7$var$load("EYiM3")
]).then(()=>parcelRequire('lvs3G'));

});

parcelRegister("5i3ci", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1lhEF = parcelRequire("1lhEF");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, entryPointId: entryPointId, isCircle: isCircle } = t0;
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    if ((0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = isCircle ? 24 : 3;
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
            radius: t1,
            testId: "loom-cross-sell-discoverability-pulse"
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    // Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
    if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("aFmsO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXjWU = parcelRequire("aXjWU");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $9c43e73b872d5b9c$var$TIMEOUT_MS = 300;
const $9c43e73b872d5b9c$var$LAST_PULSE_INDEX = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS.length - 1;
const $9c43e73b872d5b9c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (0, $3u0dr.isReactCompilerActiveV2)() ? (entryPointId)=>{
    const $ = (0, $frIzR.c)(74);
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t0;
    if ($[0] !== isPulseActive) {
        t0 = isPulseActive && (0, $gd8AW.havePulsesEnded)();
        $[0] = isPulseActive;
        $[1] = t0;
    } else t0 = $[1];
    const skipRefreshPulseStatus = t0;
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    let t1;
    if ($[2] !== pulse1 || $[3] !== pulse2 || $[4] !== pulse3 || $[5] !== pulse4 || $[6] !== pulse5) {
        t1 = [
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ];
        $[2] = pulse1;
        $[3] = pulse2;
        $[4] = pulse3;
        $[5] = pulse4;
        $[6] = pulse5;
        $[7] = t1;
    } else t1 = $[7];
    const pulseHooks = t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[8] = t2;
    } else t2 = $[8];
    const hasRequestedRef = (0, $42omo.useRef)(t2);
    const lastRequestedRef = (0, $42omo.useRef)(null);
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    let t3;
    if ($[9] !== pulseHooks || $[10] !== skipRefreshPulseStatus) {
        t3 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i = 0; i < pulseHooks.length; i++){
                const pulseHook = pulseHooks[i];
                if (pulseHook.hasMessageStarted) {
                    lastRequestedRef.current = null;
                    lastStartedIndexRef.current = i;
                    break;
                }
                if (!hasRequestedRef.current.has(i)) {
                    hasRequestedRef.current.add(i);
                    lastRequestedRef.current = {
                        index: i,
                        timestamp: Date.now()
                    };
                    pulseHook.requestMessageStart();
                    break;
                }
            }
        };
        $[9] = pulseHooks;
        $[10] = skipRefreshPulseStatus;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== pulse1.handleClickTracking || $[13] !== pulse1.hasMessageStarted || $[14] !== pulse1.requestMessageStart || $[15] !== pulse2.handleClickTracking || $[16] !== pulse2.hasMessageStarted || $[17] !== pulse2.requestMessageStart || $[18] !== pulse3.handleClickTracking || $[19] !== pulse3.hasMessageStarted || $[20] !== pulse3.requestMessageStart || $[21] !== pulse4.handleClickTracking || $[22] !== pulse4.hasMessageStarted || $[23] !== pulse4.requestMessageStart || $[24] !== pulse5.handleClickTracking || $[25] !== pulse5.hasMessageStarted || $[26] !== pulse5.requestMessageStart || $[27] !== pulseHooks || $[28] !== skipRefreshPulseStatus) {
        t4 = [
            skipRefreshPulseStatus,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted,
            pulse1.requestMessageStart,
            pulse2.requestMessageStart,
            pulse3.requestMessageStart,
            pulse4.requestMessageStart,
            pulse5.requestMessageStart,
            pulse1.handleClickTracking,
            pulse2.handleClickTracking,
            pulse3.handleClickTracking,
            pulse4.handleClickTracking,
            pulse5.handleClickTracking
        ];
        $[12] = pulse1.handleClickTracking;
        $[13] = pulse1.hasMessageStarted;
        $[14] = pulse1.requestMessageStart;
        $[15] = pulse2.handleClickTracking;
        $[16] = pulse2.hasMessageStarted;
        $[17] = pulse2.requestMessageStart;
        $[18] = pulse3.handleClickTracking;
        $[19] = pulse3.hasMessageStarted;
        $[20] = pulse3.requestMessageStart;
        $[21] = pulse4.handleClickTracking;
        $[22] = pulse4.hasMessageStarted;
        $[23] = pulse4.requestMessageStart;
        $[24] = pulse5.handleClickTracking;
        $[25] = pulse5.hasMessageStarted;
        $[26] = pulse5.requestMessageStart;
        $[27] = pulseHooks;
        $[28] = skipRefreshPulseStatus;
        $[29] = t4;
    } else t4 = $[29];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[30] !== isPulseActive || $[31] !== pulseHooks || $[32] !== skipRefreshPulseStatus) {
        t5 = ()=>{
            if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
            const { index: index, timestamp: timestamp } = lastRequestedRef.current;
            const pulseHook_0 = pulseHooks[index];
            if (pulseHook_0.hasMessageStarted) {
                lastRequestedRef.current = null;
                return;
            }
            const elapsed = Date.now() - timestamp;
            if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
                lastRequestedRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            } else {
                const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
                const timeoutId = setTimeout(()=>{
                    setTimeoutTrigger($9c43e73b872d5b9c$var$_temp);
                }, remainingTime);
                return ()=>clearTimeout(timeoutId);
            }
        };
        $[30] = isPulseActive;
        $[31] = pulseHooks;
        $[32] = skipRefreshPulseStatus;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== isPulseActive || $[35] !== pulse1.hasMessageStarted || $[36] !== pulse2.hasMessageStarted || $[37] !== pulse3.hasMessageStarted || $[38] !== pulse4.hasMessageStarted || $[39] !== pulse5.hasMessageStarted || $[40] !== pulseHooks || $[41] !== skipRefreshPulseStatus || $[42] !== timeoutTrigger) {
        t6 = [
            skipRefreshPulseStatus,
            isPulseActive,
            timeoutTrigger,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[34] = isPulseActive;
        $[35] = pulse1.hasMessageStarted;
        $[36] = pulse2.hasMessageStarted;
        $[37] = pulse3.hasMessageStarted;
        $[38] = pulse4.hasMessageStarted;
        $[39] = pulse5.hasMessageStarted;
        $[40] = pulseHooks;
        $[41] = skipRefreshPulseStatus;
        $[42] = timeoutTrigger;
        $[43] = t6;
    } else t6 = $[43];
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[44] !== entryPointId || $[45] !== pulseHooks || $[46] !== skipRefreshPulseStatus || $[47] !== startPulse) {
        t7 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
                const pulseHook_1 = pulseHooks[i_0];
                const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
                if (pulseHook_1.hasMessageStarted) {
                    lastStartedIndexRef.current = i_0;
                    startPulse(entryPointId, messageId, {
                        onDismiss: ()=>pulseHook_1.dismissMessage(),
                        onClick: ()=>pulseHook_1.handleClickTracking?.()
                    });
                    if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) (0, $gd8AW.endPulses)();
                    break;
                }
            }
        };
        $[44] = entryPointId;
        $[45] = pulseHooks;
        $[46] = skipRefreshPulseStatus;
        $[47] = startPulse;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== entryPointId || $[50] !== pulse1.hasMessageStarted || $[51] !== pulse2.hasMessageStarted || $[52] !== pulse3.hasMessageStarted || $[53] !== pulse4.hasMessageStarted || $[54] !== pulse5.hasMessageStarted || $[55] !== pulseHooks || $[56] !== skipRefreshPulseStatus || $[57] !== startPulse) {
        t8 = [
            skipRefreshPulseStatus,
            entryPointId,
            startPulse,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[49] = entryPointId;
        $[50] = pulse1.hasMessageStarted;
        $[51] = pulse2.hasMessageStarted;
        $[52] = pulse3.hasMessageStarted;
        $[53] = pulse4.hasMessageStarted;
        $[54] = pulse5.hasMessageStarted;
        $[55] = pulseHooks;
        $[56] = skipRefreshPulseStatus;
        $[57] = startPulse;
        $[58] = t8;
    } else t8 = $[58];
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[59] !== isPulseActive || $[60] !== pulseHooks || $[61] !== skipRefreshPulseStatus) {
        t9 = ()=>{
            if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
            const startedIndex = lastStartedIndexRef.current;
            const startedPulseHook = pulseHooks[startedIndex];
            if (!startedPulseHook.hasMessageStarted) {
                hasRequestedRef.current.delete(startedIndex);
                lastStartedIndexRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            }
        };
        $[59] = isPulseActive;
        $[60] = pulseHooks;
        $[61] = skipRefreshPulseStatus;
        $[62] = t9;
    } else t9 = $[62];
    let t10;
    if ($[63] !== isPulseActive || $[64] !== pulse1.hasMessageStarted || $[65] !== pulse2.hasMessageStarted || $[66] !== pulse3.hasMessageStarted || $[67] !== pulse4.hasMessageStarted || $[68] !== pulse5.hasMessageStarted || $[69] !== pulseHooks || $[70] !== skipRefreshPulseStatus) {
        t10 = [
            skipRefreshPulseStatus,
            isPulseActive,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[63] = isPulseActive;
        $[64] = pulse1.hasMessageStarted;
        $[65] = pulse2.hasMessageStarted;
        $[66] = pulse3.hasMessageStarted;
        $[67] = pulse4.hasMessageStarted;
        $[68] = pulse5.hasMessageStarted;
        $[69] = pulseHooks;
        $[70] = skipRefreshPulseStatus;
        $[71] = t10;
    } else t10 = $[71];
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    if ($[72] !== isPulseActive) {
        t11 = {
            isPulseActive: isPulseActive
        };
        $[72] = isPulseActive;
        $[73] = t11;
    } else t11 = $[73];
    return t11;
} : (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $gd8AW.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $42omo.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $42omo.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $42omo.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handleClickTracking,
        pulse2.handleClickTracking,
        pulse3.handleClickTracking,
        pulse4.handleClickTracking,
        pulse5.handleClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook_0 = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook_0.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
            const pulseHook_1 = pulseHooks[i_0];
            const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
            if (pulseHook_1.hasMessageStarted) {
                lastStartedIndexRef.current = i_0;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook_1.dismissMessage(),
                    onClick: ()=>pulseHook_1.handleClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) /**
           * Mark the EP message as "complete" and disable Loom discoverability in localStorage
           * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
           * entirely and never clicks on one while it's pulsing, they'll:
           *
           * - Remain in the TAP audience forever
           * - Continue to check the EP messages every time an entrypoint renders
           *
           * This will technically unlock EP to show other messages, but the pulse is subtle enough that
           * this shouldn't result in poor UX
           */ (0, $gd8AW.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
function $9c43e73b872d5b9c$var$_temp(prev) {
    return prev + 1;
}
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("531iT", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2Yaht = parcelRequire("2Yaht");

const $bddab39ffd1b2325$export$412f97445c5fb31e = (props)=>{
    const $ = (0, $frIzR.c)(4);
    const color = props.color || "var(--ds-icon-subtle, #505258)";
    const label = props.label || "";
    let t0;
    if ($[0] !== color || $[1] !== label || $[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            ...props,
            color: color,
            label: label,
            spacing: "spacious"
        });
        $[0] = color;
        $[1] = label;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["LoomVideoIcon"] = $bddab39ffd1b2325$export$412f97445c5fb31e;

});

parcelRegister("cxQ7E", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1qfLF = parcelRequire("1qfLF");


var $4R3wx = parcelRequire("4R3wx");


var $531iT = parcelRequire("531iT");

const $acb63ca7a29d5cd7$var$buttonSpacerStyles = (0, $ecnYn.xcss)({
    minWidth: '30px'
});
const $acb63ca7a29d5cd7$export$bc169f53ad8d6345 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { isCircle: isCircle, isEnabled: isEnabled } = t0;
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    if (entryPointVariant === "DISABLED") return null;
    else {
        const t1 = isCircle ? "circle" : "default";
        const t2 = !isEnabled;
        let t3;
        if ($[0] !== t1 || $[1] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $acb63ca7a29d5cd7$var$buttonSpacerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                shape: t1,
                icon: (0, $531iT.LoomVideoIcon),
                testId: "page-header-loom-entry-point-loading-icon",
                "data-vc": "loom-button",
                isDisabled: t2,
                label: "Record a Loom video"
            }));
            $[0] = t1;
            $[1] = t2;
            $[2] = t3;
        } else t3 = $[2];
        return t3;
    }
};
module.exports["LoomPageHeaderPlaceholder"] = $acb63ca7a29d5cd7$export$bc169f53ad8d6345;

});

parcelRegister("gtM8p", function(module, exports) {

let $bff4b1493802d7f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bff4b1493802d7f0$var$load("jOdEL"),
    $bff4b1493802d7f0$var$load("Vjtcp")
]).then(()=>parcelRequire('hmdCl'));

});

parcelRegister("6yLoQ", function(module, exports) {

let $4c6aafa456ea42e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c6aafa456ea42e3$var$load("jOdEL"),
    $4c6aafa456ea42e3$var$load("6wr18"),
    $4c6aafa456ea42e3$var$load("eufZR"),
    $4c6aafa456ea42e3$var$load("j8i2J"),
    $4c6aafa456ea42e3$var$load("ffEVr"),
    $4c6aafa456ea42e3$var$load("5Jv0P")
]).then(()=>parcelRequire('3Bted'));

});

parcelRegister("3h4cG", function(module, exports) {

let $2626385ce7a45af7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2626385ce7a45af7$var$load("jOdEL"),
    $2626385ce7a45af7$var$load("lx2XJ")
]).then(()=>parcelRequire('rnQny'));

});

parcelRegister("bvg6Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jmjWc = parcelRequire("jmjWc");


var $io723 = parcelRequire("io723");


var $blsJs = parcelRequire("blsJs");


var $9SsRl = parcelRequire("9SsRl");


var $bl4QJ = parcelRequire("bl4QJ");


const $3be9bfd0a276360e$export$baaf0df5303f8865 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "L5BJl",
    name: "LazyDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("1YNP8"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});

const $3be9bfd0a276360e$export$ab7826e0fbb7edbf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HpEKn",
    name: "WatchDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("1YNP8"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
const $3be9bfd0a276360e$export$a4de2aef32c151a8 = (props)=>{
    (0, $blsJs.useSubmitSSRScriptErrors)('page-watch-button');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3be9bfd0a276360e$export$ab7826e0fbb7edbf, props));
};
$3be9bfd0a276360e$export$a4de2aef32c151a8.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
};
module.exports["LazyDialogWrapperLoader"] = $3be9bfd0a276360e$export$baaf0df5303f8865;
module.exports["WatchDialogWrapperLoader"] = $3be9bfd0a276360e$export$ab7826e0fbb7edbf;
module.exports["WatchDialogWrapper"] = $3be9bfd0a276360e$export$a4de2aef32c151a8;

});

parcelRegister("blsJs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");

const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $42omo.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};
module.exports["useSubmitSSRScriptErrors"] = $7bdb5572ed9c8600$export$290a00987d4ffd42;

});

parcelRegister("9SsRl", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $8cjip = parcelRequire("8cjip");


var $eEA8O = parcelRequire("eEA8O");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("1YNP8", function(module, exports) {

let $17120afca49fcf8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17120afca49fcf8f$var$load("l8YLV"),
    $17120afca49fcf8f$var$load("5dBst"),
    $17120afca49fcf8f$var$load("6wr18"),
    $17120afca49fcf8f$var$load("ffEVr"),
    $17120afca49fcf8f$var$load("7EorR"),
    $17120afca49fcf8f$var$load("cUtrS")
]).then(()=>parcelRequire('9dU2w'));

});

parcelRegister("8HdsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h0mTL = parcelRequire("h0mTL");


var $jIlrR = parcelRequire("jIlrR");


var $lF24E = parcelRequire("lF24E");

const $262f69aacf5ded76$var$noop = ()=>{};
const $262f69aacf5ded76$export$e64f20017ef2874a = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, isCommentButtonSSRd: isCommentButtonSSRd = false })=>{
    const { data: data, error: error } = (0, $lF24E.usePreloadCommentButton)(contentId, isCommentButtonSSRd);
    const contentNode = data?.commentData?.content?.nodes?.[0];
    const isFabricSuported = contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
    const [showCommentButton, setShowCommentButton] = (0, $42omo.useState)(false);
    /* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */ const handleCommentButtonClick = ()=>{
        setShowCommentButton(true);
    };
    /*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/ /* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/ const isDataLoaded = Boolean(data?.commentData && !error);
    if (showCommentButton || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0mTL.CommentButtonLazy), {
        contentId: contentId,
        isDataLoaded: isDataLoaded,
        isFabricPage: isFabricSuported
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        isDisabled: !isDataLoaded && !isCommentButtonSSRd,
        handleCommentButtonClick: isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : $262f69aacf5ded76$var$noop,
        contentId: contentId
    }));
});
module.exports["CommentButtonWrapper"] = $262f69aacf5ded76$export$e64f20017ef2874a;

});

parcelRegister("h0mTL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $jIlrR = parcelRequire("jIlrR");


const $3ed4db9782b8d46b$export$43a94cba75d164d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pHrwQ",
    name: "CommentButtonLazy",
    loader: async ()=>(await (parcelRequire("iuQZU"))).CommentButton,
    loading: ({ isDataLoaded: isDataLoaded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
            isDisabled: !isDataLoaded
        })
});
module.exports["CommentButtonLazy"] = $3ed4db9782b8d46b$export$43a94cba75d164d3;

});

parcelRegister("jIlrR", function(module, exports) {
/* CommentButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $21K7m = parcelRequire("21K7m");


var $eEA8O = parcelRequire("eEA8O");


var $1yB28 = parcelRequire("1yB28");


var $3gadb = parcelRequire("3gadb");


var $gczDe = parcelRequire("gczDe");


var $7aw3q = parcelRequire("7aw3q");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $e0f29c26904b1b78$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$var$CommentCountWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$export$400dbe00d66d91c = ({ isDisabled: isDisabled = true, handleCommentButtonClick: handleCommentButtonClick = ()=>{}, style: style, onRender: onRender })=>{
    (0, $42omo.useEffect)(()=>{
        if (!isDisabled) onRender && onRender();
    }, [
        isDisabled,
        onRender
    ]);
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT)
    });
    const isEmbeddedCommentsEnabled = (0, $7aw3q.useEmbeddedComments)();
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!isEmbeddedCommentsEnabled) return null;
    else if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        testId: "comment-button-placeholder",
        "data-test-id": "comment-button-placeholder",
        appearance: "subtle",
        "aria-label": formatMessage({
            id: "comment-button.icon.label",
            defaultMessage: "Comment button placeholder"
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: "",
            spacing: "spacious"
        }),
        isDisabled: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: style
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: (e)=>{
            if (document.getElementById('renderer-comments-sidebar')) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            } else handleCommentButtonClick(e);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "comment-button.tooltip",
            defaultMessage: "Show comments"
        }),
        shortcut: commentShortcutStrings,
        hideTooltipOnClick: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$var$CommentCountWrapper, {
        onClick: handleCommentButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        "data-id": "comment-button-placeholder",
        "data-cy": "comment-button-placeholder",
        testId: "comment-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: formatMessage({
                id: "comment-button.icon.label",
                defaultMessage: "Show comments"
            }),
            spacing: "spacious"
        })),
        isDisabled: isDisabled,
        style: style
    }))));
};
module.exports["CommentButtonPlaceholder"] = $e0f29c26904b1b78$export$400dbe00d66d91c;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('platform_editor_ai_add_embed_streaming');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("iuQZU", function(module, exports) {

let $d77423890e569a3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d77423890e569a3c$var$load("8LtYa"),
    $d77423890e569a3c$var$load("iGCP8"),
    $d77423890e569a3c$var$load("i1fe2")
]).then(()=>parcelRequire('32Ecy'));

});

parcelRegister("lF24E", function(module, exports) {

var $6nmm4 = parcelRequire("6nmm4");


var $jMyy4 = parcelRequire("jMyy4");

const $d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery = (0, $6nmm4.default);
const $d0986d2d4a7f2d28$export$d1f3401b494de415 = (contentId, isCommentButtonSSRd)=>{
    const { data: commentData, error: commentError } = (0, $jMyy4.useQueryInterop)($d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery, {
        fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
        variables: {
            pageId: contentId
        }
    });
    return {
        data: {
            commentData: commentData
        },
        error: commentError
    };
};
module.exports["usePreloadCommentButton"] = $d0986d2d4a7f2d28$export$d1f3401b494de415;

});

parcelRegister("6nmm4", function(module, exports) {
/**
 * @generated SignedSource<<faa1cdaa6cd8ca161ff40125fc73e5fb>>
 * @relayHash 9c0afe40300e5013e32bbea6173aea1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5
const $31e2294f16992ac7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "count"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "editor"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"editor\")"
                    },
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                "kind": "LinkedField",
                                "name": "frontend",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fabricEditorSupported"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9c0afe40300e5013e32bbea6173aea1d",
            "id": "06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5",
            "metadata": {},
            "name": "usePreloadCommentButtonQuery",
            "operationKind": "query",
            "text": "query usePreloadCommentButtonQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ALL){count,nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}}}},content(id:$pageId){nodes{id,properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$31e2294f16992ac7$var$node.hash = "213bd75259a759693c19bec62abadf60";
var $31e2294f16992ac7$export$2e2bcd8739ae039 = $31e2294f16992ac7$var$node;
module.exports["default"] = $31e2294f16992ac7$export$2e2bcd8739ae039;

});

parcelRegister("hAnPj", function(module, exports) {
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => (parcelRequire("lQDcS")).RestrictionsDialogMenuPropsProvider);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $SAFLR = parcelRequire("SAFLR");


var $lEXFh = parcelRequire("lEXFh");


var $lQDcS = parcelRequire("lQDcS");


const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("jaWw7"))).RestrictionsDialogMountPoint
});
module.exports["LazyRestrictionsDialogMountPoint"] = $bb619eb96b539cb1$export$8c358bcfa2c0ec3f;

});

parcelRegister("SAFLR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $lEXFh = parcelRequire("lEXFh");

const $84211cd137cf57b0$export$e8086e85d5f7d830 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t0;
    if ($[0] !== hasAccess || $[1] !== props) {
        t0 = hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            key: "restriction-button-start",
            id: props.contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null;
        $[0] = hasAccess;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
            key: "restrictions-dialog-trigger"
        }, t0);
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};
module.exports["RestrictionsDialogTriggerWrapper"] = $84211cd137cf57b0$export$e8086e85d5f7d830;

});

parcelRegister("lEXFh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $io723 = parcelRequire("io723");


var $b27bJ = parcelRequire("b27bJ");


var $euL71 = parcelRequire("euL71");


var $5u6LZ = parcelRequire("5u6LZ");


var $8RR7m = parcelRequire("8RR7m");


var $9wGTI = parcelRequire("9wGTI");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $bVAxT = parcelRequire("bVAxT");


var $14SPd = parcelRequire("14SPd");


var $cSVAY = parcelRequire("cSVAY");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");

const $0b24ce56d1d6b617$var$styles = {
    buttonContainer: "_1e0c1o8l _s7n4jp4b"
};
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(36);
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || "";
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            grantAccessClicked: false,
            hasAutoOpenedRestrictionDialog: false,
            showFreeRestrictionDialog: false
        };
        $[0] = t0;
    } else t0 = $[0];
    const [state, setState] = (0, $42omo.useState)(t0);
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[1] !== contentId || $[2] !== contentSubType || $[3] !== contentType || $[4] !== edition || $[5] !== experienceTracker || $[6] !== useAnalyticsEventsHook) {
        t1 = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: "restrictionsDialogButton",
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    contentId: contentId
                });
        $[1] = contentId;
        $[2] = contentSubType;
        $[3] = contentType;
        $[4] = edition;
        $[5] = experienceTracker;
        $[6] = useAnalyticsEventsHook;
        $[7] = t1;
    } else t1 = $[7];
    const makeHandleOpen = t1;
    const getParentData = $0b24ce56d1d6b617$var$_temp;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp2);
        };
        $[8] = t2;
    } else t2 = $[8];
    const handleGrantAccessActionClicked = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp3);
        };
        $[9] = t3;
    } else t3 = $[9];
    const handleFreeEditionPadlockClicked = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp4);
        };
        $[10] = t4;
    } else t4 = $[10];
    const onFreeDialogClosed = t4;
    let t5;
    if ($[11] !== contentId || $[12] !== makeHandleOpen || $[13] !== props || $[14] !== state) {
        t5 = (dialogStateContainer_0, shouldShowDialog)=>{
            const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
            const shouldSSRViewPageFreeEditionButton = triggeredFrom === "fromView";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, (t6)=>{
                const { loading: loading, error: error, restrictions: restrictions_0 } = t6;
                if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
                const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
                const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
                const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
                const isChildPage = immediateParentPageIndex > 0;
                if (contentHasRestrictions) {
                    if (isChildPage && contentHasInheritedRestrictionsOnly) {
                        const parentData = getParentData(restrictions_0);
                        return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRRendered: true,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        }));
                    }
                    if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                        makeHandleOpen(dialogStateContainer_0)();
                        setState($0b24ce56d1d6b617$var$_temp5);
                    }
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        resetDialogState: ()=>dialogStateContainer_0.initState(),
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    });
                }
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                }));
            });
        };
        $[11] = contentId;
        $[12] = makeHandleOpen;
        $[13] = props;
        $[14] = state;
        $[15] = t5;
    } else t5 = $[15];
    const renderFreeEditionDialog = t5;
    let t6;
    if ($[16] !== contentId || $[17] !== makeHandleOpen || $[18] !== props) {
        t6 = (dialogStateContainer_1)=>{
            const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
            if (triggeredFrom_0 && triggeredFrom_0 === "fromView") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                resetDialogState: ()=>dialogStateContainer_1.initState(),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
        };
        $[16] = contentId;
        $[17] = makeHandleOpen;
        $[18] = props;
        $[19] = t6;
    } else t6 = $[19];
    const renderRestrictionsButton = t6;
    let t7;
    if ($[20] !== contentId || $[21] !== makeHandleOpen || $[22] !== props || $[23] !== renderRestrictionsButton || $[24] !== state) {
        t7 = (getQueryParams, dialogStateContainer_2, shouldShowDialog_0)=>{
            const { isDisabled: isDisabled_1, triggeredFrom: triggeredFrom_1 } = props;
            const queryParams = getQueryParams();
            const shouldSSRGrantAccessRestrictions = triggeredFrom_1 === "fromView";
            if (shouldShowDialog_0 && !state.grantAccessClicked) {
                const accountId = (0, $c3Qwv.getSingleParam)(queryParams, "accountId");
                const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, "username") || "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u6LZ.GrantAccessDialogLoader), {
                    isOpen: true,
                    contentId: contentId,
                    onActionClick: handleGrantAccessActionClicked,
                    accessType: (0, $c3Qwv.getSingleParam)(queryParams, "accessType") === "edit" ? "edit" : "view",
                    accountId: accountId || legacyUsername,
                    shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                    buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
                }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled_1,
                    resetDialogState: ()=>dialogStateContainer_2.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_2),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "default grant access",
                    triggeredFrom: triggeredFrom_1
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled_1,
                    onClick: makeHandleOpen(dialogStateContainer_2),
                    restrictionsButtonSSRLocation: "default grant access",
                    triggeredFrom: triggeredFrom_1
                }));
            }
            return renderRestrictionsButton(dialogStateContainer_2);
        };
        $[20] = contentId;
        $[21] = makeHandleOpen;
        $[22] = props;
        $[23] = renderRestrictionsButton;
        $[24] = state;
        $[25] = t7;
    } else t7 = $[25];
    const renderGrantAccessDialogAndButton = t7;
    let t8;
    if ($[26] !== contentId || $[27] !== renderRestrictionsButton) {
        t8 = (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderRestrictionsButton(dialogStateContainer_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
                contentId: contentId
            }));
        $[26] = contentId;
        $[27] = renderRestrictionsButton;
        $[28] = t8;
    } else t8 = $[28];
    const renderGrantAccessFlagAndButton = t8;
    let t9;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== contentId || $[31] !== edition || $[32] !== renderFreeEditionDialog || $[33] !== renderGrantAccessDialogAndButton || $[34] !== renderGrantAccessFlagAndButton) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t9
        }, (dialogStateContainer_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
                isCustomStart: true,
                key: `start-${contentId}`,
                metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
            }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, (t11)=>{
                const { getQueryParams: getQueryParams_0 } = t11;
                const { accountId: accountId_0, grantAccess: grantAccess, username: username } = getQueryParams_0();
                const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId_0 || username);
                const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)("confluence_frontend_grant_access_flag") ? renderGrantAccessFlagAndButton(dialogStateContainer_4) : renderGrantAccessDialogAndButton(getQueryParams_0, dialogStateContainer_4, shouldShowGrantAccessDialog);
                return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_4, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
        $[30] = contentId;
        $[31] = edition;
        $[32] = renderFreeEditionDialog;
        $[33] = renderGrantAccessDialogAndButton;
        $[34] = renderGrantAccessFlagAndButton;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
} : (props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $42omo.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleGrantAccessActionClicked = ()=>{
        setState((state_0)=>({
                ...state_0,
                grantAccessClicked: true
            }));
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state_1)=>({
                ...state_1,
                showFreeRestrictionDialog: true
            }));
    };
    const onFreeDialogClosed = ()=>{
        setState((state_2)=>({
                ...state_2,
                showFreeRestrictionDialog: false
            }));
    };
    const renderFreeEditionDialog = (dialogStateContainer_0, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props; // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions_0 })=>{
            if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
            const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0; // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions_0);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer_0)();
                    setState((state_3)=>({
                            ...state_3,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                } // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    resetDialogState: ()=>dialogStateContainer_0.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer_1)=>{
        const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
        if (triggeredFrom_0 && triggeredFrom_0 === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            resetDialogState: ()=>dialogStateContainer_1.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
    }; //  accessType=view&grantAccess=true&username=rwu&userFullName=Robin+Wu
    const renderGrantAccessDialogAndButton = (getQueryParams, dialogStateContainer_2, shouldShowDialog_0)=>{
        const { isDisabled: isDisabled_1, triggeredFrom: triggeredFrom_1 } = props;
        const queryParams = getQueryParams();
        const shouldSSRGrantAccessRestrictions = triggeredFrom_1 === 'fromView';
        if (shouldShowDialog_0 && !state.grantAccessClicked) {
            const accountId = (0, $c3Qwv.getSingleParam)(queryParams, 'accountId'); // TODO(brizvash): non-gdpr params, remove when GDPR is on
            // "username" in the URL is actually the accountId in legacy circumstances
            // which we will use to fetch username from backend
            const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, 'username') || ''; // render grant access requested user
            // preloading the queries means that isOpen wil always be true in SSR.
            // here, we set isOpen to false during SSR so the modal doesn't open on SSR (since
            // there is no handling for the inner modal clicks)
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u6LZ.GrantAccessDialogLoader // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isOpen: true,
                contentId: contentId,
                onActionClick: handleGrantAccessActionClicked,
                accessType: (0, $c3Qwv.getSingleParam)(queryParams, 'accessType') === 'edit' ? 'edit' : 'view',
                accountId: accountId || legacyUsername,
                shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
            }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_1,
                resetDialogState: ()=>dialogStateContainer_2.initState(),
                onClick: makeHandleOpen(dialogStateContainer_2),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom_1
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_1,
                onClick: makeHandleOpen(dialogStateContainer_2),
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom_1
            }));
        }
        return renderRestrictionsButton(dialogStateContainer_2);
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderRestrictionsButton(dialogStateContainer_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams_0 })=>{
            const { accountId: accountId_0, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams_0();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId_0 || username);
            const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)('confluence_frontend_grant_access_flag') ? renderGrantAccessFlagAndButton(dialogStateContainer_4) : renderGrantAccessDialogAndButton(getQueryParams_0, dialogStateContainer_4, shouldShowGrantAccessDialog);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_4, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    }); //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}
function $0b24ce56d1d6b617$var$_temp(restrictions) {
    const ancestors = restrictions?.ancestors || [];
    for(let i = ancestors.length - 1; i >= 0; i--){
        if (ancestors[i].hasRestrictions) return ancestors[i];
    }
}
function $0b24ce56d1d6b617$var$_temp2(state_0) {
    return {
        ...state_0,
        grantAccessClicked: true
    };
}
function $0b24ce56d1d6b617$var$_temp3(state_1) {
    return {
        ...state_1,
        showFreeRestrictionDialog: true
    };
}
function $0b24ce56d1d6b617$var$_temp4(state_2) {
    return {
        ...state_2,
        showFreeRestrictionDialog: false
    };
}
function $0b24ce56d1d6b617$var$_temp5(state_3) {
    return {
        ...state_3,
        hasAutoOpenedRestrictionDialog: true
    };
}
module.exports["RestrictionsDialogTrigger"] = $0b24ce56d1d6b617$export$4a978df01c3bf89e;
module.exports["startRestrictionsDialogExperience"] = $0b24ce56d1d6b617$export$59974e42a4613c7;

});

parcelRegister("b27bJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $306758770d5ee79f$export$4556cd06b2dec862 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PlyJG",
    name: "ChangeEditionInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("cf1NT"))).ChangeEditionInlineDialog
});

const $306758770d5ee79f$export$5902d4a19951b5c3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4GH4a",
    name: "ChangeEditionInlineDialogPaintLoader",
    loader: async ()=>(await (parcelRequire("cf1NT"))).ChangeEditionInlineDialog
});
module.exports["ChangeEditionInlineDialogLoader"] = $306758770d5ee79f$export$4556cd06b2dec862;
module.exports["ChangeEditionInlineDialogPaintLoader"] = $306758770d5ee79f$export$5902d4a19951b5c3;

});

parcelRegister("cf1NT", function(module, exports) {

let $8e9848ecf5f94466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e9848ecf5f94466$var$load("cEqm7"),
    $8e9848ecf5f94466$var$load("6XCf4"),
    $8e9848ecf5f94466$var$load("5pvpJ"),
    $8e9848ecf5f94466$var$load("1qlDN"),
    $8e9848ecf5f94466$var$load("1yVM6"),
    $8e9848ecf5f94466$var$load("1zoBu")
]).then(()=>parcelRequire('4QNfT'));

});

parcelRegister("cSVAY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");


const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("aJxQF"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("aJxQF"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});
module.exports["RestrictionsButtonLoaderPaint"] = $c09757da0c891efc$export$758fc7bfe6cba448;
module.exports["RestrictionsButtonLoaderAfterPaint"] = $c09757da0c891efc$export$92f59ae572209281;

});

parcelRegister("eE3dj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $cb1652ec96a3881c$export$f7c9f842c83767d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsButtonPlaceholder() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "restrictions-button-placeholder",
            "data-test-id": "restrictions-button-placeholder",
            style: {
                width: 32,
                height: 32
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RestrictionsButtonPlaceholder() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
};
module.exports["RestrictionsButtonPlaceholder"] = $cb1652ec96a3881c$export$f7c9f842c83767d4;

});

parcelRegister("fkOJz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eE3dj = parcelRequire("eE3dj");

const $560660f3777cb1ae$export$3375d726052961a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};
module.exports["RestrictionsButtonLoading"] = $560660f3777cb1ae$export$3375d726052961a6;

});

parcelRegister("aJxQF", function(module, exports) {

let $7d085cf07760cccc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d085cf07760cccc$var$load("e7wVW"),
    $7d085cf07760cccc$var$load("l8YLV"),
    $7d085cf07760cccc$var$load("e7ZUf"),
    $7d085cf07760cccc$var$load("gL8bn"),
    $7d085cf07760cccc$var$load("6wr18"),
    $7d085cf07760cccc$var$load("ffEVr"),
    $7d085cf07760cccc$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});

parcelRegister("lQDcS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $bVAxT = parcelRequire("bVAxT");


var $bQm3c = parcelRequire("bQm3c");


var $lEXFh = parcelRequire("lEXFh");

const $3b0d5969bb769929$var$label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
    id: "restrictions.dialog.link.text",
    defaultMessage: "Restrictions"
});
const $3b0d5969bb769929$export$b0eaba4fdbbe6e8b = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsDialogMenuPropsProvider(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children, contentId: contentId } = t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== children || $[1] !== contentId || $[2] !== edition || $[3] !== experienceTracker || $[4] !== useAnalyticsEventsHook) {
        t1 = children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $bVAxT.RestrictionsDialogStateContainer)
            ]
        }, (dialogStateContainer)=>children({
                id: "bm-restrictions-link",
                label: $3b0d5969bb769929$var$label,
                onClick () {
                    (0, $lEXFh.startRestrictionsDialogExperience)({
                        ...useAnalyticsEventsHook,
                        actionSubjectId: "restrictionsDialogLink",
                        dialogStateContainer: dialogStateContainer,
                        edition: edition,
                        experienceTracker: experienceTracker,
                        triggeredFrom: "actionsMenu",
                        contentId: contentId
                    });
                }
            })) : null;
        $[0] = children;
        $[1] = contentId;
        $[2] = edition;
        $[3] = experienceTracker;
        $[4] = useAnalyticsEventsHook;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : function RestrictionsDialogMenuPropsProvider({ children: children, contentId: contentId }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Note: this is used for balance A/B testing user cohorts, it will be replaced with real feature flag later.
    return children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>children({
            id: 'bm-restrictions-link',
            label: $3b0d5969bb769929$var$label,
            onClick () {
                (0, $lEXFh.startRestrictionsDialogExperience)({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: 'restrictionsDialogLink',
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    triggeredFrom: 'actionsMenu',
                    contentId: contentId
                });
            }
        })) : null;
};
module.exports["RestrictionsDialogMenuPropsProvider"] = $3b0d5969bb769929$export$b0eaba4fdbbe6e8b;

});

parcelRegister("jaWw7", function(module, exports) {

let $df5c57bfeabf1dc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5c57bfeabf1dc9$var$load("fno6o").then(()=>parcelRequire('ca7si'));

});

parcelRegister("2pIlF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $luv00 = parcelRequire("luv00");


var $lT8a1 = parcelRequire("lT8a1");

const $4c5c52253c9aa054$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $4c5c52253c9aa054$var$SkeletonGlyph = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "icon-skeleton",
            xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4c5c52253c9aa054$export$4d89be89896b480 = ()=>{
    const $ = (0, $frIzR.c)(3);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button-placeholder",
            icon: $4c5c52253c9aa054$var$SkeletonGlyph,
            label: "",
            isDisabled: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== ssrPlaceholderIdProp) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", ssrPlaceholderIdProp, t0);
        $[1] = ssrPlaceholderIdProp;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ShareRestrictAndCopyButtonPlaceholder"] = $4c5c52253c9aa054$export$4d89be89896b480;

});

parcelRegister("8Cofr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $jBnsv = parcelRequire("jBnsv");


var $frvUM = parcelRequire("frvUM");


var $iAOfI = parcelRequire("iAOfI");

const $6464ae7cd7e3f432$export$fa1acf2328e09e6c = [
    (0, $jBnsv.WATCH_BUTTON_KEY),
    (0, $jBnsv.PAGE_FAVOURITE_KEY),
    (0, $jBnsv.PAGE_UNFAVOURITE_KEY),
    (0, $jBnsv.EDIT_BUTTON_PAGE_KEY),
    (0, $jBnsv.EDIT_BUTTON_BLOGPOST_KEY),
    (0, $jBnsv.INVITE_TO_EDIT_KEY)
];
const $6464ae7cd7e3f432$var$displayInlineBlock = {
    display: 'inline-block'
};
const $6464ae7cd7e3f432$var$displayFlex = {
    display: 'flex',
    alignItems: 'center'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6464ae7cd7e3f432$var$FlexNavigationContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c1txw _2lx2vrvc _1n261q9c _1tke1ex1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable react/prop-types */ 
class $6464ae7cd7e3f432$export$60c40240daccf47b extends (0, $42omo.PureComponent) {
    render() {
        const { spaceKey: spaceKey, contentId: contentId, versionOverride: versionOverride, showEdit: showEdit = true, isFabricPage: isFabricPage, allowedContentToolsItems: allowedContentToolsItems, children: children, contentType: contentType, isExternalCollaborator: isExternalCollaborator, isContentToolsForcedOpen: isContentToolsForcedOpen, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-id": "gpb-common",
            "data-testid": "gpb-common",
            "data-vc": "grouped-page-buttons-common"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6464ae7cd7e3f432$var$FlexNavigationContainer, {
            "data-vc": "grouped-page-buttons-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: $6464ae7cd7e3f432$var$displayInlineBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-test-id": "content-buttons",
            style: $6464ae7cd7e3f432$var$displayFlex
        }, showEdit === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iAOfI.EditContentButton), {
            key: "edit-content-button",
            contentId: contentId
        }) : null, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $frvUM.ContentTools), {
            spaceKey: spaceKey,
            contentId: contentId,
            version: versionOverride,
            isFabricPage: isFabricPage,
            allowedContentToolsItems: allowedContentToolsItems,
            contentType: contentType,
            isExternalCollaborator: isExternalCollaborator,
            isContentToolsForcedOpen: isContentToolsForcedOpen,
            setIsContentToolsForcedOpen: setIsContentToolsForcedOpen
        })));
    }
}
$6464ae7cd7e3f432$export$60c40240daccf47b.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    showEdit: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isFabricPage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    allowedContentToolsItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["FILTERED_WEB_ITEM_KEYS"] = $6464ae7cd7e3f432$export$fa1acf2328e09e6c;
module.exports["GroupedPageButtonsCommon"] = $6464ae7cd7e3f432$export$60c40240daccf47b;

});

parcelRegister("frvUM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3cAEv",
    name: "ContentTools",
    loader: async ()=>(await (parcelRequire("7QJTs"))).ContentTools
});
module.exports["ContentTools"] = $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4;

});

parcelRegister("7QJTs", function(module, exports) {

let $5b70fd339a241740$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b70fd339a241740$var$load("6Xh6J"),
    $5b70fd339a241740$var$load("dVJPu"),
    $5b70fd339a241740$var$load("2vQEy"),
    $5b70fd339a241740$var$load("i8eeg"),
    $5b70fd339a241740$var$load("iFdoJ"),
    $5b70fd339a241740$var$load("6wr18"),
    $5b70fd339a241740$var$load("6QGSA"),
    $5b70fd339a241740$var$load("c831e"),
    $5b70fd339a241740$var$load("kLojH"),
    $5b70fd339a241740$var$load("h4Nf7"),
    $5b70fd339a241740$var$load("ivbae"),
    $5b70fd339a241740$var$load("4t77a"),
    $5b70fd339a241740$var$load("6jGZ7"),
    $5b70fd339a241740$var$load("cEqm7"),
    $5b70fd339a241740$var$load("e7wVW"),
    $5b70fd339a241740$var$load("l8YLV"),
    $5b70fd339a241740$var$load("6XCf4"),
    $5b70fd339a241740$var$load("e7ZUf"),
    $5b70fd339a241740$var$load("gL8bn"),
    $5b70fd339a241740$var$load("5pvpJ"),
    $5b70fd339a241740$var$load("djHM5"),
    $5b70fd339a241740$var$load("eJQji"),
    $5b70fd339a241740$var$load("1qlDN"),
    $5b70fd339a241740$var$load("1yVM6"),
    $5b70fd339a241740$var$load("dRpV3"),
    $5b70fd339a241740$var$load("ffEVr"),
    $5b70fd339a241740$var$load("5dBst"),
    $5b70fd339a241740$var$load("9jjvO"),
    $5b70fd339a241740$var$load("cpQv0"),
    $5b70fd339a241740$var$load("bzc8Q"),
    $5b70fd339a241740$var$load("kyfJT"),
    $5b70fd339a241740$var$load("Wowvf"),
    $5b70fd339a241740$var$load("4Nzvy"),
    $5b70fd339a241740$var$load("7EorR"),
    $5b70fd339a241740$var$load("9qfB8"),
    $5b70fd339a241740$var$load("loqJg"),
    $5b70fd339a241740$var$load("hhss7"),
    $5b70fd339a241740$var$load("hWs86")
]).then(()=>parcelRequire('bTUBB'));

});

parcelRegister("l0bby", function(module, exports) {

let $f4a2463ad32749e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4a2463ad32749e5$var$load("5odbj"),
    $f4a2463ad32749e5$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("bX4Zr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2FsQH = parcelRequire("2FsQH");


var $7zgzO = parcelRequire("7zgzO");

const $5437b70689f01310$var$useUnload = (fn)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    let t1;
    if ($[0] !== fn) {
        t0 = ()=>{
            window.addEventListener("beforeunload", fn);
            return ()=>{
                window.removeEventListener("beforeunload", fn);
            };
        };
        t1 = [
            fn
        ];
        $[0] = fn;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
};
function $5437b70689f01310$export$e38025aebea82d38(contentId, storageKeySuffix) {
    const $ = (0, $frIzR.c)(7);
    const { getHash: getHash } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const hashRef = (0, $42omo.useRef)(getHash);
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== storageKeySuffix) {
        t0 = ()=>{
            (0, $2FsQH.restoreScrollPositionIfNeeded)({
                contentId: contentId,
                isInViewPage: true,
                contentReadyState: 1,
                docObject: document,
                winObject: window,
                hash: hashRef.current(),
                storageKeySuffix: storageKeySuffix
            });
        };
        t1 = [
            contentId,
            storageKeySuffix
        ];
        $[0] = contentId;
        $[1] = storageKeySuffix;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] !== contentId || $[5] !== storageKeySuffix) {
        t2 = ()=>{
            (0, $2FsQH.persistRelativeScrollPosition)({
                contentId: contentId,
                isInViewPage: true,
                docObject: document,
                winObject: window,
                storageKeySuffix: storageKeySuffix
            });
        };
        $[4] = contentId;
        $[5] = storageKeySuffix;
        $[6] = t2;
    } else t2 = $[6];
    $5437b70689f01310$var$useUnload(t2);
}
module.exports["useViewPagePersistentScrollPosition"] = $5437b70689f01310$export$e38025aebea82d38;

});

parcelRegister("2FsQH", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $5ZqQS = parcelRequire("5ZqQS");


var $id4ij = parcelRequire("id4ij");

const $0318c9ad181ada0b$export$b2593172c1a4a4fd = (els)=>{
    const result = [];
    // use `Array.some` to stop the loop sooner.
    if (els) {
        for(let index = 0; index < els.length; index++)if ((0, $id4ij.isPartOfElementStillInViewPort)(els[index])) result.push({
            targetElementIndex: index,
            visibleBlockEl: els[index]
        });
    }
    return result;
};
const $0318c9ad181ada0b$export$9639f4e44d5443af = (els)=>{
    const visibleEls = $0318c9ad181ada0b$export$b2593172c1a4a4fd(els);
    let elHasTopVisible = null;
    const foundVisible = visibleEls.some((item)=>{
        if ((0, $id4ij.isTopOfElementStillInViewPort)(item.visibleBlockEl)) {
            elHasTopVisible = item;
            return true;
        }
        return false;
    });
    // in the worst case, return first element which is still in viewport
    if (!foundVisible && visibleEls.length > 0) return visibleEls[0];
    // a default value which indicates that no element is in viewport
    const noElementValue = {
        targetElementIndex: -1,
        visibleBlockEl: null
    };
    return elHasTopVisible || noElementValue;
};
const $0318c9ad181ada0b$export$f506f531b96875f7 = (columns)=>{
    const result = {
        targetElementIndexInColumn: -1,
        columnIndex: -1,
        // visible block element in target column
        visibleBlockEl: null
    };
    // usage of .some iterator without using its return value is considered a bug.
    for(let index = 0; index < columns.length; index++){
        const { visibleBlockEl: visibleBlockEl, targetElementIndex: targetElementIndex } = $0318c9ad181ada0b$export$9639f4e44d5443af(columns[index].children);
        if (visibleBlockEl) {
            result.columnIndex = index;
            result.targetElementIndexInColumn = targetElementIndex;
            result.visibleBlockEl = visibleBlockEl;
            break;
        }
    }
    return result;
};
const $0318c9ad181ada0b$export$7256c638fbf51d15 = (elContainer)=>{
    if (!elContainer) return false;
    const firstChildEl = elContainer.children[0];
    return firstChildEl && firstChildEl.classList.contains('contentLayout2');
};
function $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(elContainer, scrollY) {
    if (scrollY === 0 || elContainer === null) return null;
    const viewPositionData = {
        // index of block element in page, we call it as target element
        targetElementIndex: -1,
        // number of pixels from top of target element to current scroll position
        offsetBetweenTargetAndCurrentScroll: 0,
        // in case page has column layout, we need to save extra info.
        columnLayoutPosition: {
            columnIndex: -1,
            rowIndex: -1
        }
    };
    if (!$0318c9ad181ada0b$export$7256c638fbf51d15(elContainer)) {
        // easy in case page does not have column layout
        const { targetElementIndex: targetElementIndex, visibleBlockEl: visibleBlockEl } = $0318c9ad181ada0b$export$9639f4e44d5443af(elContainer.children);
        if (visibleBlockEl) {
            viewPositionData.targetElementIndex = targetElementIndex;
            viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockEl);
            // don't need column layout data
            delete viewPositionData.columnLayoutPosition;
        }
    } else {
        // page has column layout so page content starts from first element
        const startPageContent = elContainer.children[0];
        const rows = startPageContent.children;
        // find visible row.
        const { targetElementIndex: rowIndex, visibleBlockEl: visibleRow } = $0318c9ad181ada0b$export$9639f4e44d5443af(rows);
        if (visibleRow && visibleRow.getElementsByClassName) {
            const columns = visibleRow.getElementsByClassName('innerCell');
            const { columnIndex: columnIndex, targetElementIndexInColumn: targetElementIndexInColumn, visibleBlockEl: visibleBlockInColumn } = $0318c9ad181ada0b$export$f506f531b96875f7(columns);
            if (visibleBlockInColumn) {
                viewPositionData.targetElementIndex = targetElementIndexInColumn;
                viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockInColumn);
                viewPositionData.columnLayoutPosition = {
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                };
            }
        }
    }
    return viewPositionData.targetElementIndex !== -1 ? viewPositionData : null;
}
const $0318c9ad181ada0b$export$c3e0418bbdcd04e9 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, docObject: docObject = document, winObject: winObject = window, storageKeySuffix: storageKeySuffix = '' } = options;
    let mainContentEl;
    if (isInViewPage) // in view page
    mainContentEl = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // in edit page
    mainContentEl = docObject.body;
    const scrollPosition = $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(mainContentEl, winObject.pageYOffset);
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    if (scrollPosition) {
        // add extra information so that when we do restoring, the data is safer
        scrollPosition.contentId = contentId;
        scrollPosition.isInViewPage = isInViewPage;
        (0, $17wUi.confluenceSessionStorageInstance).setItem(persistScrollKey, JSON.stringify(scrollPosition));
    } else {
        // when the scroll position is at the very top (default)
        // the scrollPosition is null, and we must check if there is a persisted value to avoid
        // the page from jumping
        const storedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
        if (storedPosition) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
};
const $0318c9ad181ada0b$export$a9f5dc6d645cb9a8 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, contentReadyState: contentReadyState = 0, docObject: docObject = document, winObject: winObject = window, hash: hash, storageKeySuffix: storageKeySuffix = '' } = options;
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    let savedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
    try {
        savedPosition = JSON.parse(savedPosition);
        if (hash) {
            const decodeHash = decodeURIComponent(hash);
            const el = docObject.getElementById(decodeHash);
            const scrollPosition = el?.getBoundingClientRect().top;
            scrollPosition && winObject.scrollTo({
                top: scrollPosition
            });
        }
    } catch (error) {
        // could not parse the savedPosition or
        // anchor is invalid, may contain UTF-8 encoding of emoji which does not nice map back to the querySelector
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
    } finally{
        // removing the persisted scroll position here would cause the scroll position to jump
        // since this function should get called when content is and is not ready during SSR to SPA.
        // ideally we will use local storage values on SSR
        // however, when the content is READY (1) there is no need to persist the position
        if (contentReadyState === 1) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
    if (hash || // hash exists in the url, window already scrolled to the element in view
    !savedPosition || // does not match contentId so this data is invalid
    savedPosition.contentId !== contentId) return;
    let contentWrapper;
    if (isInViewPage) contentWrapper = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // inside editor iframe, content starts from body tag
    contentWrapper = docObject.body;
    if (!contentWrapper || !contentWrapper.children[0]) return;
    const { columnLayoutPosition: columnLayoutPosition } = savedPosition;
    let targetElement;
    if (columnLayoutPosition) {
        // page have layout
        const startEditorContent = contentWrapper.children[0];
        const targetRow = startEditorContent.children[columnLayoutPosition.rowIndex];
        const columns = targetRow?.getElementsByClassName('innerCell');
        const targetColumn = columns?.[columnLayoutPosition.columnIndex];
        targetElement = targetColumn && targetColumn?.children?.[savedPosition.targetElementIndex];
    } else // page does not have layout
    targetElement = contentWrapper.children[savedPosition.targetElementIndex];
    if (targetElement) {
        const topOffset = (0, $id4ij.getElementTop)(targetElement);
        const offset = savedPosition.offsetBetweenTargetAndCurrentScroll;
        let newPosition = topOffset + offset;
        // start scrolling to avoid jumping to the top of the page.
        if (isInViewPage) {
            const maxScrollHeight = docObject?.querySelector?.('#main-content')?.clientHeight || 0;
            newPosition = Math.min(maxScrollHeight, newPosition);
        }
        winObject.scrollTo(0, newPosition);
    }
};
module.exports["persistRelativeScrollPosition"] = $0318c9ad181ada0b$export$c3e0418bbdcd04e9;
module.exports["restoreScrollPositionIfNeeded"] = $0318c9ad181ada0b$export$a9f5dc6d645cb9a8;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("gsWjA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $5q601 = parcelRequire("5q601");

var $1UCmC = parcelRequire("1UCmC");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $7d41Y = parcelRequire("7d41Y");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $dpv0X = parcelRequire("dpv0X");


var $5YLPl = parcelRequire("5YLPl");


var $9SsRl = parcelRequire("9SsRl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'fy21-legacy-fmp',
            endMark: 'fy21-legacy-fmp'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        },
        {
            key: 'fy21-legacy-tti',
            endMark: 'fy21-legacy-tti'
        },
        {
            key: 'fy23-legacy-tti',
            endMark: 'fy23-legacy-tti'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isAnonymous: isAnonymous, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    if (!isAnonymous) // Note: the edit button metric is not currently tracked because there is no
    // guarantee that segment will fire even for authenticated users
    {
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $7d41Y.FAVOURITE_BUTTON_METRIC), (0, $9SsRl.WATCH_BUTTON_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};
const $a99ff50c139ee598$export$acf5746d268ae4ee = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { contentId: contentId, isLite: isLite, customConfig: customConfig } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $42omo.useRef)();
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== customConfig?.expectedPageLoadSegments || $[2] !== customConfig?.fmpUntilStopTimeMetrics || $[3] !== customConfig?.pageLoadKey || $[4] !== isEmbeddedConfluence || $[5] !== isLite || $[6] !== sendMetrics || $[7] !== userId) {
        t1 = ()=>{
            const _isInitialLoad = (0, $6VdZc.isInitial)();
            const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
                isAnonymous: Boolean(!userId),
                isInitialLoad: _isInitialLoad,
                isLite: isLite
            });
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
                isLite: isLite
            });
            const untilPageSegments = expectedPageSegments.map((segment)=>({
                    experience: segment,
                    useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
                }));
            pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
                ...$a99ff50c139ee598$var$baseConfig,
                key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
                timings: [
                    ...$a99ff50c139ee598$var$baseConfig.timings,
                    ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
                ],
                include: expectedPageSegments,
                until: untilPageSegments
            });
            if (!_isInitialLoad) expectedPageSegments.forEach($a99ff50c139ee598$var$_temp);
            pageLoadMetricRef.current.startPageLoad();
            pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
            pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
            pageLoadMetricRef.current.onStop((data)=>{
                (0, $dpv0X.markLegacyFY23TTI)(pageLoadMetricRef.current, data);
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (isEmbeddedConfluence) {
                    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                    const uniqueKey = observableObject?.object?.uniqueKey;
                    sendMetrics({
                        timestamp: Date.now(),
                        customData: {
                            ...uniqueKey ? {
                                uniqueKey: uniqueKey
                            } : {}
                        }
                    }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_VIEW_TTI)}`);
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    if (!(0, $9wGTI.fg)("confluence_frontend_sfx_hydration_errors") && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.length > 0) {
                        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                        window.__HYDRATION_ERRORS__.forEach((error)=>{
                            if (error.type) {
                                const normalizedType = error.type.startsWith("UNSAFE_") ? error.type.slice(7) : error.type;
                                monitoringClient.incrementCounter("hydrationErrorCount", [
                                    `type:${normalizedType}`,
                                    `route:${route}`
                                ]);
                            }
                        });
                    }
                    if ((0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                        source: "viewPageCommon",
                        route: route,
                        errorWithRoute: errorWithRoute,
                        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                    })).fire();
                    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                        attribution: "hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) {
                    const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                        attribution: "streaming-hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            return ()=>{
                pageLoadMetricRef.current?.cancel();
            };
        };
        $[0] = createAnalyticsEvent;
        $[1] = customConfig?.expectedPageLoadSegments;
        $[2] = customConfig?.fmpUntilStopTimeMetrics;
        $[3] = customConfig?.pageLoadKey;
        $[4] = isEmbeddedConfluence;
        $[5] = isLite;
        $[6] = sendMetrics;
        $[7] = userId;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== createAnalyticsEvent || $[11] !== customConfig || $[12] !== isEmbeddedConfluence || $[13] !== isLite || $[14] !== sendMetrics || $[15] !== userId) {
        t2 = [
            contentId,
            customConfig,
            userId,
            isLite,
            isEmbeddedConfluence,
            sendMetrics,
            createAnalyticsEvent
        ];
        $[9] = contentId;
        $[10] = createAnalyticsEvent;
        $[11] = customConfig;
        $[12] = isEmbeddedConfluence;
        $[13] = isLite;
        $[14] = sendMetrics;
        $[15] = userId;
        $[16] = t2;
    } else t2 = $[16];
    (0, $42omo.useEffect)(t1, t2);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
function $a99ff50c139ee598$var$_temp(m) {
    return m.startFromPageLoad();
}
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("70LTe", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$4716363caa82a23b;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("aWrnw", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("dpv0X", function(module, exports) {

var $5YLPl = parcelRequire("5YLPl");

const $79e64809bb47109c$export$1d7a42050347be43 = (pageLoadMetric, data)=>{
    const contentRendererLegacyMark = (0, $5YLPl.CONTENT_RENDERER_METRIC).getData().marks['fy23-legacy-tti'] || 0;
    const pageLoadMark = data?.stopTime || 0;
    pageLoadMetric?.mark('fy23-legacy-tti', Math.max(pageLoadMark, contentRendererLegacyMark));
};
module.exports["markLegacyFY23TTI"] = $79e64809bb47109c$export$1d7a42050347be43;

});

parcelRegister("fgdVB", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $2XqLN = parcelRequire("2XqLN");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<8a3d9b608a966037866ba1e23cd4b2fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<dbd3f3eb3b7ac7d87edb78571dc15b87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<496aae2805f190b889130185f14c15ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<4bfbf48d0e6d08b7a60dd90bf2791f98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $eS4vC = parcelRequire("eS4vC");


var $cemw8 = parcelRequire("cemw8");


var $6mKj3 = parcelRequire("6mKj3");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
} : ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $frIzR.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        // If confluence_frontend_use_hydration_safe_suspense is on,
        // use a suspense boundary that will block updates (via memo) until hydration has completed
        const SuspenseComponent = (0, $6mKj3.expVal)('confluence_frontend_use_hydration_safe_suspense', 'isEnabled', false) ? (0, $cemw8.HydrationSafeSuspense) : (0, $42omo.Suspense);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SuspenseComponent, {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $42omo.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("1Af7Q", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $3fCLI = parcelRequire("3fCLI");

function $9a1f832417de6544$export$ae2b233b73197bb6() {
    const $ = (0, $frIzR.c)(2);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fCLI.LegacyBridgeNextInner), {
            contentId: contentId
        }) : null;
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
module.exports["LegacyBridgeNext"] = $9a1f832417de6544$export$ae2b233b73197bb6;

});

parcelRegister("3fCLI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $1ytiN = parcelRequire("1ytiN");


var $e4o8D = parcelRequire("e4o8D");


var $8vxJi = parcelRequire("8vxJi");


var $3d5UI = parcelRequire("3d5UI");


var $jMyy4 = parcelRequire("jMyy4");


var $98Fgg = parcelRequire("98Fgg");

const $fdddd5e334b3dceb$var$logger = (0, $7W8i8.getLogger)('LegacyBridgeNext');
function $fdddd5e334b3dceb$export$af02eebb080c844({ contentId: contentId }) {
    const [contentType] = (0, $ep3mz.useContentType)();
    const { experimentFeatures: experimentFeatures } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Due to circular dependency issues we are using the PreloadLegacyBridgeQuery from query-preloaders-common package
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $98Fgg.default), {
        variables: {
            contentId: contentId || '',
            isBlog: contentType === 'blogpost'
        },
        context: {
            single: true
        }
    });
    const { ptpage: ptpage, content: content } = data || {};
    const contentNode = content?.nodes?.[0];
    const spaceNode = contentNode?.space;
    const pageVersion = contentNode?.version?.number;
    const ajsMetaParameters = [
        {
            key: 'space-key',
            value: spaceNode?.key
        },
        {
            key: 'space-name',
            value: spaceNode?.name
        },
        {
            key: 'space-type',
            value: spaceNode?.type
        },
        {
            key: 'content-type',
            value: contentNode?.type
        },
        {
            key: 'page-version',
            value: pageVersion
        },
        {
            key: 'page-title',
            value: contentNode?.title
        },
        {
            key: 'parent-page-id',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.id
        },
        {
            key: 'parent-page-title',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.title
        },
        {
            key: 'experiment-features',
            value: experimentFeatures
        }
    ];
    if (contentId) {
        const createPage = pageVersion === 0;
        const pageId = createPage ? '0' : contentId;
        ajsMetaParameters.push({
            key: 'content-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'latest-page-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'new-page',
            value: createPage
        });
        ajsMetaParameters.push({
            key: 'page-id',
            value: pageId
        });
    }
    const operations = contentNode?.operations;
    if (operations) {
        const canRemovePage = operations.filter((item)=>item?.operation === 'delete' && item?.targetType === 'page').length > 0;
        ajsMetaParameters.push({
            key: 'can-remove-page',
            value: canRemovePage
        });
    }
    const filteredAjsMetaParameters = ajsMetaParameters.filter(({ value: value })=>value !== undefined && value !== null);
    (0, $42omo.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'LegacyBridgeNext.js',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            if (error) {
                $fdddd5e334b3dceb$var$logger.error`Failed to Query Legacy AJSMetaData ${error}`;
                return;
            }
            if (filteredAjsMetaParameters.length === 0 || window.AJS.Meta.get('has-next-legacy-bridge')) return;
            // We have 2 legacy bridge here based on graphql
            // Another in packages/confluence-frontend-server/src/components/LegacyBridge/LegacyBridge.js based on Redux.
            // We need to let the legacy one know we have already dealt with these meta tags don't override
            window.AJS.Meta.set('has-next-legacy-bridge', true);
            filteredAjsMetaParameters.forEach(({ key: key, value: value_0 })=>window.AJS.Meta.set(key, value_0));
        });
        return ()=>{
            const ajsMeta = window.AJS?.Meta;
            ajsMeta && ajsMeta.set('has-next-legacy-bridge', false);
        };
    }, [
        error,
        contentId,
        filteredAjsMetaParameters
    ]);
    if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        nonce: nonceValue,
        "data-testid": "legacyBridge-ssr",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.__SSR_AJS_META__=${(0, $8vxJi.stringifyForSSR)(filteredAjsMetaParameters)}`
        }
    });
    return null;
}
module.exports["LegacyBridgeNextInner"] = $fdddd5e334b3dceb$export$af02eebb080c844;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<d464f5389340707d98e01a7df5f2a33f>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<2f52473be21986bee58c241e9bbdbeb7>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<018f680a41f998d85b2f3329e18a2d4f>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<d8f7bedffa4ad09afb1438be91b0b847>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<ef2662a3571692681f3a75de77bb506e>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<1ac0869ec5d868a961896d33c5ef93ef>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<fcddcf783b4b8317e3322bb502f8e37b>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("8VYSW", function(module, exports) {

var $1c598 = parcelRequire("1c598");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $1c598.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $1c598.ExtensionEnvironment).STAGING || extension.environmentType === (0, $1c598.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $1c598.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("7zIsq", function(module, exports) {

var $gNyf6 = parcelRequire("gNyf6");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
const $f6a9c96fc0de3888$var$fetchRequests = new Map();
const $f6a9c96fc0de3888$export$f55e1916fecb1860 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$f6a9c96fc0de3888$var$fetchRequests.has(cacheKey)) {
            const extensions = new Promise((resolve, reject)=>{
                (0, $irOoi.fetchQuery)(environment, (0, $gNyf6.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($f6a9c96fc0de3888$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error)=>{
                        $f6a9c96fc0de3888$var$fetchRequests.delete(cacheKey);
                        reject(error);
                    }
                });
            });
            $f6a9c96fc0de3888$var$fetchRequests.set(cacheKey, extensions);
        }
        $f6a9c96fc0de3888$var$fetchRequests.get(cacheKey).then((extensions)=>{
            setExtensions(extensions);
            setLoading(false);
        }).catch((error)=>{
            setError(error);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
            const err = error.source.errors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $f6a9c96fc0de3888$export$f55e1916fecb1860;

});

parcelRegister("gNyf6", function(module, exports) {
/**
 * @generated SignedSource<<95f9476ba6f9b974dc14486e1eb8afc0>>
 * @relayHash 57057313f17699c6ffabb286b9a1141a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b
const $c701b66f5c3386e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c701b66f5c3386e6$var$node.hash = "d028e6b4d01b71cf67c24b6983fbfddf";
var $c701b66f5c3386e6$export$2e2bcd8739ae039 = $c701b66f5c3386e6$var$node;
module.exports["default"] = $c701b66f5c3386e6$export$2e2bcd8739ae039;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $3afb5a6a58db13d7$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1c598 = parcelRequire("1c598");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1c598.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("6GQtz", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $477dG.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ((0, $6mKj3.isExperimentEnabled)('confluence_smartlink_default_display_types')) {
            if (this.shouldDisplayAsEmbed(url)) return 'embed';
            if (this.shouldDisplayAsCard(url)) return 'block';
        }
        return super.getHardCodedAppearance(url);
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $79vw2 = parcelRequire("79vw2");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");


var $egwA4 = parcelRequire("egwA4");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
const $807e27f9bf9a8610$var$isLoomUrl = (url)=>{
    return url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?")));
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)"));
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>/\/browse\/((?:\w+)-(?:\d+))/i.test(url);
const $807e27f9bf9a8610$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline,
    isPolarisView: $807e27f9bf9a8610$var$isPolarisView,
    isJwmView: $807e27f9bf9a8610$var$isJwmView,
    isJiraList: $807e27f9bf9a8610$var$isJiraList,
    isConfluenceWhiteboard: $807e27f9bf9a8610$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $807e27f9bf9a8610$var$isConfluenceDatabase,
    isJiraDashboard: $807e27f9bf9a8610$var$isJiraDashboard,
    isJiraBacklog: $807e27f9bf9a8610$var$isJiraBacklog,
    isJiraBoard: $807e27f9bf9a8610$var$isJiraBoard,
    isJiraPlan: $807e27f9bf9a8610$var$isJiraPlan,
    isJiraVersion: $807e27f9bf9a8610$var$isJiraVersion,
    isJiraForm: $807e27f9bf9a8610$var$isJiraForm,
    isJiraSummary: $807e27f9bf9a8610$var$isJiraSummary,
    isRovoAgentProfilePage: $807e27f9bf9a8610$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $807e27f9bf9a8610$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $807e27f9bf9a8610$var$isJiraIssueNavigator
};
function $807e27f9bf9a8610$export$4006295459a20a0(url) {
    return Object.values($807e27f9bf9a8610$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $807e27f9bf9a8610$export$78234eee43b97e81(url) {
    return !$807e27f9bf9a8610$export$4006295459a20a0(url);
}
function $807e27f9bf9a8610$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        if (details) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        const cacheStatus = this.getCacheStatusForNode(jsonNode);
        if (cacheStatus === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            if (payload.data && !payload.error) this.smartCardLocalCacheClient.setItem(key, payload.data);
            callback(payload);
        });
    }
    nodeDataKey(node) {
        // We can use URL as a key here, because CardClient returns the same data for the same URL
        // regardless of the type of card (inline, block, embed).
        return node.attrs.url;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            return this.cardClient.fetchData(url);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$807e27f9bf9a8610$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomUrl(url) || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $79vw2.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference && (0, $dh538.fg)('platform_sl_3p_unauth_paste_as_block_card_gate')) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') {
                            const isUnauthPasteAsBlockCardEnabled = !(0, $1oCLl.expValEquals)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'control', 'control');
                            if (isUnauthPasteAsBlockCardEnabled) return this.transformer.toSmartlinkAdf(url, 'block');
                        }
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $egwA4.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $807e27f9bf9a8610$export$4006295459a20a0;
module.exports["isExternalUrl"] = $807e27f9bf9a8610$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("dDhJe", function(module, exports) {
const $acfecaf0839e2c0b$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $acfecaf0839e2c0b$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $acfecaf0839e2c0b$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $acfecaf0839e2c0b$export$e2b040f052407032 = {
    dev: $acfecaf0839e2c0b$var$devBaseUrl,
    development: $acfecaf0839e2c0b$var$devBaseUrl,
    stg: $acfecaf0839e2c0b$var$stgBaseUrl,
    staging: $acfecaf0839e2c0b$var$stgBaseUrl,
    prd: $acfecaf0839e2c0b$var$prodBaseUrl,
    prod: $acfecaf0839e2c0b$var$prodBaseUrl,
    production: $acfecaf0839e2c0b$var$prodBaseUrl
};
const $acfecaf0839e2c0b$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $acfecaf0839e2c0b$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $acfecaf0839e2c0b$export$e2b040f052407032 ? $acfecaf0839e2c0b$export$e2b040f052407032[envKey] : $acfecaf0839e2c0b$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $acfecaf0839e2c0b$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $acfecaf0839e2c0b$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $acfecaf0839e2c0b$export$2e2bcd8739ae039 = $acfecaf0839e2c0b$export$e2b040f052407032;
module.exports["getBaseUrl"] = $acfecaf0839e2c0b$export$f654b28f82155665;
module.exports["getResolverUrl"] = $acfecaf0839e2c0b$export$dc37652c1696f231;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("k00oi", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $Gi9G7 = parcelRequire("Gi9G7");


var $abpX2 = parcelRequire("abpX2");


var $jHnts = parcelRequire("jHnts");

var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");

var $gmi3X = parcelRequire("gmi3X");


var $97i3I = parcelRequire("97i3I");


var $9trs7 = parcelRequire("9trs7");


var $6a9Hv = parcelRequire("6a9Hv");


var $dh538 = parcelRequire("dh538");

const $542f7628c45b2158$var$MAX_BATCH_SIZE = 50;
const $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE = 100;
const $542f7628c45b2158$export$d6a66073b5d79eb3 = new (0, $9trs7.LRUMap)($542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE);
class $542f7628c45b2158$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $jHnts.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false) {
        const hostname = (0, $dh538.fg)('platform_navx_lp_invalid_url_error') ? this.getHostName(url) : new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $542f7628c45b2158$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $dh538.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $542f7628c45b2158$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $97i3I.isSuccessfulResponse)(response) || (0, $btw9C.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $97i3I.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $97i3I.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $97i3I.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $97i3I.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $97i3I.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gmi3X.NetworkError)) return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $jHnts.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $jHnts.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $jHnts.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $jHnts.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.loadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $542f7628c45b2158$export$2e2bcd8739ae039;

});

parcelRegister("Gi9G7", function(module, exports) {
// Packages

var $bfRrZ = parcelRequire("bfRrZ");

function $07f201957e3f51a5$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $bfRrZ.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $07f201957e3f51a5$var$retry;

});

parcelRegister("bfRrZ", function(module, exports) {

module.exports = (parcelRequire("2CRnP"));

});

parcelRegister("2CRnP", function(module, exports) {

var $jWveU = parcelRequire("jWveU");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $jWveU(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("jWveU", function(module, exports) {
function $e84baaa017e10274$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $e84baaa017e10274$var$RetryOperation;
$e84baaa017e10274$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$e84baaa017e10274$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$e84baaa017e10274$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$e84baaa017e10274$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = $e84baaa017e10274$var$RetryOperation.prototype.try;
$e84baaa017e10274$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$e84baaa017e10274$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("abpX2", function(module, exports) {
'use strict';
class $769f0fd050ef86b5$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $769f0fd050ef86b5$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $769f0fd050ef86b5$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $769f0fd050ef86b5$var$pThrottle;
module.exports.AbortError = $769f0fd050ef86b5$var$AbortError;

});

parcelRegister("gmi3X", function(module, exports) {
const $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $ffe0c3b764a3e96a$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $ffe0c3b764a3e96a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $ffe0c3b764a3e96a$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["NetworkError"] = $ffe0c3b764a3e96a$export$bae979e68e4dc802;
module.exports["request"] = $ffe0c3b764a3e96a$export$b5fe3f66a567bec0;

});

parcelRegister("97i3I", function(module, exports) {
const $e30f485c735f2746$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e30f485c735f2746$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isSuccessfulResponse"] = $e30f485c735f2746$export$1b59fe731a28a49d;
module.exports["isErrorResponse"] = $e30f485c735f2746$export$bea7bee8a87e7c52;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("egwA4", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

var $7a3952f20342cebe$var$_SmartCardLocalCacheClient;
const $7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $7a3952f20342cebe$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$7a3952f20342cebe$export$1987ad1ab31f2528.instance) $7a3952f20342cebe$export$1987ad1ab31f2528.instance = new $7a3952f20342cebe$export$1987ad1ab31f2528(maxItems);
        return $7a3952f20342cebe$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $kt8c2.default)($7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$7a3952f20342cebe$var$_SmartCardLocalCacheClient = $7a3952f20342cebe$export$1987ad1ab31f2528;
$7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $7a3952f20342cebe$export$1987ad1ab31f2528;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("lrJXD", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $f9cfc574ab3845a4$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $hvy9d = parcelRequire("hvy9d");


var $knMkm = parcelRequire("knMkm");

var $f9cfc574ab3845a4$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f9cfc574ab3845a4$var$__await ? (this.v = v, this) : new $f9cfc574ab3845a4$var$__await(v);
};
var $f9cfc574ab3845a4$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f9cfc574ab3845a4$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f9cfc574ab3845a4$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $f9cfc574ab3845a4$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$f9cfc574ab3845a4$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $hvy9d.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $hvy9d.stringifyMessage)({
                                    type: (0, $hvy9d.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $f9cfc574ab3845a4$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $hvy9d.stringifyMessage)(payload ? {
                            type: (0, $hvy9d.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $hvy9d.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $hvy9d.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $hvy9d.CloseCode).InternalClientError, (0, $knMkm.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $hvy9d.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $hvy9d.stringifyMessage)(message.payload ? {
                                    type: (0, $hvy9d.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $hvy9d.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $hvy9d.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $hvy9d.CloseCode).BadResponse, (0, $knMkm.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && ($f9cfc574ab3845a4$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $hvy9d.CloseCode).InternalServerError,
            (0, $hvy9d.CloseCode).InternalClientError,
            (0, $hvy9d.CloseCode).BadRequest,
            (0, $hvy9d.CloseCode).BadResponse,
            (0, $hvy9d.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $hvy9d.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $hvy9d.CloseCode).SubscriberAlreadyExists,
            (0, $hvy9d.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $hvy9d.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $hvy9d.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $hvy9d.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $hvy9d.stringifyMessage)({
                    id: id,
                    type: (0, $hvy9d.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $hvy9d.stringifyMessage)({
                        id: id,
                        type: (0, $hvy9d.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $f9cfc574ab3845a4$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $f9cfc574ab3845a4$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $f9cfc574ab3845a4$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $f9cfc574ab3845a4$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $f9cfc574ab3845a4$export$f5b1bfead8e118a7());
        }
    };
}
class $f9cfc574ab3845a4$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $f9cfc574ab3845a4$var$isLikeCloseEvent(val) {
    return (0, $knMkm.isObject)(val) && 'code' in val && 'reason' in val;
}
function $f9cfc574ab3845a4$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $f9cfc574ab3845a4$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});

parcelRegister("hvy9d", function(module, exports) {
$parcel$export(module.exports, "CloseCode", () => $cbefd1f1d80a870f$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $cbefd1f1d80a870f$export$80edbf15fa61a4db);
/**
 *
 * common
 *
 */ 
var $knMkm = parcelRequire("knMkm");

const $cbefd1f1d80a870f$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $cbefd1f1d80a870f$export$ec743af8bb66f3be = 'graphql-ws';
var $cbefd1f1d80a870f$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($cbefd1f1d80a870f$export$777128f41f6616ec || ($cbefd1f1d80a870f$export$777128f41f6616ec = {}));
var $cbefd1f1d80a870f$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($cbefd1f1d80a870f$export$80edbf15fa61a4db || ($cbefd1f1d80a870f$export$80edbf15fa61a4db = {}));
function $cbefd1f1d80a870f$export$c17861b159b1b673(val) {
    if (!(0, $knMkm.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $knMkm.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionInit:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionAck:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Ping:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $knMkm.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $knMkm.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $knMkm.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $knMkm.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $knMkm.extendedTypeof)(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $cbefd1f1d80a870f$export$9e0e49e75fa7d548(val) {
    try {
        $cbefd1f1d80a870f$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $cbefd1f1d80a870f$export$f2f615077a189f21(data, reviver) {
    return $cbefd1f1d80a870f$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $cbefd1f1d80a870f$export$77896e5b47bfd50b(msg, replacer) {
    $cbefd1f1d80a870f$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}
module.exports["GRAPHQL_TRANSPORT_WS_PROTOCOL"] = $cbefd1f1d80a870f$export$5c0a4edfedc7c457;
module.exports["parseMessage"] = $cbefd1f1d80a870f$export$f2f615077a189f21;
module.exports["stringifyMessage"] = $cbefd1f1d80a870f$export$77896e5b47bfd50b;

});

parcelRegister("knMkm", function(module, exports) {
/** @private */ function $ed6b7173c8b91525$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) {
    return $ed6b7173c8b91525$export$573326049e1b1c6b(val) === 'object';
}
function $ed6b7173c8b91525$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $ed6b7173c8b91525$export$92bd080471bc30f1(val) {
    return $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $ed6b7173c8b91525$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $ed6b7173c8b91525$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}
module.exports["extendedTypeof"] = $ed6b7173c8b91525$export$573326049e1b1c6b;
module.exports["isObject"] = $ed6b7173c8b91525$export$a6cdc56e425d0d0a;
module.exports["areGraphQLErrors"] = $ed6b7173c8b91525$export$e6262fbc2e92290;
module.exports["limitCloseReason"] = $ed6b7173c8b91525$export$2937fa0c8dddae54;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<3dc4cd13757c8097f90e9c019f62dc38>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "0b21ca1826000dc79e07e5aee0fcca18";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<3cebf84094428ea2b6f9dabc2cda075e>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "b632c435e4326f4f3245476cffd31162";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<967d9b0950589c371f008ac197749b99>>
 * @relayHash 84e141f4639993fa671b560586b064ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "84e141f4639993fa671b560586b064ac",
            "id": "8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String){content(id:$contentId){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "0027e387b6111f3e5ddcfb9450c87857";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<9fa9040e4353965e7d75ef028f1e3386>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<51a35283eac1d4f4e50d5550518c5658>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "userCanToggle"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ]
    }, v19 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "feae64578b0a3fba44f22230201969bb",
            "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "89dc64ac31ebaadc798791741477c5f3";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<fea9fd163a01f2b40d3a0a70f9830bab>>
 * @relayHash 43e22200d20c9054da6f6b002b467f53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "43e22200d20c9054da6f6b002b467f53",
            "id": "3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "3f2ed67e9608ba74e2a432234c7f66f7";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("b1hSc", function(module, exports) {
/**
 * @generated SignedSource<<75369bf33a7b4e5726120cfbd40e165e>>
 * @relayHash 51e15b77790c5d8cdaef4df99503fbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386
const $4bf9442691f65266$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "commentState",
                    "value": "UNRESOLVED"
                },
                {
                    "kind": "Variable",
                    "name": "commentType",
                    "variableName": "type"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceCommentFilter"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "singleThreaded",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v6 /*: any*/ ,
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "type"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v21 /*: any*/ ,
                    v20 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v26 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v34 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v35 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v36 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "51e15b77790c5d8cdaef4df99503fbf3",
            "id": "3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386",
            "metadata": {},
            "name": "ActiveCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$type:[CommentType],$first:Long)@allowHigherTimeout{comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:$type},singleThreaded:true,type:$type,first:$first){__typename,nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}},totalCount}}"
        }
    };
}();
$4bf9442691f65266$var$node.hash = "37d97577cf19b12ed92bf7d36576353c";
var $4bf9442691f65266$export$2e2bcd8739ae039 = $4bf9442691f65266$var$node;
module.exports["default"] = $4bf9442691f65266$export$2e2bcd8739ae039;

});

parcelRegister("9rE3H", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 2000;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            'FOOTER'
        ],
        first: $5b808dc3cc2fdcb5$export$3816ffab97d6707
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: $5b808dc3cc2fdcb5$export$ed108990552755bd,
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<6688445582ee3073cb3b58fe45106be1>>
 * @relayHash 917128614372b454a0c92f921e265a3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "917128614372b454a0c92f921e265a3f",
            "id": "d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "0538003061ae5e768497e01082e44e58";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("lpxTx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ac0bfd36ecfdf97$export$7e83667ababb3077 = (0, $eSUdr.default)`query ContentBlogUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false){content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentBlogUnifiedQuery"] = $4ac0bfd36ecfdf97$export$7e83667ababb3077;

});

parcelRegister("61vTv", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7b6381fcd1b9e458$export$16dddce791a11901 = (0, $eSUdr.default)`query ContentUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "emoji-title-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentUnifiedQuery"] = $7b6381fcd1b9e458$export$16dddce791a11901;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<64029d77bc7e5ee7f768e71ebae7af94>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");


var $6mKj3 = parcelRequire("6mKj3");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$a586f466261ecb73 = ()=>{
    const baseRoutes = [
        (0, $1NBp8.DATABASE_VIEW).name,
        (0, $1NBp8.VIEW_PAGE).name,
        (0, $1NBp8.WHITEBOARD_BOARD).name,
        (0, $1NBp8.SLIDES_VIEW).name,
        (0, $1NBp8.EMBED_VIEW).name
    ];
    if ((0, $6mKj3.expValEquals)('cc-axp-delete-editing-page-redirect', 'isEnabled', true)) return [
        ...baseRoutes,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_PAGE_V2).name
    ];
    return baseRoutes;
};
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).WHITEBOARD
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["getDeleteSuccessRedirectRoutes"] = $2aa2bdb281c6889a$export$a586f466261ecb73;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    INCLUDE: 'include',
    JIRA: 'jira',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    NATIVE_EMBED: 'native-embed'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = Boolean(attrs?.parameters) ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams || {}
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("aMlgD", function(module, exports) {

var $h82at = parcelRequire("h82at");


var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $h82at.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<0c9440ce87b304c8d3a2ca3a70175e28>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("aqBZ0", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<513d7f919c579d2248fb418730db53cb>>
 * @relayHash f5d07637afe71c7ca06b7f159493ea94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "otherContentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "transitionType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            v4 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v8 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v9 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v10 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "success"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v14 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v15 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v17 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v23 = [
        v5 /*: any*/ ,
        v20 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v24 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v25 = [
        v21 /*: any*/ 
    ], v26 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v23 /*: any*/ 
            }
        ]
    }, v27 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v25 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v20 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v5 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5d07637afe71c7ca06b7f159493ea94",
            "id": "e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType){content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a2315c6dd75143b0285f57068b70bc22";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType]);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("gWF6I", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JyXl5 = parcelRequire("JyXl5");

function $8122506f239babd4$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $JyXl5.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $8122506f239babd4$export$43b1f3e917d65526 = $8122506f239babd4$export$6c22afad970ad5ac;
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8122506f239babd4$export$6c22afad970ad5ac, null, children);
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $8122506f239babd4$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $8122506f239babd4$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $8122506f239babd4$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $8122506f239babd4$export$e237a628f59c9f4e;

});

parcelRegister("JyXl5", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $aPmQM = parcelRequire("aPmQM");


var $hvWxm = parcelRequire("hvWxm");


var $kzjMJ = parcelRequire("kzjMJ");

const $e443eef90c98bdab$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $e443eef90c98bdab$export$4a639ebead870a0c = new (0, $kzjMJ.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $e443eef90c98bdab$export$df54517d175e6d6b = (0, $aPmQM.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $e443eef90c98bdab$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $hvWxm.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $dh538.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $hvWxm.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $e443eef90c98bdab$export$4a639ebead870a0c,
        isServer: globalThis.__SERVER__ ?? false
    }
});
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $e443eef90c98bdab$export$df54517d175e6d6b;

});

parcelRegister("aPmQM", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $hZsWa = parcelRequire("hZsWa");


var $dRnqM = parcelRequire("dRnqM");


var $j93Ay = parcelRequire("j93Ay");


var $f2OFx = parcelRequire("f2OFx");


var $59hua = parcelRequire("59hua");


var $7z5rG = parcelRequire("7z5rG");


var $1b0Xp = parcelRequire("1b0Xp");


var $7gNIX = parcelRequire("7gNIX");

// Enable Relay Resolvers globally for this module
(0, $3e6Uc.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $e57f333731aa23ab$var$createNetwork(networkOptions) {
    return (0, $3e6Uc.Network).create((request, variables, cacheConfig)=>(0, $59hua.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $7gNIX.createSubscribeFn)(networkOptions) : undefined);
}
const $e57f333731aa23ab$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hZsWa)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $e57f333731aa23ab$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $3e6Uc.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $e57f333731aa23ab$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $dRnqM.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $j93Ay.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $e57f333731aa23ab$var$deleteNode(connection, id);
            }
        });
    }
};
function $e57f333731aa23ab$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $e57f333731aa23ab$var$DeleteEdgeHandler;
        default:
            return (0, $3e6Uc.DefaultHandlerProvider)(handle);
    }
}
function $e57f333731aa23ab$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID }) {
    return new (0, $3e6Uc.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: $e57f333731aa23ab$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $e57f333731aa23ab$var$createStore(new (0, $3e6Uc.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $f2OFx.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $f2OFx.default),
        scheduler: (0, $1b0Xp.default),
        missingFieldHandlers: (0, $7z5rG.default),
        handlerProvider: $e57f333731aa23ab$var$HandlerProvider
    });
}
module.exports["createRelayEnvironment"] = $e57f333731aa23ab$export$7afaa9c867644497;

});

parcelRegister("j93Ay", function(module, exports) {
var $df01a438a0c868c1$var$isProduction = true;
function $df01a438a0c868c1$var$warning(condition, message) {
    if (!$df01a438a0c868c1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $df01a438a0c868c1$export$2e2bcd8739ae039 = $df01a438a0c868c1$var$warning;
module.exports["default"] = $df01a438a0c868c1$export$2e2bcd8739ae039;

});

parcelRegister("59hua", function(module, exports) {

var $33JSI = parcelRequire("33JSI");


var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");


var $4xBBd = parcelRequire("4xBBd");


var $2gQQV = parcelRequire("2gQQV");


var $6YELi = parcelRequire("6YELi");


var $9nJbC = parcelRequire("9nJbC");


var $l9oE3 = parcelRequire("l9oE3");


var $fr6fu = parcelRequire("fr6fu");


var $jne3Q = parcelRequire("jne3Q");


var $gfRVX = parcelRequire("gfRVX");


var $c4zvP = parcelRequire("c4zvP");

const $923cf200d647598a$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $923cf200d647598a$var$moduleID = 'relay-fetch';
const $923cf200d647598a$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    function augmentResponse(response) {
        (0, $9nJbC.addTraceId)(queryName, (0, $c4zvP.getTraceIdFromExtensions)(response));
        (0, $4xBBd.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $3e6Uc.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$923cf200d647598a$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
                const body = (0, $2gQQV.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $jne3Q.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $jne3Q.processMultipartPromise)(()=>(0, $gfRVX.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $gfRVX.shouldRetry),
                        retryAttempts: (0, $gfRVX.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $6YELi.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $6YELi.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $6YELi.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $fr6fu.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $dh538.fg)('platform_relay_use_new_non_nullability')) response = $923cf200d647598a$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($33JSI)))(ssrCache)) {
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $l9oE3.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $l9oE3.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
function $923cf200d647598a$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}
module.exports["fetch"] = $923cf200d647598a$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("4xBBd", function(module, exports) {
const $b8b31e9388977391$var$OperationExtensionsMap = {};
const $b8b31e9388977391$export$8656ba3981c6f6c1 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = $b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];
};
const $b8b31e9388977391$export$f16fa6040161f056 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = undefined;
};
const $b8b31e9388977391$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $b8b31e9388977391$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $b8b31e9388977391$export$7c6ea4184129ef74 = (operationName)=>$b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];
module.exports["startCapturingExtensions"] = $b8b31e9388977391$export$8656ba3981c6f6c1;
module.exports["stopCapturingExtensions"] = $b8b31e9388977391$export$f16fa6040161f056;
module.exports["putExtensions"] = $b8b31e9388977391$export$17dc47fdf278de21;
module.exports["getExtensions"] = $b8b31e9388977391$export$7c6ea4184129ef74;

});

parcelRegister("6YELi", function(module, exports) {
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $aec1d0280b51c3e1$export$607b80f5bc6e396d = new Map();
const $aec1d0280b51c3e1$export$cdadce6ed6361a2c = new Map();
module.exports["QueryPromisesMap"] = $aec1d0280b51c3e1$export$607b80f5bc6e396d;
module.exports["CompletedQueryPromisesMap"] = $aec1d0280b51c3e1$export$cdadce6ed6361a2c;

});

parcelRegister("9nJbC", function(module, exports) {
const $d5ce6d160f67e727$var$OperationTraceIdMap = {};
const $d5ce6d160f67e727$export$a2bcb2fac360646c = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];
};
const $d5ce6d160f67e727$export$559128bdc4352001 = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = undefined;
};
const $d5ce6d160f67e727$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $d5ce6d160f67e727$export$5113e470f5c95670 = (operationName)=>$d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];
module.exports["addTraceId"] = $d5ce6d160f67e727$export$fcaa732775f12226;

});

parcelRegister("l9oE3", function(module, exports) {

var $dCjrN = parcelRequire("dCjrN");

const $e5d9c5404c4087ad$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $e5d9c5404c4087ad$var$dispatcher;
const $e5d9c5404c4087ad$export$5bb012cf9b3a5452 = ()=>{
    if (!$e5d9c5404c4087ad$var$dispatcher) {
        $e5d9c5404c4087ad$var$dispatcher = new (0, $dCjrN.ClientDispatcher)();
        // Handle the server hangup scenarios
        $e5d9c5404c4087ad$var$dispatcher.register($e5d9c5404c4087ad$export$eb5d9c90d65c7fea, $e5d9c5404c4087ad$var$dispatcher._abort.bind($e5d9c5404c4087ad$var$dispatcher));
    }
    return $e5d9c5404c4087ad$var$dispatcher;
};
module.exports["getClientDispatcher"] = $e5d9c5404c4087ad$export$5bb012cf9b3a5452;

});

parcelRegister("dCjrN", function(module, exports) {
class $367530fdb78d8940$export$3f5ba18eb97af725 {
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
    constructor(){
        this.handlers = void 0;
        this.queuedPayloads = void 0;
        this.abortReason = void 0;
        this.abortHandlers = void 0;
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
}
module.exports["ClientDispatcher"] = $367530fdb78d8940$export$3f5ba18eb97af725;

});

parcelRegister("fr6fu", function(module, exports) {
const $4852ba516184255b$var$events = [];
const $4852ba516184255b$export$bd50bc4cd3c601ee = (event)=>{
    $4852ba516184255b$var$events.push(event);
};
const $4852ba516184255b$export$3c7145db84d4587c = ()=>{
    return $4852ba516184255b$var$events.splice(0, $4852ba516184255b$var$events.length);
};
module.exports["registerEvent"] = $4852ba516184255b$export$bd50bc4cd3c601ee;

});

parcelRegister("jne3Q", function(module, exports) {
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $lgmus = parcelRequire("lgmus");


var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");


var $bDPoq = parcelRequire("bDPoq");

const $ee37f6fc0d924aec$var$NO_CONTENT = 204;
function $ee37f6fc0d924aec$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $ee37f6fc0d924aec$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $ee37f6fc0d924aec$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $ee37f6fc0d924aec$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $ee37f6fc0d924aec$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $ee37f6fc0d924aec$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $ee37f6fc0d924aec$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function $ee37f6fc0d924aec$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $ee37f6fc0d924aec$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        let traceId = '';
        if ((0, $dh538.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        observer.error(new Error(`Error while parsing text response ${traceId}(Content-Type: ${response?.headers?.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $ee37f6fc0d924aec$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $3e6Uc.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $ee37f6fc0d924aec$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $ee37f6fc0d924aec$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer);
            else $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
        }).catch((error)=>observer.error(error));
    });
}
const $ee37f6fc0d924aec$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $ee37f6fc0d924aec$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function $ee37f6fc0d924aec$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = $ee37f6fc0d924aec$export$28ae0033b80c6303(baseUrl, variables).length;
    const headersSize = $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH && headersSize <= $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $ee37f6fc0d924aec$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $ee37f6fc0d924aec$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $bDPoq.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = $ee37f6fc0d924aec$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = $ee37f6fc0d924aec$export$28ae0033b80c6303(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}
module.exports["processMultipartPromise"] = $ee37f6fc0d924aec$export$f76505a7f2969e4e;
module.exports["buildGraphqlSmartFetch"] = $ee37f6fc0d924aec$export$33c9c992c7855d86;

});

parcelRegister("gfRVX", function(module, exports) {
const $a71dc4ac2c5f78d6$export$81189edc9b923717 = 1;
const $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $a71dc4ac2c5f78d6$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $a71dc4ac2c5f78d6$export$81189edc9b923717 ? $a71dc4ac2c5f78d6$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $a71dc4ac2c5f78d6$export$81189edc9b923717;
    return 0;
};
module.exports["retryOnError"] = $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c;
module.exports["shouldRetry"] = $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8;
module.exports["getRetryAttemptsForQuery"] = $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab;

});

parcelRegister("c4zvP", function(module, exports) {
const $7d88968840210126$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
module.exports["getTraceIdFromExtensions"] = $7d88968840210126$export$eefb7f54c3b07211;

});

parcelRegister("7gNIX", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $255Lo = parcelRequire("255Lo");

var $48B0E = parcelRequire("48B0E");

let $c52e2194a2c31d31$var$cachedDefaultSubscribe;
function $c52e2194a2c31d31$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $c52e2194a2c31d31$var$cachedDefaultSubscribe !== 'undefined') return $c52e2194a2c31d31$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $3e6Uc.Observable).create((sink)=>{
            const client = (0, $255Lo.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayConfig && {
                        replay: replayConfig
                    }
                }
            };
            let requestId = null;
            subscribeOptions?.onSubscribeTrigger?.(payload);
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value?.extensions?.gateway?.request_id;
                    requestId = aggRequestId ?? requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, $48B0E.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId
                    });
                }
            });
        });
    if (typeof subscribeOptions === 'undefined') $c52e2194a2c31d31$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $c52e2194a2c31d31$export$ec068583843480e7 = $c52e2194a2c31d31$export$10f5a0700f263f11();
module.exports["createSubscribeFn"] = $c52e2194a2c31d31$export$10f5a0700f263f11;

});

parcelRegister("255Lo", function(module, exports) {

var $lrJXD = parcelRequire("lrJXD");


var $bDPoq = parcelRequire("bDPoq");


var $95JXf = parcelRequire("95JXf");


var $iFSKP = parcelRequire("iFSKP");

let $4e4d80ce73ad627c$var$client;
const $4e4d80ce73ad627c$export$6bb76d6eba7e258c = ()=>{
    if ((0, $iFSKP.isSSR)()) return null;
    if (!$4e4d80ce73ad627c$var$client) $4e4d80ce73ad627c$var$client = (0, $lrJXD.createClient)({
        url: (0, $iFSKP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $95JXf.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $95JXf.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $bDPoq.getRelayExperimentalApis)().join(',')
        }
    });
    return $4e4d80ce73ad627c$var$client;
};
const $4e4d80ce73ad627c$export$2f0afd443356d36f = ()=>{
    $4e4d80ce73ad627c$var$client = null;
};
module.exports["getClient"] = $4e4d80ce73ad627c$export$6bb76d6eba7e258c;

});

parcelRegister("95JXf", function(module, exports) {
const $036ca9aa83e0f390$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $036ca9aa83e0f390$export$bf6cd96e19b2987f = 100;
const $036ca9aa83e0f390$export$1ad8434180c5936c = 300000; // 5m
module.exports["WS_CLIENT_KEEP_ALIVE"] = $036ca9aa83e0f390$export$8b012b965402e06a;
module.exports["WS_CLIENT_RETRIES"] = $036ca9aa83e0f390$export$bf6cd96e19b2987f;

});

parcelRegister("iFSKP", function(module, exports) {
const $3f9756dc2e75e45b$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $3f9756dc2e75e45b$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
module.exports["isSSR"] = $3f9756dc2e75e45b$export$48d7c418edadb60c;
module.exports["getAggSubscriptionEndpoint"] = $3f9756dc2e75e45b$export$29a72e89601dfc59;

});

parcelRegister("48B0E", function(module, exports) {
const $b1307ce3a1c15d36$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
module.exports["getSinkError"] = $b1307ce3a1c15d36$export$ece4736473c28965;

});

parcelRegister("kzjMJ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

function $55e864d84c99338e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $3e6Uc.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $55e864d84c99338e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $55e864d84c99338e$export$be21c283b097d175 extends (0, $3e6Uc.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $55e864d84c99338e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}
module.exports["SSRQueryResponseCache"] = $55e864d84c99338e$export$be21c283b097d175;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $30lHU = parcelRequire("30lHU");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $30lHU.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $1cfRh = parcelRequire("1cfRh");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $1cfRh.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $k00oi = parcelRequire("k00oi");

function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const client = customClient || new (0, $k00oi.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<985afb1ba32cad5bc298aead4c442fda>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dA1Sn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || !fullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder && (0, $6mKj3.expValEquals)("platform_editor_two_stage_hydration_placeholder", "isEnabled", true) ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder && (0, $6mKj3.expValEquals)("platform_editor_two_stage_hydration_placeholder", "isEnabled", true) ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card?.id === rec?.content?.id);
        pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage
        }
    });
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        }
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $1LZHF = parcelRequire("1LZHF");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1LZHF.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("1LZHF", function(module, exports) {

var $gFQkO = parcelRequire("gFQkO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/slide/manifest.ts
var $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gFQkO.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $gFQkO.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $14aa0b35cfffabf8$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $14aa0b35cfffabf8$export$86048ac46024146a;

});

parcelRegister("gFQkO", function(module, exports) {
// src/confluence/slide/types.ts
var $c23912470bd9b644$export$204fa7edd529d4b3 = "confluence", $c23912470bd9b644$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $c23912470bd9b644$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $c23912470bd9b644$export$3de52c55a164daa4;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $8rneB = parcelRequire("8rneB");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("hjygH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("ecUYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("jyw2s", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}
module.exports["getHashCode"] = $514d44140915e951$export$c14f61804029af13;
module.exports["getParticipantColor"] = $514d44140915e951$export$60ba61eca4eb64f2;

});

parcelRegister("83Vfg", function(module, exports) {

var $8ocXC = parcelRequire("8ocXC");


var $fDtVg = parcelRequire("fDtVg");


var $99F08 = parcelRequire("99F08");

const $eeb5105c6a539702$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $eeb5105c6a539702$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $eeb5105c6a539702$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $eeb5105c6a539702$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $eeb5105c6a539702$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $8ocXC.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $8ocXC.ANONYMOUS_ASSETS).length);
};
const $eeb5105c6a539702$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $eeb5105c6a539702$export$65fe496f5eb91c21 = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    const response = await (0, $99F08.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $eeb5105c6a539702$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $eeb5105c6a539702$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $eeb5105c6a539702$export$101d00feadd67b75(svg)
    };
};
const $eeb5105c6a539702$export$da26b707e2b53fcf = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $eeb5105c6a539702$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $fDtVg.getIntl)();
    return (0, $8ocXC.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $eeb5105c6a539702$export$65fe496f5eb91c21;

});

parcelRegister("8ocXC", function(module, exports) {

var $lfFy6 = parcelRequire("lfFy6");


var $45p5c = parcelRequire("45p5c");

var $66aLS = parcelRequire("66aLS");

var $eA5k9 = parcelRequire("eA5k9");

var $dLHML = parcelRequire("dLHML");

var $5QM3U = parcelRequire("5QM3U");

var $1zbJy = parcelRequire("1zbJy");

var $absgL = parcelRequire("absgL");

var $i9wU3 = parcelRequire("i9wU3");

var $7BD8h = parcelRequire("7BD8h");

var $ipNYr = parcelRequire("ipNYr");

var $5Fo99 = parcelRequire("5Fo99");

var $futbp = parcelRequire("futbp");

var $1tL0q = parcelRequire("1tL0q");

var $gsqYV = parcelRequire("gsqYV");

var $aV0Ix = parcelRequire("aV0Ix");

var $7f8BP = parcelRequire("7f8BP");

var $w2g3p = parcelRequire("w2g3p");

var $7pNkU = parcelRequire("7pNkU");

var $3saEQ = parcelRequire("3saEQ");

var $bBrvm = parcelRequire("bBrvm");

var $2MJ1F = parcelRequire("2MJ1F");

var $62PyO = parcelRequire("62PyO");

var $ct5mQ = parcelRequire("ct5mQ");

var $geCWF = parcelRequire("geCWF");

var $cA6yA = parcelRequire("cA6yA");

var $gE9fP = parcelRequire("gE9fP");

var $6Cmrb = parcelRequire("6Cmrb");

var $7Za1I = parcelRequire("7Za1I");

var $kgPFA = parcelRequire("kgPFA");

var $2hRuV = parcelRequire("2hRuV");

var $8H1nG = parcelRequire("8H1nG");

var $jfdMm = parcelRequire("jfdMm");

var $jAnMk = parcelRequire("jAnMk");

var $kiped = parcelRequire("kiped");

var $ijRK6 = parcelRequire("ijRK6");

var $hQTrZ = parcelRequire("hQTrZ");

var $3ussC = parcelRequire("3ussC");

var $bfQlR = parcelRequire("bfQlR");

var $g2zNl = parcelRequire("g2zNl");

var $dnUXX = parcelRequire("dnUXX");

var $ldCFU = parcelRequire("ldCFU");

var $gcvuo = parcelRequire("gcvuo");

var $3aulr = parcelRequire("3aulr");

var $jj7JF = parcelRequire("jj7JF");

var $gFh8H = parcelRequire("gFh8H");

var $ib1i9 = parcelRequire("ib1i9");

var $7vWf2 = parcelRequire("7vWf2");

var $MAw5A = parcelRequire("MAw5A");

var $4R6fR = parcelRequire("4R6fR");

var $3G8sv = parcelRequire("3G8sv");

var $5L3ZL = parcelRequire("5L3ZL");

var $1tIXy = parcelRequire("1tIXy");

var $gIr5o = parcelRequire("gIr5o");

var $jMi9Z = parcelRequire("jMi9Z");

var $5fTd1 = parcelRequire("5fTd1");

var $70IXo = parcelRequire("70IXo");

var $k45BN = parcelRequire("k45BN");

var $5t7IX = parcelRequire("5t7IX");

var $7y9m7 = parcelRequire("7y9m7");

var $kRP7t = parcelRequire("kRP7t");

var $dLJHp = parcelRequire("dLJHp");

var $MvguA = parcelRequire("MvguA");

var $i2wVj = parcelRequire("i2wVj");

var $bqNy3 = parcelRequire("bqNy3");

var $5RzHY = parcelRequire("5RzHY");

var $jN43s = parcelRequire("jN43s");

var $018bO = parcelRequire("018bO");

var $c3T8r = parcelRequire("c3T8r");

var $h0256 = parcelRequire("h0256");

var $8O3eM = parcelRequire("8O3eM");

var $8BcsQ = parcelRequire("8BcsQ");

var $ctuOo = parcelRequire("ctuOo");

var $9wms3 = parcelRequire("9wms3");

var $1j7TY = parcelRequire("1j7TY");

var $4ux8O = parcelRequire("4ux8O");

var $44Sb4 = parcelRequire("44Sb4");

var $dQMZo = parcelRequire("dQMZo");

var $zYoHs = parcelRequire("zYoHs");

var $04PGh = parcelRequire("04PGh");

var $ddSO1 = parcelRequire("ddSO1");

var $ivVMv = parcelRequire("ivVMv");

var $eJnd2 = parcelRequire("eJnd2");

var $98ut7 = parcelRequire("98ut7");

var $9q1Vk = parcelRequire("9q1Vk");

var $eMHgQ = parcelRequire("eMHgQ");

var $3LKHJ = parcelRequire("3LKHJ");

var $3ZCOi = parcelRequire("3ZCOi");

var $5xoX8 = parcelRequire("5xoX8");

var $5qhol = parcelRequire("5qhol");

var $dGRYO = parcelRequire("dGRYO");

var $6dhVt = parcelRequire("6dhVt");

var $ighEF = parcelRequire("ighEF");

var $jiyfa = parcelRequire("jiyfa");

var $aRWto = parcelRequire("aRWto");

var $3VNps = parcelRequire("3VNps");

var $62BuW = parcelRequire("62BuW");

var $54a3y = parcelRequire("54a3y");

var $cjnzF = parcelRequire("cjnzF");

var $faukZ = parcelRequire("faukZ");

var $Ox4am = parcelRequire("Ox4am");

var $hembw = parcelRequire("hembw");

var $5gEBh = parcelRequire("5gEBh");

var $76eQq = parcelRequire("76eQq");

var $68Yx0 = parcelRequire("68Yx0");

var $l08I5 = parcelRequire("l08I5");

const $40b74b738da6af36$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($45p5c))),
        messageDescriptor: (0, $lfFy6.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66aLS))),
        messageDescriptor: (0, $lfFy6.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eA5k9))),
        messageDescriptor: (0, $lfFy6.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLHML))),
        messageDescriptor: (0, $lfFy6.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5QM3U))),
        messageDescriptor: (0, $lfFy6.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1zbJy))),
        messageDescriptor: (0, $lfFy6.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7BD8h))),
        messageDescriptor: (0, $lfFy6.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ipNYr))),
        messageDescriptor: (0, $lfFy6.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Fo99))),
        messageDescriptor: (0, $lfFy6.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($futbp))),
        messageDescriptor: (0, $lfFy6.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tL0q))),
        messageDescriptor: (0, $lfFy6.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aV0Ix))),
        messageDescriptor: (0, $lfFy6.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f8BP))),
        messageDescriptor: (0, $lfFy6.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($w2g3p))),
        messageDescriptor: (0, $lfFy6.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7y9m7))),
        messageDescriptor: (0, $lfFy6.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pNkU))),
        messageDescriptor: (0, $lfFy6.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3saEQ))),
        messageDescriptor: (0, $lfFy6.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62PyO))),
        messageDescriptor: (0, $lfFy6.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ct5mQ))),
        messageDescriptor: (0, $lfFy6.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($geCWF))),
        messageDescriptor: (0, $lfFy6.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cA6yA))),
        messageDescriptor: (0, $lfFy6.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gE9fP))),
        messageDescriptor: (0, $lfFy6.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Cmrb))),
        messageDescriptor: (0, $lfFy6.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgPFA))),
        messageDescriptor: (0, $lfFy6.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jfdMm))),
        messageDescriptor: (0, $lfFy6.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jAnMk))),
        messageDescriptor: (0, $lfFy6.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ijRK6))),
        messageDescriptor: (0, $lfFy6.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hQTrZ))),
        messageDescriptor: (0, $lfFy6.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ussC))),
        messageDescriptor: (0, $lfFy6.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfQlR))),
        messageDescriptor: (0, $lfFy6.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g2zNl))),
        messageDescriptor: (0, $lfFy6.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ldCFU))),
        messageDescriptor: (0, $lfFy6.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gcvuo))),
        messageDescriptor: (0, $lfFy6.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3aulr))),
        messageDescriptor: (0, $lfFy6.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jj7JF))),
        messageDescriptor: (0, $lfFy6.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gFh8H))),
        messageDescriptor: (0, $lfFy6.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ib1i9))),
        messageDescriptor: (0, $lfFy6.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7vWf2))),
        messageDescriptor: (0, $lfFy6.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MAw5A))),
        messageDescriptor: (0, $lfFy6.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4R6fR))),
        messageDescriptor: (0, $lfFy6.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3G8sv))),
        messageDescriptor: (0, $lfFy6.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5L3ZL))),
        messageDescriptor: (0, $lfFy6.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tIXy))),
        messageDescriptor: (0, $lfFy6.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gIr5o))),
        messageDescriptor: (0, $lfFy6.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jMi9Z))),
        messageDescriptor: (0, $lfFy6.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k45BN))),
        messageDescriptor: (0, $lfFy6.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5t7IX))),
        messageDescriptor: (0, $lfFy6.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MvguA))),
        messageDescriptor: (0, $lfFy6.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i2wVj))),
        messageDescriptor: (0, $lfFy6.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bqNy3))),
        messageDescriptor: (0, $lfFy6.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jN43s))),
        messageDescriptor: (0, $lfFy6.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3T8r))),
        messageDescriptor: (0, $lfFy6.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h0256))),
        messageDescriptor: (0, $lfFy6.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8O3eM))),
        messageDescriptor: (0, $lfFy6.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BcsQ))),
        messageDescriptor: (0, $lfFy6.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ctuOo))),
        messageDescriptor: (0, $lfFy6.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9wms3))),
        messageDescriptor: (0, $lfFy6.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1j7TY))),
        messageDescriptor: (0, $lfFy6.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ux8O))),
        messageDescriptor: (0, $lfFy6.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($44Sb4))),
        messageDescriptor: (0, $lfFy6.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dQMZo))),
        messageDescriptor: (0, $lfFy6.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04PGh))),
        messageDescriptor: (0, $lfFy6.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ddSO1))),
        messageDescriptor: (0, $lfFy6.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ivVMv))),
        messageDescriptor: (0, $lfFy6.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eJnd2))),
        messageDescriptor: (0, $lfFy6.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($98ut7))),
        messageDescriptor: (0, $lfFy6.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9q1Vk))),
        messageDescriptor: (0, $lfFy6.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3LKHJ))),
        messageDescriptor: (0, $lfFy6.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ZCOi))),
        messageDescriptor: (0, $lfFy6.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5xoX8))),
        messageDescriptor: (0, $lfFy6.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5qhol))),
        messageDescriptor: (0, $lfFy6.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6dhVt))),
        messageDescriptor: (0, $lfFy6.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ighEF))),
        messageDescriptor: (0, $lfFy6.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jiyfa))),
        messageDescriptor: (0, $lfFy6.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aRWto))),
        messageDescriptor: (0, $lfFy6.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3VNps))),
        messageDescriptor: (0, $lfFy6.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54a3y))),
        messageDescriptor: (0, $lfFy6.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cjnzF))),
        messageDescriptor: (0, $lfFy6.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($faukZ))),
        messageDescriptor: (0, $lfFy6.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hembw))),
        messageDescriptor: (0, $lfFy6.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68Yx0))),
        messageDescriptor: (0, $lfFy6.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l08I5))),
        messageDescriptor: (0, $lfFy6.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $40b74b738da6af36$export$4522d3d70312bbdc;

});

parcelRegister("lfFy6", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $11f365f4e13bb9e0$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $11f365f4e13bb9e0$export$defe85febe8b728c;

});

parcelRegister("45p5c", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("66aLS", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("eA5k9", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("dLHML", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("5QM3U", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("1zbJy", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("absgL", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("i9wU3", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("7BD8h", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("ipNYr", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("5Fo99", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("futbp", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("1tL0q", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("gsqYV", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("aV0Ix", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("7f8BP", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("w2g3p", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("7pNkU", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("3saEQ", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("bBrvm", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("2MJ1F", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("62PyO", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("ct5mQ", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("geCWF", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("cA6yA", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("gE9fP", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("6Cmrb", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("7Za1I", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kgPFA", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("2hRuV", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("8H1nG", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("jfdMm", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("jAnMk", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("kiped", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("ijRK6", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("hQTrZ", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("3ussC", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("bfQlR", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("g2zNl", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("dnUXX", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("ldCFU", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("gcvuo", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("3aulr", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("jj7JF", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("gFh8H", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("ib1i9", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("7vWf2", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("MAw5A", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("4R6fR", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("3G8sv", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("5L3ZL", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("1tIXy", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("gIr5o", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("jMi9Z", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("5fTd1", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("70IXo", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("k45BN", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("5t7IX", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("7y9m7", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("kRP7t", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("dLJHp", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("MvguA", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("i2wVj", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("bqNy3", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("5RzHY", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("jN43s", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("018bO", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("c3T8r", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("h0256", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("8O3eM", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("8BcsQ", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("ctuOo", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("9wms3", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("1j7TY", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("4ux8O", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("44Sb4", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("dQMZo", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("zYoHs", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("04PGh", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("ddSO1", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("ivVMv", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("eJnd2", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("98ut7", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("9q1Vk", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("eMHgQ", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("3LKHJ", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("3ZCOi", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("5xoX8", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("5qhol", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("dGRYO", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("6dhVt", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("ighEF", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("jiyfa", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("aRWto", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("3VNps", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("62BuW", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("54a3y", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("cjnzF", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("faukZ", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("Ox4am", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("hembw", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("5gEBh", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("76eQq", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("68Yx0", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("l08I5", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("fDtVg", function(module, exports) {

var $gc1M8 = parcelRequire("gc1M8");

var $jaEJa = parcelRequire("jaEJa");


var $hTKp4 = parcelRequire("hTKp4");


var $eUBDm = parcelRequire("eUBDm");


var $hFOxw = parcelRequire("hFOxw");

const $9e6967f04f453315$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $9e6967f04f453315$var$intlCacheMap = new Map();
const $9e6967f04f453315$export$51771ec7613ad564 = async ()=>{
    const key = (0, $hTKp4.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$9e6967f04f453315$var$intlCacheMap.has(key)) {
        const messages = await $9e6967f04f453315$var$fetchMessages(key);
        const cache = (0, $jaEJa.createIntlCache)();
        const intl = (0, $gc1M8.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $9e6967f04f453315$var$intlCacheMap.set(key, intl);
    }
    return $9e6967f04f453315$var$intlCacheMap.get(key);
};
const $9e6967f04f453315$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($9e6967f04f453315$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $hFOxw.default;
};
module.exports["getIntl"] = $9e6967f04f453315$export$51771ec7613ad564;

});

parcelRegister("eUBDm", function(module, exports) {




























const $6e63713db070a09c$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("hFOxw"))),
    cs: ()=>(parcelRequire("kc8TR")),
    da: ()=>(parcelRequire("l3Kdd")),
    de: ()=>(parcelRequire("69yb2")),
    en_GB: ()=>(parcelRequire("cSOaW")),
    en_ZZ: ()=>(parcelRequire("ctTgM")),
    es: ()=>(parcelRequire("7UFmH")),
    fi: ()=>(parcelRequire("9H5BD")),
    fr: ()=>(parcelRequire("gXf6j")),
    hr: ()=>(parcelRequire("3qf4b")),
    hu: ()=>(parcelRequire("d7gDR")),
    it: ()=>(parcelRequire("l2XrF")),
    ja: ()=>(parcelRequire("VVLwh")),
    ko: ()=>(parcelRequire("8mka3")),
    nb: ()=>(parcelRequire("16UCW")),
    nl: ()=>(parcelRequire("6xRKn")),
    pl: ()=>(parcelRequire("1tICX")),
    pt_BR: ()=>(parcelRequire("1nGwo")),
    ru: ()=>(parcelRequire("aVCyQ")),
    sr_RS: ()=>(parcelRequire("gJHrP")),
    sr_YR: ()=>(parcelRequire("lmyN0")),
    sv: ()=>(parcelRequire("fgOYH")),
    th: ()=>(parcelRequire("iASA2")),
    tr: ()=>(parcelRequire("gK9Le")),
    uk: ()=>(parcelRequire("5TJ1f")),
    vi: ()=>(parcelRequire("aaIRG")),
    zh: ()=>(parcelRequire("9nWlJ")),
    zh_TW: ()=>(parcelRequire("4oaks"))
};
module.exports["locales"] = $6e63713db070a09c$export$df1c34db1371eeed;

});

parcelRegister("kc8TR", function(module, exports) {

let $eb3bd4f74933f558$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb3bd4f74933f558$var$load("jMBLi").then(()=>parcelRequire('7ZLoJ'));

});

parcelRegister("l3Kdd", function(module, exports) {

let $f54db99165770b8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f54db99165770b8b$var$load("dKSPa").then(()=>parcelRequire('aEN3l'));

});

parcelRegister("69yb2", function(module, exports) {

let $0127f821ddfc863b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0127f821ddfc863b$var$load("aNGGp").then(()=>parcelRequire('33xoI'));

});

parcelRegister("cSOaW", function(module, exports) {

let $961172f85f6e3edb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $961172f85f6e3edb$var$load("16eqk").then(()=>parcelRequire('kWJx6'));

});

parcelRegister("ctTgM", function(module, exports) {

let $916310dbaec8ddd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $916310dbaec8ddd8$var$load("smHwh").then(()=>parcelRequire('dbZYo'));

});

parcelRegister("7UFmH", function(module, exports) {

let $5c2dd99cb70ac8a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c2dd99cb70ac8a2$var$load("lLAhl").then(()=>parcelRequire('9KFoy'));

});

parcelRegister("9H5BD", function(module, exports) {

let $70ec7a6fe087c63a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70ec7a6fe087c63a$var$load("7lUpZ").then(()=>parcelRequire('4qdbO'));

});

parcelRegister("gXf6j", function(module, exports) {

let $c57ddebbf836b105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c57ddebbf836b105$var$load("iFuRL").then(()=>parcelRequire('bIVe0'));

});

parcelRegister("3qf4b", function(module, exports) {

let $27df7cab7356feaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27df7cab7356feaf$var$load("bwpap").then(()=>parcelRequire('8NtSc'));

});

parcelRegister("d7gDR", function(module, exports) {

let $98c8d68f3df49e25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98c8d68f3df49e25$var$load("2qkmI").then(()=>parcelRequire('cGCVy'));

});

parcelRegister("l2XrF", function(module, exports) {

let $f527e57b693e6f21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f527e57b693e6f21$var$load("kxYID").then(()=>parcelRequire('9bmhY'));

});

parcelRegister("VVLwh", function(module, exports) {

let $0ae221fff906b001$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ae221fff906b001$var$load("iHsNL").then(()=>parcelRequire('51o1K'));

});

parcelRegister("8mka3", function(module, exports) {

let $6160045ed2e1ab4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6160045ed2e1ab4f$var$load("jGOT0").then(()=>parcelRequire('gLajM'));

});

parcelRegister("16UCW", function(module, exports) {

let $0cf246f0069fd885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cf246f0069fd885$var$load("3s5dS").then(()=>parcelRequire('2zKQ5'));

});

parcelRegister("6xRKn", function(module, exports) {

let $4c3f843445da2586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c3f843445da2586$var$load("ffRdF").then(()=>parcelRequire('1nf4f'));

});

parcelRegister("1tICX", function(module, exports) {

let $113b1df702e7a97e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $113b1df702e7a97e$var$load("bS9i1").then(()=>parcelRequire('8l63g'));

});

parcelRegister("1nGwo", function(module, exports) {

let $1018ec47e040097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1018ec47e040097d$var$load("3ydLu").then(()=>parcelRequire('asVO6'));

});

parcelRegister("aVCyQ", function(module, exports) {

let $7f4d23afc1ab1ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f4d23afc1ab1ef8$var$load("lqmbR").then(()=>parcelRequire('FrAje'));

});

parcelRegister("gJHrP", function(module, exports) {

let $c2f28d20061ad1be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2f28d20061ad1be$var$load("3px1j").then(()=>parcelRequire('54f3C'));

});

parcelRegister("lmyN0", function(module, exports) {

let $f8d6a37afb93b948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8d6a37afb93b948$var$load("1NiRW").then(()=>parcelRequire('3pGwL'));

});

parcelRegister("fgOYH", function(module, exports) {

let $b1dfe4ceecde867c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1dfe4ceecde867c$var$load("auBTD").then(()=>parcelRequire('5D8Rs'));

});

parcelRegister("iASA2", function(module, exports) {

let $d895ed4bca06a46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d895ed4bca06a46b$var$load("fxn2i").then(()=>parcelRequire('aWxTt'));

});

parcelRegister("gK9Le", function(module, exports) {

let $c30883821cb64545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30883821cb64545$var$load("adwGb").then(()=>parcelRequire('34LZI'));

});

parcelRegister("5TJ1f", function(module, exports) {

let $44b502b0c10ff069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44b502b0c10ff069$var$load("guUGa").then(()=>parcelRequire('2u29z'));

});

parcelRegister("aaIRG", function(module, exports) {

let $767da3c31aa6ce24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767da3c31aa6ce24$var$load("9bAgX").then(()=>parcelRequire('clDBP'));

});

parcelRegister("9nWlJ", function(module, exports) {

let $01c369634d8d2eb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01c369634d8d2eb9$var$load("HLzfe").then(()=>parcelRequire('9dypO'));

});

parcelRegister("4oaks", function(module, exports) {

let $33216a6e72302c57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33216a6e72302c57$var$load("in5qk").then(()=>parcelRequire('2iJQj'));

});

parcelRegister("hFOxw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1afed9367fc4c445$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $1afed9367fc4c445$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("99F08", function(module, exports) {
const $a1227471ca9b2621$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $a1227471ca9b2621$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $a1227471ca9b2621$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $a1227471ca9b2621$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $a1227471ca9b2621$export$cffaac380b94df26;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}workflowApplicationChanged{contentId changeType newWorkflowStatusId contentStatus version __typename}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("jacyh", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $1P1Tu.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $9zUhf.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $9zUhf.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("5M5fB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $42omo.useRef)(null);
    const currentParticipants = (0, $42omo.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $42omo.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $42omo.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $42omo.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("gabmL", function(module, exports) {

var $9eNhQ = parcelRequire("9eNhQ");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $h82at.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && edition === (0, $euL71.ConfluenceEdition).PREMIUM && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const canEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $1cfRh.default)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $jMyy4.useQueryInterop)((0, $9eNhQ.default), {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $42omo.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $42omo.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("9eNhQ", function(module, exports) {
/**
 * @generated SignedSource<<7779e11981511fd73194a1f3ea622429>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184
const $858700f9e1edfc48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "publicLinkPage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                },
                {
                    "kind": "ScalarField",
                    "name": "publicLinkUrlPath"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
            "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
            "metadata": {},
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
        }
    };
}();
$858700f9e1edfc48$var$node.hash = "c030204610be720b223484d4a8d871cf";
var $858700f9e1edfc48$export$2e2bcd8739ae039 = $858700f9e1edfc48$var$node;
module.exports["default"] = $858700f9e1edfc48$export$2e2bcd8739ae039;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("1X7PR", function(module, exports) {

var $OoVEI = parcelRequire("OoVEI");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");


var $jMyy4 = parcelRequire("jMyy4");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const canEditPage = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
    return {
        contentType: contentType,
        canEditPublicLink: (isSpaceAdmin || canEditPage) && !isExternalCollaborator
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $OoVEI.default), {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("OoVEI", function(module, exports) {
/**
 * @generated SignedSource<<9ee0129e987eefa6c6435a45dfdde784>>
 * @relayHash 6ab077a19d911ef98a26d3adbdc3fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da
const $77c51ddc0082b191$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "hasSpaceKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6ab077a19d911ef98a26d3adbdc3fb56",
            "id": "d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da",
            "metadata": {},
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "operationKind": "query",
            "text": "query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!,$spaceKey:String!,$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id,type,operations{operation,targetType}}},space(key:$spaceKey)@include(if:$hasSpaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$77c51ddc0082b191$var$node.hash = "59655c56a4e7fa1ddec49b3697d04128";
var $77c51ddc0082b191$export$2e2bcd8739ae039 = $77c51ddc0082b191$var$node;
module.exports["default"] = $77c51ddc0082b191$export$2e2bcd8739ae039;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("bgRei", function(module, exports) {

var $8lkfF = parcelRequire("8lkfF");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8lkfF.default), {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions?.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("8lkfF", function(module, exports) {
/**
 * @generated SignedSource<<74a53b97ddf6a36aa7667de58bb5ee11>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1
const $5d187f97ac5d0d36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "objectId",
                    "variableName": "objectId"
                },
                {
                    "kind": "Variable",
                    "name": "objectType",
                    "variableName": "objectType"
                }
            ],
            "concreteType": "PublicLinkPermissions",
            "kind": "LinkedField",
            "name": "publicLinkPermissionsForObject",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissions"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f71176804f0f8510a7464cc538777917",
            "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
            "metadata": {},
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
        }
    };
}();
$5d187f97ac5d0d36$var$node.hash = "374477f8db79649c77f638ae2ac0ca9b";
var $5d187f97ac5d0d36$export$2e2bcd8739ae039 = $5d187f97ac5d0d36$var$node;
module.exports["default"] = $5d187f97ac5d0d36$export$2e2bcd8739ae039;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("gPK0E"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("5HFAF"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("bq57R"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("htsj6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, options);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<2907f65b81f9f12ac8d707a3a8f4b524>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("gPK0E", function(module, exports) {

let $c415194a66103e4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c415194a66103e4f$var$load("i4xbo"),
    $c415194a66103e4f$var$load("i8eeg"),
    $c415194a66103e4f$var$load("iFdoJ"),
    $c415194a66103e4f$var$load("ivbae"),
    $c415194a66103e4f$var$load("3Bbwl"),
    $c415194a66103e4f$var$load("7EorR"),
    $c415194a66103e4f$var$load("dRpV3"),
    $c415194a66103e4f$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("5HFAF", function(module, exports) {

let $42713ae597167d49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42713ae597167d49$var$load("kHOMt"),
    $42713ae597167d49$var$load("dRpV3"),
    $42713ae597167d49$var$load("jYUNl"),
    $42713ae597167d49$var$load("foy8I"),
    $42713ae597167d49$var$load("i8eeg"),
    $42713ae597167d49$var$load("iFdoJ"),
    $42713ae597167d49$var$load("6wr18"),
    $42713ae597167d49$var$load("ffEVr"),
    $42713ae597167d49$var$load("gYeBT"),
    $42713ae597167d49$var$load("8LtYa"),
    $42713ae597167d49$var$load("9qN8n"),
    $42713ae597167d49$var$load("g9CVe"),
    $42713ae597167d49$var$load("3JSgG"),
    $42713ae597167d49$var$load("cKm5l"),
    $42713ae597167d49$var$load("i4xbo"),
    $42713ae597167d49$var$load("h3ABO"),
    $42713ae597167d49$var$load("kC80R"),
    $42713ae597167d49$var$load("7EorR"),
    $42713ae597167d49$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("bq57R", function(module, exports) {

let $8506194902a9f1db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8506194902a9f1db$var$load("h3ABO"),
    $8506194902a9f1db$var$load("282rq"),
    $8506194902a9f1db$var$load("6wr18"),
    $8506194902a9f1db$var$load("d24tW"),
    $8506194902a9f1db$var$load("bfveI"),
    $8506194902a9f1db$var$load("1GCFv"),
    $8506194902a9f1db$var$load("4l6RQ"),
    $8506194902a9f1db$var$load("cLmw6"),
    $8506194902a9f1db$var$load("lNrIG"),
    $8506194902a9f1db$var$load("dvUU0"),
    $8506194902a9f1db$var$load("a9w2G"),
    $8506194902a9f1db$var$load("gYeBT"),
    $8506194902a9f1db$var$load("8LtYa"),
    $8506194902a9f1db$var$load("iGCP8"),
    $8506194902a9f1db$var$load("lGcru"),
    $8506194902a9f1db$var$load("6cnH1"),
    $8506194902a9f1db$var$load("lkOIY"),
    $8506194902a9f1db$var$load("dI1Cd"),
    $8506194902a9f1db$var$load("jbxHq"),
    $8506194902a9f1db$var$load("8YSo7"),
    $8506194902a9f1db$var$load("e7ZUf"),
    $8506194902a9f1db$var$load("gL8bn"),
    $8506194902a9f1db$var$load("9ijrN"),
    $8506194902a9f1db$var$load("hv4mn"),
    $8506194902a9f1db$var$load("Wowvf"),
    $8506194902a9f1db$var$load("3JSgG"),
    $8506194902a9f1db$var$load("cyGuT"),
    $8506194902a9f1db$var$load("ffEVr"),
    $8506194902a9f1db$var$load("dRpV3"),
    $8506194902a9f1db$var$load("dTsOE"),
    $8506194902a9f1db$var$load("hhss7"),
    $8506194902a9f1db$var$load("kbsoN"),
    $8506194902a9f1db$var$load("fM2zn"),
    $8506194902a9f1db$var$load("jYUNl"),
    $8506194902a9f1db$var$load("foy8I"),
    $8506194902a9f1db$var$load("bIjrH"),
    $8506194902a9f1db$var$load("9dXbh"),
    $8506194902a9f1db$var$load("i4xbo"),
    $8506194902a9f1db$var$load("jY21r"),
    $8506194902a9f1db$var$load("dP7ao"),
    $8506194902a9f1db$var$load("hogcU"),
    $8506194902a9f1db$var$load("9jjvO"),
    $8506194902a9f1db$var$load("i8eeg"),
    $8506194902a9f1db$var$load("iFdoJ"),
    $8506194902a9f1db$var$load("77NEU"),
    $8506194902a9f1db$var$load("2uVTT"),
    $8506194902a9f1db$var$load("5tmW9"),
    $8506194902a9f1db$var$load("cpQv0"),
    $8506194902a9f1db$var$load("kAaiF"),
    $8506194902a9f1db$var$load("8ublV"),
    $8506194902a9f1db$var$load("9LW4b"),
    $8506194902a9f1db$var$load("enrPB"),
    $8506194902a9f1db$var$load("fnlWy"),
    $8506194902a9f1db$var$load("7EorR"),
    $8506194902a9f1db$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<b75deca64f0533d7fe2b70cf54f2ff13>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("3pU8m", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $3scmi = parcelRequire("3scmi");


var $56M4r = parcelRequire("56M4r");


var $iTh4n = parcelRequire("iTh4n");


var $jwNgW = parcelRequire("jwNgW");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $a61a6d10c0a933b0$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $jwNgW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $iTh4n.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $a61a6d10c0a933b0$export$2e2bcd8739ae039 = $a61a6d10c0a933b0$var$DropdownItemCheckbox;
module.exports["default"] = $a61a6d10c0a933b0$export$2e2bcd8739ae039;

});

parcelRegister("iTh4n", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $ade312c7505f4d8d$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $ade312c7505f4d8d$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $ade312c7505f4d8d$export$2e2bcd8739ae039 = $ade312c7505f4d8d$var$CheckboxIcon;
module.exports["default"] = $ade312c7505f4d8d$export$2e2bcd8739ae039;

});

parcelRegister("jwNgW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1FJYC = parcelRequire("1FJYC");


var $nVQ0B = parcelRequire("nVQ0B");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $05848c92b720c3b2$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $42omo.useContext)((0, $nVQ0B.SelectionStoreContext));
    const groupId = (0, $42omo.useContext)((0, $1FJYC.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $05848c92b720c3b2$export$2e2bcd8739ae039 = $05848c92b720c3b2$var$useCheckboxState;
module.exports["default"] = $05848c92b720c3b2$export$2e2bcd8739ae039;

});

parcelRegister("1FJYC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d17552b6cb2fab4$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $42omo.createContext)('');
module.exports["CheckboxGroupContext"] = $5d17552b6cb2fab4$export$baf37c4be89255b8;

});

parcelRegister("fKL7x", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $1FJYC = parcelRequire("1FJYC");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FJYC.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $b6be4855f2bf1ca8$export$2e2bcd8739ae039 = $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup;
module.exports["default"] = $b6be4855f2bf1ca8$export$2e2bcd8739ae039;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");





var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eSUdr.default)`query useViewedCommentsQuery($contentId:ID!$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId contentType:$contentType){commentIds}}`;
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, whiteboard, and slide support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType)) return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $aXiya.default),
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds,
                        __typename: 'ViewedComments'
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<d7ff2c3ce2ccb5f9937eae905c203b17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<4105699bb3b57f32cd10410da7fded55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("fy5yb", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");

const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cUycv.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && comment.isOpen) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};
const $747cae967af72a91$export$4e544898773875e3 = ({ isReply: isReply, threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    if (isReply || !(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: {
            [threadKey]: commentsDataMap.inline[threadKey]
        },
        [(0, $8i27m.CommentType).GENERAL]: {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$36d96c1319999e05 = ({ threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: commentType === (0, $8i27m.CommentType).INLINE ? {
            [threadKey]: parentComment
        } : {},
        [(0, $8i27m.CommentType).GENERAL]: commentType === (0, $8i27m.CommentType).GENERAL ? {
            [threadKey]: parentComment
        } : {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$485aa15bd11fefca = ({ threadKey: threadKey, commentId: commentId, commentType: commentType, commentsDataMap: commentsDataMap, handleRemovingComments: handleRemovingComments })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const replies = parentComment.replies;
    const deletedReplyComment = replies.find((reply)=>reply.id === commentId);
    if (!deletedReplyComment) return null;
    handleRemovingComments({
        threadKey: threadKey,
        commentId: commentId,
        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
        commentType: commentType
    });
    return deletedReplyComment;
};
module.exports["getResolvedAnnotationState"] = $747cae967af72a91$export$765c3cc11af57952;
module.exports["computeResolvedCommentIds"] = $747cae967af72a91$export$8407ff9f3ad87778;
module.exports["updateResolvedComments"] = $747cae967af72a91$export$e25befbc00a116b;
module.exports["deleteInlineParentComment"] = $747cae967af72a91$export$4e544898773875e3;
module.exports["deleteParentCommentOptimistically"] = $747cae967af72a91$export$36d96c1319999e05;
module.exports["deleteReplyCommentOptimistically"] = $747cae967af72a91$export$485aa15bd11fefca;

});

parcelRegister("b4BfG", function(module, exports) {

var $hMac6 = parcelRequire("hMac6");


var $42omo = parcelRequire("42omo");


var $lesF8 = parcelRequire("lesF8");


var $7EEGh = parcelRequire("7EEGh");


var $jMyy4 = parcelRequire("jMyy4");


var $hXzKU = parcelRequire("hXzKU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");

const $a75b2138c8eb75e6$export$b9905c4f8315d0a1 = ({ mode: mode, saveHandler: saveHandler, cancelHandler: cancelHandler, onEditorLoaded: onEditorLoaded, onEditorReady: onEditorReady, onEditorContentChanged: onEditorContentChanged, onEditorContentChangedWithData: onEditorContentChangedWithData, afterActivate: afterActivate, content: content, useNewExperienceAbort: useNewExperienceAbort, expandEditor: expandEditor, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, isOffline: isOffline = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hMac6.default), {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const operations = (0, $42omo.useMemo)(()=>data?.content?.nodes?.[0]?.operations ?? [], [
        data
    ]);
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? data?.content?.nodes?.[0]?.space?.operations || [] : [], [
        data
    ]);
    const canEditPage = (0, $42omo.useMemo)(()=>operations.filter((op)=>op?.operation === 'update' && op?.targetType === contentType).length > 0, [
        operations,
        contentType
    ]);
    const canAddComment = (0, $42omo.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'), [
        operations
    ]);
    const canAddAttachment = (0, $42omo.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'), [
        operations,
        spaceOperations
    ]);
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : canEditPage;
    // Simulate the unmount function for the other editor
    (0, $42omo.useEffect)(()=>()=>{
            cancelHandler({
                isEditorAborted: false
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        const handleExperienceAbort = ()=>{
            const reason = 'Navigated away from page';
            if (mode === 'edit') experienceTracker.abort({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else if (mode === 'reply') experienceTracker.abort({
                name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else experienceTracker.abort({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
        };
        if (useNewExperienceAbort) window.addEventListener('beforeunload', handleExperienceAbort);
        return ()=>{
            if (useNewExperienceAbort) window.removeEventListener('beforeunload', handleExperienceAbort);
        };
    }, [
        experienceTracker,
        mode,
        useNewExperienceAbort
    ]);
    const handleSave = (0, $42omo.useCallback)((adf, onSuccess)=>saveHandler({
            adf: adf
        }, onSuccess).catch((err)=>{
            // There is another handler higher up to re-enable the buttons, throw the error to allow for that
            throw err;
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        saveHandler
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        cancelHandler({
            isEditorAborted: true
        });
    }, [
        cancelHandler
    ]);
    const handleEditorReady = (0, $42omo.useCallback)((editorActions)=>{
        onEditorLoaded();
        onEditorReady?.(editorActions);
    }, [
        onEditorLoaded,
        onEditorReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditorWithoutSpinner), {
        pageId: contentId,
        pageType: contentType,
        appearance: isCommentsPanel ? 'chromeless' : 'comment',
        EditorComponent: isCommentsPanel ? (0, $7EEGh.ChromelessEditor) : (0, $lesF8.CommentEditor),
        commentMode: mode,
        commentType: "page",
        spaceId: spaceId,
        onSaveComment: handleSave,
        content: content,
        onCancelComment: handleCancel,
        onEditorReady: handleEditorReady,
        onContentChange: onEditorContentChanged,
        onContentChangeWithData: onEditorContentChangedWithData,
        afterActivation: afterActivate,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldWarnOnInternalNavigation: true,
        expandEditor: expandEditor,
        showCancelButton: isCommentsPanel || isFooterComment,
        useNewWarningModal: isCommentsPanel || isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isOffline: isOffline
    });
};
module.exports["PageCommentEditor"] = $a75b2138c8eb75e6$export$b9905c4f8315d0a1;

});

parcelRegister("hMac6", function(module, exports) {
/**
 * @generated SignedSource<<652bcab032e5a74815fb8aa3068e715b>>
 * @relayHash 84a9c75863296610fb60639c2398b5f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608
const $e6c37684dc7bdb3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "84a9c75863296610fb60639c2398b5f3",
            "id": "f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608",
            "metadata": {},
            "name": "PageCommentEditorContentOperationsQuery",
            "operationKind": "query",
            "text": "query PageCommentEditorContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}}}"
        }
    };
}();
$e6c37684dc7bdb3d$var$node.hash = "84986896d9e1b1e2bb0707f822adf359";
var $e6c37684dc7bdb3d$export$2e2bcd8739ae039 = $e6c37684dc7bdb3d$var$node;
module.exports["default"] = $e6c37684dc7bdb3d$export$2e2bcd8739ae039;

});

parcelRegister("lesF8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

function $0eec8481dd12dbe1$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
}
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

function $c97a308eea576e63$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
}
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("9pcI3"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("9pcI3"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("9pcI3"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1cfRh = parcelRequire("1cfRh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("9pcI3", function(module, exports) {

let $6d904eb8182365b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d904eb8182365b8$var$load("e7ZUf"),
    $6d904eb8182365b8$var$load("gL8bn"),
    $6d904eb8182365b8$var$load("djHM5"),
    $6d904eb8182365b8$var$load("eJQji"),
    $6d904eb8182365b8$var$load("kbsoN"),
    $6d904eb8182365b8$var$load("fM2zn"),
    $6d904eb8182365b8$var$load("cXen0"),
    $6d904eb8182365b8$var$load("enrPB"),
    $6d904eb8182365b8$var$load("fnlWy"),
    $6d904eb8182365b8$var$load("2YffH"),
    $6d904eb8182365b8$var$load("0sMQY"),
    $6d904eb8182365b8$var$load("jOdEL"),
    $6d904eb8182365b8$var$load("1f9Ew"),
    $6d904eb8182365b8$var$load("1P7J4"),
    $6d904eb8182365b8$var$load("i1up4"),
    $6d904eb8182365b8$var$load("6cnH1"),
    $6d904eb8182365b8$var$load("1GvGi"),
    $6d904eb8182365b8$var$load("d4u0p"),
    $6d904eb8182365b8$var$load("hfoh5"),
    $6d904eb8182365b8$var$load("eNZbx"),
    $6d904eb8182365b8$var$load("h4mB6"),
    $6d904eb8182365b8$var$load("k8QRJ"),
    $6d904eb8182365b8$var$load("43bfx"),
    $6d904eb8182365b8$var$load("cD6Zr"),
    $6d904eb8182365b8$var$load("lkOIY"),
    $6d904eb8182365b8$var$load("g3Ife"),
    $6d904eb8182365b8$var$load("kLojH"),
    $6d904eb8182365b8$var$load("282rq"),
    $6d904eb8182365b8$var$load("lHACy"),
    $6d904eb8182365b8$var$load("eBY1U"),
    $6d904eb8182365b8$var$load("dUz9k"),
    $6d904eb8182365b8$var$load("5IKAE"),
    $6d904eb8182365b8$var$load("9wzNh"),
    $6d904eb8182365b8$var$load("5uHxI"),
    $6d904eb8182365b8$var$load("9ldRJ"),
    $6d904eb8182365b8$var$load("9anPW"),
    $6d904eb8182365b8$var$load("klllM"),
    $6d904eb8182365b8$var$load("5pvpJ"),
    $6d904eb8182365b8$var$load("hshEG"),
    $6d904eb8182365b8$var$load("6iz6l"),
    $6d904eb8182365b8$var$load("4SCW2"),
    $6d904eb8182365b8$var$load("855o0"),
    $6d904eb8182365b8$var$load("8MfZE"),
    $6d904eb8182365b8$var$load("Wowvf"),
    $6d904eb8182365b8$var$load("6wr18"),
    $6d904eb8182365b8$var$load("kjZZD"),
    $6d904eb8182365b8$var$load("2zxmz"),
    $6d904eb8182365b8$var$load("7269o"),
    $6d904eb8182365b8$var$load("3JSgG"),
    $6d904eb8182365b8$var$load("cyGuT"),
    $6d904eb8182365b8$var$load("ffEVr"),
    $6d904eb8182365b8$var$load("1qlDN"),
    $6d904eb8182365b8$var$load("1yVM6"),
    $6d904eb8182365b8$var$load("hhss7"),
    $6d904eb8182365b8$var$load("jYUNl"),
    $6d904eb8182365b8$var$load("foy8I"),
    $6d904eb8182365b8$var$load("bIjrH"),
    $6d904eb8182365b8$var$load("9dXbh"),
    $6d904eb8182365b8$var$load("jY21r"),
    $6d904eb8182365b8$var$load("9jjvO"),
    $6d904eb8182365b8$var$load("i8eeg"),
    $6d904eb8182365b8$var$load("iFdoJ"),
    $6d904eb8182365b8$var$load("5tmW9"),
    $6d904eb8182365b8$var$load("7EorR"),
    $6d904eb8182365b8$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("gsf3i", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4c2208d3e228490f$var$initialState = {
    firstRedactionIdRendered: null,
    titleRedactionRenderedForContentId: null,
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $4c2208d3e228490f$var$Store = (0, $1P1Tu.createStore)({
    initialState: $4c2208d3e228490f$var$initialState,
    actions: {
        setFirstRedactionIdRendered: (redactionId)=>({ getState: getState, setState: setState })=>{
                const { firstRedactionIdRendered: firstRedactionIdRendered } = getState();
                if (firstRedactionIdRendered) return;
                setState({
                    firstRedactionIdRendered: redactionId
                });
            },
        setTitleRedactionRenderedForContentId: (contentId)=>({ setState: setState })=>{
                setState({
                    titleRedactionRenderedForContentId: contentId
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: $4c2208d3e228490f$var$initialState.activeSpotlightIndex,
                    lastActiveSpotlightIndex: $4c2208d3e228490f$var$initialState.lastActiveSpotlightIndex
                });
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $4c2208d3e228490f$export$4e8589b303f4384d = (0, $9zUhf.createHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$b121a589d2d05ff2 = (0, $9zUhf.createActionsHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$f2a6ed6b1eb18db8 = (0, $9zUhf.createStateHook)($4c2208d3e228490f$var$Store, {
    selector: (state)=>state.activeSpotlightIndex !== null
});
module.exports["useRedactionsTourState"] = $4c2208d3e228490f$export$4e8589b303f4384d;
module.exports["useRedactionsTourActions"] = $4c2208d3e228490f$export$b121a589d2d05ff2;

});

parcelRegister("iuuqT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");


var $aWwYt = parcelRequire("aWwYt");


var $ep3mz = parcelRequire("ep3mz");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $8Lx5S = parcelRequire("8Lx5S");


var $kycWk = parcelRequire("kycWk");


var $gsf3i = parcelRequire("gsf3i");

const { IS_REDACTIONS_TOUR_VISIBLE: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $cbee4c9267979126$var$i18n = (0, $h82at.defineMessages)({
    stepOfSteps: {
        id: "redactions.redactions-tour.steps",
        defaultMessage: "{step}/{steps}"
    },
    dismiss: {
        id: "redactions.redactions-tour.dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "redactions.redactions-tour.next",
        defaultMessage: "Next"
    },
    ok: {
        id: "redactions.redactions-tour.ok",
        defaultMessage: "OK"
    },
    readMore: {
        id: "redactions.redactions-tour.read-more",
        defaultMessage: "Read more"
    },
    solidBarIndicates: {
        id: "redactions.redactions-tour.solid-bar-indicates",
        defaultMessage: "The solid bar indicates that your organization detected and deleted sensitive data."
    },
    goToRedactions: {
        id: "redactions.redactions-tour.go-to-redactions",
        defaultMessage: "Go to Redactions in this menu to view details about the redactions on this page."
    }
});
const $cbee4c9267979126$var$useSpotlights = ({ next: next, end: end, tourStartsInTitle: tourStartsInTitle })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const firstSpotlightKeyTarget = tourStartsInTitle ? (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION : (0, $kycWk.REDACTIONS_TOUR_TARGETS).REDACTION_EXTENSION;
    return [
        {
            key: firstSpotlightKeyTarget,
            target: firstSpotlightKeyTarget,
            messageType: (0, $kycWk.MessageType).Engagement,
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 1,
                steps: 2
            }),
            targetRadius: 3,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.next),
                    onClick: next
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.dismiss),
                    onClick: end
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.solidBarIndicates)
        },
        {
            key: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageType: (0, $kycWk.MessageType).Transactional,
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 2,
                steps: 2
            }),
            targetRadius: 100,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.ok),
                    onClick: end
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.readMore),
                    href: (0, $kycWk.READ_MORE_URL),
                    target: '_blank'
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.goToRedactions)
        }
    ];
};
var $cbee4c9267979126$export$f5d398bf946a6bf8 = /*#__PURE__*/ function(RedactionTourStepSource) {
    RedactionTourStepSource["bodyRedaction"] = "bodyRedaction";
    RedactionTourStepSource["titleRedaction"] = "titleRedaction";
    return RedactionTourStepSource;
}({});
const $cbee4c9267979126$export$9b351a5d16cec916 = ({ contentId: contentId, step: step, firstStepSource: firstStepSource = "bodyRedaction" })=>{
    const { sidebarControlState: sidebarControlState } = (0, $aWwYt.useObjectSidebarState)();
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex, firstRedactionIdRendered: firstRedactionIdRendered, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId }, { concludeTour: endTour, proceedToNext: proceedToNext, initiateTour: initiateTour, resetTour: resetTour, setFirstRedactionIdRendered: setFirstRedactionIdRendered, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId }] = (0, $gsf3i.useRedactionsTourState)();
    const isFirstTourTargetVisible = firstStepSource === "bodyRedaction" ? step === 0 && firstRedactionIdRendered && !titleRedactionRenderedForContentId : step === 0 && titleRedactionRenderedForContentId === contentId; // otherwise, it's a title redaction
    const isSecondTourTargetVisible = sidebarControlState === 'shown';
    const [contentType] = (0, $ep3mz.useContentType)();
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)($cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE, false);
    const isTourOnboardingStateCompleted = onboardingStateData?.onboardingState?.some(({ key: key, value: value })=>{
        return key === $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE && value === (0, $kycWk.IS_DISMISSED_FLAG);
    });
    const isTourCompleted = !onboardingStateError && !onboardingStateLoading && isTourOnboardingStateCompleted;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $42omo.useCallback)(()=>{
        endTour();
        setOnboardingState({
            key: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE,
            value: (0, $kycWk.IS_DISMISSED_FLAG)
        });
    }, [
        endTour,
        setOnboardingState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isFirstTourTargetVisible && isSecondTourTargetVisible && !isTourCompleted && !onboardingStateError && !onboardingStateLoading && isLicensed && canUpdateContent) setTimeout(()=>{
            initiateTour();
        }, 0);
    }, [
        initiateTour,
        isFirstTourTargetVisible,
        isSecondTourTargetVisible,
        isTourCompleted,
        onboardingStateError,
        onboardingStateLoading,
        isLicensed,
        canUpdateContent
    ]);
    const spotlights = $cbee4c9267979126$var$useSpotlights({
        next: proceedToNext,
        end: concludeTour,
        tourStartsInTitle: !!titleRedactionRenderedForContentId
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            dialogPlacement: "bottom right",
            shouldWatchTarget: true // Note: problematic layout shifts for both spotlights
            ,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }) : null,
        initiateTour: initiateTour,
        proceedToNext: proceedToNext,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex,
        isTourCompleted: isTourCompleted,
        setFirstRedactionIdRendered: setFirstRedactionIdRendered,
        setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId // Note: mainly here for testing purposes
    };
};
module.exports["RedactionTourStepSource"] = $cbee4c9267979126$export$f5d398bf946a6bf8;
module.exports["useRedactionsTour"] = $cbee4c9267979126$export$9b351a5d16cec916;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents ?? false);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("ly0vw", function(module, exports) {

var $2UZI2 = parcelRequire("2UZI2");


var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $2UZI2.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("2UZI2", function(module, exports) {
function $bbe34607a1cf1c94$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $bbe34607a1cf1c94$export$9df8b8301f41e4b7;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $1ZEfa = parcelRequire("1ZEfa");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $1ZEfa.default);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
        variables: {
            ids: ids
        }
    });
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await $ed0e2cb9f5186ade$var$getUserData(ids);
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("1ZEfa", function(module, exports) {
/**
 * @generated SignedSource<<59554e5c48b23248e96fbd4f6208bc53>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;
module.exports["default"] = $2c3903aefb77a74c$export$2e2bcd8739ae039;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
// URS filter to include agents (app accounts with agent app type) alongside regular users
const $76cb501321125a14$var$INCLUDE_AGENTS_FILTER = 'account_type:atlassian OR (account_type:app AND app_type:agent)';
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {},
                    ...this.includeAgents ? {
                        filter: $76cb501321125a14$var$INCLUDE_AGENTS_FILTER
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $h82at.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isShareableLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.SHAREABLE_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {
/**
 * This is a temporary exception list which is used to determine if the link
 * is pointing to either Jira, a different instance or outside of Atlassian
 * entirely.
 */ const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = window.location.hostname;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        urlObject = url && new URL(url);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("laFNM", function(module, exports) {

var $lKLmX = parcelRequire("lKLmX");


var $fenUZ = parcelRequire("fenUZ");


var $2WqwD = parcelRequire("2WqwD");


var $chVEh = parcelRequire("chVEh");


var $lygOH = parcelRequire("lygOH");


var $8V29N = parcelRequire("8V29N");


var $l5Ac1 = parcelRequire("l5Ac1");


var $dzmR0 = parcelRequire("dzmR0");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $jln20 = parcelRequire("jln20");


var $i9VoI = parcelRequire("i9VoI");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $1vpkQ = parcelRequire("1vpkQ");


var $aZUL4 = parcelRequire("aZUL4");

const $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS = 'DRAFT';
const $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS = 'CURRENT';
// errorType values returned by confluence_createContentApproval that represent
// known, expected failure conditions. These are marked as handled so they do not
// surface as unexpected errors in monitoring.
const $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES = new Set([
    'BAD_REQUEST',
    'ACCESS_DENIED',
    'NOT_FOUND'
]);
// GraphQL Mutations - AGG Ready
// Mutation: Create Workflow Application
const $e450e61f37c9899d$var$createWorkflowApplicationMutation = (0, $dzmR0.default);
// Mutation: Create Workflow Review
const $e450e61f37c9899d$var$createWorkflowReviewMutation = (0, $l5Ac1.default);
// Mutation: Update Workflow Application
const $e450e61f37c9899d$var$updateWorkflowApplicationMutation = (0, $8V29N.default);
// Mutation: Update Reviewer Decision (Approve/Deny)
const $e450e61f37c9899d$var$updateReviewerDecisionMutation = (0, $lygOH.default);
// Mutation: Update Workflow Review (add/remove reviewers, update status)
const $e450e61f37c9899d$var$updateWorkflowReviewMutation = (0, $chVEh.default);
// Mutation: Resolve Approval Agent
const $e450e61f37c9899d$var$resolveApprovalAgentMutation = (0, $2WqwD.default);
// Mutation: Remove Content Approval Reviewer
const $e450e61f37c9899d$var$removeContentApprovalReviewerMutation = (0, $fenUZ.default);
// GraphQL Query - Combined: active workflow application + available workflow statuses
// Single query for preloading and runtime; fetches both confluence_getActiveWorkflowApplication
// and confluence_contentApprovalStatuses (transitionType: null returns all statuses)
const $e450e61f37c9899d$var$approvalsDataQuery = (0, $lKLmX.default);
// Default context values
const $e450e61f37c9899d$var$defaultContextValue = {
    approvalRequest: null,
    approvalRequestLoading: false,
    availableWorkflowStatuses: [],
    contentId: '',
    contentStatus: $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS,
    isCurrentUserRequestor: false,
    isCurrentUserApprover: false,
    currentUserApprover: null,
    approvalProgress: {
        current: 0,
        total: 0
    },
    hasEditPermission: false,
    isDraftLockedForEditing: false,
    otherModeReviewStatus: null
};
const $e450e61f37c9899d$var$defaultDispatchValue = {
    createWorkflowApplication: async ()=>{
        throw new Error('createWorkflowApplication not implemented');
    },
    cancelWorkflowApplication: async ()=>{
        throw new Error('cancelWorkflowApplication not implemented');
    },
    clearApprovalRequestOptimistically: ()=>{},
    startApproval: async ()=>{
        throw new Error('startApproval not implemented');
    },
    updateApprovalStatus: async ()=>{
        throw new Error('updateApprovalStatus not implemented');
    },
    addApprover: async ()=>{
        throw new Error('addApprover not implemented');
    },
    removeApprover: async ()=>{
        throw new Error('removeApprover not implemented');
    },
    cancelApproval: async ()=>{
        throw new Error('cancelApproval not implemented');
    },
    resolveApprovalAgent: async ()=>''
};
const $e450e61f37c9899d$export$eb47cecb126081cc = /*#__PURE__*/ (0, $42omo.createContext)($e450e61f37c9899d$var$defaultContextValue);
$e450e61f37c9899d$export$eb47cecb126081cc.displayName = 'ApprovalsContext';
const $e450e61f37c9899d$export$a8239efa8a51a660 = /*#__PURE__*/ (0, $42omo.createContext)($e450e61f37c9899d$var$defaultDispatchValue);
$e450e61f37c9899d$export$a8239efa8a51a660.displayName = 'ApprovalsDispatchContext';
/**
 * DefaultApprovalsProvider - Returns default/empty approval context
 */ const $e450e61f37c9899d$var$DefaultApprovalsProvider = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: $e450e61f37c9899d$var$defaultContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: $e450e61f37c9899d$var$defaultDispatchValue
    }, children));
const $e450e61f37c9899d$export$c720d3c28af710a = ({ children: children, contentId: contentIdProp })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contentIdProp || pageContentId;
    if (!cloudId || !contentId || !(0, $9wGTI.fg)('confluence_approvals_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$var$DefaultApprovalsProvider, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$var$ApprovalsProviderComponent, {
        contentId: contentId
    }, children);
};
/**
 * This provider:
 * 1. Fetches approval data using GraphQL query
 * 2. Exposes data through read context (ApprovalsContext)
 * 3. Exposes mutations through write context (ApprovalsDispatchContext)
 * 4. Handles cache updates and refetching after mutations
 */ const $e450e61f37c9899d$var$ApprovalsProviderComponent = ({ children: children, contentId: contentId })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatus = pageMode === (0, $cD1qu.PageMode).EDIT ? $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS : $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS;
    // The content status that is opposite of the current status
    const otherContentStatus = contentStatus === $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS ? $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS : $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS;
    const { close: closeRightSidebar } = (0, $jln20.useRightSidebarContext)();
    const [isOptimisticallyCancelled, setIsOptimisticallyCancelled] = (0, $42omo.useState)(false);
    const [optimisticWorkflowStatus, setOptimisticWorkflowStatus] = (0, $42omo.useState)(null);
    // Track whether we've received data for the current contentId. This ensures
    // approvalRequestLoading stays true from the moment contentId changes until fresh data
    // has actually arrived — even if useQueryInteropRelay's loading flag flips true→false
    // within a single React batch (e.g. when the Relay store has cached normalized data).
    const lastSettledContentIdRef = (0, $42omo.useRef)(null);
    // Reset optimistic state when navigating to a different page or switching content status (View ↔ Edit).
    (0, $42omo.useEffect)(()=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(null);
    }, [
        contentId,
        contentStatus
    ]);
    const canEdit = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? (0, $cD1qu.CURRENT_STATUS) : (0, $cD1qu.DRAFT_STATUS)
    });
    const hasEditPermission = canEdit ?? false;
    // Query for available workflow statuses and active workflow application
    const { data: approvalsData, loading: approvalsLoading, refetch: refetchApprovalsData } = (0, $jMyy4.useQueryInterop)($e450e61f37c9899d$var$approvalsDataQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: // null returns all statuses
            otherContentStatus
        },
        skip: !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)
    });
    // Detect when approvalsData belongs to a previously-viewed page. useQueryInteropRelay keeps old
    // data in state while a refetch with new variables is in flight, so without this guard the UI
    // would render Page A's fully-interactive workflow/review data while viewing Page B.
    const isDataStale = (0, $42omo.useMemo)(()=>{
        const responseContentId = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentId;
        // If the response contains a workflow application for a different page, data is stale.
        // When responseContentId is null/undefined/empty (no active workflow or falsy defaults),
        // there is nothing stale to hide.
        return !!responseContentId && responseContentId !== contentId;
    }, [
        approvalsData,
        contentId
    ]);
    if (!approvalsLoading && !isDataStale) lastSettledContentIdRef.current = contentId;
    const isAwaitingFreshData = lastSettledContentIdRef.current !== contentId;
    const availableWorkflowStatuses = (0, $42omo.useMemo)(()=>{
        if (isDataStale || !approvalsData?.confluence_contentApprovalStatuses) return [];
        return approvalsData.confluence_contentApprovalStatuses.reduce((acc, status)=>{
            if (status === null || status === undefined) return acc;
            acc.push({
                id: status.id || '',
                name: status.displayProperties?.name || '',
                allowsReviews: status.allowsReviews || false,
                color: status.displayProperties?.color || undefined
            });
            return acc;
        }, []);
    }, [
        isDataStale,
        approvalsData
    ]);
    const contentVersion = (0, $42omo.useMemo)(()=>{
        const fromWorkflow = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentVersion;
        if (fromWorkflow !== undefined && fromWorkflow !== null) return fromWorkflow;
        return approvalsData?.content?.nodes?.[0]?.version?.number ?? 0;
    }, [
        approvalsData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (optimisticWorkflowStatus && approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.workflowStatusId === optimisticWorkflowStatus.id) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setOptimisticWorkflowStatus(null);
    }, [
        approvalsData,
        optimisticWorkflowStatus
    ]);
    const approvalRequest = (0, $42omo.useMemo)(()=>{
        if (isDataStale) return null;
        if (isOptimisticallyCancelled) return null;
        const application = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication;
        if (optimisticWorkflowStatus && application?.workflowStatusId !== optimisticWorkflowStatus.id) return {
            application: {
                contentId: contentId,
                contentVersion: contentVersion,
                contentStatus: contentStatus,
                applicationId: '',
                isActive: true,
                workflowStatusId: optimisticWorkflowStatus.id
            },
            review: null
        };
        const review = approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions;
        if (!application) return null;
        return {
            application: {
                contentId: application.contentId || contentId,
                contentVersion: application.contentVersion || 1,
                contentStatus: application.contentStatus || '',
                // NOTE: This indicates draft (DRAFT) or published (CURRENT)
                applicationId: application.id || '',
                isActive: application.isActive || false,
                workflowStatusId: application.workflowStatusId || '',
                ...application.modifier && {
                    applicationLastModifiedBy: {
                        displayName: application.modifier.displayName || '',
                        avatarUrl: application.modifier.photos?.find((p)=>p?.isPrimary)?.value || undefined,
                        userId: application.modifier.id || ''
                    }
                },
                applicationLastModifiedDate: application.lastModificationDate?.value || ''
            },
            // There can be an application without a review; return review: null in that case
            review: review !== null && review !== undefined ? {
                reviewId: review.id || '',
                reviewCreationDate: review.creationDate?.value || '',
                requestorId: review.creatorAaid || '',
                requestorName: review.creator?.displayName || '',
                requestorAvatarUrl: review.creator?.photos?.find((p)=>p?.isPrimary)?.value || '',
                reviewLastModifiedDate: review.reviewLastModified?.value || '',
                // milliseconds since epoch
                reviewComment: review.reviewComment || undefined,
                reviewStatus: review.reviewStatus || 'PENDING',
                approvers: review.reviewerDecisions?.reduce((acc, reviewerDecision)=>{
                    if (reviewerDecision == null) return acc;
                    acc.push({
                        decisionId: reviewerDecision.decisionId || '',
                        reviewerId: reviewerDecision.reviewerId || '',
                        isRequired: reviewerDecision.required ?? true,
                        principalId: reviewerDecision.principalId || '',
                        principalType: reviewerDecision.principalType || 'USER',
                        name: reviewerDecision.user?.displayName || '',
                        avatarUrl: reviewerDecision.user?.photos?.find((p)=>p?.isPrimary)?.value || '',
                        status: reviewerDecision.reviewerDecisionStatus || 'PENDING_REVIEW',
                        decisionComment: reviewerDecision.comment || '',
                        responseLastModifiedDate: reviewerDecision?.lastModifiedDate?.value || ''
                    });
                    return acc;
                }, [])
            } : null
        };
    }, [
        isDataStale,
        isOptimisticallyCancelled,
        optimisticWorkflowStatus,
        contentVersion,
        contentStatus,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions,
        contentId
    ]);
    const isCurrentUserRequestor = (0, $42omo.useMemo)(()=>{
        return approvalRequest?.review?.requestorId === userId;
    }, [
        approvalRequest,
        userId
    ]);
    const currentUserApprover = (0, $42omo.useMemo)(()=>{
        return approvalRequest?.review?.approvers?.find((approver)=>approver.principalId === userId) || null;
    }, [
        approvalRequest,
        userId
    ]);
    const onWorkflowApplicationChanged = (0, $42omo.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== contentStatus) return;
        // Reset the optimistic cancellation state when a live update arrives from another user.
        // Without this, if User 1 clears the review status (setting isOptimisticallyCancelled=true)
        // and User 2 then adds the review status back, User 1 would never see the new review
        // because isOptimisticallyCancelled would still be true, causing approvalRequest to
        // remain null even after the refetch returns fresh data with the new review.
        setIsOptimisticallyCancelled(false);
        refetchApprovalsData({
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: otherContentStatus
        });
    }, [
        refetchApprovalsData,
        cloudId,
        contentId,
        contentStatus,
        otherContentStatus
    ]);
    // Subscribe to real-time approval status changes (from backend workflowApplicationChanged events)
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onWorkflowApplicationChanged
    });
    // When the other mode's workflow changes (e.g. a DRAFT review is started while viewing the
    // published page), refetch so that otherModeReviewStatus reflects the latest state and any
    // banners or warnings dependent on it update accordingly.
    const onOtherModeWorkflowApplicationChanged = (0, $42omo.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== otherContentStatus) return;
        refetchApprovalsData({
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: otherContentStatus
        });
    }, [
        refetchApprovalsData,
        cloudId,
        contentId,
        contentStatus,
        otherContentStatus
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderOtherModeWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onOtherModeWorkflowApplicationChanged
    });
    const approvalProgress = (0, $42omo.useMemo)(()=>{
        if (!approvalRequest) return {
            current: 0,
            total: 0
        };
        const responded = approvalRequest.review?.approvers?.filter((a)=>a.status !== null && a.status !== 'PENDING_REVIEW').length;
        return {
            current: responded ?? 0,
            total: approvalRequest.review?.approvers?.length ?? 0
        };
    }, [
        approvalRequest
    ]);
    // GraphQL Mutations
    const [createWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowApplicationMutation);
    const [createWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowApplicationMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateReviewerDecisionMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateReviewerDecisionMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [removeContentApprovalReviewerMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$removeContentApprovalReviewerMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [resolveApprovalAgentMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$resolveApprovalAgentMutation);
    // Wrapped mutation functions
    // Resolves the approval agent ID. If the mutation fails, returns an empty string
    // so the caller can fall back to invoking regular Rovo instead of the agent.
    const resolveApprovalAgent = (0, $42omo.useCallback)(async ()=>{
        try {
            const result = await resolveApprovalAgentMutationFn({
                variables: {
                    cloudId: cloudId
                }
            });
            const response = result?.data?.confluence_resolveApprovalAgent;
            if (!response?.success || response.errors?.length > 0) return '';
            return response.agent?.id ?? '';
        } catch  {
            return '';
        }
    }, [
        cloudId,
        resolveApprovalAgentMutationFn
    ]);
    const createWorkflowApplication = (0, $42omo.useCallback)(async (status)=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(status);
        try {
            const result = await createWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    createWorkflowApplicationRequestInput: {
                        contentId: contentId,
                        contentStatus: contentStatus,
                        version: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1,
                        workflowId: 1,
                        workflowStatusId: 1,
                        // hardcoded -- backend assigns status on creation
                        isActive: true
                    }
                }
            });
            const workflowStatus = result.data?.confluence_createWorkflowApplication?.workflowStatus;
            return {
                workflowStatusId: workflowStatus?.id ?? '1',
                name: workflowStatus?.displayProperties?.name || '',
                allowsReviews: workflowStatus?.allowsReviews || false
            };
        } catch (error) {
            setOptimisticWorkflowStatus(null);
            throw error;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        createWorkflowApplicationMutationFn
    ]);
    /** Variables are optional: if not provided, this will cancel the workflow application for
  the latest content version for the current content status */ const cancelWorkflowApplication = (0, $42omo.useCallback)(async (variables)=>{
        closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        try {
            await updateWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    updateWorkflowApplicationRequestInput: {
                        contentId: variables?.contentId ? parseInt(variables.contentId, 10) : parseInt(contentId, 10),
                        contentStatus: variables?.contentStatus ?? contentStatus,
                        version: variables?.version ?? (contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1),
                        workflowStatusId: parseInt(variables?.workflowStatusId ?? approvalRequest?.application?.workflowStatusId ?? '1', 10),
                        isActive: false,
                        workflowId: 1
                    }
                }
            });
        } catch (error) {
            setIsOptimisticallyCancelled(false);
            (0, $7Sm4c.markErrorAsHandled)(error);
        // TODO: Add error handling
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        approvalRequest?.application?.workflowStatusId,
        updateWorkflowApplicationMutationFn,
        closeRightSidebar
    ]);
    const clearApprovalRequestOptimistically = (0, $42omo.useCallback)(()=>{
        setIsOptimisticallyCancelled(true);
        setOptimisticWorkflowStatus(null);
    }, []);
    const startApproval = (0, $42omo.useCallback)(async (variables)=>{
        const result = await createWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                createContentApprovalRequestInput: {
                    contentId: contentId,
                    contentStatus: contentStatus,
                    version: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1,
                    // DRAFT version is always 1,
                    comment: variables.message,
                    reviewers: variables.approvers
                }
            }
        });
        const response = result.data?.confluence_createContentApproval;
        if (response && !response.success) {
            const firstError = response.errors?.[0];
            const errorMessage = firstError?.message || 'Failed to start approval';
            const errorType = firstError?.extensions?.errorType;
            // Attach extensions to the error so callers (e.g. getFailureStatusCode in
            // analytics) can read the statusCode without access to the raw response.
            const error = Object.assign(new Error(errorMessage), {
                extensions: firstError?.extensions
            });
            if (errorType && $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES.has(errorType)) // Known, expected error — mark as handled so it is not reported to monitoring.
            (0, $7Sm4c.markErrorAsHandled)(error);
            else // Unexpected error — report to monitoring before surfacing to the caller.
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
            });
            throw error;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        createWorkflowReviewMutationFn
    ]);
    const updateApprovalStatus = (0, $42omo.useCallback)(async (variables)=>{
        const decisionStatus = variables.status;
        const result = await updateReviewerDecisionMutationFn({
            variables: {
                cloudId: cloudId,
                confluenceUpdateReviewerDecisionInput: {
                    reviewerId: parseInt(variables.reviewerId, 10),
                    decisionStatus: decisionStatus,
                    comment: variables.comment || null
                }
            }
        });
        const response = result.data?.confluence_updateReviewerDecision;
        if (response && !response.success) {
            const errorMessage = response.errors?.[0]?.message || 'Failed to update reviewer decision';
            throw new Error(errorMessage);
        }
    }, [
        cloudId,
        updateReviewerDecisionMutationFn
    ]);
    const addApprover = (0, $42omo.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const existingReviewers = approvalRequest.review.approvers.map((a)=>({
                principalId: a.principalId,
                principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                isRequired: a.isRequired
            }));
        const existingIds = new Set(existingReviewers.map((r)=>r.principalId));
        const mergedReviewers = [
            ...existingReviewers
        ];
        for (const r of variables.approvers)if (!existingIds.has(r.principalId)) {
            mergedReviewers.push({
                principalId: r.principalId,
                principalType: r.principalType,
                isRequired: r.isRequired
            });
            existingIds.add(r.principalId);
        }
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(approvalRequest.application.applicationId, 10),
                    contentApprovalReviewId: parseInt(approvalRequest.review.reviewId, 10),
                    reviewers: mergedReviewers.map((a)=>({
                            principalId: a.principalId,
                            principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                            isRequired: a.isRequired
                        }))
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        updateWorkflowReviewMutationFn
    ]);
    const removeApprover = (0, $42omo.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const approver = approvalRequest.review.approvers.find((a)=>a.principalId === variables.principalId);
        if (!approver) throw new Error('Approver not found in current review');
        await removeContentApprovalReviewerMutationFn({
            variables: {
                cloudId: cloudId,
                removeContentApprovalReviewerInput: {
                    workflowApplicationId: approvalRequest.application.applicationId,
                    contentApprovalReviewId: approvalRequest.review.reviewId,
                    principalId: variables.principalId,
                    principalType: approver.principalType
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        removeContentApprovalReviewerMutationFn
    ]);
    const cancelApproval = (0, $42omo.useCallback)(async (variables)=>{
        closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(variables.workflowApplicationId, 10),
                    contentApprovalReviewId: parseInt(variables.contentApprovalReviewId, 10),
                    approvalStatus: 'CANCELED'
                }
            }
        });
    }, [
        cloudId,
        updateWorkflowReviewMutationFn,
        closeRightSidebar
    ]);
    const otherModeReviewStatus = (0, $42omo.useMemo)(()=>{
        if (isDataStale) return null;
        return approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus?.workflowReviewWithDecisions?.reviewStatus ?? null;
    }, [
        isDataStale,
        approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus
    ]);
    const isDraftLockedForEditing = (0, $42omo.useMemo)(()=>{
        if (contentStatus !== $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS) return false;
        const review = approvalRequest?.review;
        if (review == null) return false;
        return review.reviewStatus === 'PENDING' || review.reviewStatus === 'APPROVED';
    }, [
        contentStatus,
        approvalRequest?.review
    ]);
    // Context values - memoized to prevent unnecessary re-renders
    const contextValue = (0, $42omo.useMemo)(()=>({
            approvalRequest: approvalRequest,
            approvalRequestLoading: approvalsLoading || isDataStale || isAwaitingFreshData,
            contentVersion: contentVersion,
            availableWorkflowStatuses: availableWorkflowStatuses,
            contentId: contentId,
            contentStatus: contentStatus,
            isCurrentUserRequestor: isCurrentUserRequestor,
            isCurrentUserApprover: !!currentUserApprover,
            currentUserApprover: currentUserApprover,
            approvalProgress: approvalProgress,
            hasEditPermission: hasEditPermission,
            isDraftLockedForEditing: isDraftLockedForEditing,
            otherModeReviewStatus: otherModeReviewStatus
        }), [
        approvalRequest,
        approvalsLoading,
        isDataStale,
        isAwaitingFreshData,
        contentVersion,
        availableWorkflowStatuses,
        contentId,
        contentStatus,
        isCurrentUserRequestor,
        currentUserApprover,
        approvalProgress,
        hasEditPermission,
        isDraftLockedForEditing,
        otherModeReviewStatus
    ]);
    const dispatchValue = (0, $42omo.useMemo)(()=>({
            createWorkflowApplication: createWorkflowApplication,
            cancelWorkflowApplication: cancelWorkflowApplication,
            clearApprovalRequestOptimistically: clearApprovalRequestOptimistically,
            startApproval: startApproval,
            updateApprovalStatus: updateApprovalStatus,
            addApprover: addApprover,
            removeApprover: removeApprover,
            cancelApproval: cancelApproval,
            resolveApprovalAgent: resolveApprovalAgent
        }), [
        createWorkflowApplication,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        startApproval,
        updateApprovalStatus,
        addApprover,
        removeApprover,
        cancelApproval,
        resolveApprovalAgent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: dispatchValue
    }, children, (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZUL4.ApprovalUnavailableFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
        name: "approvals",
        types: [
            (0, $c0urc.ReloadType).content
        ],
        reload: refetchApprovalsData
    }))));
};
const $e450e61f37c9899d$export$38d1715f438e155f = ()=>{
    return (0, $42omo.useContext)($e450e61f37c9899d$export$eb47cecb126081cc);
};
const $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8 = ()=>{
    return (0, $42omo.useContext)($e450e61f37c9899d$export$a8239efa8a51a660);
};
module.exports["ApprovalsProvider"] = $e450e61f37c9899d$export$c720d3c28af710a;
module.exports["useApprovals"] = $e450e61f37c9899d$export$38d1715f438e155f;
module.exports["useApprovalsDispatch"] = $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8;

});

parcelRegister("fenUZ", function(module, exports) {
/**
 * @generated SignedSource<<1c5e3cf1fef66465e64a0e9eda23f392>>
 * @relayHash 1c45745cc12810ecdbcde25f697fac8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02
const $51700bb24bdc6b5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "removeContentApprovalReviewerInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "removeContentApprovalReviewerInput",
            "variableName": "removeContentApprovalReviewerInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1c45745cc12810ecdbcde25f697fac8e",
            "id": "1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02",
            "metadata": {},
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextRemoveContentApprovalReviewerMutation($cloudId:ID!,$removeContentApprovalReviewerInput:ConfluenceRemoveContentApprovalReviewerInput!){confluence_removeContentApprovalReviewer(cloudId:$cloudId,removeContentApprovalReviewerInput:$removeContentApprovalReviewerInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$51700bb24bdc6b5f$var$node.hash = "697e5f36bdc5f862fd4fb3d7c42a7b48";
var $51700bb24bdc6b5f$export$2e2bcd8739ae039 = $51700bb24bdc6b5f$var$node;
module.exports["default"] = $51700bb24bdc6b5f$export$2e2bcd8739ae039;

});

parcelRegister("2WqwD", function(module, exports) {
/**
 * @generated SignedSource<<189937bf7147e7bf13abd89f5e093d73>>
 * @relayHash 7e7e86c50393bd91ccd31140eb439adb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328
const $e3200d7e3785782c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceApprovalAgentPayload",
            "kind": "LinkedField",
            "name": "confluence_resolveApprovalAgent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceApprovalAgent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e7e86c50393bd91ccd31140eb439adb",
            "id": "b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328",
            "metadata": {},
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextResolveApprovalAgentMutation($cloudId:ID!){confluence_resolveApprovalAgent(cloudId:$cloudId){success,agent{id},errors{message}}}"
        }
    };
}();
$e3200d7e3785782c$var$node.hash = "e4cb35491d152f5cba04815adf8e599d";
var $e3200d7e3785782c$export$2e2bcd8739ae039 = $e3200d7e3785782c$var$node;
module.exports["default"] = $e3200d7e3785782c$export$2e2bcd8739ae039;

});

parcelRegister("chVEh", function(module, exports) {
/**
 * @generated SignedSource<<8e4ee3f6ef8dd61fa181a75d32ff9cd2>>
 * @relayHash 27144a0bed02bf89bd05934de4bc8547
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1
const $340575ae55838f10$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentApprovalGraphQLInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateContentApprovalGraphQLInput",
            "variableName": "updateContentApprovalGraphQLInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "27144a0bed02bf89bd05934de4bc8547",
            "id": "b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowReviewMutation($cloudId:ID!,$updateContentApprovalGraphQLInput:ConfluenceUpdateContentApprovalRequestInput!){confluence_updateContentApproval(cloudId:$cloudId,updateContentApprovalGraphQLInput:$updateContentApprovalGraphQLInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$340575ae55838f10$var$node.hash = "6e686f80296d6e3ef707726180b7464e";
var $340575ae55838f10$export$2e2bcd8739ae039 = $340575ae55838f10$var$node;
module.exports["default"] = $340575ae55838f10$export$2e2bcd8739ae039;

});

parcelRegister("lygOH", function(module, exports) {
/**
 * @generated SignedSource<<be6515ebe11df8688934488959a07356>>
 * @relayHash afa8664360527d902e240ba8f2439caa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde
const $0aa9e770fdcc2607$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "confluenceUpdateReviewerDecisionInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "confluenceUpdateReviewerDecisionInput",
            "variableName": "confluenceUpdateReviewerDecisionInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "afa8664360527d902e240ba8f2439caa",
            "id": "3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde",
            "metadata": {},
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateReviewerDecisionMutation($cloudId:ID!,$confluenceUpdateReviewerDecisionInput:ConfluenceUpdateReviewerDecisionInput!){confluence_updateReviewerDecision(cloudId:$cloudId,confluenceUpdateReviewerDecisionInput:$confluenceUpdateReviewerDecisionInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$0aa9e770fdcc2607$var$node.hash = "60408e64e95523cddd0fb83ab25da2c7";
var $0aa9e770fdcc2607$export$2e2bcd8739ae039 = $0aa9e770fdcc2607$var$node;
module.exports["default"] = $0aa9e770fdcc2607$export$2e2bcd8739ae039;

});

parcelRegister("8V29N", function(module, exports) {
/**
 * @generated SignedSource<<e82f895a11323a843ce0fbf6e9b6b2d3>>
 * @relayHash dc259a2e51a1b01648a5dcdfa8b8904f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6
const $f7bc745188f2b8be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateWorkflowApplicationRequestInput",
            "variableName": "updateWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dc259a2e51a1b01648a5dcdfa8b8904f",
            "id": "9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowApplicationMutation($cloudId:ID!,$updateWorkflowApplicationRequestInput:ConfluenceUpdateWorkflowApplicationRequestInput!){confluence_updateWorkflowApplication(cloudId:$cloudId,updateWorkflowApplicationRequestInput:$updateWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$f7bc745188f2b8be$var$node.hash = "cc3c6f7f13981af43e98d2ff646b92b8";
var $f7bc745188f2b8be$export$2e2bcd8739ae039 = $f7bc745188f2b8be$var$node;
module.exports["default"] = $f7bc745188f2b8be$export$2e2bcd8739ae039;

});

parcelRegister("l5Ac1", function(module, exports) {
/**
 * @generated SignedSource<<77969c2300964a5327f94f178c5aa7cd>>
 * @relayHash dcc67a3c302bf1451aa072fa5b312aec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb
const $8c79d69cd01688c2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createContentApprovalRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createContentApprovalRequestInput",
            "variableName": "createContentApprovalRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowApplicationId"
            },
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dcc67a3c302bf1451aa072fa5b312aec",
            "id": "43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowReviewMutation($cloudId:ID!,$createContentApprovalRequestInput:ConfluenceCreateContentApprovalRequestInput!){confluence_createContentApproval(cloudId:$cloudId,createContentApprovalRequestInput:$createContentApprovalRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,workflowApplicationId,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$8c79d69cd01688c2$var$node.hash = "7aac889eeb2c9a4140e4c54a84dd5a22";
var $8c79d69cd01688c2$export$2e2bcd8739ae039 = $8c79d69cd01688c2$var$node;
module.exports["default"] = $8c79d69cd01688c2$export$2e2bcd8739ae039;

});

parcelRegister("dzmR0", function(module, exports) {
/**
 * @generated SignedSource<<a1faec691463bed2ea2c558c32a416ff>>
 * @relayHash a1b6aebb0a3efe580078f09140cd9804
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b87d0eb948f5407df1811406c925f73088ce67bb0d369b4469a01bdf115f2114
const $2c0c245b53785143$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createWorkflowApplicationRequestInput",
            "variableName": "createWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "workflowStatus",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "icon"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a1b6aebb0a3efe580078f09140cd9804",
            "id": "b87d0eb948f5407df1811406c925f73088ce67bb0d369b4469a01bdf115f2114",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowApplicationMutation($cloudId:ID!,$createWorkflowApplicationRequestInput:ConfluenceCreateWorkflowApplicationRequestInput!){confluence_createWorkflowApplication(cloudId:$cloudId,createWorkflowApplicationRequestInput:$createWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}}"
        }
    };
}();
$2c0c245b53785143$var$node.hash = "c3c0d131e6ac8750fb00ef4b6b3fad85";
var $2c0c245b53785143$export$2e2bcd8739ae039 = $2c0c245b53785143$var$node;
module.exports["default"] = $2c0c245b53785143$export$2e2bcd8739ae039;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("aZUL4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $7aRa9 = parcelRequire("7aRa9");


var $laFNM = parcelRequire("laFNM");

const $9eff6b0f0df1bcea$var$SOURCE_CONFLUENCE_APPROVALS_PARAM = 'source_confluence_approvals';
const $9eff6b0f0df1bcea$var$i18n = (0, $h82at.defineMessages)({
    approvalUnavailableTitle: {
        id: "approvals.flag.approval-unavailable.title",
        defaultMessage: "This approval request is no longer available"
    },
    approvalUnavailableDescription: {
        id: "approvals.flag.approval-unavailable.description",
        defaultMessage: "It may have been deleted."
    }
});
/**
 * Removes the `source_confluence_approvals` query param from the URL without triggering a page reload.
 * This is a client-side-only operation and must only be called after mount.
 */ const $9eff6b0f0df1bcea$var$removeSourceConfluenceApprovalsParam = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete($9eff6b0f0df1bcea$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
    const newSearch = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
    const newUrl = `${window.location.pathname}${newSearch}${window.location.hash}`;
    window.history.replaceState({}, '', newUrl);
};
const $9eff6b0f0df1bcea$var$ApprovalUnavailableFlagComponent = ({ flags: flags })=>{
    const { approvalRequestLoading: approvalRequestLoading, isCurrentUserApprover: isCurrentUserApprover } = (0, $laFNM.useApprovals)();
    (0, $42omo.useEffect)(()=>{
        // Only run on the client side (this component is never rendered during SSR
        // because it's mounted inside ApprovalsProviderComponent which is guarded
        // by the feature gate check in ApprovalsProvider).
        // We wait until loading is complete before checking so we have accurate data.
        if (approvalRequestLoading) return;
        const urlParams = new URLSearchParams(window.location.search);
        const isFromApprovalsCta = urlParams.has($9eff6b0f0df1bcea$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
        if (!isFromApprovalsCta) return;
        // Always clean up the query param once we've read it.
        $9eff6b0f0df1bcea$var$removeSourceConfluenceApprovalsParam();
        // no need to show the warning flag if the current user is still an active reviewer.
        if (isCurrentUserApprover) return;
        // The param is present but the current user is not a reviewer, which means
        // the approval request was cancelled or the user was removed. Show a warning.
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9eff6b0f0df1bcea$var$i18n.approvalUnavailableTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9eff6b0f0df1bcea$var$i18n.approvalUnavailableDescription),
            isAutoDismiss: true
        });
    }, [
        approvalRequestLoading,
        isCurrentUserApprover,
        flags
    ]);
    return null;
};
const $9eff6b0f0df1bcea$export$44ae57b1062ca014 = (0, $7aRa9.withFlags)($9eff6b0f0df1bcea$var$ApprovalUnavailableFlagComponent);
module.exports["ApprovalUnavailableFlag"] = $9eff6b0f0df1bcea$export$44ae57b1062ca014;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $4m76H = parcelRequire("4m76H");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    const bodyRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        ref: bodyRef,
        children: children
    });
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ if ((0, $dh538.fg)('platform_preview_panels_sniffer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4m76H.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes,
        children: panelBodyContent
    });
    return panelBodyContent;
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("4m76H", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");

const $b7ecffdf81d3e124$export$93a96f69a5c679de = ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $42omo.useRef)(false);
    const isValidContentSizeMessage = (0, $42omo.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $42omo.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth = bodyElement.clientWidth;
            const scrollWidth = bodyElement.scrollWidth;
            if (scrollWidth > clientWidth) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth,
                scrollWidth: scrollWidth
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const contentSizePayload = event.data;
            if (!isValidContentSizeMessage(event, contentSizePayload)) return;
            const panelIframe = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe?.clientWidth ?? 0;
            const clientWidth = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth !== 'number' || contentSizePayload.width <= clientWidth) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth,
                scrollWidth: contentSizePayload.width
            });
        };
        return (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["PreviewPanelSniffer"] = $b7ecffdf81d3e124$export$93a96f69a5c679de;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $h82at = parcelRequire("h82at");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $h82at.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $1cfRh = parcelRequire("1cfRh");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("39XmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84bdce2dbfd750d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $fFa3V = parcelRequire("fFa3V");


var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $a4UIB = parcelRequire("a4UIB");


var $26AWB = parcelRequire("26AWB");


var $5O1V9 = parcelRequire("5O1V9");

function $f84bdce2dbfd750d$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $42omo.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const shouldDisable = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $5spQU.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $T9xHm.isFedrampModerate)();
    const isEnabled = !shouldDisable;
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $42omo.useMemo)(()=>{
        if (isEnabled) return new (0, $a4UIB.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $fFa3V.bind)(document, {
                type: (0, $5O1V9.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $26AWB.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $da1a55ed1292d791$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $da1a55ed1292d791$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$da1a55ed1292d791$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("9XexZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");

const $26e790de36bba91a$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $15h8H.getBrowserBridgeAPI)())=>{
    const refApi = (0, $42omo.useRef)(apiInstance);
    const refReady = (0, $42omo.useRef)(false);
    const refMount = (0, $42omo.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $42omo.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $42omo.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $42omo.useCallback)((command, params)=>{
        // devx: provide current `clientId`
        return api.send(command, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $42omo.useCallback)((command, params, options)=>{
        api.broadcast(command, params, options);
    }, [
        api
    ]);
    const teardown = (0, $42omo.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
	 * If we have already mounted our handlers once and marked ourselves as ready, then this
	 * bridge API client is already capable of receiving & handling commands. On subsequent renders
	 * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
	 *
	 * This will ensure the newest state of every handler is being used, with no stale references
	 * in closures, as can often occur with initialise-only-once code in React.
	 */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $26e790de36bba91a$export$a74fbbd6fb01001c;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $d7ZU3 = parcelRequire("d7ZU3");

var $led7c = parcelRequire("led7c");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("bAT9l", function(module, exports) {
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });
module.exports["mention"] = $6b7e17532fed1b16$export$db83999c14438df4;

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("liGyh", function(module, exports) {

var $dIPzP = parcelRequire("dIPzP");


var $42omo = parcelRequire("42omo");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $dIPzP.default);
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $jMyy4.useQueryInterop)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("dIPzP", function(module, exports) {
/**
 * @generated SignedSource<<ac4e67ff45a7147f3db0219d66449b21>>
 * @relayHash ab6c713571991d15a172cc151a881572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae
const $c1e2aac1eea196bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab6c713571991d15a172cc151a881572",
            "id": "f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae",
            "metadata": {},
            "name": "useCommentQueryParamsCommentLocationQuery",
            "operationKind": "query",
            "text": "query useCommentQueryParamsCommentLocationQuery($commentId:ID,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,contentStatus:$contentStatus){nodes{container{id},location{__typename,type},id}}}"
        }
    };
}();
$c1e2aac1eea196bd$var$node.hash = "60bed37eee2f8a7739db095067b4457b";
var $c1e2aac1eea196bd$export$2e2bcd8739ae039 = $c1e2aac1eea196bd$var$node;
module.exports["default"] = $c1e2aac1eea196bd$export$2e2bcd8739ae039;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<5436b93d76e4ad3ca1b847dd48c8568a>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: onError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $42omo.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $42omo.useCallback)((error)=>applyQueryErrorHandling(error, onError), [
        applyQueryErrorHandling,
        onError
    ]);
    // Skip query if experiment is disabled, no content ID, or explicitly skipped
    const shouldSkip = !contentId || !!options.skip || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError
    });
    const refetch = (0, $42omo.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? onError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        onError
    ]);
    const addCommentInCache = (0, $42omo.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $42omo.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<ffe25591c3e17983b11fcfcb1d4214ba>>
 * @relayHash 9e9dce87233142bdde0be6a1e1389db3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9dce87233142bdde0be6a1e1389db3",
            "id": "ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "f3f3f95ad61519f75dd5ba8d0cde2302";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("ag51I", function(module, exports) {

var $49xGN = parcelRequire("49xGN");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");

// This hook returns a mutation function to create a new comment on an object. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new comment is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
const $8cba0eaacdb447e5$var$CreateObjectCommentMutation = (0, $49xGN.default);
const $8cba0eaacdb447e5$export$14bad9f468eeedfb = ()=>{
    const [createObjectCommentFn] = (0, $308Wd.useMutationInterop)($8cba0eaacdb447e5$var$CreateObjectCommentMutation);
    return createObjectCommentFn;
};
const $8cba0eaacdb447e5$export$be067408524a8736 = (commentData)=>{
    return commentData ? {
        ...commentData,
        replies: [],
        reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? null : commentData.reactionsSummary ?? null
    } : undefined;
};
module.exports["useCreateObjectCommentMutation"] = $8cba0eaacdb447e5$export$14bad9f468eeedfb;
module.exports["addEmptyObjectRepliesAndReactions"] = $8cba0eaacdb447e5$export$be067408524a8736;

});

parcelRegister("49xGN", function(module, exports) {
/**
 * @generated SignedSource<<4a62784e7c1768c3b30993ff416274c3>>
 * @relayHash e4c493ec197fdfb6eb597c1e5cc6c430
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e
const $2b92f41c42f85596$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v14 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v9 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "e4c493ec197fdfb6eb597c1e5cc6c430",
            "id": "ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e",
            "metadata": {},
            "name": "useCreateObjectCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateObjectCommentMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactionsSummary:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$2b92f41c42f85596$var$node.hash = "c1ecd7a7f6b08a2552cfea3da74fecee";
var $2b92f41c42f85596$export$2e2bcd8739ae039 = $2b92f41c42f85596$var$node;
module.exports["default"] = $2b92f41c42f85596$export$2e2bcd8739ae039;

});

parcelRegister("famWw", function(module, exports) {
/* AddCommentPromptButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1Whri = parcelRequire("1Whri");


var $c6fYi = parcelRequire("c6fYi");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");

const $6aab88ace7ca0350$var$styles = {
    addCommentButtonStyle: "_1yt4ze3t _2rko12b0 _11c8fhey _1e0c1txw _1tkezwfg _19bvutpp _u5f3utpp _1bah1h6o _4cvr1h6o _syazazsu",
    enabledStyle: "_bfhksm61 _d0altlke _irr31dpa",
    disabledStyle: "_bfhkby5v _80om13gf _syaz1gmx",
    fullWidthStyle: "_1bsb1osq"
};
const $6aab88ace7ca0350$var$i18n = (0, $h82at.defineMessages)({
    addCommentPromptText: {
        id: "comments-common.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "comments-common.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
const $6aab88ace7ca0350$export$caf1bbdc1c7b1a40 = ({ onClick: onClick, autofocusRef: autofocusRef, shouldFitContainer: shouldFitContainer, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || '');
    const buttonRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus({
                preventScroll: true
            });
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    const allowAddComment = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? canAddComments : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($6aab88ace7ca0350$var$styles.addCommentButtonStyle, !allowAddComment ? $6aab88ace7ca0350$var$styles.disabledStyle : $6aab88ace7ca0350$var$styles.enabledStyle, shouldFitContainer && $6aab88ace7ca0350$var$styles.fullWidthStyle),
        isDisabled: !allowAddComment,
        onClick: onClick,
        testId: testId,
        ref: buttonRef,
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            'aria-label': formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptAriaLabel)
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))), {
        label: formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText))));
};
module.exports["AddCommentPromptButton"] = $6aab88ace7ca0350$export$caf1bbdc1c7b1a40;

});

parcelRegister("kKAQX", function(module, exports) {
/**
 * @generated SignedSource<<c5008fda444ba5427db7f5c49b38d99b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $485d7166d746f7d6$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $485d7166d746f7d6$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $485d7166d746f7d6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ContentRepresentation"] = $485d7166d746f7d6$export$f4016897b165b6d5;
module.exports["Platform"] = $485d7166d746f7d6$export$2dffd0b5373a4389;

});

parcelRegister("87CZC", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $abN8T = parcelRequire("abN8T");


var $86okN = parcelRequire("86okN");


var $7W8i8 = parcelRequire("7W8i8");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $cD1qu = parcelRequire("cD1qu");


var $irVI7 = parcelRequire("irVI7");


var $56QzY = parcelRequire("56QzY");


var $en1dX = parcelRequire("en1dX");


var $gtj7V = parcelRequire("gtj7V");


var $2i3To = parcelRequire("2i3To");


var $ftXPY = parcelRequire("ftXPY");

const $80b47fa0b569ef69$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $80b47fa0b569ef69$export$a02bedef5e94d20c = (actionType, queryVariables, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $86okN.toDocumentNode)((0, $b1hSc.default)),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                const panelNodes = commentsPanelCacheResponse?.comments?.nodes || [];
                if (actionType === 'delete') {
                    // Remove the returned commentId from the cache and reset it
                    const idxToRemove = panelNodes.findIndex((comment)=>comment?.id === commentId);
                    if (idxToRemove !== -1) panelNodes.splice(idxToRemove, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        replies: []
                    };
                    // Add the new reply entry to the cache and reset it
                    panelNodes.push(mutationResult);
                }
                cache.writeQuery({
                    query: (0, $86okN.toDocumentNode)((0, $b1hSc.default)),
                    variables: consistentQueryVariables,
                    data: commentsPanelCacheResponse
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentSectionCacheDataClone = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentSectionCacheDataClone?.comments?.edges || [];
                if (actionType === 'delete') {
                    // Find the last index of the top level comment to delete
                    const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                    if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment
                    };
                    // As far as I can tell, this is always called w/o reactions enabled
                    // This maps the mutation result we get to the cache object that's expected by the comments section query
                    const cacheCommentObject = {
                        id: mutationResult.id,
                        ancestors: [],
                        author: {
                            ...mutationResult.author,
                            type: 'known'
                        },
                        body: mutationResult.body,
                        contentStatus: mutationResult.contentStatus,
                        links: {
                            webui: mutationResult.links.webui,
                            // @ts-ignore
                            __typename: mutationResult.links.__typename
                        },
                        location: mutationResult.location,
                        parentId: mutationResult.parentId,
                        permissions: mutationResult.permissions,
                        version: {
                            ...mutationResult.version,
                            friendlyWhen: 'Just now',
                            // TODO: Maybe replace this with the actual date
                            by: {
                                type: 'user',
                                displayName: '',
                                accountId: '',
                                __typename: 'User'
                            },
                            __typename: 'Version'
                        },
                        __typename: 'Comment'
                    };
                    // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                    const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                    const newEdge = {
                        cursor: (commentEdges.length - 1).toString(),
                        node: cacheContentDeepCopy,
                        __typename: 'CommentEdge'
                    };
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                }
                cache.writeQuery({
                    query: commentsSectionQuery,
                    variables: {
                        contentId: pageId,
                        offset: '',
                        first: (0, $2i3To.DEFAULT_LIMIT)
                    },
                    data: {
                        ...commentSectionCacheDataClone,
                        comments: {
                            ...commentSectionCacheDataClone.comments,
                            totalCount: commentEdges.length,
                            pageInfo: {
                                ...commentSectionCacheDataClone.comments?.pageInfo,
                                endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                hasNextPage: false
                            },
                            edges: commentEdges
                        }
                    }
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments section cache for ${actionType} - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$bab18f310e4f95e8 = (actionType, queryVariables, parentCommentId, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $86okN.toDocumentNode)((0, $b1hSc.default)),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsPanelParentComment = commentsPanelCacheResponse?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') {
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = commentsPanelParentComment.replies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) commentsPanelParentComment.replies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.createFooterComment;
                        // Add the new reply entry to the cache and reset it
                        commentsPanelParentComment.replies.push(mutationResult);
                    }
                    cache.writeQuery({
                        query: (0, $86okN.toDocumentNode)((0, $b1hSc.default)),
                        variables: consistentQueryVariables,
                        data: commentsPanelCacheResponse
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsSectionCacheData = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentsSectionCacheData?.comments?.edges || [];
                const parentCommentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === parentCommentId);
                if (parentCommentIdx !== -1) {
                    if (actionType === 'delete') {
                        // Find the last index of the comment to delete
                        const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                        if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                    } else {
                        const mutationResult = {
                            ...result.data.createFooterComment
                        };
                        // As far as I can tell, this is always called w/o reactions enabled
                        // This maps the mutation result we get to the cache object that's expected by the comments section query
                        const cacheCommentObject = {
                            id: mutationResult.id,
                            ancestors: [
                                {
                                    id: mutationResult.parentId,
                                    __typename: 'Comment'
                                }
                            ],
                            author: {
                                ...mutationResult.author,
                                type: 'known'
                            },
                            body: mutationResult.body,
                            contentStatus: mutationResult.contentStatus,
                            links: {
                                webui: mutationResult.links.webui,
                                // @ts-ignore
                                __typename: mutationResult.links.__typename
                            },
                            location: mutationResult.location,
                            parentId: mutationResult.parentId,
                            permissions: mutationResult.permissions,
                            version: {
                                ...mutationResult.version,
                                friendlyWhen: 'Just now',
                                // TODO: Maybe replace this with the actual date
                                by: {
                                    type: 'user',
                                    displayName: '',
                                    accountId: '',
                                    __typename: 'User'
                                },
                                __typename: 'Version'
                            },
                            __typename: 'Comment'
                        };
                        // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                        const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                        const newEdge = {
                            cursor: (commentEdges.length - 1).toString(),
                            node: cacheContentDeepCopy,
                            __typename: 'CommentEdge'
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                    }
                    cache.writeQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: pageId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...commentsSectionCacheData,
                            comments: {
                                ...commentsSectionCacheData.comments,
                                totalCount: commentEdges.length,
                                pageInfo: {
                                    ...commentsSectionCacheData.comments?.pageInfo,
                                    endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                    hasNextPage: false
                                },
                                edges: commentEdges
                            }
                        }
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating general comments cache for ${actionType} reply - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$aee61debd6ae89df = (commentId, newBody, pageId, isReactionsEnabled, cache, sessionDisplayName)=>{
    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
    try {
        // Update the comments section data
        const commentsSectionCacheData = cache.readQuery({
            query: commentsSectionQuery,
            variables: {
                contentId: pageId,
                offset: '',
                first: (0, $2i3To.DEFAULT_LIMIT)
            }
        });
        if (commentsSectionCacheData) {
            // grab the parent comment for the comments panel
            const commentEdges = commentsSectionCacheData?.comments?.edges || [];
            const commentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === commentId);
            if (commentIdx !== undefined && commentIdx !== null && commentIdx !== -1 && commentEdges[commentIdx]?.node?.body && commentEdges[commentIdx]?.node?.version?.number) {
                // Find the index to update. TS will throw an error even though we've already checked the index is valid
                // @ts-ignore
                commentEdges[commentIdx].node.body.value = newBody; // Update the body we keep in the footer cache
                // @ts-ignore
                commentEdges[commentIdx].node.version.number += 1; // This is required for the propagated footer version to also be editable
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.by.displayName', sessionDisplayName); // Update the display name to the user who edited the comment
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.when', new Date().toISOString()); // Update the version date to the date of the edit
            }
            cache.writeQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                data: {
                    ...commentsSectionCacheData,
                    comments: {
                        ...commentsSectionCacheData.comments,
                        totalCount: commentEdges.length,
                        pageInfo: {
                            ...commentsSectionCacheData.comments?.pageInfo,
                            endCursor: Math.random().toString(),
                            // The cache won't update without this. Should be harmless, given hasNextPage is false, so we won't be loading more
                            hasNextPage: false
                        },
                        edges: commentEdges
                    }
                }
            });
        }
    } catch (err) {
        $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for edit footer reply - ${err}`;
    }
};
const $80b47fa0b569ef69$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, experienceTracker: experienceTracker, searchSessionId: searchSessionId, isFooterComment: isFooterComment })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit && setCommentForEdit('');
    const replyCommentInfo = data?.createFooterComment;
    // Find the reply button container and scroll to it if needed
    if (replyCommentInfo?.id && commentId && isFooterComment) {
        // First find the container
        const container = document.getElementById(`footer-comment-thread-${commentId}-container`);
        if (container) {
            // Set up observer to watch for the reply button in the container
            const observer = new MutationObserver((_mutations, obs)=>{
                const replyButtonContainer = container.querySelector('[data-testid="comments-panel-reply-comment-action"]');
                if (replyButtonContainer) {
                    obs.disconnect();
                    // Check if the element is not in viewport, accounting for 75px add comment prompt at bottom
                    const rect = replyButtonContainer.getBoundingClientRect();
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewportHeight - 75 && // Account for add comment prompt
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                    if (!isInViewport) replyButtonContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
            // Cleanup observer after 2 seconds to prevent memory leaks
            setTimeout(()=>{
                observer.disconnect();
            }, 2000);
        }
    }
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).GENERAL,
                source: analyticsSource,
                pageType: pageType,
                isReply: true,
                pageMode: pageMode,
                isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                editor: 'v2',
                searchSessionId: searchSessionId,
                navdexPointType: (0, $56QzY.END),
                parentCommentId: commentId ?? null // analytics event schema type expects string or null
            }
        }
    }).fire();
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE)
    });
};
module.exports["updateApolloCacheParentCallback"] = $80b47fa0b569ef69$export$a02bedef5e94d20c;
module.exports["updateApolloCacheReplyCallback"] = $80b47fa0b569ef69$export$bab18f310e4f95e8;
module.exports["updateFooterApolloCacheOnEdit"] = $80b47fa0b569ef69$export$aee61debd6ae89df;
module.exports["handleCreateReplySuccess"] = $80b47fa0b569ef69$export$c94bffbead878776;

});

parcelRegister("2i3To", function(module, exports) {
const $a410f94860ee0eb3$export$ebc5ec3267fbcf57 = 100;
const $a410f94860ee0eb3$export$55256f24239e6668 = 0;
module.exports["DEFAULT_LIMIT"] = $a410f94860ee0eb3$export$ebc5ec3267fbcf57;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("lFkRf", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    switch(parsedError.message){
        case (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCreateNotPermittedError"] = $ad3c53086a228972$export$aa951ce6b8761d86;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed && (0, $9wGTI.fg)('confluence_comment_donot_use_cache') ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $b1hSc.default), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        pageMode,
        currentUserId,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("6lAIr", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$wasCommentRemovedByAnotherUser = (comment)=>Boolean(comment.wasRemovedByAnotherUser);
const $475d5d8641a18b80$var$wasCommentDeletedByAnotherUser = (comment)=>comment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>{
    return location && 'inlineMarkerRef' in location;
};
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter((reply)=>reply && isCommentValid(reply))
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling)=>{
    const { replies: replies, ...rest } = comment;
    return {
        ...rest,
        replies: replies,
        location: $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling)
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, _isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter(isCommentValid)
        });
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentDeletedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentRemovedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
            return sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? visibleInlineThreadsForView : sortedNonDanglingComments;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
// Determine if general comments are enabled based on the user's selection and - if using the new
// Comments Data Manager -  the user is not in Edit mode. In the legacy commments data management,
// general comments were not loaded into the commentsDataMap when the page is in Edit mode and thus
// not added to the visible threads list. But in the Comments Data Manager, all comments are loaded
// regardless of the page mode, and since we still don't want to have general comments in the list
// in Edit mode we need to explicitly hide them.
const $475d5d8641a18b80$var$isGeneralCommentsEnabled = ({ includeGeneralComments: includeGeneralComments, pageMode: pageMode })=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? includeGeneralComments && pageMode !== (0, $cD1qu.PageMode).EDIT : includeGeneralComments;
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux'), isCommentValid: providedIsCommentValid, pageMode: pageMode })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if ($475d5d8641a18b80$var$isGeneralCommentsEnabled({
        includeGeneralComments: includeGeneralComments,
        pageMode: pageMode
    })) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("i6UMJ", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $422HI = parcelRequire("422HI");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");

const $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $6ed006a18ff2d87d$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $6ed006a18ff2d87d$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$export$68e3ad656cdca3ec = (orderedActiveAnnotationIdList)=>{
    return orderedActiveAnnotationIdList.slice(0, Math.min(orderedActiveAnnotationIdList.length, (0, $7Oxky.COMMENT_BATCH_SIZE))).filter((item)=>!item.isLoaded) // only get the ones that are not loaded yet
    .map((item)=>item.threadKey);
};
const $6ed006a18ff2d87d$var$getDanglingComments = ({ commentsDataMap: commentsDataMap, annotationsSet: annotationsSet, openCommentThreads: openCommentThreads })=>{
    // Add dangling comments and handle real-time changes
    for(const threadKey in commentsDataMap.inline){
        const commentThread = commentsDataMap.inline[threadKey];
        const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
        if (commentThread?.isOpen) {
            // if the comment is already dangling, we want to add it to the list
            if (isDanglingComment) {
                const markerRef = commentThread?.location?.inlineMarkerRef;
                // comment is no longer dangling if it has a marker ref and is in the annotations set
                if (markerRef && annotationsSet && annotationsSet.has(markerRef)) {
                    const inlineLocation = commentThread.location;
                    const updatedCommentThread = {
                        ...commentThread,
                        location: {
                            ...commentThread.location,
                            inlineResolveProperties: {
                                ...inlineLocation.inlineResolveProperties,
                                isDangling: false
                            }
                        }
                    };
                    openCommentThreads.push(updatedCommentThread);
                } else openCommentThreads.push(commentThread);
                continue;
            }
            // check for real time dangling comments
            const markerRef = commentThread?.location?.inlineMarkerRef;
            // comment is dangling if it has a marker ref and is not in the annotations set
            // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
            // we do this here so the view will update immediately, but the actual mutation is handled in useDanglingOperations
            if (markerRef && annotationsSet && !annotationsSet.has(markerRef)) {
                const inlineLocation = commentThread.location;
                const updatedCommentThread = {
                    ...commentThread,
                    location: {
                        ...commentThread.location,
                        inlineResolveProperties: {
                            ...inlineLocation.inlineResolveProperties,
                            isDangling: true
                        }
                    }
                };
                openCommentThreads.push(updatedCommentThread);
            }
        }
    }
};
const $6ed006a18ff2d87d$export$aa9a5ed6405f18d6 = ({ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const openCommentThreads = [];
    const annotationsSet = new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey));
    // inline comments
    if (showInlineComments && location === "panel") {
        const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
        const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
        const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap).length;
        let activeIndex = 0; // Track position in filteredActiveAnnotationIds
        for(let i = 0; i < totalAnnotationsCount; i++){
            let threadKey = '';
            if (removedThreadsMap.inline.hasOwnProperty(i)) {
                threadKey = removedThreadsMap.inline[i];
                const commentThread = commentsDataMap.inline[threadKey];
                if (commentThread) openCommentThreads.push(commentThread);
            } else if (activeIndex < filteredActiveAnnotationIds.length) {
                threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                const commentThread = commentsDataMap.inline[threadKey];
                // dangling comments had a marker ref and will be inside commentsDataMap, so we want to ignore these first
                const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                // Don't add if it's dangling or might become dangling (has marker ref but not in annotations set)
                const markerRef = commentThread?.location?.inlineMarkerRef;
                const mightBecomeDangling = markerRef && annotationsSet && !annotationsSet.has(markerRef);
                if (commentThread?.isOpen && !isDanglingComment && !mightBecomeDangling) openCommentThreads.push(commentThread);
                activeIndex++;
            }
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) $6ed006a18ff2d87d$var$getDanglingComments({
            commentsDataMap: commentsDataMap,
            openCommentThreads: openCommentThreads,
            annotationsSet: annotationsSet
        });
    }
    // general comments
    if (showGeneralComments || location === "footer") {
        // We can just push these in the order we have them because we have no concept of "active"
        const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
            return generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
        });
        openCommentThreads.push(...generalComments);
    }
    return openCommentThreads;
};
const $6ed006a18ff2d87d$export$4fc364cd63a9b204 = ({ commentsDataMap: commentsDataMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const resolvedCommentThreads = [];
    // inline comments
    if (showInlineComments && location === "panel") for(const key in commentsDataMap.inline){
        const comment = commentsDataMap.inline[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    // general comments
    if (showGeneralComments) for(const key in commentsDataMap.general){
        const comment = commentsDataMap.general[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    return resolvedCommentThreads;
};
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime; // from the BE, this is for both reopened and resolved time, in milliseconds
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime(); // getTime() returns milliseconds
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9wEpK.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getOpenCommentThreads"] = $6ed006a18ff2d87d$export$aa9a5ed6405f18d6;
module.exports["getResolvedCommentThreads"] = $6ed006a18ff2d87d$export$4fc364cd63a9b204;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("7Oxky", function(module, exports) {

var $9j86J = parcelRequire("9j86J");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $9j86J.default);
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;

});

parcelRegister("9j86J", function(module, exports) {
/**
 * @generated SignedSource<<820e3c68982756b482d9121e85166189>>
 * @relayHash 7f2f5b1f8eabf86158412fc6d30f35d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15
const $1a28e5c1a6e6a8b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7f2f5b1f8eabf86158412fc6d30f35d6",
            "id": "13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15",
            "metadata": {},
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$1a28e5c1a6e6a8b1$var$node.hash = "55c0fbf12929f614cd8832ad8c70d69e";
var $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039 = $1a28e5c1a6e6a8b1$var$node;
module.exports["default"] = $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $h82at.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("3cu4A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $8i27m = parcelRequire("8i27m");


var $6eYRP = parcelRequire("6eYRP");

const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $42omo.memo)(({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $42omo.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $42omo.useState)(0);
    const onBatchRendered = (0, $42omo.useCallback)((batchIndex)=>{
        if (passThroughProps) {
            passThroughProps.onCommentBatchRendered && passThroughProps.onCommentBatchRendered();
            if (batches.length && batchIndex === batches.length - 1) passThroughProps.onLastThreadRendered && passThroughProps.onLastThreadRendered();
        }
        setBatch(batchIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const globalTransitionIndex = (0, $42omo.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
});
module.exports["BATCH_SIZE"] = $ba24a8cc7b954968$export$3577ba943a5537ec;
module.exports["CommentBatchList"] = $ba24a8cc7b954968$export$69f1296a446ecce6;

});

parcelRegister("6eYRP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $9wGTI = parcelRequire("9wGTI");


var $3cu4A = parcelRequire("3cu4A");

const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $42omo.memo)(({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'comment-batch' : undefined,
        size: "medium"
    })) : null);
});
module.exports["CommentBatch"] = $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("3B9cR", function(module, exports) {

var $6kgLu = parcelRequire("6kgLu");

const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $6kgLu.default);
module.exports["InlineCommentQuery"] = $7d2c123586cab1f2$export$5fa1043645dd2c26;

});

parcelRegister("6kgLu", function(module, exports) {
/**
 * @generated SignedSource<<dfabd3c27bade74b0da51b4082e1fc57>>
 * @relayHash 1565f9a21fb928625638bc549e846634
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86
const $91432cb47dad508a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "annotationId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRef",
            "variableName": "annotationId"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "when"
    }, v18 = {
        "kind": "ScalarField",
        "name": "number"
    }, v19 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v5 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1565f9a21fb928625638bc549e846634",
            "id": "66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86",
            "metadata": {},
            "name": "InlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentQuery($annotationId:String,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId,pageId:$pageId,contentStatus:$contentStatus){nodes{replies{id,parentId,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},location{__typename,type},version{by{__typename,displayName},when,number},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}},version{by{__typename,displayName},when,number},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,resolvedTime,resolvedUser}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$91432cb47dad508a$var$node.hash = "97a27177dfbb0afcc0c9bf12ba1b9268";
var $91432cb47dad508a$export$2e2bcd8739ae039 = $91432cb47dad508a$var$node;
module.exports["default"] = $91432cb47dad508a$export$2e2bcd8739ae039;

});

parcelRegister("1C8XP", function(module, exports) {

var $3cQo5 = parcelRequire("3cQo5");

const $087454af48047e63$export$c9407390b0cf740d = (0, $3cQo5.default);
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("3cQo5", function(module, exports) {
/**
 * @generated SignedSource<<3adebb861a4734f8a5ae8c4e98b2a746>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4
const $487b4c2a573008bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
            "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
            "metadata": {},
            "name": "ActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$487b4c2a573008bb$var$node.hash = "93367b15ee96494c20452626f5b23b5d";
var $487b4c2a573008bb$export$2e2bcd8739ae039 = $487b4c2a573008bb$var$node;
module.exports["default"] = $487b4c2a573008bb$export$2e2bcd8739ae039;

});

parcelRegister("isdzP", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
        case (0, $hL41C.InlineCommentError).NO_SPACE_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? (0, $9CnRS.i18n).cannotHighlightContent : (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_SPACE_PERMS"] = "Space is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("9CnRS", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("cZRYC", function(module, exports) {

var $21K7m = parcelRequire("21K7m");


var $cD1qu = parcelRequire("cD1qu");

const $360cac0569dadbce$export$24cbf19a725de615 = ({ id: id, threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(true);
        id && setHoveredCommentId(id);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('sethoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
const $360cac0569dadbce$export$8ce16d4c9a8b2b8a = ({ threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(false);
        setHoveredCommentId(undefined);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('removehoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
module.exports["handleCommentThreadMouseEnter"] = $360cac0569dadbce$export$24cbf19a725de615;
module.exports["handleCommentThreadMouseLeave"] = $360cac0569dadbce$export$8ce16d4c9a8b2b8a;

});

parcelRegister("i8TeS", function(module, exports) {
/* BaseCommentThread.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $8jHAi = parcelRequire("8jHAi");


var $8i27m = parcelRequire("8i27m");


var $cAdj8 = parcelRequire("cAdj8");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $3mVfX = parcelRequire("3mVfX");


var $fHAwL = parcelRequire("fHAwL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $cZRYC = parcelRequire("cZRYC");


var $ibqdE = parcelRequire("ibqdE");

const $74b51dc92462c104$var$styles = {
    threadBoxStyles: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _kqswh2mm _19bvpxbi _u5f3pxbi _ca0qpxbi _n3tdpxbi _1e0c1txw _2lx21bp4",
    selectedThreadStyles: "_bfhkl4ek",
    commentTypeSeperatorStyle: "_zulp1b66 _x3doia51 _ca0q1ejb _u5f31ejb _n3tdutpp _19bvpxbi",
    commentBodyBoxStyles: "_qtt8glyw _kqswh2mm"
};
const $74b51dc92462c104$var$i18n = (0, $h82at.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-common.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        // COMMENTS-5979: ObjectCommentThread doesn't have timestamp, but it probably should
        id: "comments-common.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread, {timestamp}"
    }
});
const $74b51dc92462c104$var$noop = ()=>{}; // This component renders the parent comment and its replies.
const $74b51dc92462c104$export$a9ce751de1bf208f = ({ commentThreadRef: commentThreadRef, commentComponent: commentComponent, commentRepliesComponent: commentRepliesComponent, parentComment: parentComment, eventEmitter: eventEmitter, pageMode: pageMode, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, canAddComments: canAddComments, handleCommentThreadClick: handleCommentThreadClick, handleCommentThreadMouseDown: onCommentThreadMouseDown, testIdPrefix: testIdPrefix, isEditorExpanded: isEditorExpanded, forceShowRepliesSection: forceShowRepliesSection = false })=>{
    const intl = (0, $1cfRh.default)();
    const { formatMessage: formatMessage } = intl;
    const { currentlySelectedThreadKey: currentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelState)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const [isThreadHovered, setIsThreadHovered] = (0, $42omo.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey;
    (0, $42omo.useEffect)(()=>{
        const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
        if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
        else setIsThreadPressed(false);
    }, [
        currentlySelectedThreadKey,
        isCurrentSelectedComment,
        parentComment?.replies
    ]);
    const handleCommentThreadMouseDown = (0, $42omo.useCallback)(()=>{
        onCommentThreadMouseDown?.(); /**
                                   * Limiting executions of this function because updating isThreadPressed
                                   * rerenders every component in this tree. Most notably, a user clicking into
                                   * the reply comment editor will call this function every time (and really any sibling component).
                                   * 1. isThreadPressed is only used as a style variable alongside isCurrentSelectedComment
                                   * 2. if clicking doesn't change threadKey then currentlySelectedThreadKey never changes either
                                   * which are the two variables isCurrentSelectedComment compares. We should only call this function
                                   * if threadKey has changed.
                                   */ 
        if (!isCurrentSelectedComment) setIsThreadPressed(true);
    }, [
        onCommentThreadMouseDown,
        isCurrentSelectedComment
    ]);
    const handleCommentThreadHoverProps = (0, $42omo.useMemo)(()=>({
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode,
            eventEmitter: eventEmitter
        }), [
        threadKey,
        setIsThreadHovered,
        setHoveredCommentId,
        pageMode,
        eventEmitter
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((id)=>{
        (0, $cZRYC.handleCommentThreadMouseEnter)({
            ...handleCommentThreadHoverProps,
            id: id
        });
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleFocus = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setCommentIsFocused(true);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        // Only clear focus if we're not focusing a child element
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    const resolveProperties = parentComment.location?.inlineResolveProperties || parentComment.location?.commentResolveProperties || undefined;
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: resolveProperties
    });
    const timestamp = (0, $6faGq.formatTimestampForAriaLabel)({
        intl: intl,
        dateString: parentComment.createdAtNonLocalized,
        commentStatus: commentStatus,
        resolveProperties: resolveProperties
    });
    const testIdPrefixWithDelimiter = testIdPrefix ? `${testIdPrefix}-` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $74b51dc92462c104$var$styles.commentTypeSeperatorStyle,
        as: "li",
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: commentThreadRef,
        id: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        testId: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        xcss: (0, $1Whri.cx)($74b51dc92462c104$var$styles.threadBoxStyles, (isCurrentSelectedComment || isThreadPressed) && $74b51dc92462c104$var$styles.selectedThreadStyles),
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentThreadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false),
        onFocus: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleFocus,
        onBlur: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleBlur,
        onKeyDown: ()=>{},
        tabIndex: 0,
        "aria-label": formatMessage($74b51dc92462c104$var$i18n.threadContentAriaLabelWithName, {
            name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            timestamp: timestamp
        }),
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            role: 'button'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testIdPrefixWithDelimiter}comment-thread-${parentComment.id}-parent`,
        xcss: $74b51dc92462c104$var$styles.commentBodyBoxStyles,
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : ()=>handleMouseEnter(parentComment.id),
        onMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleMouseLeave
    }, commentComponent({
        comment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: unreadCommentIDSet.has(parentComment.id),
        isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === parentComment.id || commentIsFocused && (0, $9wGTI.fg)('confluence_comments_hover_state_on_focused_comment'),
        threadKey: threadKey,
        hideBranchingStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? parentComment.replies.length === 0 && !isEditorExpanded : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered
    })), ((0, $ibqdE.getShouldShowRepliesSection)({
        replies: parentComment.replies,
        isEditorExpanded: isEditorExpanded
    }) || forceShowRepliesSection) && commentRepliesComponent({
        parentComment: parentComment,
        pageInfo: pageInfo,
        hoveredCommentId: hoveredCommentId ?? '',
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        handleMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseEnter,
        handleMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseLeave,
        canAddComments: canAddComments,
        isEditorExpanded: isEditorExpanded
    })));
};
module.exports["BaseCommentThread"] = $74b51dc92462c104$export$a9ce751de1bf208f;

});

parcelRegister("7wP5b", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $189731c52bd04a36$var$createInlineMarkerMatcher = (parentLocation)=>(reply)=>{
        if (!reply) return false;
        const replyLocation = reply.location;
        return parentLocation.inlineMarkerRef === replyLocation.inlineMarkerRef;
    };
const $189731c52bd04a36$export$ea659f9ae26b6c6b = (parentComment, location)=>{
    const { hasNestedComments: legacyHasNestedComments } = (0, $8i27m.useCommentsDataState)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const hasNestedComments = (0, $6mKj3.expValEquals)('cc_comments_new_comments_data_manager', 'isEnabled', true) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const { replyToCommentId: replyToCommentId, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    return (0, $42omo.useMemo)(()=>{
        if (location === (0, $i6UMJ.LocationValue).FOOTER) {
            if (commentLocation === (0, $i6UMJ.LocationValue).FOOTER) return parentComment.id === replyToCommentId || // Editor management depends on reply nesting configuration:
            // - With nested replies: ObjectCommentNestableReplies handles the Editor
            // - Without nested replies: Open Editor when replyToComment query parameter
            //   matches a reply's ID
            !hasNestedComments && parentComment.replies.some(({ id: id })=>id === replyToCommentId);
            return false;
        }
        const inlineMarkerMatcher = $189731c52bd04a36$var$createInlineMarkerMatcher(parentComment.location);
        const parentReplies = parentComment.replies || [];
        const matchedReplies = parentReplies.filter(inlineMarkerMatcher);
        if (commentLocation === (0, $i6UMJ.LocationValue).PANEL) {
            const isReplyingToParent = replyToCommentId === parentComment.id;
            const isReplyingToChild = matchedReplies.some((reply)=>reply.id === replyToCommentId);
            const canExpandForChildReply = isReplyingToChild && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true);
            return isReplyingToParent || canExpandForChildReply;
        }
        return false;
    }, [
        commentLocation,
        hasNestedComments,
        location,
        parentComment.id,
        parentComment.location,
        parentComment.replies,
        replyToCommentId
    ]);
};
module.exports["useIsEditorExpanded"] = $189731c52bd04a36$export$ea659f9ae26b6c6b;

});

parcelRegister("666Tc", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $4KS7f = parcelRequire("4KS7f");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $7sObp.default)(`${rightOffset}px`),
                "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-150, 12px)" : "var(--ds-space-100, 8px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-075, 6px) var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)");
            $[7] = t7;
        } else t7 = $[7];
        let t8;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)");
            $[8] = t8;
        } else t8 = $[8];
        let t9;
        if ($[9] !== __cmpls || $[10] !== t4 || $[11] !== t6) {
            t9 = {
                ...__cmpls,
                "--_35y4il": t4,
                "--_1je193e": t6,
                "--_567avp": t7,
                "--_1n1whry": t8
            };
            $[9] = __cmpls;
            $[10] = t4;
            $[11] = t6;
            $[12] = t9;
        } else t9 = $[12];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt4pe71 _n3td1fzo _1k0c1qnt _159vzwfg _1wv15a2x",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vwadc _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv6wadc _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["TopContainer"] = $003eb47e4cfe7fce$export$f895097fe90363d1;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("daq5m", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $77XlC = parcelRequire("77XlC");


var $aFLCH = parcelRequire("aFLCH");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cUiCf = parcelRequire("cUiCf");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $8jHAi = parcelRequire("8jHAi");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $9wGTI = parcelRequire("9wGTI");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6b5EI = parcelRequire("6b5EI");


var $cWhxr = parcelRequire("cWhxr");


var $lRNq8 = parcelRequire("lRNq8");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $aFLCH.default);
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $77XlC.default);
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) {
        const negativeMarginForEditMode = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? '-16px' : '-24px';
        return commentMode === 'edit' ? isReply || isStandaloneComment || isFooterComment ? '0' : negativeMarginForEditMode : undefined;
    }
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' ? isReply ? '8px' : '12px' : undefined;
    return commentMode === 'view' ? undefined : '8px';
};
const $005e7fbdd3b99ea0$var$authorContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$AuthorContainer = (props)=>{
    const { commentMode: _commentMode, isReply: _isReply, isStandaloneComment: _isStandaloneComment, isFooterComment: _isFooterComment, isFixedEditStyles: _isFixedEditStyles, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            marginLeft: $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(props),
            paddingBottom: $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(props)
        },
        ...rest,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1ul9idpf _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv"
        ])
    });
};
const $005e7fbdd3b99ea0$var$avatarWrapperBaseStyles = null;
const $005e7fbdd3b99ea0$var$avatarSmallPaddingStyles = null;
const $005e7fbdd3b99ea0$var$avatarLargePaddingStyles = null;
const $005e7fbdd3b99ea0$var$AvatarWrapper = ({ isCommentsTuneupActive: isCommentsTuneupActive, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            !isCommentsTuneupActive && (isCommentsPanel || isFooterComment || isFixedEditStyles) ? "_u5f312x7" : "_u5f3u2gc"
        ])
    });
};
const $005e7fbdd3b99ea0$var$containerStyles = null;
const $005e7fbdd3b99ea0$var$Container = ({ useProfileLinkStyle: useProfileLinkStyle, useColumnStyle: useColumnStyle, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf _14yyfhey _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            useProfileLinkStyle && "_zulpu2gc _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _4cvr1q9y _1ul9idpf",
            useColumnStyle && "_zulpidpf _2lx21bp4 _4cvr1y6m"
        ])
    });
};
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative'
}); // TODO: remove the following 3 styles when cleaning up `confluence_frontend_content_wrapper` flag
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $005e7fbdd3b99ea0$var$pageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025'
});
const $005e7fbdd3b99ea0$var$generalCommentFooterStyle = (0, $ecnYn.xcss)({
    top: 'space.negative.050'
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null;
const $005e7fbdd3b99ea0$var$profileLinkContainerColumnStyle = null;
const $005e7fbdd3b99ea0$var$truncateTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 0%',
    wordBreak: 'unset'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$dateContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerStandaloneStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerSubtlestStyles = null;
const $005e7fbdd3b99ea0$var$DateContainer = ({ isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _2lx2n7od _4cvrn7od _102ewadc _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_2lx21bp4 _4cvr1y6m",
            (isStandaloneComment || isCommentsPanel && isFixedEditStyles) && "_syaz1rpy"
        ])
    });
}; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $h82at.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select,\n\t\t\tundefined {}\n\t\t\tother { at {timeStamp}}\n\t\t}"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const skipUserIdPath = Boolean(avatarUrl && displayName || !userId || commentId);
    const { data: authorData } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userDataFromOld } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        skip: skipUserIdPath || (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)
    });
    const { data: userDataFromNew } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, {
        skip: skipUserIdPath || !(0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true),
        fetchPolicy: 'cache-and-network'
    });
    const userData = (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true) ? userDataFromNew : userDataFromOld;
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $1cfRh.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }))));
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const hasPageCommentIconEnabled = (0, $42omo.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]); // TODO: remove renderDateInfoOldExperience() when cleaning up `confluence_frontend_content_wrapper` flag
    const renderDateInfoOldExperience = (resolvedInfo)=>{
        return resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $005e7fbdd3b99ea0$var$pageIconStyle,
                $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date)
        }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$pageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))));
    };
    const renderCopyButton = ()=>{
        const resolvedInfo_0 = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && !isCommentsPanel;
        const timeAgoDate = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cWhxr.RelativeTimestamp), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = (commentMode === 'view' || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        "data-testid": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        isBlockLevel: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRNq8.MaybeTooltip), {
        date: date,
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
        useProfileLinkStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        useColumnStyle: !!(resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $005e7fbdd3b99ea0$var$truncateTextStyle
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton())));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("77XlC", function(module, exports) {
/**
 * @generated SignedSource<<f3a4b4ed7601aace35c2653bcb912fb4>>
 * @relayHash 7603ffb5cdb0040c872fb1a866b28175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0
const $a4999a70afb18ca0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7603ffb5cdb0040c872fb1a866b28175",
            "id": "0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0",
            "metadata": {},
            "name": "CommentAuthorUserQuery",
            "operationKind": "query",
            "text": "query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4999a70afb18ca0$var$node.hash = "b941cc393296a840051106bc2b577a66";
var $a4999a70afb18ca0$export$2e2bcd8739ae039 = $a4999a70afb18ca0$var$node;
module.exports["default"] = $a4999a70afb18ca0$export$2e2bcd8739ae039;

});

parcelRegister("aFLCH", function(module, exports) {
/**
 * @generated SignedSource<<ea6bac65cbc1f11b4d15bcbc69caa479>>
 * @relayHash 3fce16c4b50c6a412fa8487092b88148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641
const $05493535de3a048c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fce16c4b50c6a412fa8487092b88148",
            "id": "e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641",
            "metadata": {},
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "operationKind": "query",
            "text": "query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id,history{createdBy{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}"
        }
    };
}();
$05493535de3a048c$var$node.hash = "7be748651ddc7f6e555a6f8193a7649c";
var $05493535de3a048c$export$2e2bcd8739ae039 = $05493535de3a048c$var$node;
module.exports["default"] = $05493535de3a048c$export$2e2bcd8739ae039;

});

parcelRegister("cUiCf", function(module, exports) {

var $kVisP = parcelRequire("kVisP");


var $jMyy4 = parcelRequire("jMyy4");

const $e7d88eb3577c40b3$export$81e6931b5465b2c6 = (0, $kVisP.default);
const $e7d88eb3577c40b3$export$15a9d6bfd715c3fb = (userId, options = {})=>{
    const { skip: skip = !userId, fetchPolicy: fetchPolicy = 'cache-and-network' } = options;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($e7d88eb3577c40b3$export$81e6931b5465b2c6, {
        variables: {
            id: userId
        },
        fetchPolicy: fetchPolicy,
        skip: skip || !userId
    });
    const isReady = skip || !!data || !loading;
    return {
        data: data,
        loading: loading,
        isReady: isReady
    };
};
module.exports["useCommentAuthorQuery"] = $e7d88eb3577c40b3$export$15a9d6bfd715c3fb;

});

parcelRegister("kVisP", function(module, exports) {
/**
 * @generated SignedSource<<bc24953310fa78820eb739edf69525c0>>
 * @relayHash d7dd18272a64084411071f3794bede2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d
const $a036ea87d0b71d0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d7dd18272a64084411071f3794bede2a",
            "id": "034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d",
            "metadata": {},
            "name": "useCommentAuthorQuery",
            "operationKind": "query",
            "text": "query useCommentAuthorQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a036ea87d0b71d0a$var$node.hash = "5a28bff8b85798e31c8498c8ffd13edb";
var $a036ea87d0b71d0a$export$2e2bcd8739ae039 = $a036ea87d0b71d0a$var$node;
module.exports["default"] = $a036ea87d0b71d0a$export$2e2bcd8739ae039;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $h82at.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $1cfRh.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("8lYIw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $22s37 = parcelRequire("22s37");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $4B6DI = parcelRequire("4B6DI");


var $bjNrH = parcelRequire("bjNrH");



var $dRnqM = parcelRequire("dRnqM");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $7Q5yr.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $4B6DI.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $bjNrH.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $h82at.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $1cfRh.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("6b5EI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1cfRh = parcelRequire("1cfRh");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
});
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("cWhxr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

var $lvvx5 = parcelRequire("lvvx5");

const $677d422179b5c9e8$var$messages = (0, $h82at.defineMessages)({
    now: {
        id: "inline-comments-common.relative-timestamp.now",
        defaultMessage: "Now"
    }
});
const $677d422179b5c9e8$export$705da3a6fb3571ab = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { date: date } = t0;
    const intl = (0, $1cfRh.default)();
    const now = new Date();
    const diffInMinutes = (0, $d6omw.default)(now, date);
    const diffInHours = (0, $8uR5k.default)(now, date);
    const diffInDays = (0, $917iu.default)(now, date);
    const diffInWeeks = (0, $lvvx5.default)(now, date);
    if (diffInMinutes < 2) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($677d422179b5c9e8$var$messages.now);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (diffInMinutes < 60) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h82at.FormattedNumber), {
        value: diffInMinutes,
        style: "unit",
        unit: "minute",
        unitDisplay: "narrow"
    });
    if (diffInHours < 24) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h82at.FormattedNumber), {
        value: diffInHours,
        style: "unit",
        unit: "hour",
        unitDisplay: "narrow"
    });
    if (diffInWeeks < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h82at.FormattedNumber), {
        value: diffInDays,
        style: "unit",
        unit: "day",
        unitDisplay: "narrow"
    });
    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();
    if (currentYear === dateYear) {
        let t1;
        if ($[4] !== date || $[5] !== intl) {
            t1 = intl.formatDate(date, {
                month: "short",
                day: "numeric"
            });
            $[4] = date;
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    let t1;
    if ($[9] !== date || $[10] !== intl) {
        t1 = intl.formatDate(date, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[9] = date;
        $[10] = intl;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
module.exports["RelativeTimestamp"] = $677d422179b5c9e8$export$705da3a6fb3571ab;

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lRNq8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $3gadb = parcelRequire("3gadb");


var $gdv5Z = parcelRequire("gdv5Z");


var $6faGq = parcelRequire("6faGq");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $82d0090970c55653$var$styles = {
    tooltipWrapper: "_1ul9idpf"
};
const $82d0090970c55653$var$i18n = (0, $h82at.defineMessages)({
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    }
});
const $82d0090970c55653$export$8d25ba73a810c5c5 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, date: date, name: name } = t0;
    const intl = (0, $1cfRh.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t1;
    if ($[0] !== children || $[1] !== date || $[2] !== formatMessage || $[3] !== intl || $[4] !== name || $[5] !== timeZone) {
        t1 = date && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $82d0090970c55653$var$styles.tooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($82d0090970c55653$var$i18n.addedTooltip, {
                username: name,
                date: intl.formatDate((0, $6faGq.getValidDate)(date), {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime((0, $6faGq.getValidDate)(date), {
                    hour: "numeric",
                    minute: "numeric",
                    timeZone: timeZone
                })
            })
        }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = date;
        $[2] = formatMessage;
        $[3] = intl;
        $[4] = name;
        $[5] = timeZone;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["MaybeTooltip"] = $82d0090970c55653$export$8d25ba73a810c5c5;

});

parcelRegister("9Z0wk", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $5e18336ff60a0b69$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $5e18336ff60a0b69$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $gMc0m.default)([
            $5e18336ff60a0b69$var$editedContentStyles.root
        ]),
        children: children
    });
$5e18336ff60a0b69$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5e18336ff60a0b69$export$2e2bcd8739ae039 = $5e18336ff60a0b69$var$Edited;
module.exports["default"] = $5e18336ff60a0b69$export$2e2bcd8739ae039;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("le4yZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $9pwVP = parcelRequire("9pwVP");


var $bbPOv = parcelRequire("bbPOv");

var $850e39d8df191904$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
var $850e39d8df191904$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
const $850e39d8df191904$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $850e39d8df191904$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $850e39d8df191904$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$850e39d8df191904$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $850e39d8df191904$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : "AUTO";
};
const $850e39d8df191904$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: "AUTO",
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $850e39d8df191904$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $42omo.useState)($850e39d8df191904$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $42omo.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$850e39d8df191904$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $bbPOv.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $bbPOv.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $dh538.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $9pwVP.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $850e39d8df191904$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$850e39d8df191904$var$initialState,
                keyPhraseCategory: $850e39d8df191904$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$850e39d8df191904$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $42omo.useCallback)(()=>{
        setState($850e39d8df191904$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $42omo.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $42omo.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $42omo.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $850e39d8df191904$export$5fc610914b028d97;
module.exports["KeyPhraseCategory"] = $850e39d8df191904$export$17a511c5c23509af;
module.exports["getHighlightRegex"] = $850e39d8df191904$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $850e39d8df191904$export$52e9ff9bfbb65046;

});

parcelRegister("9pwVP", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $le4yZ = parcelRequire("le4yZ");


var $fjzE4 = parcelRequire("fjzE4");

const $135aee7ed4d7fef7$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $135aee7ed4d7fef7$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $fjzE4.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $le4yZ.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    });
module.exports["onCuratedDefinitionUpdateButtonClicked"] = $135aee7ed4d7fef7$export$ae4ae603f16dcf42;
module.exports["onCuratedDefinitionSeeEditHistoryButtonClicked"] = $135aee7ed4d7fef7$export$d80f83cdfda72179;
module.exports["onLikeButtonClick"] = $135aee7ed4d7fef7$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $135aee7ed4d7fef7$export$c4c8b81ee90e6af2;
module.exports["onShownAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$42897f8f02baa658;
module.exports["onClickAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$9e6261f08debf93b;
module.exports["onClickDisableDefinition"] = $135aee7ed4d7fef7$export$bfe6deae035e3ea7;

});

parcelRegister("fjzE4", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f09d80c8646d0453$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $f09d80c8646d0453$export$72ebbc2f4d73897b = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f09d80c8646d0453$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $f09d80c8646d0453$export$f600f3124ea5916b;

});

parcelRegister("bbPOv", function(module, exports) {
const $b754f76c2ea6a90a$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $b754f76c2ea6a90a$export$39b2bc657daf065 = `
	query ${$b754f76c2ea6a90a$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $b754f76c2ea6a90a$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $b754f76c2ea6a90a$export$39b2bc657daf065;

});

parcelRegister("14FKK", function(module, exports) {
// create separate utils folder if need to export more utils
const $e67d683b71b74003$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e67d683b71b74003$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e67d683b71b74003$var$extractContent = (data, flatMap)=>{
    if ($e67d683b71b74003$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e67d683b71b74003$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e67d683b71b74003$var$validMarks(data)) flatMap.push(data);
};
const $e67d683b71b74003$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e67d683b71b74003$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e67d683b71b74003$export$4cf5403beffb0fc1;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("jWDKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4dd7b9fe81a55e61$export$ab78b8e7dad428f8 = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // single click
            if (state.e?.detail === 1) singleClickCallback(state.e);
            else if (state.e?.detail && state.e.detail > 1) doubleClickCallback(state.e);
            setState({
                e: null
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            e: e
        });
    };
};
const $4dd7b9fe81a55e61$export$f93f1774a43b3eae = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        click: 0,
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // simple click
            if (state.click === 1) singleClickCallback(state.e);
            setState({
                e: null,
                click: 0
            });
        }, delay);
        // the duration between this click and the previous one
        // is less than the value of delay = double-click
        if (state.click === 2) doubleClickCallback(state.e);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            click: state.click + 1,
            e: e
        });
    };
};
module.exports["useTextHighlighterClickNative"] = $4dd7b9fe81a55e61$export$ab78b8e7dad428f8;
module.exports["useTextHighlighterClick"] = $4dd7b9fe81a55e61$export$f93f1774a43b3eae;

});

parcelRegister("lmNXu", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $2XqLN.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $c7f67cb608b5916f$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("1421M"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("1421M", function(module, exports) {

let $0c67bcd931c05ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c67bcd931c05ad3$var$load("6wr18"),
    $0c67bcd931c05ad3$var$load("ffEVr"),
    $0c67bcd931c05ad3$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("9eOvr", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b2dbadf512f98f64$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b2dbadf512f98f64$export$1536d3aa2f6b9cd9 = ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
};
const $b2dbadf512f98f64$export$5f0b55764d1d819f = ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $42omo.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $b2dbadf512f98f64$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $b2dbadf512f98f64$export$5f0b55764d1d819f;

});

parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $ejAeh = parcelRequire("ejAeh");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) {
                if ((0, $dh538.fg)('platform_synced_block_patch_8')) {
                    // No reference found
                    if (isSourceSyncBlock) {
                        // Verify that a reference sync block for this specific source actually
                        // exists on the current page by checking if the reference manager has
                        // an active subscription for the derived reference resourceId.
                        const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
                        const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
                        if (hasUnregisteredReferenceOnPage) {
                            // This is current page data. It is the same for data for source and reference
                            const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                            const references = [];
                            if (sourceSyncBlockData) references.push({
                                ...sourceSyncBlockData,
                                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                                hasAccess: true,
                                isSource: true
                            });
                            const unregisteredReferenceData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(referenceResourceId);
                            if (unregisteredReferenceData) references.push({
                                ...unregisteredReferenceData,
                                onSameDocument: true,
                                hasAccess: true,
                                isSource: false
                            });
                            this.fetchReferencesExperience?.success();
                            return {
                                references: references
                            };
                        }
                        // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
                        this.fetchReferencesExperience?.success();
                        return {
                            references: []
                        };
                    }
                    if (!isSourceSyncBlock) {
                        // Though no references registered yet for this reference sync block,
                        // still show the source and the current page itself since they are known
                        // but not saved yet.
                        const references = [];
                        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
                        if (sourceSyncBlockData) references.push({
                            ...sourceSyncBlockData,
                            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                            hasAccess: true,
                            isSource: true
                        });
                        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
                        if (currentPageData) references.push({
                            ...currentPageData,
                            onSameDocument: true,
                            hasAccess: true,
                            isSource: false
                        });
                        if (references.length === 0) {
                            this.fetchReferencesExperience?.failure({
                                reason: 'No references found for reference synced block'
                            });
                            return {
                                error: (0, $awHlv.SyncBlockError).Errored
                            };
                        }
                        this.fetchReferencesExperience?.success();
                        return {
                            references: references
                        };
                    }
                } else {
                    // No reference found
                    if (isSourceSyncBlock) this.fetchReferencesExperience?.success();
                    else this.fetchReferencesExperience?.failure({
                        reason: 'No references found for reference synced block'
                    });
                    return isSourceSyncBlock ? {
                        references: []
                    } : {
                        error: (0, $awHlv.SyncBlockError).Errored
                    };
                }
            }
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $ejAeh.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $QkKjT.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    constructor(dataProvider){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        return $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $42omo.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("QkKjT", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $fo9p3 = parcelRequire("fo9p3");

const $48856e1ef5d8a6d7$var$TIMEOUT_DURATION = 30000;
const $48856e1ef5d8a6d7$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $d925B.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $d925B.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $48856e1ef5d8a6d7$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $48856e1ef5d8a6d7$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $48856e1ef5d8a6d7$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $48856e1ef5d8a6d7$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $48856e1ef5d8a6d7$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $48856e1ef5d8a6d7$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $48856e1ef5d8a6d7$export$3ba8782eb93c9adf;

});

parcelRegister("3RNNl", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");


var $dyHCj = parcelRequire("dyHCj");


var $bBz3A = parcelRequire("bBz3A");


var $cTANx = parcelRequire("cTANx");


var $axlAB = parcelRequire("axlAB");

const $bf9ff2ea047058dc$var$CACHE_KEY_PREFIX = 'sync-block-data-';
class $bf9ff2ea047058dc$export$fb04276dca31302e {
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $QkKjT.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) return providerData;
        return this.getFromSessionCache(resourceId);
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $bBz3A.syncBlockInMemorySessionCache).setItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $bBz3A.syncBlockInMemorySessionCache).getItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            return JSON.parse(raw);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product
            });
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('No source info returned', resourceId));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Missing title or url', resourceId));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) throw new Error('Data provider not set');
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(payload));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            if (syncBlockInstance.error) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId));
                if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: syncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, syncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
        (0, $bBz3A.syncBlockInMemorySessionCache).clear();
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $axlAB.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            deleteFromCache: (rid)=>this.deleteFromCache(rid),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            }
        });
        this._providerFactoryManager = new (0, $cTANx.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $dyHCj.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $f8eu7 = parcelRequire("f8eu7");


var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $awHlv.SyncBlockError).NotFound || newResult.error?.type === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $165aef3c3dcb8be4$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined
        }
    };
};
const $165aef3c3dcb8be4$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dyHCj", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");


var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $f5bf878eca9bbfe8$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.cancel();
        this.clearPending();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $2P8Ax.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $gtauf.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resId));
                });
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $f5bf878eca9bbfe8$export$7d827e0357659116;

});

parcelRegister("bBz3A", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $657a090a5274b259$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $657a090a5274b259$export$b811313deafee9ed = new $657a090a5274b259$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $657a090a5274b259$export$b811313deafee9ed;

});

parcelRegister("cTANx", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");

class $acb948bac57fc60c$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $47N43.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        const { contentId: contentId, product: contentProduct } = parsedResourceId;
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)('Sync block source ari or product not found'));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $acb948bac57fc60c$export$3bfff6c128de82c9;

});

parcelRegister("axlAB", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $4wATI = parcelRequire("4wATI");

class $e3afe1feb1dd429f$export$200c87d47b3d6e17 {
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delay cache deletion to handle block moves (unmount/remount).
                    // When a block is moved, the old component unmounts before the new one mounts.
                    // By delaying deletion, we give the new component time to subscribe and
                    // cancel this pending deletion, preserving the cached data.
                    // TODO: EDITOR-4152 - Rework this logic
                    const deletionTimeout = setTimeout(()=>{
                        // Only delete if still no subscribers (wasn't re-subscribed)
                        if (!this.subscriptions.has(resourceId)) this.deps.deleteFromCache(resourceId);
                        this.pendingCacheDeletions.delete(resourceId);
                    }, 1000);
                    this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
        // Clear any pending cache deletions
        for (const timeout of this.pendingCacheDeletions.values())clearTimeout(timeout);
        this.pendingCacheDeletions.clear();
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = new Map();
    }
}
module.exports["SyncBlockSubscriptionManager"] = $e3afe1feb1dd429f$export$200c87d47b3d6e17;

});

parcelRegister("dBGrG", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $QkKjT.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $QkKjT.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode) {
        try {
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const cachedBlock = this.syncBlockCache.get(resourceId);
            if ((0, $dh538.fg)('platform_synced_block_update_refactor')) {
                // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
                // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
                if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
                const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
                if (cachedBlock) this.hasReceivedContentChange = true;
                this.syncBlockCache.set(resourceId, {
                    ...syncBlockData,
                    isDirty: true,
                    contentFragment: syncBlockNode.content
                });
            } else {
                const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
                if (cachedBlock && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncBlockData.content, cachedBlock.content)) this.hasReceivedContentChange = true;
                this.syncBlockCache.set(resourceId, {
                    ...syncBlockData,
                    isDirty: true
                });
            }
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) this.fireAnalyticsEvent?.((0, $cFpEg.updateSuccessPayload)(result.resourceId, false));
                });
                return true;
            } else {
                this.saveExperience?.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        } finally{
            if ((0, $dh538.fg)('platform_synced_block_patch_7')) this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            if (success && (0, $iu6m9.editorExperiment)('platform_synced_block_patch_6', true, {
                exposure: true
            })) // If creation is successful, set hasReceivedContentChange to true
            // to indicate that there are unsaved changes in the cache
            this.hasReceivedContentChange = true;
        } else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('creation complete callback missing', resourceId));
        if (success) this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessPayload)(resourceId || ''));
        else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('Fail to create bodied sync block', resourceId));
        }
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   */ createBodiedSyncBlockNode(attrs, onCompletion) {
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId));
            });
        } catch (error) {
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
                results.forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                });
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                results.forEach((result)=>{
                    if (result.success) this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                    else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message, Ids.resourceId));
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return Promise.resolve({
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $42omo.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $h82at = parcelRequire("h82at");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $h82at.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("Ovp0E"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("Ovp0E", function(module, exports) {

let $097d077c1d0e1bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $097d077c1d0e1bc5$var$load("iMSgb"),
    $097d077c1d0e1bc5$var$load("9a2oY"),
    $097d077c1d0e1bc5$var$load("7EorR"),
    $097d077c1d0e1bc5$var$load("hhss7"),
    $097d077c1d0e1bc5$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("cTt7H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $lEN6w = parcelRequire("lEN6w");


var $c1GUA = parcelRequire("c1GUA");

const $3ab45e305da1892a$export$570dec5b65c6715b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1GUA.UFOLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEN6w.Bm3PageLoadEnd), props);
};
module.exports["PageLoadEnd"] = $3ab45e305da1892a$export$570dec5b65c6715b;

});

parcelRegister("lEN6w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $4XtQK = parcelRequire("4XtQK");

const $fd3232056a8feb49$var$Bm3PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $fd3232056a8feb49$export$ad1c47bc07e7de3b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($fd3232056a8feb49$var$Bm3PageLoadEndComponent);
module.exports["Bm3PageLoadEnd"] = $fd3232056a8feb49$export$ad1c47bc07e7de3b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("c1GUA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $af29827660b87816$var$UFOLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $cbc8g.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $af29827660b87816$export$6f85d00e0066bc7 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($af29827660b87816$var$UFOLoadEndComponent);
module.exports["UFOLoadEnd"] = $af29827660b87816$export$6f85d00e0066bc7;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("8jTDW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e542faf6fbe5ebc711b672478100d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60eb42a7b08ac844$var$_react = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("42omo")));

var $60eb42a7b08ac844$var$_baseNew = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60eb42a7b08ac844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudOffline".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing when a connection can't be established to the cloud.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60eb42a7b08ac844$var$CloudOfflineIcon = (props)=>/*#__PURE__*/ $60eb42a7b08ac844$var$_react.default.createElement($60eb42a7b08ac844$var$_baseNew.default, Object.assign({
        name: "CloudOfflineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.5 1.5H3.75a3.75 3.75 0 0 1-1.42-7.22q.06-.32.14-.62l1.29 1.28a.75.75 0 0 1-.56.63A2.25 2.25 0 0 0 3.75 12zM8 1.5c-.96 0-1.87.24-2.66.65l1.13 1.13a4.25 4.25 0 0 1 5.72 3.23.75.75 0 0 0 .53.59 2.5 2.5 0 0 1 1.36 3.79l1.07 1.07a4 4 0 0 0-1.58-6.15A5.75 5.75 0 0 0 8 1.5"/>`
    }, props));
$60eb42a7b08ac844$var$CloudOfflineIcon.displayName = 'CloudOfflineIcon';
var $60eb42a7b08ac844$var$_default = module.exports.default = $60eb42a7b08ac844$var$CloudOfflineIcon;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $bQm3c = parcelRequire("bQm3c");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default));
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<f880ece3b8b9b4b21f57f3587db960a1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $h82at.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<22ecfb49e3c2856e89f63a40e9fe0bd7>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("hkzol", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $h82at.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $1cfRh.default)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $9wGTI = parcelRequire("9wGTI");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip
    });
    const makeContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<b0a6b2cd3e5ca219cd45a254159cb692>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("jooGc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $1P1Tu.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $9zUhf.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $9zUhf.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("i2BsV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c26d5c1d83386c25$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $1Whri = parcelRequire("1Whri");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $dokWT = parcelRequire("dokWT");


var $5HQ8i = parcelRequire("5HQ8i");


var $gWldI = parcelRequire("gWldI");


var $1HYxw = parcelRequire("1HYxw");

const $c26d5c1d83386c25$var$styles = {
    base: "_zulp1b66 _2rko12b0 _1e0c116y _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _4cvr1h6o _1bah1h6o _o5724jg8 _1bto1l2s _80om73ad",
    compact: "_4t3igktf",
    expanded: "_4t3i1tcg",
    disabled: "_syaz1gmx _bfhkby5v _80om73ad",
    clickable: "_80omtlke",
    red: "_syazi7uo _bfhk1rtt",
    redClickable: "_13ix1rtt _irr3affd _1di61j5a",
    redBold: "_syaz15cr _bfhkuibq",
    redBoldClickable: "_13ixuibq _irr3100f _1di61cl6",
    orange: "_syazi7uo _bfhk1kkj",
    orangeClickable: "_13ix1kkj _irr39mfs _1di6axpp",
    yellow: "_syazi7uo _bfhkibhp",
    yellowClickable: "_13ixibhp _irr3aetg _1di61o1l",
    green: "_syazi7uo _bfhkn729",
    greenClickable: "_13ixn729 _irr33utz _1di6yfny",
    blue: "_syazi7uo _bfhk1dy8",
    blueClickable: "_13ix1dy8 _irr3815t _1di6rwxf",
    teal: "_syazi7uo _bfhk1a17",
    tealClickable: "_13ix1a17 _irr3kwwr _1di61jb0",
    lime: "_syazi7uo _bfhkz2ec",
    limeClickable: "_13ixz2ec _irr31gf0 _1di62kxc",
    purple: "_syazi7uo _bfhkp2ly",
    purpleClickable: "_13ixp2ly _irr3kca2 _1di61jbm",
    grey: "_syazi7uo _bfhkysee",
    greyClickable: "_13ixysee _irr3wejn _1di618ut",
    popup: "_1bsbp2n4"
};
function $c26d5c1d83386c25$export$2e2bcd8739ae039({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, guidelineADF: guidelineADF, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false, associatedPoliciesCount: associatedPoliciesCount, spacing: spacing = 'default' }) {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameWithRules = isMissingName ? '' : associatedPoliciesCount ? name + ' ' + formatMessage((0, $1HYxw.messages).rules, {
        associatedPoliciesCount: associatedPoliciesCount
    }) : name;
    const nameTruncated = (nameWithRules ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    const iconPx = iconSize === 'small' ? 12 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 12;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    const getContainer = (triggerProps = {})=>{
        // @ts-ignore
        const { 'aria-expanded': ariaExpanded, ...restProps } = triggerProps;
        const Container = isClickable ? (0, $fVUfS.default) : (0, $gdv5Z.default);
        return /*#__PURE__*/ (0, $l998X.jsxs)(Container, {
            role: isClickable ? 'button' : 'presentation',
            "aria-disabled": isDisabled,
            ...isClickable ? {
                'aria-label': `${formatMessage((0, $1HYxw.messages).dataClassificationLevel)} - ${name}`
            } : {},
            xcss: (0, $1Whri.cx)(...[
                $c26d5c1d83386c25$var$styles.base,
                // Add size styles if not icon only
                ...!isIconOnly ? [
                    spacing === 'expanded' ? $c26d5c1d83386c25$var$styles.expanded : $c26d5c1d83386c25$var$styles.compact
                ] : [],
                // Add disabled styles if disabled
                ...isDisabled ? [
                    $c26d5c1d83386c25$var$styles.disabled
                ] : [],
                // Add color styles
                ...!isDisabled ? [
                    {
                        RED: $c26d5c1d83386c25$var$styles.red,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBold,
                        ORANGE: $c26d5c1d83386c25$var$styles.orange,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellow,
                        GREEN: $c26d5c1d83386c25$var$styles.green,
                        BLUE: $c26d5c1d83386c25$var$styles.blue,
                        TEAL: $c26d5c1d83386c25$var$styles.teal,
                        LIME: $c26d5c1d83386c25$var$styles.lime,
                        PURPLE: $c26d5c1d83386c25$var$styles.purple,
                        GREY: $c26d5c1d83386c25$var$styles.grey
                    }[color]
                ] : [],
                // Add clickable styles if clickable
                ...!isDisabled && isClickable ? [
                    $c26d5c1d83386c25$var$styles.clickable,
                    {
                        RED: $c26d5c1d83386c25$var$styles.redClickable,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBoldClickable,
                        ORANGE: $c26d5c1d83386c25$var$styles.orangeClickable,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellowClickable,
                        GREEN: $c26d5c1d83386c25$var$styles.greenClickable,
                        BLUE: $c26d5c1d83386c25$var$styles.blueClickable,
                        TEAL: $c26d5c1d83386c25$var$styles.tealClickable,
                        LIME: $c26d5c1d83386c25$var$styles.limeClickable,
                        PURPLE: $c26d5c1d83386c25$var$styles.purpleClickable,
                        GREY: $c26d5c1d83386c25$var$styles.greyClickable
                    }[color]
                ] : []
            ]),
            testId: testId,
            padding: "space.050",
            onClick: ()=>{
                if (onClick) onClick();
                handleContainerClicked();
            },
            ...isClickable ? triggerProps : restProps,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWldI.ClassificationIcon), {
                        width: iconPx,
                        height: iconPx,
                        color: isDisabled ? (0, $5HQ8i.disabledColorConfig).iconColor : (0, $5HQ8i.colorsConfig)[color].iconColor
                    })
                }),
                !isIconOnly && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    maxLines: 1,
                    color: color === 'RED_BOLD' ? 'color.text.inverse' : 'color.text',
                    testId: "data-classification-level-name",
                    children: nameTruncated
                })
            ]
        });
    };
    return isPopupDisabled ? getContainer() : // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition,
                children: getContainer(triggerProps)
            }),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.250",
                xcss: $c26d5c1d83386c25$var$styles.popup,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dokWT.ClassificationView), {
                    name: name,
                    guideline: guideline,
                    guidelineADF: guidelineADF,
                    guidelineRepresentation: guidelineRepresentation
                })
            }),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
}

});

parcelRegister("dokWT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7bZ3i = parcelRequire("7bZ3i");


var $gdv5Z = parcelRequire("gdv5Z");


var $67O0h = parcelRequire("67O0h");


var $5HQ8i = parcelRequire("5HQ8i");


var $blUZ2 = parcelRequire("blUZ2");


var $kGNkZ = parcelRequire("kGNkZ");

// Maximum height for guideline content to enable scrolling for long text
const $6522a38deabe02d9$var$GUIDELINE_MAX_HEIGHT = '300px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6522a38deabe02d9$var$Name = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$var$Guideline = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _o5721jtm _1i4q1hna _c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$var$GuidelineADFContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$export$d413367b4cbb5577 = ({ name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    // Select the appropriate guideline based on guidelineRepresentation
    // Prefers guidelineADF when in EDITOR mode, falls back to guideline
    const selectedGuideline = (0, $kGNkZ.selectGuideline)({
        guidelineADF: guidelineADF,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation
    });
    // Parse ADF if in EDITOR mode - parse before truncation to avoid breaking JSON
    const parsedADF = guidelineRepresentation === 'EDITOR' ? (0, $blUZ2.safeParseGuidelineADF)(selectedGuideline) : undefined;
    // Only truncate for plain text mode - ADF content shows full text with scrolling
    const guidelineTruncated = (selectedGuideline ?? '').substring(0, (0, $5HQ8i.guidelineMaxLength));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            nameTruncated && /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Name, {
                id: "data-classification-read-content-name",
                children: nameTruncated
            }),
            selectedGuideline && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockStart: "space.200",
                children: guidelineRepresentation === 'PLAIN' || !parsedADF ? /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Guideline, {
                    id: "data-classification-read-content-guideline",
                    children: guidelineTruncated
                }) : /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$GuidelineADFContainer, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                            document: parsedADF
                        })
                    })
                })
            })
        ]
    });
};
module.exports["ClassificationView"] = $6522a38deabe02d9$export$d413367b4cbb5577;

});

parcelRegister("5HQ8i", function(module, exports) {

var $gc1M8 = parcelRequire("gc1M8");


var $1HYxw = parcelRequire("1HYxw");

const { formatMessage: $e53ad3413efcb6ae$var$formatMessage } = (0, $gc1M8.createIntl)({
    locale: 'en'
});
const $e53ad3413efcb6ae$export$89b67151eed9295a = {
    definition: $e53ad3413efcb6ae$var$formatMessage((0, $1HYxw.messages).noClassification),
    includeIcon: false
};
const $e53ad3413efcb6ae$export$5f11f8883714351 = {
    id: 'no-selection',
    name: 'No selection'
};
const $e53ad3413efcb6ae$export$253bdad208569777 = 50;
const $e53ad3413efcb6ae$export$cbc3cef853d1014b = 1000;
const $e53ad3413efcb6ae$export$e1444e5b0a63d793 = 1000;
const $e53ad3413efcb6ae$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E06C00)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #357DE8)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #7D818A)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #292A2E)"
    }
};
const $e53ad3413efcb6ae$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #080F214A)",
    bgColor: "var(--ds-background-disabled, #17171708)",
    fontColor: "var(--ds-text-disabled, #080F214A)"
};
module.exports["NO_SELECTION_OPTION"] = $e53ad3413efcb6ae$export$5f11f8883714351;
module.exports["nameMaxLength"] = $e53ad3413efcb6ae$export$253bdad208569777;
module.exports["guidelineMaxLength"] = $e53ad3413efcb6ae$export$e1444e5b0a63d793;
module.exports["colorsConfig"] = $e53ad3413efcb6ae$export$fb2992e82b83582a;
module.exports["disabledColorConfig"] = $e53ad3413efcb6ae$export$9cdea53b8993b139;

});

parcelRegister("1HYxw", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $eac3d8fc17e23def$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    noClassification: {
        id: "data-classification-level.no-classification",
        defaultMessage: "No classification"
    },
    classifyContent: {
        id: "data-classification-level.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    selectClassification: {
        id: "data-classification-level.edit-popup.select-classification",
        defaultMessage: "Select classification"
    },
    updateButton: {
        id: "data-classification-level.edit-popup.update-button",
        defaultMessage: "Update"
    },
    cancelButton: {
        id: "data-classification-level.edit-popup.cancel-button",
        defaultMessage: "Cancel"
    },
    changeLevel: {
        id: "data-classification-level.read-popup.change-level",
        defaultMessage: "Change level"
    },
    rules: {
        id: "data-classification-level.rules",
        defaultMessage: "({associatedPoliciesCount, plural, one {# rule} other {# rules}})"
    },
    dataClassificationLevel: {
        id: "data-classification-level.data-classification-level",
        defaultMessage: "Data classification level"
    },
    dataClassificationLevelDialog: {
        id: "data-classification-level.read-popup.data-classification-level",
        defaultMessage: "Data classification level Dialog"
    },
    classificationLevelGuidelines: {
        id: "data-classification-level.read-popup.heading",
        defaultMessage: "Classification level guidelines"
    },
    sourceAutoClassification: {
        id: "data-classification-level.read-popup.source-auto-classification",
        defaultMessage: "The current classification level is based on information detected in the content. <a>Update classification level</a>"
    },
    sourceUserClassification: {
        id: "data-classification-level.read-popup.source-user-classification",
        defaultMessage: "A user assigned the current classification level. <a>Update classification level</a>"
    },
    sourceSpaceDefaultClassification: {
        id: "data-classification-level.read-popup.source-space-default-classification",
        defaultMessage: "The current classification level is the default for this space. <a>Update classification level</a>"
    },
    sourceOrgDefaultClassification: {
        id: "data-classification-level.read-popup.source-org-default-classification",
        defaultMessage: "The current classification level is the default for your organization. <a>Update classification level</a>"
    },
    sourceNoneClassification: {
        id: "data-classification-level.read-popup.source-none-classification",
        defaultMessage: "<a>Update classification level</a>"
    },
    sourceAutoClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-auto-classification-user-override-disallow",
        defaultMessage: "The current classification level is based on information detected in the content. Updates to classification levels aren't permitted."
    },
    sourceUserClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-user-classification-user-override-disallow",
        defaultMessage: "A user assigned the current classification level. Updates to classification levels aren't permitted."
    },
    sourceSpaceDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-space-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for this space. Updates to classification levels aren't permitted."
    },
    sourceOrgDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-org-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for your organization. Updates to classification levels aren't permitted."
    },
    sourceNoneClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-none-classification-user-override-disallow",
        defaultMessage: "Updates to classification levels aren't permitted."
    },
    sourceAutoClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-auto-classification-not-container-admin",
        defaultMessage: "The current classification level is based on information detected in the content. Only users who can manage space settings can update the current classification level."
    },
    sourceUserClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-user-classification-not-container-admin",
        defaultMessage: "A user assigned the current classification level. Only users who can manage space settings can update the current classification level."
    },
    sourceSpaceDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-space-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for this space. Only users who can manage space settings can update the current classification level."
    },
    sourceOrgDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-org-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for your organization. Only users who can manage space settings can update the current classification level."
    },
    sourceNoneClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-none-classification-not-container-admin",
        defaultMessage: "Only users who can manage space settings can update the current classification level."
    },
    assignClassificationLevel: {
        id: "data-classification-level.edit-popup.assign-classification-level",
        defaultMessage: "Assign classification level"
    },
    lowestPermittedLevelOrgDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-org-default",
        defaultMessage: "Classification levels less sensitive than the organization default aren't available."
    },
    lowestPermittedLevelSpaceDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-space-default",
        defaultMessage: "Classification levels less sensitive than the space default aren't available."
    },
    lowestPermittedLevelAutoClassification: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-auto-classification",
        defaultMessage: "Classification levels less sensitive than the level automatically applied aren't available."
    },
    noSelection: {
        id: "data-classification-level.edit-popup.no-selection",
        defaultMessage: "No selection"
    },
    noSelectionDescription: {
        id: "data-classification-level.edit-popup.no-selection-description",
        defaultMessage: "The classification level will be updated based on the default or detected content."
    },
    assignButton: {
        id: "data-classification-level.edit-popup.assign-button",
        defaultMessage: "Assign"
    }
});
module.exports["messages"] = $eac3d8fc17e23def$export$defe85febe8b728c;

});

parcelRegister("blUZ2", function(module, exports) {
/**
 * @fileoverview ADF parsing utilities for handling guideline content
 *
 * TODO: Consider extracting these utilities to a shared ADF library once the API is stable.
 * This would benefit other teams dealing with similar ReactRenderer empty content issues.
 */ /**
 * Valid empty ADF document that ComposableEditor can work with
 */ const $d467d863edde4456$var$EMPTY_ADF_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
/**
 * Type guard to check if a parsed object is a valid ADF DocNode
 *
 * Performs basic structural validation of ADF documents. This intentionally does not validate
 * the entire ADF content tree, as ReactRenderer will handle that validation during rendering.
 * This approach allows for graceful degradation - if the ADF is invalid at a deeper level,
 * the component will fallback to plain text rendering.
 *
 * @param {unknown} obj - Object to validate
 * @returns {boolean} True if the object has the basic structure of an ADF DocNode
 */ const $d467d863edde4456$var$isValidADFDocument = (obj)=>{
    if (!obj || typeof obj !== 'object') return false;
    const doc = obj;
    // ADF documents must have type 'doc', version 1, and content array
    // Note: We don't validate the content array items themselves, as ReactRenderer
    // will handle that and provide appropriate error handling
    return doc.type === 'doc' && doc.version === 1 && Array.isArray(doc.content);
};
/**
 * Checks if a text node is empty (no text or only whitespace)
 */ const $d467d863edde4456$var$isEmptyText = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const textNode = node;
    if (textNode.type !== 'text') return false;
    const text = textNode.text;
    return !text || text.trim().length === 0;
};
/**
 * Checks if a paragraph node is empty (no content or only empty text nodes)
 */ const $d467d863edde4456$var$isEmptyParagraph = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const paragraph = node;
    if (paragraph.type !== 'paragraph') return false;
    // Paragraph with no content property or empty array
    if (!('content' in paragraph) || !paragraph.content || paragraph.content.length === 0) return true;
    // Paragraph with only empty text nodes
    return paragraph.content.every($d467d863edde4456$var$isEmptyText);
};
/**
 * Returns true if the given ADF doc is "visually empty".
 *
 * The ReactRenderer shows "Unsupported text" errors when it encounters certain
 * empty content structures that the backend may return (e.g., paragraphs with
 * empty text nodes). This function detects those cases so we can normalize them
 * to a proper empty ADF document, allowing components to gracefully fallback
 * to plain text rendering.
 *
 * Handles canonical empty forms like:
 * - {"version":1,"type":"doc","content":[]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph"}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[]}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":""}]}]}
 * - And variations where text is only whitespace
 *
 * Note: Only handles single-paragraph empty documents to avoid false positives.
 * More complex documents are passed through for ReactRenderer to handle.
 *
 * @param {DocNode} doc - ADF document to check
 * @returns {boolean} True if the document is visually empty
 */ const $d467d863edde4456$var$isVisuallyEmptyAdf = (doc)=>{
    // Type guard - should always be valid at this point
    if (!doc || doc.type !== 'doc') return true;
    const content = doc.content ?? [];
    // Empty content array
    if (content.length === 0) return true;
    // Only handle simple single-paragraph case to avoid false positives
    // More complex documents should be handled by ReactRenderer
    if (content.length === 1) return $d467d863edde4456$var$isEmptyParagraph(content[0]);
    return false;
};
const $d467d863edde4456$export$caab9411b15d6295 = (guideline)=>{
    if (!guideline) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
    try {
        const parsed = JSON.parse(guideline);
        if (!$d467d863edde4456$var$isValidADFDocument(parsed)) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
        // Check if the ADF is visually empty (would cause renderer errors)
        if ($d467d863edde4456$var$isVisuallyEmptyAdf(parsed)) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
        return parsed;
    } catch  {
        return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
    }
};
module.exports["safeParseGuidelineADF"] = $d467d863edde4456$export$caab9411b15d6295;

});

parcelRegister("kGNkZ", function(module, exports) {
const $eac995fb73d1f5cf$export$1da3a1abbabd0674 = ({ guidelineADF: guidelineADF, guideline: guideline, guidelineRepresentation: guidelineRepresentation })=>{
    if (guidelineRepresentation === 'EDITOR') // Prefer ADF format when in EDITOR mode, fallback to plain text
    // Use nullish coalescing to treat empty strings as valid values
    return guidelineADF ?? guideline;
    // Use plain text guideline for PLAIN mode
    return guideline;
};
module.exports["selectGuideline"] = $eac995fb73d1f5cf$export$1da3a1abbabd0674;

});

parcelRegister("gWldI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $cf27063ba0229f9a$export$d2e14829910b9b7d = ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        })
    });
};
module.exports["ClassificationIcon"] = $cf27063ba0229f9a$export$d2e14829910b9b7d;

});

parcelRegister("lvOsp", function(module, exports) {

var $jxs8y = parcelRequire("jxs8y");


var $9wGTI = parcelRequire("9wGTI");


var $86okN = parcelRequire("86okN");

function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    {
        if (!(0, $9wGTI.fg)('cc-fd-lazy-query-interop-agg')) return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
        const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
        return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
            ...apolloOptions,
            ...interopApolloAggClient ? {
                client: window['GLOBAL_APOLLO_AGG_CLIENT']
            } : {},
            context: {
                ...apolloOptions?.context,
                requestId: query.params?.id
            }
        });
    }
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("5LTS4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $4VJDS = parcelRequire("4VJDS");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $4VJDS.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $42omo.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $42omo.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true));
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("giS6h", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a6c7790f33c3e831$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["ClassicEditorContext"] = $a6c7790f33c3e831$export$bbe9955f93d6ed27;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1QAOp"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1QAOp"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("1QAOp", function(module, exports) {

let $158733e70190bea3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $158733e70190bea3$var$load("eBHYD"),
    $158733e70190bea3$var$load("i8eeg"),
    $158733e70190bea3$var$load("iFdoJ"),
    $158733e70190bea3$var$load("5tmW9"),
    $158733e70190bea3$var$load("8ublV"),
    $158733e70190bea3$var$load("9qfB8"),
    $158733e70190bea3$var$load("loqJg"),
    $158733e70190bea3$var$load("jXx9i"),
    $158733e70190bea3$var$load("hhss7"),
    $158733e70190bea3$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("2YJkl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $jn9ek = parcelRequire("jn9ek");


var $30jvk = parcelRequire("30jvk");

var $jNfjl = parcelRequire("jNfjl");

var $hITJv = parcelRequire("hITJv");

var $hDgvL = parcelRequire("hDgvL");

var $4CcGu = parcelRequire("4CcGu");


var $9g0qH = parcelRequire("9g0qH");

const $aa34679af4551f50$export$23fd6793559ac02f = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // these Creatable custom hooks all have
    // canHandle function that checks if the template is the right type for that Creatable
    // and handle function that creates the content from the template
    const editorOnboardingCreatable = (0, $hDgvL.useEditorOnboardingBlueprintCreatable)();
    const blogpostCreatable = (0, $30jvk.useBlogpostCreatable)();
    const calendarCreatable = (0, $hITJv.useCalendarCreatable)();
    const blueprintCreatable = (0, $jNfjl.useBlueprintCreatable)();
    const templateCreatable = (0, $4CcGu.useTemplateCreatable)();
    return (0, $42omo.useCallback)(async (template, spaceKey, options = {})=>{
        const creatables = [
            editorOnboardingCreatable,
            blogpostCreatable,
            calendarCreatable,
            blueprintCreatable,
            templateCreatable
        ];
        (0, $9g0qH.startExperienceTracking)();
        try {
            // looks for the first Creatable that can handle the template
            const creatable = creatables.find(({ canHandle: canHandle })=>canHandle(template));
            // if a Creatable is found, it will call handle method of that creatable to create the content and return true if succesful
            if (creatable) {
                const createdContent = await creatable.handle(template, spaceKey, options);
                // if createdContent is true, it means the content was created successfully
                // createdContent will be false if a variable input component was opened instead.
                if (createdContent) (0, $9g0qH.succeedExperienceTracking)();
            } else // if no Creatable can handle the template, then throw an error
            throw new Error(`Cant handle this template: ${JSON.stringify(template)}`);
        } catch (error) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            // Handle known errors
            if ((0, $jn9ek.isRateExceededError)(error)) (0, $9g0qH.abortDueToExceededRateLimitExperienceTracking)();
            else if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error) || (0, $jn9ek.isBadThirdPartyBlueprintError)(error) || (0, $jn9ek.isBadEditedFirstPartyBlueprintError)(error) || (0, $jn9ek.isInvalidSpaceKeyError)(error)) {
                // Normally this is tracked in the individual handlers,
                // but we will only get 403s/bad 3rd party blueprints on creation attempts
                // so we know the whole experience is over, unlike opening a wizard.
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
                });
                (0, $9g0qH.succeedExperienceTracking)();
                // Re-throw specific errors that need to bubble up
                if ((0, $f9jv7.isNotFoundError)(error)) throw error;
            } else {
                // Handle unexpected errors
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PAGE_MODES
                });
                (0, $9g0qH.failExperienceTracking)(error);
            }
            // Re-throw the original error for further handling if needed
            throw error;
        }
    }, [
        experienceTracker,
        editorOnboardingCreatable,
        blogpostCreatable,
        calendarCreatable,
        blueprintCreatable,
        templateCreatable
    ]);
};
module.exports["useCreateContentFromTemplate"] = $aa34679af4551f50$export$23fd6793559ac02f;

});

parcelRegister("30jvk", function(module, exports) {

var $3qZCH = parcelRequire("3qZCH");


var $42omo = parcelRequire("42omo");


var $jLw6A = parcelRequire("jLw6A");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $de2j9 = parcelRequire("de2j9");


var $308Wd = parcelRequire("308Wd");


var $iPv75 = parcelRequire("iPv75");


var $kUSbj = parcelRequire("kUSbj");

const $d2a2f878812cd2e2$export$a7e6c3730e12cf1a = (0, $3qZCH.default);
const $d2a2f878812cd2e2$export$c773aa5a9ec7e47b = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const navigate = (0, $kUSbj.useNavigation)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const [createBlogpostMutationFn] = (0, $308Wd.useMutationInterop)($d2a2f878812cd2e2$export$a7e6c3730e12cf1a);
    const { restrictions: restrictions } = (0, $jLw6A.usePageRestrictionsContext)();
    const canHandle = (0, $42omo.useCallback)((template)=>template.itemModuleCompleteKey === 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post', []);
    const handle = (0, $42omo.useCallback)(async (_, spaceKey, options = {})=>{
        const { title: title, openContentInNewTab: openContentInNewTab } = options;
        const createBlogpostResponse = await createBlogpostMutationFn({
            variables: {
                spaceKey: spaceKey,
                title: title
            }
        });
        const editui = createBlogpostResponse?.data?.createContentContextual?.links?.editui;
        const url = (0, $iPv75.processDraftUrl)(editui);
        // if your in the editor, pressing browser back shouldn't land back you in the previous page editor.
        if (isEditorPage) {
            if (restrictions?.hasRestrictions) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE, true);
            navigate(url, {
                openContentInNewTab: openContentInNewTab,
                isReplaceAction: true
            });
        } else navigate(url, {
            openContentInNewTab: openContentInNewTab
        });
        experienceTracker.succeed({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
        });
        return true;
    }, [
        createBlogpostMutationFn,
        experienceTracker,
        isEditorPage,
        navigate,
        restrictions
    ]);
    return (0, $42omo.useMemo)(()=>({
            canHandle: canHandle,
            handle: handle
        }), [
        canHandle,
        handle
    ]);
};
module.exports["useBlogpostCreatable"] = $d2a2f878812cd2e2$export$c773aa5a9ec7e47b;

});

parcelRegister("3qZCH", function(module, exports) {
/**
 * @generated SignedSource<<2a08cbfa87d42247d77b00246a837693>>
 * @relayHash 325b57b34cf8c4ef0ad9dac9c01203fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 186fa43c58cab96c88c0bf1560cfb4f01bf4d0e957f4ce21a445c4a50e9dfa43
const $d7fc8a178bfa77ed$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": "DRAFT"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBlogpostCreatableMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBlogpostCreatableMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "325b57b34cf8c4ef0ad9dac9c01203fa",
            "id": "186fa43c58cab96c88c0bf1560cfb4f01bf4d0e957f4ce21a445c4a50e9dfa43",
            "metadata": {},
            "name": "useBlogpostCreatableMutation",
            "operationKind": "mutation",
            "text": "mutation useBlogpostCreatableMutation($spaceKey:String!,$title:String){createContentContextual(input:{spaceKey:$spaceKey,title:$title,type:\"blogpost\",status:DRAFT}){id,links{editui}}}"
        }
    };
}();
$d7fc8a178bfa77ed$var$node.hash = "79f00a1cd5d21c7813a8e8ef72be19f2";
var $d7fc8a178bfa77ed$export$2e2bcd8739ae039 = $d7fc8a178bfa77ed$var$node;
module.exports["default"] = $d7fc8a178bfa77ed$export$2e2bcd8739ae039;

});

parcelRegister("iPv75", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $f9ff62d7c779d6ac$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No editor url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
module.exports["processDraftUrl"] = $f9ff62d7c779d6ac$export$f59f47d22cf7d84d;

});

parcelRegister("kUSbj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $81110950b51bc75f$export$7c6c102bc5828a1c = (url)=>{
    let contentId = null;
    // Try to extract from edit-v2 URLs (path format)
    const editV2Match = url.match(/\/edit-v2\/(\d+)/);
    if (editV2Match) contentId = editV2Match[1];
    else {
        // Try to extract from resumedraft URLs (query param format)
        const draftIdMatch = url.match(/[?&]draftId=(\d+)/);
        if (draftIdMatch) contentId = draftIdMatch[1];
    }
    // Validate that the extracted contentId is purely numerical
    if (contentId && /^\d+$/.test(contentId)) return contentId;
    return null;
};
const $81110950b51bc75f$export$d0fd4b7106de2769 = ()=>{
    const { push: push, replace: replace } = (0, $dPJCf.useRouteActions)();
    return (0, $42omo.useCallback)((url, options)=>{
        const { openContentInNewTab: openContentInNewTab, isReplaceAction: isReplaceAction, forceReload: forceReload } = options || {};
        // Track when we're navigating after template creation.
        if ((0, $6mKj3.expValEquals)('platform_editor_template_creation_ufo_attribute', 'isEnabled', true)) {
            const contentId = $81110950b51bc75f$export$7c6c102bc5828a1c(url);
            if (contentId) {
                const templateKey = (0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${contentId}-${(0, $1UApO.keys).PAGE_CREATED_FROM_TEMPLATE}` : `${(0, $1UApO.keys).PAGE_CREATED_FROM_TEMPLATE_PREFIX}${contentId}`;
                (0, $17wUi.confluenceLocalStorageInstance).setItem(templateKey, Date.now().toString());
            }
        }
        if (openContentInNewTab) window.open(url, '_blank', 'noreferrer');
        else if (isReplaceAction) replace(url, forceReload);
        else push(url, forceReload);
    }, [
        push,
        replace
    ]);
};
module.exports["useNavigation"] = $81110950b51bc75f$export$d0fd4b7106de2769;

});

parcelRegister("jNfjl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8hUXc = parcelRequire("8hUXc");


var $cb6fO = parcelRequire("cb6fO");


var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");


var $de2j9 = parcelRequire("de2j9");


var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");


var $9g0qH = parcelRequire("9g0qH");


var $iPv75 = parcelRequire("iPv75");


var $kyXQd = parcelRequire("kyXQd");


var $eYb9Y = parcelRequire("eYb9Y");


var $kUSbj = parcelRequire("kUSbj");

const $6c42e536b5e78490$var$hasWizard = (template)=>!!template?.hasWizard;
const $6c42e536b5e78490$var$isOnLiveDocRoute = {
    selector: (routeName)=>{
        return routeName === (0, $1NBp8.VIEW_PAGE).name;
    }
};
const $6c42e536b5e78490$export$d47f3bcd44391f19 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const navigate = (0, $kUSbj.useNavigation)();
    const { openBlueprintWizard: openBlueprintWizard } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isLiveDocCurrently = (0, $dPJCf.useRouteName)($6c42e536b5e78490$var$isOnLiveDocRoute);
    const [createFromBlueprintMutation] = (0, $kyXQd.useExperimentalPublishPageByBlueprintMutation)();
    const [updateFromBlueprintMutation] = (0, $eYb9Y.useExperimentalUpdateDraftWithBlueprintMutation)();
    const canHandle = (0, $42omo.useCallback)((template)=>!!(template.blueprintModuleCompleteKey && template.itemModuleCompleteKey && template.contentBlueprintId), []);
    const handle = (0, $42omo.useCallback)(async (template, spaceKey, options = {})=>{
        const { templateOriginSpaceKey: templateOriginSpaceKey, contentId: contentId, parentPageId: parentPageId, title: title, subType: subType, onContentUpdated: onContentUpdated, onVariableInputError: onVariableInputError, beforeUpdateRequest: beforeUpdateRequest, forceTemplatePanelOpen: forceTemplatePanelOpen, openContentInNewTab: openContentInNewTab } = options;
        const handleUpdateContentResponse = (response)=>{
            const isLivePageResponse = response?.content?.subType === 'live';
            const isEditorV2Response = (0, $6mKj3.expValEquals)('cc_fix_deprecated_editor_property_for_template_v2', 'isEnabled', true) ? response?.content?.metadata?.simple?.isFabric === true : response?.content?.metadata?.properties?.editor?.value === 'v2';
            const onContentUpdatedAndResponseExists = onContentUpdated && response;
            if (isLivePageResponse && !isLiveDocCurrently || !isEditorV2Response || !onContentUpdatedAndResponseExists) navigate((0, $iPv75.processDraftUrl)(response?.content?._links?.editui), {
                isReplaceAction: true
            });
            else onContentUpdated(response, template, spaceKey, contentId || '');
        };
        if ($6c42e536b5e78490$var$hasWizard(template)) {
            // Since the wizard will make the actual update call, we need it to succeed/fail the create-content-from-template
            // experience as part of these callbacks
            const handleUpdateContentResponseWithExperienceTracking = (response)=>{
                if (onContentUpdated) handleUpdateContentResponse(response);
                (0, $9g0qH.succeedExperienceTracking)();
            };
            const onVariableInputErrorWithExperienceTracking = (e)=>{
                if (onVariableInputError) onVariableInputError(e);
                (0, $9g0qH.failExperienceTracking)(e);
            };
            openBlueprintWizard({
                spaceKey: spaceKey,
                templateOriginSpaceKey: templateOriginSpaceKey,
                title: title,
                blueprint: {
                    itemModuleCompleteKey: template.itemModuleCompleteKey,
                    contentBlueprintId: template.contentBlueprintId
                },
                parentPageId: parentPageId || '',
                ...contentId && {
                    contentId: contentId
                },
                onContentUpdated: handleUpdateContentResponseWithExperienceTracking,
                onError: onVariableInputErrorWithExperienceTracking,
                beforeUpdateRequest: beforeUpdateRequest
            });
            return false;
        } else if (contentId) {
            if (beforeUpdateRequest) beforeUpdateRequest();
            const updateFromBlueprintResponse = await updateFromBlueprintMutation({
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    title: title,
                    blueprint: JSON.stringify(template)
                }
            });
            const response = updateFromBlueprintResponse?.data?.experimentalUpdateDraftWithBlueprint || null;
            handleUpdateContentResponse(response);
        } else {
            // ToDo: Set attemptSpaUrlResponse to always be true and verify that there are no longer editor->editor
            //  transition bugs (https://product-fabric.atlassian.net/browse/MODES-3741)
            //  remove the call to isEditorPage if successful
            const createFromBlueprintResponse = await createFromBlueprintMutation({
                variables: {
                    spaceKey: spaceKey,
                    title: title,
                    subType: subType,
                    parentPageId: options.parentPageId,
                    blueprint: JSON.stringify(template),
                    attemptSpaUrlResponse: !isEditorPage
                }
            });
            const draftUrl = createFromBlueprintResponse?.data?.experimentalPublishPageByBlueprint?.links?.draftUrl;
            if (forceTemplatePanelOpen) navigate((0, $cb6fO.addQueryParams)((0, $iPv75.processDraftUrl)(draftUrl), {
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: 'true'
            }), {
                openContentInNewTab: openContentInNewTab
            });
            else navigate((0, $cb6fO.addQueryParams)((0, $iPv75.processDraftUrl)(draftUrl), {
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: 'true'
            }), {
                openContentInNewTab: openContentInNewTab
            });
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
            });
        }
        return true;
    }, [
        createFromBlueprintMutation,
        updateFromBlueprintMutation,
        isEditorPage,
        experienceTracker,
        navigate,
        openBlueprintWizard,
        isLiveDocCurrently
    ]);
    return (0, $42omo.useMemo)(()=>({
            canHandle: canHandle,
            handle: handle
        }), [
        canHandle,
        handle
    ]);
};
module.exports["useBlueprintCreatable"] = $6c42e536b5e78490$export$d47f3bcd44391f19;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("9g0qH", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $1A7bE = parcelRequire("1A7bE");


var $fGzMp = parcelRequire("fGzMp");


var $jn9ek = parcelRequire("jn9ek");

const $96ed5e78b6a7fe89$export$a21fa48448d23b1f = ()=>{
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE),
        collect (events, experience) {
            (0, $1A7bE.collectAny)([
                (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE)
            ])(events, experience);
            experience.stopOn(events.find((event)=>(event.action === 'taskFail' || event.action === 'taskAbort') && (0, $gykrH.hasName)(event, (0, $irVI7.BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE))));
        }
    });
};
const $96ed5e78b6a7fe89$export$17d2b592d1ccb7b4 = (error)=>{
    const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
    (0, $fGzMp.stopExperienceOnError)((0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE), error, {
        cteTraceId: cteTraceId
    });
};
const $96ed5e78b6a7fe89$export$6f547e6921bcc1f4 = ()=>{
    (0, $fGzMp.getExperienceTracker)().succeed({
        name: (0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE)
    });
};
const $96ed5e78b6a7fe89$export$e031673dde91f3d6 = ()=>{
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const reason = 'Rate limit exceeded while attempting to create content from a template';
    experienceTracker.abort({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        reason: reason
    });
    experienceTracker.abort({
        name: (0, $irVI7.CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE),
        reason: reason
    });
};
module.exports["startExperienceTracking"] = $96ed5e78b6a7fe89$export$a21fa48448d23b1f;
module.exports["failExperienceTracking"] = $96ed5e78b6a7fe89$export$17d2b592d1ccb7b4;
module.exports["succeedExperienceTracking"] = $96ed5e78b6a7fe89$export$6f547e6921bcc1f4;
module.exports["abortDueToExceededRateLimitExperienceTracking"] = $96ed5e78b6a7fe89$export$e031673dde91f3d6;

});

parcelRegister("kyXQd", function(module, exports) {

var $5qzNs = parcelRequire("5qzNs");


var $hBkCm = parcelRequire("hBkCm");


var $aBfpe = parcelRequire("aBfpe");


var $bZ9Ng = parcelRequire("bZ9Ng");


var $9o40q = parcelRequire("9o40q");


var $6mKj3 = parcelRequire("6mKj3");

const $776ff9ca0913058a$var$MEETING_NOTES_KEY = 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item';
const $776ff9ca0913058a$var$isMeetingNote = ({ itemModuleCompleteKey: itemModuleCompleteKey })=>itemModuleCompleteKey === $776ff9ca0913058a$var$MEETING_NOTES_KEY;
// omit certain GraphQL attributes from being sent to /content/blueprint/:blueprintId/instance
const $776ff9ca0913058a$var$processData = (blueprint)=>(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(blueprint, [
        '__typename',
        'wizard'
    ]);
const $776ff9ca0913058a$export$6f870c1aedb454f3 = ()=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>{
            let blueprintSpec;
            try {
                blueprintSpec = $776ff9ca0913058a$var$processData(JSON.parse(variables.blueprint));
            } catch (err) {
                throw new Error(`blueprint JSON passed to experimentalPublishPageByBlueprint is invalid ${err}`);
            }
            const expandParam = (0, $6mKj3.expValEquals)('cc_fix_deprecated_editor_property_for_template_v2', 'isEnabled', true) ? 'metadata.simple.isFabric,space' : 'metadata.properties.editor,space';
            const expand = variables.attemptSpaUrlResponse ? `?expand=${expandParam}` : '';
            return `/wiki/rest/create-dialog/1.0/content/blueprint/${blueprintSpec.itemModuleCompleteKey}/instance${expand}`;
        },
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ title: title, spaceKey: spaceKey, blueprint: blueprint, parentPageId: contentId, subType: subType })=>{
            let blueprintSpec;
            try {
                blueprintSpec = $776ff9ca0913058a$var$processData(JSON.parse(blueprint));
            } catch (err) {
                throw new Error(`blueprint JSON passed to experimentalPublishPageByBlueprint is invalid ${err}`);
            }
            const commonContentProperties = {
                title: title,
                type: 'page',
                status: 'draft',
                space: {
                    key: spaceKey
                }
            };
            if (contentId && contentId !== 'no-parent-page') commonContentProperties.ancestors = [
                {
                    id: contentId
                }
            ];
            if (subType) commonContentProperties.subType = subType;
            // add spaceKey so there is no infinite spinner when creating page with meeting notes
            if ($776ff9ca0913058a$var$isMeetingNote(blueprintSpec)) blueprintSpec.spaceKey = spaceKey;
            return JSON.stringify({
                content: {
                    ...commonContentProperties
                },
                contentBlueprintSpec: {
                    blueprintId: blueprintSpec.contentBlueprintId,
                    context: blueprintSpec
                }
            });
        },
        parseResult: async (json, { attemptSpaUrlResponse: attemptSpaUrlResponse = false })=>{
            const editui = await (0, $bZ9Ng.getEditDraftPageUrl)(json, attemptSpaUrlResponse);
            if (!editui) throw new Error('Missing content draft url');
            return {
                experimentalPublishPageByBlueprint: {
                    links: {
                        draftUrl: editui
                    }
                }
            };
        },
        transformError: async (error)=>{
            if (error instanceof (0, $hBkCm.BadStatusError) && error.response?.status === 500) {
                const backendError = await error.response.json();
                return new (0, $hBkCm.BadStatusError)(backendError.errorMessage, error.response);
            }
            return error;
        }
    });
};
module.exports["useExperimentalPublishPageByBlueprintMutation"] = $776ff9ca0913058a$export$6f870c1aedb454f3;

});

parcelRegister("bZ9Ng", function(module, exports) {
/* This module exports shared functions used by both blueprint & template endpoints, as these REST APIs share similar
 * request/response patterns.
 */ // eslint-disable-next-line no-restricted-imports

var $hBkCm = parcelRequire("hBkCm");


var $dw6y2 = parcelRequire("dw6y2");

const $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f = (json)=>{
    const title = json?.content?.title;
    return {
        content: {
            id: json?.content?.id || null,
            type: 'page',
            subType: json?.content?.subType || null,
            title: typeof title === 'string' ? title : null,
            space: {
                key: json?.content?.space?.key || null
            },
            _links: {
                editui: json?.content?._links?.editui || null
            },
            metadata: {
                properties: {
                    editor: {
                        value: json?.content?.metadata?.properties?.editor?.value || null
                    }
                },
                simple: {
                    isFabric: json?.content?.metadata?.simple?.isFabric || null
                }
            }
        }
    };
};
const $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4 = async (cfetch, url, method, headers, pageData)=>{
    const MAX_CONTENT_UPDATE_RETRY = 1;
    const updateTemplate = async (count = 0)=>{
        try {
            const res = await cfetch(url, {
                method: method,
                headers: headers,
                body: JSON.stringify(pageData)
            });
            return res.json();
        } catch (err) {
            const errorStatus = err?.response?.status;
            if (errorStatus === 500) {
                const backendError = await err.response.json();
                throw new (0, $hBkCm.BadStatusError)(backendError.errorMessage, err.response);
            }
            if (count < MAX_CONTENT_UPDATE_RETRY && errorStatus === 409) return updateTemplate(++count);
            throw err;
        }
    };
    const json = await updateTemplate();
    return $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f(json);
};
const $2dc0a210c1f3c9f7$export$6a221318e0d372a4 = async (createPageResponseJson, attemptSpaUrl)=>{
    if (attemptSpaUrl) {
        // TODO: remove the old metadata field check once we use the new metadata field for template
        const isFabric = createPageResponseJson?.content?.metadata?.properties?.editor?.value === 'v2' || createPageResponseJson?.content?.metadata?.simple?.isFabric === true;
        const isLivePage = createPageResponseJson?.content?.subType === 'live';
        if (isLivePage) return createPageResponseJson?.content?._links?.editui;
        if (isFabric) return (0, $dw6y2.createEditDraftPageUrl)(createPageResponseJson);
    }
    return createPageResponseJson?.content?._links?.editui;
};
module.exports["getOnContentUpdatedObjFromResponse"] = $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f;
module.exports["getEditDraftPageUrl"] = $2dc0a210c1f3c9f7$export$6a221318e0d372a4;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});

parcelRegister("eYb9Y", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $bZ9Ng = parcelRequire("bZ9Ng");


var $hBkCm = parcelRequire("hBkCm");


var $6mKj3 = parcelRequire("6mKj3");

const $9e0842ed38e2799a$export$2f8a447f177ab65e = ()=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ()=>{
            const expandParam = (0, $6mKj3.expValEquals)('cc_fix_deprecated_editor_property_for_template_v2', 'isEnabled', true) ? 'space.key,metadata.simple.isFabric' : 'space.key,metadata.properties.editor';
            return `/wiki/rest/create-dialog/1.0/content/blueprint/instance?expand=${expandParam}`;
        },
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, spaceKey: spaceKey, blueprint: blueprint, parentPageId: parentPageId, title: title })=>{
            const blueprintSpec = JSON.parse(blueprint);
            const content = {
                id: contentId,
                type: 'page',
                status: 'draft',
                space: {
                    key: spaceKey
                },
                version: {
                    number: 1
                }
            };
            if (title) content.title = title;
            if (parentPageId && parentPageId !== 'no-parent-page') content.ancestors = [
                {
                    id: parentPageId
                }
            ];
            const pageData = {
                content: content,
                contentBlueprintSpec: {
                    blueprintId: blueprintSpec.contentBlueprintId,
                    context: blueprintSpec
                }
            };
            return JSON.stringify(pageData);
        },
        parseResult: (response)=>{
            return {
                experimentalUpdateDraftWithBlueprint: (0, $bZ9Ng.getOnContentUpdatedObjFromResponse)(response)
            };
        },
        transformError: async (error)=>{
            if (error instanceof (0, $hBkCm.BadStatusError) && error.response?.status === 500) {
                const backendError = await error.response.json();
                return new (0, $hBkCm.BadStatusError)(backendError.errorMessage, error.response);
            }
            return error;
        },
        maxRetries: 1
    });
};
module.exports["useExperimentalUpdateDraftWithBlueprintMutation"] = $9e0842ed38e2799a$export$2f8a447f177ab65e;

});

parcelRegister("hITJv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $1NBp8 = parcelRequire("1NBp8");


var $kUSbj = parcelRequire("kUSbj");

const $3e735de8e4e6dfb6$export$e81eb01a21f50dc3 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const navigate = (0, $kUSbj.useNavigation)();
    const canHandle = (0, $42omo.useCallback)((template)=>template.itemModuleCompleteKey === 'com.atlassian.confluence.extra.team-calendars:tc-on-space-blueprint-webitem', []);
    const handle = (0, $42omo.useCallback)(async (_, spaceKey, options = {})=>{
        const { openContentInNewTab: openContentInNewTab } = options;
        navigate((0, $1NBp8.SPACE_CALENDAR).toUrl({
            spaceKey: spaceKey
        }), {
            openContentInNewTab: openContentInNewTab
        });
        experienceTracker.succeed({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
        });
        return true;
    }, [
        experienceTracker,
        navigate
    ]);
    return (0, $42omo.useMemo)(()=>({
            canHandle: canHandle,
            handle: handle
        }), [
        canHandle,
        handle
    ]);
};
module.exports["useCalendarCreatable"] = $3e735de8e4e6dfb6$export$e81eb01a21f50dc3;

});

parcelRegister("hDgvL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $5cryL = parcelRequire("5cryL");


var $iPv75 = parcelRequire("iPv75");


var $cQJci = parcelRequire("cQJci");


var $kyXQd = parcelRequire("kyXQd");


var $c0rhi = parcelRequire("c0rhi");

const $d3f01bf822b95ee0$export$1cee546de5e33824 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [createFromBlueprintMutation] = (0, $kyXQd.useExperimentalPublishPageByBlueprintMutation)();
    // this has to be done via getApolloClient() because neither useQuery or useLazyQuery return a promise with the data, they return void.
    const getPersonalSpaceKey = (0, $42omo.useCallback)(async ()=>{
        let personalSpaceData;
        if (isLicensed) try {
            personalSpaceData = (await (0, $c0rhi.queryInterop)({
                query: (0, $cQJci.GetPersonalSpaceKeyQuery)
            })).data;
        } catch (personalSpaceError) {
            (0, $7Sm4c.markErrorAsHandled)(personalSpaceError);
            (0, $5ZqQS.getMonitoringClient)().submitError(personalSpaceError, {
                attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'getPersonalSpaceKey',
                    actionSubjectId: 'editorOnboardingTutorial',
                    source: 'useEditorOnboardingBluePrintCreatable'
                }
            }).fire();
        }
        const hasPersonalSpace = personalSpaceData?.user?.confluence?.hasPersonalSpace;
        const personalSpaceKey = hasPersonalSpace ? personalSpaceData?.user?.confluence?.space?.key : undefined;
        return {
            hasPersonalSpace: hasPersonalSpace,
            personalSpaceKey: personalSpaceKey
        };
    }, [
        isLicensed,
        createAnalyticsEvent
    ]);
    const canHandle = (0, $42omo.useCallback)((template)=>{
        return template.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY) || template.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED);
    }, []);
    const handle = (0, $42omo.useCallback)(async (template, spaceKey, options = {})=>{
        const { title: title, parentPageId: parentPageId, subType: subType } = options;
        /*
			 * This will create the draft under the root directory of the user's personal space.
			 * Fallback to current spaceKey (should be rare unless GetPersonalSpaceKeyQuery fails or
			 * when user immediately clicks on Editor Tutorial Template before loading is done).
			 */ const { personalSpaceKey: personalSpaceKey } = await getPersonalSpaceKey();
        const createFromBlueprintResponse = await createFromBlueprintMutation({
            variables: {
                spaceKey: personalSpaceKey || spaceKey,
                title: title,
                subType: subType,
                parentPageId: personalSpaceKey ? undefined : parentPageId,
                blueprint: JSON.stringify(template),
                attemptSpaUrlResponse: false
            }
        });
        const draftUrl = createFromBlueprintResponse?.data?.experimentalPublishPageByBlueprint?.links?.draftUrl;
        window.open((0, $iPv75.processDraftUrl)(draftUrl), '_blank', 'noreferrer');
        experienceTracker.succeed({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
        });
        return true;
    }, [
        createFromBlueprintMutation,
        experienceTracker,
        getPersonalSpaceKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            canHandle: canHandle,
            handle: handle
        }), [
        canHandle,
        handle
    ]);
};
module.exports["useEditorOnboardingBlueprintCreatable"] = $d3f01bf822b95ee0$export$1cee546de5e33824;

});

parcelRegister("cQJci", function(module, exports) {

var $68Yal = parcelRequire("68Yal");

const $78ffbd180e0a2d22$export$ec209108e9c3bdab = (0, $68Yal.default);
module.exports["GetPersonalSpaceKeyQuery"] = $78ffbd180e0a2d22$export$ec209108e9c3bdab;

});

parcelRegister("68Yal", function(module, exports) {
/**
 * @generated SignedSource<<d165fec53fab427984300828db6865a9>>
 * @relayHash aa2486e7ead66b97d496e48ba1524c69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b61dee2518db6b8b6a19d7c91e77ffca8b3a54085863fda904055d5685d9e8db
const $c6d1ac59647095e9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "aa2486e7ead66b97d496e48ba1524c69",
            "id": "b61dee2518db6b8b6a19d7c91e77ffca8b3a54085863fda904055d5685d9e8db",
            "metadata": {},
            "name": "GetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query GetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c6d1ac59647095e9$var$node.hash = "a8e2440b035e9c6c70444845a662185b";
var $c6d1ac59647095e9$export$2e2bcd8739ae039 = $c6d1ac59647095e9$var$node;
module.exports["default"] = $c6d1ac59647095e9$export$2e2bcd8739ae039;

});

parcelRegister("4CcGu", function(module, exports) {

var $d4crM = parcelRequire("d4crM");


var $42omo = parcelRequire("42omo");


var $a2xFu = parcelRequire("a2xFu");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8hUXc = parcelRequire("8hUXc");


var $1NBp8 = parcelRequire("1NBp8");


var $lJDEI = parcelRequire("lJDEI");


var $cb6fO = parcelRequire("cb6fO");


var $de2j9 = parcelRequire("de2j9");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $iPv75 = parcelRequire("iPv75");


var $hivPX = parcelRequire("hivPX");


var $77u46 = parcelRequire("77u46");


var $kUSbj = parcelRequire("kUSbj");


var $c0rhi = parcelRequire("c0rhi");

const $8781a99089269bbb$var$getTemplateBodyDetails = async (templateId)=>{
    const templateBodyResponse = (await (0, $c0rhi.queryInterop)({
        query: (0, $77u46.GetTemplateBodyContentQuery),
        variables: {
            templateId: templateId
        }
    })).data;
    const adfString = templateBodyResponse?.template?.body?.atlas_doc_format?.value || '';
    const hasVariables = adfString.indexOf('com.atlassian.confluence.template') !== -1;
    const editorVersion = templateBodyResponse?.template?.editorVersion || '';
    return {
        hasVariables: hasVariables,
        editorVersion: editorVersion
    };
};
const $8781a99089269bbb$export$d3dc05eb5b2c4ff8 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const navigate = (0, $kUSbj.useNavigation)();
    const { openTemplateVariables: openTemplateVariables } = (0, $42omo.useContext)((0, $8hUXc.CreateDialogContext));
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createFromTemplateMutation] = (0, $hivPX.useExperimentalPublishPageByTemplateMutation)();
    const [updateFromTemplateMutation] = (0, $308Wd.useMutationInterop)((0, $d4crM.default));
    const canHandle = (0, $42omo.useCallback)((template)=>!!template.templateId, []);
    const handle = (0, $42omo.useCallback)(async (template, spaceKey, options = {})=>{
        // casting because i know it exists from canHandle
        const templateId = template.templateId;
        const { contentId: contentId, parentPageId: parentPageId, title: title, subType: subType, onContentUpdated: onContentUpdated, onVariableInputError: onVariableInputError, beforeUpdateRequest: beforeUpdateRequest, forceTemplatePanelOpen: forceTemplatePanelOpen, openContentInNewTab: openContentInNewTab } = options;
        const { hasVariables: hasVariables, editorVersion: editorVersion } = await $8781a99089269bbb$var$getTemplateBodyDetails(templateId);
        if (hasVariables) {
            const onContentUpdatedWrapper = (response)=>{
                if (onContentUpdated) onContentUpdated(response, template, spaceKey, contentId || '');
            };
            if (editorVersion === 'v2') openTemplateVariables({
                templateId: templateId,
                spaceKey: spaceKey,
                parentPageId: parentPageId || '',
                title: title || '',
                beforeUpdateRequest: beforeUpdateRequest,
                forceTemplatePanelOpen: forceTemplatePanelOpen,
                openContentInNewTab: openContentInNewTab,
                ...contentId && {
                    contentId: contentId
                },
                ...onContentUpdated && {
                    onContentUpdated: onContentUpdatedWrapper
                },
                ...onVariableInputError && {
                    onError: onVariableInputError
                }
            });
            else {
                const legacyVariablesUrl = (0, $1NBp8.CREATE_PAGE_VARIABLES_ACTION_LEGACY).toUrl({}, {
                    query: {
                        templateId: templateId,
                        spaceKey: spaceKey,
                        title: title || '',
                        newSpaceKey: spaceKey,
                        fromPageId: parentPageId || '',
                        // Try to get window.AJS if it doesn't exist, return nothing
                        // @ts-ignore
                        atl_token: window.AJS?.Meta?.get('atl-token') || ''
                    }
                });
                // use forceReload because the SPA routing for this legacy page is broken
                navigate(legacyVariablesUrl, {
                    openContentInNewTab: openContentInNewTab,
                    forceReload: true
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
                });
            }
            return false;
        } else if (contentId) {
            beforeUpdateRequest && beforeUpdateRequest();
            const updateFromTemplateResponse = await updateFromTemplateMutation({
                variables: {
                    pageAri: (0, $a2xFu.ConfluencePageAri).create({
                        siteId: cloudId,
                        pageId: contentId
                    }).toString(),
                    templateId: template.templateId,
                    title: title,
                    spaceKey: spaceKey
                }
            });
            const response = updateFromTemplateResponse?.data?.confluence_updateInstance;
            const responseEditorIsFabric = !!response?.content?.metadata?.simple?.isFabric;
            if (responseEditorIsFabric && onContentUpdated && response) onContentUpdated(response, template, spaceKey, contentId);
            else {
                const draftUrl = response?.content?.links?.editui;
                navigate((0, $iPv75.processDraftUrl)(draftUrl), {
                    isReplaceAction: true
                });
            }
        } else {
            // ToDo: Set attemptSpaUrlResponse to always be true and verify that there are no longer editor->editor
            //  transition bugs (https://product-fabric.atlassian.net/browse/MODES-3741)
            //  remove the call to isEditorPage if successful
            const createFromTemplateResponse = await createFromTemplateMutation({
                variables: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId,
                    title: title,
                    subType: subType,
                    blueprint: JSON.stringify(template),
                    attemptSpaUrlResponse: !isEditorPage
                }
            });
            const draftUrl = createFromTemplateResponse?.data?.experimentalPublishPageByTemplate?.links?.draftUrl;
            if (forceTemplatePanelOpen) navigate((0, $cb6fO.addQueryParams)((0, $iPv75.processDraftUrl)(draftUrl), {
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: 'true'
            }), {
                openContentInNewTab: openContentInNewTab
            });
            else navigate((0, $cb6fO.addQueryParams)((0, $iPv75.processDraftUrl)(draftUrl), {
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: 'true'
            }), {
                openContentInNewTab: openContentInNewTab
            });
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_PAGE_EXPERIENCE)
            });
        }
        return true;
    }, [
        createFromTemplateMutation,
        updateFromTemplateMutation,
        isEditorPage,
        experienceTracker,
        navigate,
        openTemplateVariables,
        cloudId
    ]);
    return (0, $42omo.useMemo)(()=>({
            canHandle: canHandle,
            handle: handle
        }), [
        canHandle,
        handle
    ]);
};
module.exports["useTemplateCreatable"] = $8781a99089269bbb$export$d3dc05eb5b2c4ff8;

});

parcelRegister("d4crM", function(module, exports) {
/**
 * @generated SignedSource<<d1fb022ac2a0d3270e5a85cef4a16245>>
 * @relayHash 781eb670fe145d14fa4a1dc05136b7b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 623c2d2232ba4b00b3ad6e06d683127f498d69b64b2edd5b4681e32a0e07d3f0
const $a656c33fb94257ca$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "expand",
            "value": "metadata.simple.isFabric,space,version"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "name",
                                    "variableName": "title"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "spaceKey",
                                    "variableName": "spaceKey"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "templateId",
                            "variableName": "templateId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "contentBlueprintSpec"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": "DRAFT"
                },
                {
                    "kind": "Literal",
                    "name": "nextVersion",
                    "value": 1
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "pageAri",
            "variableName": "pageAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "title"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v10 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SimpleContentMetadataProvider_simple",
                "kind": "LinkedField",
                "name": "simple",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFabric"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useTemplateCreatableUpdateInstanceMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateInstancePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateInstance",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useTemplateCreatableUpdateInstanceMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateInstancePayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateInstance",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "781eb670fe145d14fa4a1dc05136b7b9",
            "id": "623c2d2232ba4b00b3ad6e06d683127f498d69b64b2edd5b4681e32a0e07d3f0",
            "metadata": {},
            "name": "useTemplateCreatableUpdateInstanceMutation",
            "operationKind": "mutation",
            "text": "mutation useTemplateCreatableUpdateInstanceMutation($pageAri:ID!,$templateId:String,$title:String,$spaceKey:String){confluence_updateInstance(pageAri:$pageAri,input:{contentBlueprintSpec:{templateId:$templateId,context:{name:$title,spaceKey:$spaceKey}},contentStatus:DRAFT,nextVersion:1},expand:\"metadata.simple.isFabric,space,version\"){content{id,type,title,space{key,id},links{editui},metadata{simple{isFabric}}}}}"
        }
    };
}();
$a656c33fb94257ca$var$node.hash = "8cf4fc4fc1b951143c31cf6f68da5947";
var $a656c33fb94257ca$export$2e2bcd8739ae039 = $a656c33fb94257ca$var$node;
module.exports["default"] = $a656c33fb94257ca$export$2e2bcd8739ae039;

});

parcelRegister("hivPX", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $bZ9Ng = parcelRequire("bZ9Ng");

const $cc0054905feea787$export$1d1fe3670628f053 = ()=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ blueprint: blueprint, attemptSpaUrlResponse: attemptSpaUrlResponse })=>{
            const blueprintSpec = JSON.parse(blueprint);
            return `/wiki/rest/api/template/page/${blueprintSpec.templateId}/instance${attemptSpaUrlResponse ? '?expand=metadata.properties.editor,space' : ''}`;
        },
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ spaceKey: spaceKey, parentPageId: contentId, blueprint: blueprint, title: title, subType: subType })=>{
            const blueprintSpec = JSON.parse(blueprint);
            const commonContentProperties = {
                type: 'page',
                status: 'draft',
                space: {
                    key: spaceKey
                },
                title: title
            };
            if (contentId && contentId !== 'no-parent-page') commonContentProperties.ancestors = [
                {
                    id: contentId
                }
            ];
            if (subType) commonContentProperties.subType = subType;
            return JSON.stringify({
                content: {
                    ...commonContentProperties
                },
                contentBlueprintSpec: {
                    contentTemplateId: blueprintSpec.templateId
                }
            });
        },
        parseResult: async (json, { attemptSpaUrlResponse: attemptSpaUrlResponse })=>{
            const editui = await (0, $bZ9Ng.getEditDraftPageUrl)(json, attemptSpaUrlResponse);
            if (!editui) throw new Error('Missing content draft url');
            return {
                experimentalPublishPageByTemplate: {
                    links: {
                        draftUrl: editui
                    }
                }
            };
        }
    });
};
module.exports["useExperimentalPublishPageByTemplateMutation"] = $cc0054905feea787$export$1d1fe3670628f053;

});

parcelRegister("77u46", function(module, exports) {

var $96m7w = parcelRequire("96m7w");

const $b0565e800446c8cf$export$5449b28ca807d7c5 = (0, $96m7w.default);
module.exports["GetTemplateBodyContentQuery"] = $b0565e800446c8cf$export$5449b28ca807d7c5;

});

parcelRegister("96m7w", function(module, exports) {
/**
 * @generated SignedSource<<1fd64c56e0dfee3c8f8e24690c5a1d60>>
 * @relayHash 90bbdfd066c472a82dcb4c9e40e7e214
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9d6b64831195378ddcecd6fc95c30ab8b99f0ad3ef256010f57edf3842a8c1a
const $0e383027279626ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId"
        }
    ], v1 = [
        {
            "alias": "template",
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentTemplateId",
                    "variableName": "templateId"
                }
            ],
            "concreteType": "ContentTemplate",
            "kind": "LinkedField",
            "name": "confluence_template",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "templateId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "editorVersion"
                },
                {
                    "concreteType": "EnrichableMap_ContentRepresentation_ContentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GetTemplateBodyContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GetTemplateBodyContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "90bbdfd066c472a82dcb4c9e40e7e214",
            "id": "f9d6b64831195378ddcecd6fc95c30ab8b99f0ad3ef256010f57edf3842a8c1a",
            "metadata": {},
            "name": "GetTemplateBodyContentQuery",
            "operationKind": "query",
            "text": "query GetTemplateBodyContentQuery($templateId:String!){template:confluence_template(contentTemplateId:$templateId){templateId,name,editorVersion,body{atlas_doc_format{value}}}}"
        }
    };
}();
$0e383027279626ce$var$node.hash = "a38b8268d20002984129f389a2681eda";
var $0e383027279626ce$export$2e2bcd8739ae039 = $0e383027279626ce$var$node;
module.exports["default"] = $0e383027279626ce$export$2e2bcd8739ae039;

});

parcelRegister("hHZWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("8cOoD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            this.emit(localId, data.eventData);
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("fNtDT", function(module, exports) {

let $b8026cfc4781e004$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8026cfc4781e004$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("eV0v4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("c1UWH", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer && typeof this.observer.unobserve === 'function') {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
            // Only set observer if it has the required methods
            if (observer && typeof observer.disconnect === 'function' && typeof observer.observe === 'function' && typeof observer.unobserve === 'function') this.observer = observer;
            else this.observer = null;
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer && typeof this.observer.disconnect === 'function') {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $2XqLN.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("1l1Yn"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("1l1Yn"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $b3Wpp = parcelRequire("b3Wpp");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4FHTF = parcelRequire("4FHTF");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, t3);
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $gMc0m.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<9f372e14beed666db49d6ddfdc096722>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $eTjjM = parcelRequire("eTjjM");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("1l1Yn", function(module, exports) {

let $0f99486100b22437$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f99486100b22437$var$load("i8eeg"),
    $0f99486100b22437$var$load("iFdoJ"),
    $0f99486100b22437$var$load("5tmW9"),
    $0f99486100b22437$var$load("6wr18"),
    $0f99486100b22437$var$load("Wowvf"),
    $0f99486100b22437$var$load("7EorR"),
    $0f99486100b22437$var$load("3EXzu"),
    $0f99486100b22437$var$load("ffEVr"),
    $0f99486100b22437$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("isEtk", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0cd4a5fc89cb5961$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isContentReady: false,
        contentLoading: {}
    },
    actions: {
        onContentRendered: ()=>({ setState: setState })=>{
                setState({
                    isContentReady: true
                });
            },
        addContentToBeLoaded: (content, value)=>({ setState: setState, getState: getState })=>{
                const newContentLoading = getState().contentLoading;
                newContentLoading[content] = value;
                setState({
                    contentLoading: newContentLoading
                });
            },
        removeContentFromLoading: (content)=>({ setState: setState, getState: getState })=>{
                const existingContentLoading = getState().contentLoading;
                existingContentLoading[content] && delete existingContentLoading[content];
                setState({
                    contentLoading: existingContentLoading
                });
            }
    },
    name: 'isContentReady'
});
const $0cd4a5fc89cb5961$export$fce89f7e653f0af5 = (0, $FOT9i.createContainer)($0cd4a5fc89cb5961$var$Store);
const $0cd4a5fc89cb5961$export$b49d63386d42e7ce = (0, $9zUhf.createHook)($0cd4a5fc89cb5961$var$Store);
module.exports["ContentStateContainer"] = $0cd4a5fc89cb5961$export$fce89f7e653f0af5;
module.exports["useContentState"] = $0cd4a5fc89cb5961$export$b49d63386d42e7ce;

});

parcelRegister("ewCYL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

// helper function for page comment reactions styles
const $9204e37f72fd5b13$var$getPageCommentLeftMargin = (isDisabled)=>{
    if (isDisabled) // reactions-spacer is 5px wide
    return '0';
    else return '5px';
};
const $9204e37f72fd5b13$var$reactionsContainerStyles = null; // styling for disable state of reactions
const $9204e37f72fd5b13$var$disabledOrReadOnlyStyles = null; // hide the add reaction button and users dialog link for read-only
const $9204e37f72fd5b13$var$readOnlyStyles = null;
const $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 = ({ isDisabled: isDisabled, hasReactions: _hasReactions, readOnly: readOnly, ...props })=>{
    'use no memo';
    return /*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1tr11xsr _sathhq3d _1i5z15vq _f7sg15vq _1ohd1ul9 _5f0qr5cr _1m31azsu",
            (isDisabled || readOnly) && "_1y1513gf _1m311rpy _4rtx13gf _1rjiglyw",
            readOnly && "_7jwlglyw _2yquglyw"
        ])
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$c7a67ebff2d113d4 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1y44 _2hwxgktf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$b4e61fe3d4c2583b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0idpf _19pk1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // apply for inline comment on view or edit page
const $9204e37f72fd5b13$export$86c494d6cf94f63c = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t2;
        const t3 = __cmplp.isDisabled ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-subtle, #505258)";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_10axpyj": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1m311c3d",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$144e39595b801848 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$6534fd4b5ea3346a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.hasReactions && "_1e0c1txw _2lx21bp4 _4cvr1y6m _dw34s8vo _zi9xfajl _nindxy5q _1ozzazsu _13ysdlk8 _ubseazsu _5btvdlk8 _179eu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$a44f62ffda6523d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul9p3fh _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$49f6fd955ad6275a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["ReactionsContainer"] = $9204e37f72fd5b13$export$3dcc1cf4fc9c7641;
module.exports["PageReactionsContainer"] = $9204e37f72fd5b13$export$c7a67ebff2d113d4;
module.exports["PageCommentReactionsContainer"] = $9204e37f72fd5b13$export$b4e61fe3d4c2583b;
module.exports["InlineCommentReactionsContainer"] = $9204e37f72fd5b13$export$86c494d6cf94f63c;
module.exports["FeedReactionsContainer"] = $9204e37f72fd5b13$export$144e39595b801848;
module.exports["ObjectCommentFooterReactionsContainer"] = $9204e37f72fd5b13$export$6534fd4b5ea3346a;
module.exports["MutationErrorContainer"] = $9204e37f72fd5b13$export$a44f62ffda6523d1;

});

parcelRegister("5qhgL", function(module, exports) {

var $ewCYL = parcelRequire("ewCYL");


var $3FlVr = parcelRequire("3FlVr");

const $bfbd403eb560ce3e$export$610a53f6a2b349ea = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
            return 0, $ewCYL.PageReactionsContainer;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
            return 0, $ewCYL.PageCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            return 0, $ewCYL.InlineCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 0, $ewCYL.FeedReactionsContainer;
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 0, $ewCYL.ObjectCommentFooterReactionsContainer;
        default:
            return 0, $ewCYL.ReactionsContainer;
    }
};
const $bfbd403eb560ce3e$export$bab27241713f2853 = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
            return 'page';
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 'blogpost';
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 'comment';
    }
};
const $bfbd403eb560ce3e$export$ebc11b395f5b2d6c = (location)=>{
    let isPage = false;
    let isComment = false;
    let isFeed = false;
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            isPage = true;
            break;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
            isFeed = true;
            break;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            isComment = true;
            break;
        // Feed comment is a special case that looks and queries like feed, but is technically a comment
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            isComment = true;
            isFeed = true;
            break;
    }
    return {
        isPage: isPage,
        isComment: isComment,
        isFeed: isFeed
    };
};
module.exports["getWrappingContainerByLocation"] = $bfbd403eb560ce3e$export$610a53f6a2b349ea;
module.exports["getContentTypeByLocation"] = $bfbd403eb560ce3e$export$bab27241713f2853;
module.exports["getBooleanLocationTypes"] = $bfbd403eb560ce3e$export$ebc11b395f5b2d6c;

});

parcelRegister("ke5Nx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");

var $7176b627a488fb1c$export$eeec4f91154bc947 = /*#__PURE__*/ function(ReactionType) {
    ReactionType["COMMENT"] = "comment";
    return ReactionType;
}({});
const $7176b627a488fb1c$export$2278b801a31eb230 = ()=>{
    const $ = (0, $frIzR.c)(15);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    if ($[0] !== getQueryParams) {
        t0 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t0;
    } else t0 = $[1];
    const { action: action, contentId: contentId, contentType: contentType, focusedCommentId: focusedCommentId, emojiId: emojiId } = t0;
    const reaction = action && action === "react";
    const quickReaction = action && action === "addReaction";
    const focusedPageReactionsId = reaction && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    const focusedCommentReactionsId = reaction && focusedCommentId ? focusedCommentId : undefined;
    const quickReactionsEmojiId = quickReaction && emojiId ? emojiId : undefined;
    const focusedCommentQuickReactionsId = quickReactionsEmojiId && focusedCommentId ? focusedCommentId : undefined;
    const focusedPageQuickReactionsId = quickReaction && quickReactionsEmojiId && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    let t1;
    if ($[2] !== action || $[3] !== emojiId || $[4] !== focusedCommentId || $[5] !== getQueryParams || $[6] !== setQueryParams) {
        t1 = (t2)=>{
            const { reactionType: reactionType } = t2 === undefined ? {} : t2;
            if (action && emojiId) {
                const queryParams = getQueryParams();
                setQueryParams({
                    ...queryParams,
                    action: undefined,
                    emojiId: undefined,
                    contentType: undefined,
                    contentId: undefined
                });
            } else if (reactionType === "comment" && action && focusedCommentId) {
                const queryParams_0 = getQueryParams();
                setQueryParams({
                    ...queryParams_0,
                    action: undefined,
                    focusedCommentId: undefined
                });
            }
        };
        $[2] = action;
        $[3] = emojiId;
        $[4] = focusedCommentId;
        $[5] = getQueryParams;
        $[6] = setQueryParams;
        $[7] = t1;
    } else t1 = $[7];
    const removeReactionsQueryParams = t1;
    let t2;
    if ($[8] !== focusedCommentQuickReactionsId || $[9] !== focusedCommentReactionsId || $[10] !== focusedPageQuickReactionsId || $[11] !== focusedPageReactionsId || $[12] !== quickReactionsEmojiId || $[13] !== removeReactionsQueryParams) {
        t2 = {
            focusedPageReactionsId: focusedPageReactionsId,
            focusedCommentReactionsId: focusedCommentReactionsId,
            focusedCommentQuickReactionsId: focusedCommentQuickReactionsId,
            focusedPageQuickReactionsId: focusedPageQuickReactionsId,
            quickReactionsEmojiId: quickReactionsEmojiId,
            removeReactionsQueryParams: removeReactionsQueryParams
        };
        $[8] = focusedCommentQuickReactionsId;
        $[9] = focusedCommentReactionsId;
        $[10] = focusedPageQuickReactionsId;
        $[11] = focusedPageReactionsId;
        $[12] = quickReactionsEmojiId;
        $[13] = removeReactionsQueryParams;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
};
module.exports["ReactionType"] = $7176b627a488fb1c$export$eeec4f91154bc947;
module.exports["useReactionsQueryParams"] = $7176b627a488fb1c$export$2278b801a31eb230;

});

parcelRegister("aUU0C", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $1P1Tu.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $9zUhf.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $9zUhf.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("inDu6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, removedThreadsMap: removedThreadsMap } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $42omo.useMemo)(()=>{
        const footerCommentThreads = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        }) : (0, $i6UMJ.getOpenCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: false,
            showGeneralComments: true,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode,
        removedThreadsMap
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("ihn35", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qoahv _n3tdv47k _p12fukw8 _1bsb1osq _4t3i68cl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81qyo _1e0c1txw _1bah1yb4 _4cvr1h6o _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _u5f3u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _bfhki8nm _4t3it94y _1bsbidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulputpp _11c8fhey _1yt44ar7 _1e0c1txw _2lx21bp4 _p12fsb0t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _19bvu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261g80 _zulppxbi _1e0c1txw _4t3i1obz _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1ejb _11c8fhey _1e0c1txw _2lx21bp4 _u5f3xncg _p12f10k3",
            !__cmplp.isNav4Enabled && "_19bvv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulputpp _11c8i4vh _syazazsu _1e0c1txw _4cvr1h6o _19bv1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19bvutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8i4vh _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8i4vh _syazazsu _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["EndOfPageRecPlaceholderContainer"] = $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d;
module.exports["EndOfPageRecHeader"] = $e8a7d12ee4dfec6a$export$efb20161e583b9b8;
module.exports["HeaderFrontContainer"] = $e8a7d12ee4dfec6a$export$80837d77c7223a53;
module.exports["HeaderLineContainer"] = $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a;
module.exports["InfoContainer"] = $e8a7d12ee4dfec6a$export$48423cf6a25b5248;
module.exports["FeedbackContainer"] = $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1;
module.exports["EndOfPageRecAdminConfigContainer"] = $e8a7d12ee4dfec6a$export$227f3f793075b973;
module.exports["EndOfPageRecHideControlContainer"] = $e8a7d12ee4dfec6a$export$545440ab15c19255;
module.exports["EndOfPageRecHideToggleContainer"] = $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab;
module.exports["SpaceFeedbackButtonWrapper"] = $e8a7d12ee4dfec6a$export$a1abff0c22b50819;
module.exports["FeedbackFormQuestion"] = $e8a7d12ee4dfec6a$export$23b4998b204f6604;

});

parcelRegister("4r9Ir", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [newCommentPositions, setNewCommentPositions] = (0, $42omo.useState)(t1);
    const { count: count, setCount: setCount } = (0, $42omo.useContext)((0, $7IghX.PageCommentsCountContext));
    let t2;
    if ($[1] !== count || $[2] !== setCount) {
        t2 = (t3)=>{
            const { currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId } = t3;
            if (newCommentId) {
                const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                setNewCommentPositions((existingPositions)=>{
                    const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                    return !commentExists ? [
                        ...existingPositions,
                        {
                            id: newCommentId,
                            pos: pos,
                            seen: false,
                            currentUserMadeComment: currentUserMadeComment
                        }
                    ] : existingPositions;
                });
                setCount(count + 1);
            }
        };
        $[1] = count;
        $[2] = setCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== count || $[5] !== newCommentPositions || $[6] !== setCount) {
        t3 = (commentId)=>{
            if (commentId) {
                const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                if (idx !== -1) {
                    const positionCopy = [
                        ...newCommentPositions
                    ];
                    positionCopy.splice(idx, 1);
                    setNewCommentPositions(positionCopy);
                }
                const newCount = count - 1;
                setCount(newCount < 0 ? 0 : newCount);
            }
        };
        $[4] = count;
        $[5] = newCommentPositions;
        $[6] = setCount;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    let t5;
    if ($[8] !== newCommentPositions) {
        t4 = (commentId_0)=>{
            if (commentId_0) {
                const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                if (comment_0) comment_0.seen = true;
            }
        };
        t5 = (commentIds)=>{
            if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                if (comment_1) comment_1.seen = true;
            });
        };
        $[8] = newCommentPositions;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setNewCommentPositions([]);
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== newCommentPositions || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t7 = {
            newCommentPositions: newCommentPositions,
            addNewComment: t2,
            removeComment: t3,
            acknowledgeComment: t4,
            acknowledgeComments: t5,
            clearNewComments: t6
        };
        $[12] = newCommentPositions;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    const newCommentsContextValue = t7;
    let t8;
    if ($[18] !== children || $[19] !== newCommentsContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
            value: newCommentsContextValue
        }, children);
        $[18] = children;
        $[19] = newCommentsContextValue;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $42omo.useState)([]);
    const { count: count, setCount: setCount } = (0, $42omo.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $42omo.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId_0)=>{
                if (commentId_0) {
                    const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                    if (comment_0) comment_0.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                    const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                    if (comment_1) comment_1.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $42omo.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $42omo.useState)(0);
    const pageCommentsCountContextValue = (0, $42omo.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $42omo = parcelRequire("42omo");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $42omo.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $42omo.useRef)(null);
    const missedEventQueryTimeout = (0, $42omo.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $42omo.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $42omo.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all'
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $42omo.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<40589faa05c60ea2d854afc08790f884>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("kQekh", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $eSUdr.default)`query CommentsSectionGetSingleCommentQuery($commentId:ID!$contentId:ID!){comments(commentId:$commentId){nodes{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $eSUdr.default)`query CommentsSectionGetSingleCommentWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}`;
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("lfmjq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $1cfRh.default)();
    (0, $42omo.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $h82at.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("hd53J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aSsfA = parcelRequire("aSsfA");


var $gtj7V = parcelRequire("gtj7V");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ lastProcessedData: lastProcessedData }, { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch, clearErrorAndResetIsDataProcessed: clearErrorAndResetIsDataProcessed, setDataToProcessed: setDataToProcessed, processCommentsData: processCommentsData }] = (0, $4L9ve.useProcessedCommentsData)();
    // Track refetch count to force effect to run after every refetch
    const [refetchCount, setRefetchCount] = (0, $42omo.useState)(0);
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes.
    // Wrap refetch so that when the view calls it (e.g. Retry), we clear error/processed state first.
    // Increment refetchCount in .then() to force the processing effect to run.
    // On refetch failure we always setError, then call the caller's onError if they passed one.
    (0, $42omo.useEffect)(()=>{
        if (refetch) {
            const wrappedRefetch = ({ onError: callerOnError } = {})=>{
                clearErrorAndResetIsDataProcessed();
                return refetch({
                    onError: (err)=>{
                        setError(err instanceof Error ? err : new Error(String(err)));
                        callerOnError?.(err);
                    }
                }).then((result)=>{
                    setRefetchCount((c)=>c + 1);
                    return result;
                });
            };
            setRefetch(wrappedRefetch);
        }
    }, [
        refetch,
        setRefetch,
        clearErrorAndResetIsDataProcessed,
        setError
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes or refetch completes
    // This is the ONLY place where the processed data store should be updated
    // Depends on refetchCount to ensure effect runs after every refetch
    (0, $42omo.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            setError(error);
            return;
        }
        // When data is undefined (e.g. refetch failed and error was set in the wrapper catch),
        // don't call setProcessedData or we'd overwrite that error with error: undefined.
        if (data === undefined) return;
        // Fast path: if data reference is same as last processed (cached data from refetch),
        // just flip isDataProcessed to true without reprocessing
        if (data === lastProcessedData) {
            setDataToProcessed();
            return;
        }
        processCommentsData({
            data: data,
            pageMode: pageMode
        });
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError,
        contentId,
        refetchCount,
        lastProcessedData,
        setDataToProcessed,
        processCommentsData
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("7xF2y"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("7xF2y", function(module, exports) {

let $57db73307be7d1f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57db73307be7d1f4$var$load("i8eeg"),
    $57db73307be7d1f4$var$load("iFdoJ"),
    $57db73307be7d1f4$var$load("6wr18"),
    $57db73307be7d1f4$var$load("fzXjm"),
    $57db73307be7d1f4$var$load("ffEVr"),
    $57db73307be7d1f4$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("6Hogt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("eTcMK", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("i28ZW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $eSUdr.default)`query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}operations{operation targetType}}}`;
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: hasSpaceOperation($981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: hasSpaceOperation($981a614bc39b93a3$export$92f9e1ed9114d3a6),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("x3fqJ"))).ReadTime
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("x3fqJ", function(module, exports) {

let $06359a247ac58c99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06359a247ac58c99$var$load("irgIM").then(()=>parcelRequire('cbZqw'));

});

parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $frIzR.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("1gG4q"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: t1, variant: t2, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId } = t0;
    const readOnly = t1 === undefined ? true : t1;
    const variant = t2 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t2;
    let t3;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t3 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t3);
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) {
        let t4;
        if ($[3] !== contentLevelError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
                contentLevelError: contentLevelError
            });
            $[3] = contentLevelError;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    const t4 = readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit;
    let t5;
    if ($[5] !== buttonTestId || $[6] !== canManageSpaceSettings || $[7] !== classificationControlSetting || $[8] !== contentId || $[9] !== contentType || $[10] !== currentClassification || $[11] !== handleSubmit || $[12] !== isLoading || $[13] !== onRestoreFocus || $[14] !== popupPlacementOverride || $[15] !== source || $[16] !== spaceDefaultIsOverridden || $[17] !== spaceKey || $[18] !== spacing || $[19] !== t4 || $[20] !== userOverrideSetting || $[21] !== variant) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType,
            currentClassification: currentClassification,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            onEditSubmit: handleSubmit,
            menuBehavior: t4,
            loading: isLoading,
            variant: variant,
            popupPlacementOverride: popupPlacementOverride,
            spacing: spacing,
            onRestoreFocus: onRestoreFocus,
            buttonTestId: buttonTestId,
            source: source,
            canManageSpaceSettings: canManageSpaceSettings,
            classificationControlSetting: classificationControlSetting,
            userOverrideSetting: userOverrideSetting
        });
        $[5] = buttonTestId;
        $[6] = canManageSpaceSettings;
        $[7] = classificationControlSetting;
        $[8] = contentId;
        $[9] = contentType;
        $[10] = currentClassification;
        $[11] = handleSubmit;
        $[12] = isLoading;
        $[13] = onRestoreFocus;
        $[14] = popupPlacementOverride;
        $[15] = source;
        $[16] = spaceDefaultIsOverridden;
        $[17] = spaceKey;
        $[18] = spacing;
        $[19] = t4;
        $[20] = userOverrideSetting;
        $[21] = variant;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== flagStatus || $[24] !== isLoading || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
            isLoading: isLoading,
            flagStatus: flagStatus
        }, t5);
        $[23] = flagStatus;
        $[24] = isLoading;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        currentClassification: currentClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId,
        source: source,
        canManageSpaceSettings: canManageSpaceSettings,
        classificationControlSetting: classificationControlSetting,
        userOverrideSetting: userOverrideSetting
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $i2BsV = parcelRequire("i2BsV");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $earLp = parcelRequire("earLp");


var $1u6lx = parcelRequire("1u6lx");


var $6Ry4r = parcelRequire("6Ry4r");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("ddDB2"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await (parcelRequire("kGmHz"))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $i2BsV.default));
const $e299f5faef060d8a$var$messages = (0, $h82at.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: t1, isPopupDisabled: t2, menuBehavior: t3, variant: t4, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: t5, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = t0;
    const loading = t1 === undefined ? false : t1;
    const isPopupDisabled = t2 === undefined ? false : t2;
    const menuBehavior = t3 === undefined ? "readOnly" : t3;
    const variant = t4 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t4;
    const buttonTestId = t5 === undefined ? "data-classification-level" : t5;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || "auto";
    let t6;
    let t7;
    if ($[0] !== menuBehavior) {
        t6 = ()=>{
            if (menuBehavior === "editOnly") setIsReadView(false);
        };
        t7 = [
            menuBehavior
        ];
        $[0] = menuBehavior;
        $[1] = t6;
        $[2] = t7;
    } else {
        t6 = $[1];
        t7 = $[2];
    }
    (0, $42omo.useEffect)(t6, t7);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    let getOnChangeLevelClick;
    let handlePopupShown;
    let onEditCancel;
    let onEditSubmit;
    if ($[3] !== isReadView || $[4] !== menuBehavior || $[5] !== onEditCancelProp || $[6] !== onEditSubmitProp || $[7] !== onRestoreFocus || $[8] !== trackEditPopupViewed) {
        getOnChangeLevelClick = ()=>{
            if (menuBehavior === "readOnly") return;
            return ()=>{
                setIsReadView(false);
                handlePopupShown({
                    isOpen: true,
                    shouldForce: true
                });
            };
        };
        let t8;
        if ($[13] !== menuBehavior || $[14] !== onEditCancelProp) {
            t8 = (closePopup)=>{
                onEditCancelProp && onEditCancelProp();
                closePopup();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[13] = menuBehavior;
            $[14] = onEditCancelProp;
            $[15] = t8;
        } else t8 = $[15];
        onEditCancel = t8;
        let t9;
        if ($[16] !== menuBehavior || $[17] !== onEditSubmitProp || $[18] !== onRestoreFocus) {
            t9 = (classification, closePopup_0)=>{
                onEditSubmitProp && onEditSubmitProp(classification);
                onRestoreFocus && onRestoreFocus();
                closePopup_0();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[16] = menuBehavior;
            $[17] = onEditSubmitProp;
            $[18] = onRestoreFocus;
            $[19] = t9;
        } else t9 = $[19];
        onEditSubmit = t9;
        handlePopupShown = (t10)=>{
            const { isOpen: isOpen, shouldForce: t11 } = t10;
            const shouldForce = t11 === undefined ? false : t11;
            if (isOpen) {
                const shouldTrackEvent = !isReadView || shouldForce;
                if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
            }
        };
        $[3] = isReadView;
        $[4] = menuBehavior;
        $[5] = onEditCancelProp;
        $[6] = onEditSubmitProp;
        $[7] = onRestoreFocus;
        $[8] = trackEditPopupViewed;
        $[9] = getOnChangeLevelClick;
        $[10] = handlePopupShown;
        $[11] = onEditCancel;
        $[12] = onEditSubmit;
    } else {
        getOnChangeLevelClick = $[9];
        handlePopupShown = $[10];
        onEditCancel = $[11];
        onEditSubmit = $[12];
    }
    let t8;
    if ($[20] !== canManageSpaceSettings || $[21] !== classificationControlSetting || $[22] !== cloudId || $[23] !== contentId || $[24] !== currentClassification || $[25] !== defaultSelectedEditOption || $[26] !== getOnChangeLevelClick || $[27] !== isReadView || $[28] !== loading || $[29] !== onEditCancel || $[30] !== onEditSubmit || $[31] !== source || $[32] !== spaceKey || $[33] !== userOverrideSetting) {
        t8 = (closePopup_1)=>isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
                name: currentClassification.name,
                classification: currentClassification,
                onChangeLevelClick: getOnChangeLevelClick(),
                source: source ?? undefined,
                isCurrentUserSpaceAdmin: canManageSpaceSettings,
                classificationControl: classificationControlSetting ?? "ANY",
                userOverride: userOverrideSetting ?? "ANY"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
                spaceKey: spaceKey,
                selectedOption: defaultSelectedEditOption,
                onEditCancel: ()=>onEditCancel(closePopup_1),
                onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
                loading: loading,
                cloudId: cloudId,
                contentId: contentId,
                userOverride: userOverrideSetting ?? "ANY"
            });
        $[20] = canManageSpaceSettings;
        $[21] = classificationControlSetting;
        $[22] = cloudId;
        $[23] = contentId;
        $[24] = currentClassification;
        $[25] = defaultSelectedEditOption;
        $[26] = getOnChangeLevelClick;
        $[27] = isReadView;
        $[28] = loading;
        $[29] = onEditCancel;
        $[30] = onEditSubmit;
        $[31] = source;
        $[32] = spaceKey;
        $[33] = userOverrideSetting;
        $[34] = t8;
    } else t8 = $[34];
    const renderPopupComponent = t8;
    let t9;
    if ($[35] !== currentClassification) {
        t9 = (0, $6Ry4r.getGuidelineProps)(currentClassification, (0, $9wGTI.fg)("confluence_dlp_guideline_rich_text_support"));
        $[35] = currentClassification;
        $[36] = t9;
    } else t9 = $[36];
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = t9;
    const t10 = currentClassification.name;
    let t11;
    if ($[37] !== contentType || $[38] !== currentClassification.name || $[39] !== formatMessage) {
        t11 = formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        });
        $[37] = contentType;
        $[38] = currentClassification.name;
        $[39] = formatMessage;
        $[40] = t11;
    } else t11 = $[40];
    const t12 = renderPopupComponent;
    let t13;
    if ($[41] !== handlePopupShown) {
        t13 = ()=>handlePopupShown({
                isOpen: true
            });
        $[41] = handlePopupShown;
        $[42] = t13;
    } else t13 = $[42];
    const t14 = variant === (0, $1u6lx.TagButtonUIVariant).iconOnly;
    let t15;
    if ($[43] !== buttonTestId || $[44] !== currentClassification.color || $[45] !== currentClassification.name || $[46] !== guideline || $[47] !== guidelineRepresentation || $[48] !== isPopupDisabled || $[49] !== popupPlacement || $[50] !== spacing || $[51] !== t11 || $[52] !== t12 || $[53] !== t13 || $[54] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
            testId: buttonTestId,
            name: t10,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation,
            tooltip: t11,
            color: currentClassification.color,
            isPopupDisabled: isPopupDisabled,
            renderPopupComponent: t12,
            onPopupShown: t13,
            isIconOnly: t14,
            popupPlacement: popupPlacement,
            spacing: spacing
        }));
        $[43] = buttonTestId;
        $[44] = currentClassification.color;
        $[45] = currentClassification.name;
        $[46] = guideline;
        $[47] = guidelineRepresentation;
        $[48] = isPopupDisabled;
        $[49] = popupPlacement;
        $[50] = spacing;
        $[51] = t11;
        $[52] = t12;
        $[53] = t13;
        $[54] = t14;
        $[55] = t15;
    } else t15 = $[55];
    return t15;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level', source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || 'auto';
    (0, $42omo.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup_0)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup_0();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup_1)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            classification: currentClassification,
            onChangeLevelClick: getOnChangeLevelClick(),
            source: source ?? undefined,
            isCurrentUserSpaceAdmin: canManageSpaceSettings,
            classificationControl: classificationControlSetting ?? 'ANY',
            userOverride: userOverrideSetting ?? 'ANY'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup_1),
            onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
            loading: loading,
            cloudId: cloudId,
            contentId: contentId,
            userOverride: userOverrideSetting ?? 'ANY'
        });
    };
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = (0, $6Ry4r.getGuidelineProps)(currentClassification, (0, $9wGTI.fg)('confluence_dlp_guideline_rich_text_support'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color,
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("6Ry4r", function(module, exports) {
const $588818833e6e4a91$export$44b43449ad5e39e3 = (classification, isADFEnabled)=>{
    // When feature flag is enabled, prefer ADF guideline over plain text
    if (isADFEnabled && classification?.guidelineADF) return {
        guideline: classification.guidelineADF,
        guidelineRepresentation: 'EDITOR'
    };
    // Fall back to plain text guideline
    return {
        guideline: classification?.guideline,
        guidelineRepresentation: 'PLAIN'
    };
};
module.exports["getGuidelineProps"] = $588818833e6e4a91$export$44b43449ad5e39e3;

});

parcelRegister("ddDB2", function(module, exports) {

let $027bcb2a62b71cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $027bcb2a62b71cce$var$load("iJsKa").then(()=>parcelRequire('ePhVt'));

});

parcelRegister("kGmHz", function(module, exports) {

let $f0e956f9b8b5df56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0e956f9b8b5df56$var$load("cZdQT"),
    $f0e956f9b8b5df56$var$load("58UdM")
]).then(()=>parcelRequire('8KSlr'));

});

parcelRegister("9yVdT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9hlns = parcelRequire("9hlns");


var $u9agA = parcelRequire("u9agA");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, flagStatus: flagStatus, isLoading: t1 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isLoading) {
        t2 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        });
        $[0] = isLoading;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== flagStatus) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
                flags: flags,
                title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
                description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
                type: "warning",
                showRefresh: false
            }));
        $[3] = flagStatus;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050"
        }, children, t2, t4);
        $[5] = children;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("gfkT8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $h82at.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh } = t0;
    let t1;
    let t2;
    if ($[0] !== classification || $[1] !== description || $[2] !== flags || $[3] !== showRefresh || $[4] !== spaceName || $[5] !== title || $[6] !== type) {
        t1 = ()=>{
            const actions = !!showRefresh ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4ebf6b4d55a3b532$var$actionMessage),
                    onClick: $4ebf6b4d55a3b532$var$_temp
                }
            ] : [];
            const showFlag = async ()=>{
                const successFlag = await flags.showFlag({
                    type: type,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        ...description,
                        values: {
                            spaceName: spaceName,
                            classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? "unclassified" : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                        }
                    }),
                    actions: actions
                });
                setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
            };
            showFlag().catch(console.error);
        };
        t2 = [
            flags,
            type,
            title,
            description,
            spaceName,
            showRefresh,
            classification
        ];
        $[0] = classification;
        $[1] = description;
        $[2] = flags;
        $[3] = showRefresh;
        $[4] = spaceName;
        $[5] = title;
        $[6] = type;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $42omo.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
function $4ebf6b4d55a3b532$var$_temp() {
    return window.location.reload();
}
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("93WhG", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $h82at.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("fGQzQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7tHGa = parcelRequire("7tHGa");


var $in5LX = parcelRequire("in5LX");


var $4oYaK = parcelRequire("4oYaK");


var $3tzmY = parcelRequire("3tzmY");


var $45d60 = parcelRequire("45d60");


var $fcQxC = parcelRequire("fcQxC");

const $3ebf4e9018306b37$export$9756cece5bf0eb59 = (contentStatus)=>{
    switch(contentStatus){
        case (0, $7tHGa.ContentStatus).DRAFT:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).DRAFT;
        default:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).CURRENT;
    }
};
const $3ebf4e9018306b37$export$94cbb2414d06bc8b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { contentId: contentId, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    let t1;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== deleteClassificationMutation || $[3] !== setFlagStatus || $[4] !== setSubmittedClassification || $[5] !== updateClassificationMutation) {
        t1 = (classificationOption)=>{
            if (!classificationOption?.id) return;
            setFlagStatus((0, $in5LX.FlagStatus).LOADING);
            const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? "current-only");
            const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
            const baseVariables = {
                id: parseInt(contentId),
                contentStatuses: contentStatuses
            };
            const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
            const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
            const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
            if (shouldDeleteClassification) {
                if (optionIsNoClassificationOption) setSubmittedClassification(null);
                if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
                deleteClassificationMutation({
                    variables: baseVariables
                });
            } else {
                setSubmittedClassification(classificationOption);
                updateClassificationMutation({
                    variables: {
                        ...baseVariables,
                        classificationLevelId: classificationOption.id
                    }
                });
            }
        };
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = deleteClassificationMutation;
        $[3] = setFlagStatus;
        $[4] = setSubmittedClassification;
        $[5] = updateClassificationMutation;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ contentId: contentId, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    return (0, $42omo.useCallback)((classificationOption)=>{
        // Provides type safety for the mutation variables
        if (!classificationOption?.id) return;
        setFlagStatus((0, $in5LX.FlagStatus).LOADING);
        const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? 'current-only');
        const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
        const baseVariables = {
            id: parseInt(contentId),
            contentStatuses: contentStatuses
        };
        const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
        const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
        const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
        if (shouldDeleteClassification) {
            if (optionIsNoClassificationOption) setSubmittedClassification(null);
            if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
            deleteClassificationMutation({
                variables: baseVariables
            });
        } else {
            setSubmittedClassification(classificationOption);
            updateClassificationMutation({
                variables: {
                    ...baseVariables,
                    classificationLevelId: classificationOption.id
                }
            });
        }
    }, [
        contentId,
        setFlagStatus,
        contentStatusContext,
        updateClassificationMutation,
        deleteClassificationMutation,
        setSubmittedClassification
    ]);
};
module.exports["useEditSubmitCallback"] = $3ebf4e9018306b37$export$94cbb2414d06bc8b;

});

parcelRegister("4oYaK", function(module, exports) {
const $8d28ed91f3c96188$export$ea52aaec0b4536b2 = 'data-classification.no-classification-option';
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $8d28ed91f3c96188$export$ea52aaec0b4536b2;

});

parcelRegister("3tzmY", function(module, exports) {
const $1cdd6556a0b2e638$export$8942d0d7876f8b98 = 'data-classification.space-default-classification-option';
module.exports["SPACE_DEFAULT_CLASSIFICATION_OPTION_ID"] = $1cdd6556a0b2e638$export$8942d0d7876f8b98;

});

parcelRegister("45d60", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d94436a169325872$export$8be450ac125d65b9 = /*#__PURE__*/ function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["CURRENT"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["DRAFT"] = "DRAFT";
    return ContentDataClassificationMutationContentStatus;
}({});
module.exports["ContentDataClassificationMutationContentStatus"] = $d94436a169325872$export$8be450ac125d65b9;

});

parcelRegister("1gG4q", function(module, exports) {

let $0ec7eb59ea45e0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ec7eb59ea45e0fc$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $42omo.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $42omo.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("knzfV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $40pD8 = parcelRequire("40pD8");


var $fGQzQ = parcelRequire("fGQzQ");


var $earLp = parcelRequire("earLp");


const $5cd13874f5033207$var$LazyClassificationEditModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "oT96U",
    name: "LazyClassificationEditModalContent",
    loader: async ()=>(await (parcelRequire("ctS5p"))).ClassificationEditModalContent
});
const $5cd13874f5033207$export$d7e008c8afea1e79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    let t1;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t1 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t1);
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    let t2;
    if ($[3] !== handleSubmit || $[4] !== setIsClassificationModalOpen) {
        t2 = (classificationOption)=>{
            handleSubmit(classificationOption);
            setIsClassificationModalOpen(false);
        };
        $[3] = handleSubmit;
        $[4] = setIsClassificationModalOpen;
        $[5] = t2;
    } else t2 = $[5];
    const onEditSubmit = t2;
    let t3;
    if ($[6] !== setIsClassificationModalOpen) {
        t3 = ()=>{
            setIsClassificationModalOpen(false);
        };
        $[6] = setIsClassificationModalOpen;
        $[7] = t3;
    } else t3 = $[7];
    const onEditCancel = t3;
    let t4;
    let t5;
    if ($[8] !== isClassificationModalOpen || $[9] !== trackEditPopupViewed) {
        t4 = ()=>{
            if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
        };
        t5 = [
            isClassificationModalOpen,
            trackEditPopupViewed
        ];
        $[8] = isClassificationModalOpen;
        $[9] = trackEditPopupViewed;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $42omo.useEffect)(t4, t5);
    if (!isClassificationModalOpen) return null;
    let t6;
    if ($[12] !== setIsClassificationModalOpen) {
        t6 = ()=>setIsClassificationModalOpen(false);
        $[12] = setIsClassificationModalOpen;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = defaultSelectedEditOption ?? undefined;
    let t8;
    if ($[14] !== contentId || $[15] !== onEditCancel || $[16] !== onEditSubmit || $[17] !== spaceKey || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
            onClose: t6,
            onEditSubmit: onEditSubmit,
            onEditCancel: onEditCancel,
            selectedOption: t7,
            spaceKey: spaceKey,
            contentId: contentId
        });
        $[14] = contentId;
        $[15] = onEditCancel;
        $[16] = onEditSubmit;
        $[17] = spaceKey;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    const onEditSubmit = (0, $42omo.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $42omo.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    if (!isClassificationModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
        onClose: ()=>setIsClassificationModalOpen(false),
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        spaceKey: spaceKey,
        contentId: contentId
    });
};
module.exports["ClassificationEditModal"] = $5cd13874f5033207$export$d7e008c8afea1e79;

});

parcelRegister("ctS5p", function(module, exports) {

let $916225d9cb0b81df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $916225d9cb0b81df$var$load("cZdQT"),
    $916225d9cb0b81df$var$load("58UdM"),
    $916225d9cb0b81df$var$load("20qsp")
]).then(()=>parcelRequire('enSER'));

});

parcelRegister("kZEms", function(module, exports) {
/* ViewPageLabelsLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $io723 = parcelRequire("io723");


var $PPtZc = parcelRequire("PPtZc");

const $ba30ab1568e9f84e$export$78128841bacb1fe0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

const $ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vfOAM",
    name: "ViewPageLabelsLoaderBase",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba30ab1568e9f84e$export$78128841bacb1fe0, null),
    loader: async ()=>(await (parcelRequire("bClul"))).ViewPageLabels
});
const $ba30ab1568e9f84e$export$34eb2891dd16ab98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: (0, $PPtZc.VIEW_PAGE_LABELS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase, props));
module.exports["LabelsSelectPlaceholder"] = $ba30ab1568e9f84e$export$78128841bacb1fe0;
module.exports["ViewPageLabelsLoader"] = $ba30ab1568e9f84e$export$34eb2891dd16ab98;

});

parcelRegister("PPtZc", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY)
});
module.exports["VIEW_PAGE_LABELS_METRIC"] = $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2;

});

parcelRegister("bClul", function(module, exports) {

let $8753e97884b0074c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8753e97884b0074c$var$load("5dBst"),
    $8753e97884b0074c$var$load("loqJg"),
    $8753e97884b0074c$var$load("7EorR"),
    $8753e97884b0074c$var$load("jigcs"),
    $8753e97884b0074c$var$load("4LmEY")
]).then(()=>parcelRequire('heHIK'));

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if (Boolean((0, $1NBp8.FOLDER_VIEW).match(url))) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("fuYhW")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $fuYhW = parcelRequire("fuYhW");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("2391m"))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $h82at.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("2391m", function(module, exports) {

let $17e2dbf2ddfaf56d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17e2dbf2ddfaf56d$var$load("l8YLV"),
    $17e2dbf2ddfaf56d$var$load("nrKDI")
]).then(()=>parcelRequire('9WYR7'));

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("dOv3U"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("dOv3U", function(module, exports) {

let $a0e80a2a8bae1cae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0e80a2a8bae1cae$var$load("e7wVW"),
    $a0e80a2a8bae1cae$var$load("dVJPu"),
    $a0e80a2a8bae1cae$var$load("jbxHq"),
    $a0e80a2a8bae1cae$var$load("e7ZUf"),
    $a0e80a2a8bae1cae$var$load("gL8bn"),
    $a0e80a2a8bae1cae$var$load("jXx9i"),
    $a0e80a2a8bae1cae$var$load("loqJg"),
    $a0e80a2a8bae1cae$var$load("6wr18"),
    $a0e80a2a8bae1cae$var$load("k55bj"),
    $a0e80a2a8bae1cae$var$load("jrCdz"),
    $a0e80a2a8bae1cae$var$load("dedpp"),
    $a0e80a2a8bae1cae$var$load("djHM5"),
    $a0e80a2a8bae1cae$var$load("eJQji"),
    $a0e80a2a8bae1cae$var$load("ffEVr"),
    $a0e80a2a8bae1cae$var$load("7EorR"),
    $a0e80a2a8bae1cae$var$load("Wowvf"),
    $a0e80a2a8bae1cae$var$load("4Nzvy"),
    $a0e80a2a8bae1cae$var$load("9LW4b"),
    $a0e80a2a8bae1cae$var$load("hhss7"),
    $a0e80a2a8bae1cae$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("h03Gt"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("h03Gt"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("h03Gt", function(module, exports) {

let $c6054b58d4c9db37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6054b58d4c9db37$var$load("cyGuT"),
    $c6054b58d4c9db37$var$load("hhss7"),
    $c6054b58d4c9db37$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("6JXWM"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("6JXWM", function(module, exports) {

let $4e8572441aa9d111$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e8572441aa9d111$var$load("l8YLV"),
    $4e8572441aa9d111$var$load("6wr18"),
    $4e8572441aa9d111$var$load("ffEVr"),
    $4e8572441aa9d111$var$load("e7ZUf"),
    $4e8572441aa9d111$var$load("gL8bn"),
    $4e8572441aa9d111$var$load("9LW4b"),
    $4e8572441aa9d111$var$load("7EorR"),
    $4e8572441aa9d111$var$load("hhss7"),
    $4e8572441aa9d111$var$load("2OcM6"),
    $4e8572441aa9d111$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("f3euL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

const $af526147f97ee327$export$dcb53e05895a448a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.INACCESSIBLE_PAGE_LOAD_KEY)
});
module.exports["INACCESSIBLE_PAGE_LOAD"] = $af526147f97ee327$export$dcb53e05895a448a;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<05b973445049d9886074234415ca3582>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("ZugQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $4u5NT = parcelRequire("4u5NT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

/**
 * Marks FMP (First Meaningful Paint) on UFO transition interactions.
 *
 * When the `confluence_fe_deprecate_bm3` feature gate is **disabled** (legacy BM3 mode),
 * this component does nothing — FMP for transitions is handled through the BM3 pipeline
 * (although unreliably, see investigation in CCP-7117).
 *
 * When the feature gate is **enabled** (UFO mode) and we are in a transition, this
 * component places an `addUFOCustomMark('fmp', timestamp)` call. Unlike `PageLoadMarkFMP`
 * which is meant for initial page loads, this component is specifically designed for SPA
 * transitions where the platform UFO library does not natively track FMP.
 *
 * The corresponding `metric:fmp` value is computed in `additionalPayloadData.ts` by
 * reading this mark from the interaction and calculating the offset from interaction start.
 */ const $70ecb93741312159$var$UFOTransitionMarkFMPComponent = ({ timestamp: timestamp })=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        if (isTransition && (0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) {
            (0, $kGwvc.addUFOCustomMark)('fmp', timestamp);
            // The code below unfortunately relies on internals of the UFO library and on some
            // knowledge of how the UFO event data (especially FMP) are processed by the analytics
            // pipeline. This is relatively stable "private API", but it has to be sorted out with
            // the UFO team, as a follow up to https://product-fabric.atlassian.net/browse/CCP-7117.
            const interaction = (0, $4u5NT.getActiveInteraction)();
            if (!interaction) return;
            // In UFO realm, there's no concept of FMP, and by design it is defaulted to TTAI. While
            // in Confluence we rely on FMP for transitions, so emulating the legacy behavior here.
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push({
                key: 'fmp',
                config: {
                    type: 'PAGE_LOAD'
                },
                start: 0,
                stop: timestamp ?? null,
                type: 'PAGE_LOAD',
                custom: {}
            });
        }
    }, [
        isTransition,
        timestamp
    ]);
    return null;
};
const $70ecb93741312159$export$f881402a7a312ba4 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($70ecb93741312159$var$UFOTransitionMarkFMPComponent);
module.exports["UFOTransitionMarkFMP"] = $70ecb93741312159$export$f881402a7a312ba4;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$1fa8ce0cc2ea267e = 10;
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        const visit = (node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        };
        document?.content?.forEach(visit);
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.migration' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else if (extensionType === 'com.atlassian.confluence.migration') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9Z1sw = parcelRequire("9Z1sw");

const $816e839f3c4509f6$export$b3d89882591ee965 = ({ contentId: contentId, location: location })=>{
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: location
        }
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    const panels = data?.webPanels || [];
    return panels.map((panel)=>panel?.moduleKey).join(',');
};
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("bXXeH"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("bXXeH", function(module, exports) {

let $8b63277980f0ae45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b63277980f0ae45$var$load("geNwN"),
    $8b63277980f0ae45$var$load("d24tW"),
    $8b63277980f0ae45$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("7N1sB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $h82at.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c0db869228662b46$var$i18n.previousCommentLabel);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage($c0db869228662b46$var$i18n.previousCommentLabel);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== formatMessage) {
        t14 = formatMessage($c0db869228662b46$var$i18n.nextCommentLabel);
        $[24] = formatMessage;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: t14,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== experienceTracker || $[29] !== goToNextInlineComment || $[30] !== isPageOrDoc || $[31] !== isSSRFocusedComment || $[32] !== pageClass) {
        t16 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[28] = experienceTracker;
        $[29] = goToNextInlineComment;
        $[30] = isPageOrDoc;
        $[31] = isSSRFocusedComment;
        $[32] = pageClass;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== isSSRFocusedComment || $[35] !== t15 || $[36] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t15,
            onClick: t16
        });
        $[34] = isSSRFocusedComment;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== nextCommentShortcutStrings || $[39] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t17);
        $[38] = nextCommentShortcutStrings;
        $[39] = t17;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== renderServerPlaceholder) {
        t19 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[41] = renderServerPlaceholder;
        $[42] = t19;
    } else t19 = $[42];
    let t20;
    if ($[43] !== t12 || $[44] !== t18 || $[45] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: t6
        }, t12, t18, t19);
        $[43] = t12;
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    return t20;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("g1WP0", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("21jkZ")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("21jkZ")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;
module.exports["NotificationNudgeAsyncWrapper"] = $a55d612ff94024a3$export$abc42570cc861f1b;

});

parcelRegister("21jkZ", function(module, exports) {

let $178aacc6fa897e8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $178aacc6fa897e8a$var$load("6wr18"),
    $178aacc6fa897e8a$var$load("1TOYq"),
    $178aacc6fa897e8a$var$load("ffEVr"),
    $178aacc6fa897e8a$var$load("7EorR"),
    $178aacc6fa897e8a$var$load("dRpV3"),
    $178aacc6fa897e8a$var$load("hhss7"),
    $178aacc6fa897e8a$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("1JyKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $eSUdr.gql)`
	mutation useGetContextTokenMutation(
		$cloudId: ID!
		$input: ConfluenceForgeContextTokenRequestInput!
	) {
		confluence_generateForgeContextToken(cloudId: $cloudId, input: $input) {
			success
			errors {
				message
			}
			forgeContextToken {
				jwt
				expiresAt
				extensionId
			}
		}
	}
`;
const $765515c26d11d063$export$42cd66ed92f75ea0 = ({ extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, cachingEnabled: cachingEnabled = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        client: (0, $gKr8t.getAGGClient)()
    });
    return (0, $42omo.useMemo)(()=>{
        const fetchTokenFromServer = async (effectiveContextIds, effectiveExtension, effectiveLocalId, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: effectiveExtension.appVersion,
                        context: {
                            appVersion: effectiveExtension.appVersion,
                            environmentId: effectiveExtension.environmentId,
                            environmentType: effectiveExtension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...extensionData?.template?.id && {
                                    template: {
                                        id: extensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: extensionData?.selectedText
                            },
                            localId: effectiveLocalId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(effectiveExtension)
                        },
                        extensionId: effectiveExtension.id,
                        extensionType: effectiveExtension.type,
                        installationId: effectiveExtension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                if (cachingEnabled) {
                    const cachedEntry = cache.get(cacheKey);
                    if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                }
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                if (cachingEnabled) cache.delete(cacheKey);
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        // Original implementation - only supports contextIdsOverride
        async function getForgeContextTokenLegacy(options) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride } = options ?? {};
            const effectiveContextIds_0 = contextIdsOverride ?? contextIds;
            const cacheKey_0 = JSON.stringify({
                id: localId || extension.id,
                data: extensionData,
                contextIds: effectiveContextIds_0
            });
            const cache_0 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache_0.get(cacheKey_0);
            if (cachingEnabled) {
                if (cached) {
                    if (typeof cached.expiresAt !== 'number') return cached.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
                }
                const issuedAt = Date.now();
                const tokenPromise = fetchTokenFromServer(effectiveContextIds_0, extension, localId, cache_0, cacheKey_0);
                cache_0.set(cacheKey_0, {
                    promise: tokenPromise,
                    expiresAt: undefined,
                    issuedAt: issuedAt
                });
                return tokenPromise;
            }
            return fetchTokenFromServer(effectiveContextIds_0, extension, localId, cache_0, cacheKey_0);
        }
        // New implementation - supports both contextIdsOverride and extensionOverride for embedded macros
        async function getForgeContextTokenWithExtensionOverride(options_0) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride_0, extensionOverride: extensionOverride } = options_0 ?? {};
            // Use override values if provided (for embedded macros), otherwise use parent values
            const effectiveExtension_0 = extensionOverride?.extension ?? extension;
            const effectiveLocalId_0 = extensionOverride?.localId ?? localId;
            const effectiveContextIds_1 = contextIdsOverride_0 ?? contextIds;
            const cacheKey_1 = JSON.stringify({
                id: effectiveLocalId_0 || effectiveExtension_0.id,
                data: extensionData,
                contextIds: effectiveContextIds_1
            });
            const cache_1 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached_0 = cache_1.get(cacheKey_1);
            if (cachingEnabled) {
                if (cached_0) {
                    if (typeof cached_0.expiresAt !== 'number') return cached_0.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached_0.expiresAt) return cached_0.promise;
                }
                const issuedAt_0 = Date.now();
                const tokenPromise_0 = fetchTokenFromServer(effectiveContextIds_1, effectiveExtension_0, effectiveLocalId_0, cache_1, cacheKey_1);
                cache_1.set(cacheKey_1, {
                    promise: tokenPromise_0,
                    expiresAt: undefined,
                    issuedAt: issuedAt_0
                });
                return tokenPromise_0;
            }
            return fetchTokenFromServer(effectiveContextIds_1, effectiveExtension_0, effectiveLocalId_0, cache_1, cacheKey_1);
        }
        return (0, $9wGTI.fg)('platform_embedded_macro_fct_override') ? getForgeContextTokenWithExtensionOverride // once FG rolled out rename to getForgeContextToken and remove the legacy function
         : getForgeContextTokenLegacy;
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        cachingEnabled
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("2BQQi", function(module, exports) {

var $auRWi = parcelRequire("auRWi");


var $jMyy4 = parcelRequire("jMyy4");

const $513635d9ade3aacb$var$UseInlineHighlightsQuery = (0, $auRWi.default);
const $513635d9ade3aacb$export$7a17e81d6650ad94 = ({ pageId: pageId, shouldFireQuery: shouldFireQuery = true })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($513635d9ade3aacb$var$UseInlineHighlightsQuery, {
        variables: {
            pageId: pageId
        },
        skip: !Boolean(shouldFireQuery)
    });
    let markerRefs = [];
    let markerRefMap = {};
    const comments = data?.comments?.nodes;
    if (comments && Array.isArray(comments)) {
        // We need to create a map that connects markerRefs to commentId, we need commentId to fire analytic event
        // https://github.com/microsoft/TypeScript/issues/17002 - for type casting
        markerRefMap = comments.reduce((inlineRefAccumulator, comment)=>{
            if (!comment) return inlineRefAccumulator;
            const { inlineMarkerRef: inlineMarkerRef } = comment.location;
            // We should always get top-level inline comments, but if this doesn't exist, just return
            if (!inlineMarkerRef) return inlineRefAccumulator;
            inlineRefAccumulator[comment?.id] = inlineMarkerRef;
            comment?.replies?.forEach((reply)=>{
                if (reply) {
                    const { id: replyId } = reply;
                    inlineRefAccumulator[replyId] = inlineMarkerRef;
                }
            });
            return inlineRefAccumulator;
        }, {});
        markerRefs = [
            ...new Set(Object.values(markerRefMap))
        ];
    }
    return {
        markerRefs: markerRefs,
        markerRefMap: markerRefMap,
        loading: loading
    };
};
module.exports["useInlineHighlights"] = $513635d9ade3aacb$export$7a17e81d6650ad94;

});

parcelRegister("auRWi", function(module, exports) {
/**
 * @generated SignedSource<<ae6c0cd0e6b2ccebe266c857fe0c5bfd>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d
const $e084fe268cd37421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v5 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
            "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
            "metadata": {},
            "name": "useInlineHighlightsQuery",
            "operationKind": "query",
            "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
        }
    };
}();
$e084fe268cd37421$var$node.hash = "2fb3b51eea98e2fd2a940548824e472b";
var $e084fe268cd37421$export$2e2bcd8739ae039 = $e084fe268cd37421$var$node;
module.exports["default"] = $e084fe268cd37421$export$2e2bcd8739ae039;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("lCnGZ"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("8Dmra"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("lCnGZ", function(module, exports) {

let $fbcf866c0067bfb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fbcf866c0067bfb0$var$load("h3ABO"),
    $fbcf866c0067bfb0$var$load("6aTYS"),
    $fbcf866c0067bfb0$var$load("8HiPp"),
    $fbcf866c0067bfb0$var$load("bfveI"),
    $fbcf866c0067bfb0$var$load("e7ZUf"),
    $fbcf866c0067bfb0$var$load("gL8bn"),
    $fbcf866c0067bfb0$var$load("3JSgG"),
    $fbcf866c0067bfb0$var$load("6wr18"),
    $fbcf866c0067bfb0$var$load("gBT55"),
    $fbcf866c0067bfb0$var$load("6kOJQ"),
    $fbcf866c0067bfb0$var$load("aGWeM"),
    $fbcf866c0067bfb0$var$load("2F69B"),
    $fbcf866c0067bfb0$var$load("9OQNK"),
    $fbcf866c0067bfb0$var$load("d24tW"),
    $fbcf866c0067bfb0$var$load("a9w2G"),
    $fbcf866c0067bfb0$var$load("iGCP8"),
    $fbcf866c0067bfb0$var$load("lkOIY"),
    $fbcf866c0067bfb0$var$load("282rq"),
    $fbcf866c0067bfb0$var$load("lHACy"),
    $fbcf866c0067bfb0$var$load("dI1Cd"),
    $fbcf866c0067bfb0$var$load("jbxHq"),
    $fbcf866c0067bfb0$var$load("8YSo7"),
    $fbcf866c0067bfb0$var$load("4t77a"),
    $fbcf866c0067bfb0$var$load("9anPW"),
    $fbcf866c0067bfb0$var$load("hv4mn"),
    $fbcf866c0067bfb0$var$load("cyGuT"),
    $fbcf866c0067bfb0$var$load("ffEVr"),
    $fbcf866c0067bfb0$var$load("kbsoN"),
    $fbcf866c0067bfb0$var$load("fM2zn"),
    $fbcf866c0067bfb0$var$load("jYUNl"),
    $fbcf866c0067bfb0$var$load("foy8I"),
    $fbcf866c0067bfb0$var$load("bIjrH"),
    $fbcf866c0067bfb0$var$load("9dXbh"),
    $fbcf866c0067bfb0$var$load("5dBst"),
    $fbcf866c0067bfb0$var$load("i4xbo"),
    $fbcf866c0067bfb0$var$load("jY21r"),
    $fbcf866c0067bfb0$var$load("dP7ao"),
    $fbcf866c0067bfb0$var$load("hogcU"),
    $fbcf866c0067bfb0$var$load("9jjvO"),
    $fbcf866c0067bfb0$var$load("i8eeg"),
    $fbcf866c0067bfb0$var$load("iFdoJ"),
    $fbcf866c0067bfb0$var$load("77NEU"),
    $fbcf866c0067bfb0$var$load("2uVTT"),
    $fbcf866c0067bfb0$var$load("5tmW9"),
    $fbcf866c0067bfb0$var$load("cpQv0"),
    $fbcf866c0067bfb0$var$load("Wowvf"),
    $fbcf866c0067bfb0$var$load("4Nzvy"),
    $fbcf866c0067bfb0$var$load("kAaiF"),
    $fbcf866c0067bfb0$var$load("8ublV"),
    $fbcf866c0067bfb0$var$load("9LW4b"),
    $fbcf866c0067bfb0$var$load("loqJg"),
    $fbcf866c0067bfb0$var$load("hhss7"),
    $fbcf866c0067bfb0$var$load("enrPB"),
    $fbcf866c0067bfb0$var$load("fnlWy"),
    $fbcf866c0067bfb0$var$load("7EorR"),
    $fbcf866c0067bfb0$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("8Dmra", function(module, exports) {

let $64935ecdc0929fff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64935ecdc0929fff$var$load("kAaiF"),
    $64935ecdc0929fff$var$load("loqJg"),
    $64935ecdc0929fff$var$load("6wr18"),
    $64935ecdc0929fff$var$load("j104l"),
    $64935ecdc0929fff$var$load("9OQNK"),
    $64935ecdc0929fff$var$load("h4Nf7"),
    $64935ecdc0929fff$var$load("ffEVr"),
    $64935ecdc0929fff$var$load("e7ZUf"),
    $64935ecdc0929fff$var$load("gL8bn"),
    $64935ecdc0929fff$var$load("i4xbo"),
    $64935ecdc0929fff$var$load("9jjvO"),
    $64935ecdc0929fff$var$load("Wowvf"),
    $64935ecdc0929fff$var$load("8ublV"),
    $64935ecdc0929fff$var$load("hhss7"),
    $64935ecdc0929fff$var$load("7EorR"),
    $64935ecdc0929fff$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $1cfRh = parcelRequire("1cfRh");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("f8DBM"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("lVILn"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("iOudU"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("eGjii"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("6IMSD"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("k59GD"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("hDPT7"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hO50i"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("c9UYr"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("7vQxP"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("iA4uL"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("4mKg6"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("f8DBM", function(module, exports) {

let $b05653c392a9c0b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b05653c392a9c0b8$var$load("2YffH"),
    $b05653c392a9c0b8$var$load("1o23t"),
    $b05653c392a9c0b8$var$load("lqFMg"),
    $b05653c392a9c0b8$var$load("duC9l"),
    $b05653c392a9c0b8$var$load("ci4aH"),
    $b05653c392a9c0b8$var$load("l1nJ9"),
    $b05653c392a9c0b8$var$load("iQ0Jm"),
    $b05653c392a9c0b8$var$load("eBRUf"),
    $b05653c392a9c0b8$var$load("k8QRJ"),
    $b05653c392a9c0b8$var$load("43bfx"),
    $b05653c392a9c0b8$var$load("h4Nf7"),
    $b05653c392a9c0b8$var$load("7f9Fz"),
    $b05653c392a9c0b8$var$load("8YSo7"),
    $b05653c392a9c0b8$var$load("e7ZUf"),
    $b05653c392a9c0b8$var$load("gL8bn"),
    $b05653c392a9c0b8$var$load("g9CVe"),
    $b05653c392a9c0b8$var$load("djHM5"),
    $b05653c392a9c0b8$var$load("eJQji"),
    $b05653c392a9c0b8$var$load("6wr18"),
    $b05653c392a9c0b8$var$load("kjZZD"),
    $b05653c392a9c0b8$var$load("3JSgG"),
    $b05653c392a9c0b8$var$load("dRpV3"),
    $b05653c392a9c0b8$var$load("ffEVr"),
    $b05653c392a9c0b8$var$load("dTsOE"),
    $b05653c392a9c0b8$var$load("jYUNl"),
    $b05653c392a9c0b8$var$load("foy8I"),
    $b05653c392a9c0b8$var$load("jY21r"),
    $b05653c392a9c0b8$var$load("2vAWg"),
    $b05653c392a9c0b8$var$load("7cABH"),
    $b05653c392a9c0b8$var$load("9jjvO"),
    $b05653c392a9c0b8$var$load("i8eeg"),
    $b05653c392a9c0b8$var$load("iFdoJ"),
    $b05653c392a9c0b8$var$load("2uVTT"),
    $b05653c392a9c0b8$var$load("hhss7"),
    $b05653c392a9c0b8$var$load("Wowvf"),
    $b05653c392a9c0b8$var$load("4Nzvy"),
    $b05653c392a9c0b8$var$load("hJpvQ"),
    $b05653c392a9c0b8$var$load("bIPPg"),
    $b05653c392a9c0b8$var$load("lnKog"),
    $b05653c392a9c0b8$var$load("h3ABO"),
    $b05653c392a9c0b8$var$load("kC80R"),
    $b05653c392a9c0b8$var$load("7EorR"),
    $b05653c392a9c0b8$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("lVILn", function(module, exports) {

let $ff71a4e00a89d299$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ff71a4e00a89d299$var$load("2YffH"),
    $ff71a4e00a89d299$var$load("1o23t"),
    $ff71a4e00a89d299$var$load("lqFMg"),
    $ff71a4e00a89d299$var$load("duC9l"),
    $ff71a4e00a89d299$var$load("ci4aH"),
    $ff71a4e00a89d299$var$load("l1nJ9"),
    $ff71a4e00a89d299$var$load("iQ0Jm"),
    $ff71a4e00a89d299$var$load("eBRUf"),
    $ff71a4e00a89d299$var$load("k8QRJ"),
    $ff71a4e00a89d299$var$load("43bfx"),
    $ff71a4e00a89d299$var$load("h4Nf7"),
    $ff71a4e00a89d299$var$load("7f9Fz"),
    $ff71a4e00a89d299$var$load("8YSo7"),
    $ff71a4e00a89d299$var$load("e7ZUf"),
    $ff71a4e00a89d299$var$load("gL8bn"),
    $ff71a4e00a89d299$var$load("g9CVe"),
    $ff71a4e00a89d299$var$load("djHM5"),
    $ff71a4e00a89d299$var$load("eJQji"),
    $ff71a4e00a89d299$var$load("6wr18"),
    $ff71a4e00a89d299$var$load("kjZZD"),
    $ff71a4e00a89d299$var$load("3JSgG"),
    $ff71a4e00a89d299$var$load("dRpV3"),
    $ff71a4e00a89d299$var$load("ffEVr"),
    $ff71a4e00a89d299$var$load("dTsOE"),
    $ff71a4e00a89d299$var$load("jYUNl"),
    $ff71a4e00a89d299$var$load("foy8I"),
    $ff71a4e00a89d299$var$load("jY21r"),
    $ff71a4e00a89d299$var$load("2vAWg"),
    $ff71a4e00a89d299$var$load("7cABH"),
    $ff71a4e00a89d299$var$load("9jjvO"),
    $ff71a4e00a89d299$var$load("i8eeg"),
    $ff71a4e00a89d299$var$load("iFdoJ"),
    $ff71a4e00a89d299$var$load("2uVTT"),
    $ff71a4e00a89d299$var$load("hhss7"),
    $ff71a4e00a89d299$var$load("Wowvf"),
    $ff71a4e00a89d299$var$load("4Nzvy"),
    $ff71a4e00a89d299$var$load("hJpvQ"),
    $ff71a4e00a89d299$var$load("bIPPg"),
    $ff71a4e00a89d299$var$load("lnKog"),
    $ff71a4e00a89d299$var$load("h3ABO"),
    $ff71a4e00a89d299$var$load("kC80R"),
    $ff71a4e00a89d299$var$load("7EorR"),
    $ff71a4e00a89d299$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("iOudU", function(module, exports) {

let $db24573fa0be274f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db24573fa0be274f$var$load("2YffH"),
    $db24573fa0be274f$var$load("1o23t"),
    $db24573fa0be274f$var$load("lqFMg"),
    $db24573fa0be274f$var$load("duC9l"),
    $db24573fa0be274f$var$load("ci4aH"),
    $db24573fa0be274f$var$load("l1nJ9"),
    $db24573fa0be274f$var$load("iQ0Jm"),
    $db24573fa0be274f$var$load("eBRUf"),
    $db24573fa0be274f$var$load("k8QRJ"),
    $db24573fa0be274f$var$load("43bfx"),
    $db24573fa0be274f$var$load("h4Nf7"),
    $db24573fa0be274f$var$load("7f9Fz"),
    $db24573fa0be274f$var$load("8YSo7"),
    $db24573fa0be274f$var$load("e7ZUf"),
    $db24573fa0be274f$var$load("gL8bn"),
    $db24573fa0be274f$var$load("g9CVe"),
    $db24573fa0be274f$var$load("djHM5"),
    $db24573fa0be274f$var$load("eJQji"),
    $db24573fa0be274f$var$load("6wr18"),
    $db24573fa0be274f$var$load("kjZZD"),
    $db24573fa0be274f$var$load("3JSgG"),
    $db24573fa0be274f$var$load("dRpV3"),
    $db24573fa0be274f$var$load("ffEVr"),
    $db24573fa0be274f$var$load("dTsOE"),
    $db24573fa0be274f$var$load("jYUNl"),
    $db24573fa0be274f$var$load("foy8I"),
    $db24573fa0be274f$var$load("jY21r"),
    $db24573fa0be274f$var$load("2vAWg"),
    $db24573fa0be274f$var$load("7cABH"),
    $db24573fa0be274f$var$load("9jjvO"),
    $db24573fa0be274f$var$load("i8eeg"),
    $db24573fa0be274f$var$load("iFdoJ"),
    $db24573fa0be274f$var$load("2uVTT"),
    $db24573fa0be274f$var$load("hhss7"),
    $db24573fa0be274f$var$load("Wowvf"),
    $db24573fa0be274f$var$load("4Nzvy"),
    $db24573fa0be274f$var$load("hJpvQ"),
    $db24573fa0be274f$var$load("bIPPg"),
    $db24573fa0be274f$var$load("lnKog"),
    $db24573fa0be274f$var$load("h3ABO"),
    $db24573fa0be274f$var$load("kC80R"),
    $db24573fa0be274f$var$load("7EorR"),
    $db24573fa0be274f$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("eGjii", function(module, exports) {

let $ab03f45afd232856$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab03f45afd232856$var$load("e7ZUf"),
    $ab03f45afd232856$var$load("gL8bn"),
    $ab03f45afd232856$var$load("2YffH"),
    $ab03f45afd232856$var$load("lqFMg"),
    $ab03f45afd232856$var$load("duC9l"),
    $ab03f45afd232856$var$load("ci4aH"),
    $ab03f45afd232856$var$load("hJpvQ"),
    $ab03f45afd232856$var$load("l1nJ9"),
    $ab03f45afd232856$var$load("eBRUf"),
    $ab03f45afd232856$var$load("k8QRJ"),
    $ab03f45afd232856$var$load("43bfx"),
    $ab03f45afd232856$var$load("h4Nf7"),
    $ab03f45afd232856$var$load("7f9Fz"),
    $ab03f45afd232856$var$load("8YSo7"),
    $ab03f45afd232856$var$load("g9CVe"),
    $ab03f45afd232856$var$load("djHM5"),
    $ab03f45afd232856$var$load("eJQji"),
    $ab03f45afd232856$var$load("6wr18"),
    $ab03f45afd232856$var$load("kjZZD"),
    $ab03f45afd232856$var$load("3JSgG"),
    $ab03f45afd232856$var$load("dRpV3"),
    $ab03f45afd232856$var$load("ffEVr"),
    $ab03f45afd232856$var$load("dTsOE"),
    $ab03f45afd232856$var$load("jYUNl"),
    $ab03f45afd232856$var$load("foy8I"),
    $ab03f45afd232856$var$load("jY21r"),
    $ab03f45afd232856$var$load("2vAWg"),
    $ab03f45afd232856$var$load("7cABH"),
    $ab03f45afd232856$var$load("9jjvO"),
    $ab03f45afd232856$var$load("i8eeg"),
    $ab03f45afd232856$var$load("iFdoJ"),
    $ab03f45afd232856$var$load("bIPPg"),
    $ab03f45afd232856$var$load("2uVTT"),
    $ab03f45afd232856$var$load("hhss7"),
    $ab03f45afd232856$var$load("Wowvf"),
    $ab03f45afd232856$var$load("4Nzvy"),
    $ab03f45afd232856$var$load("h3ABO"),
    $ab03f45afd232856$var$load("kC80R"),
    $ab03f45afd232856$var$load("7EorR"),
    $ab03f45afd232856$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("6IMSD", function(module, exports) {

let $4e4cc4ba91f15d48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e4cc4ba91f15d48$var$load("e7ZUf"),
    $4e4cc4ba91f15d48$var$load("gL8bn"),
    $4e4cc4ba91f15d48$var$load("2YffH"),
    $4e4cc4ba91f15d48$var$load("lqFMg"),
    $4e4cc4ba91f15d48$var$load("duC9l"),
    $4e4cc4ba91f15d48$var$load("ci4aH"),
    $4e4cc4ba91f15d48$var$load("hJpvQ"),
    $4e4cc4ba91f15d48$var$load("l1nJ9"),
    $4e4cc4ba91f15d48$var$load("eBRUf"),
    $4e4cc4ba91f15d48$var$load("k8QRJ"),
    $4e4cc4ba91f15d48$var$load("43bfx"),
    $4e4cc4ba91f15d48$var$load("h4Nf7"),
    $4e4cc4ba91f15d48$var$load("7f9Fz"),
    $4e4cc4ba91f15d48$var$load("8YSo7"),
    $4e4cc4ba91f15d48$var$load("g9CVe"),
    $4e4cc4ba91f15d48$var$load("djHM5"),
    $4e4cc4ba91f15d48$var$load("eJQji"),
    $4e4cc4ba91f15d48$var$load("6wr18"),
    $4e4cc4ba91f15d48$var$load("kjZZD"),
    $4e4cc4ba91f15d48$var$load("3JSgG"),
    $4e4cc4ba91f15d48$var$load("dRpV3"),
    $4e4cc4ba91f15d48$var$load("ffEVr"),
    $4e4cc4ba91f15d48$var$load("dTsOE"),
    $4e4cc4ba91f15d48$var$load("jYUNl"),
    $4e4cc4ba91f15d48$var$load("foy8I"),
    $4e4cc4ba91f15d48$var$load("jY21r"),
    $4e4cc4ba91f15d48$var$load("2vAWg"),
    $4e4cc4ba91f15d48$var$load("7cABH"),
    $4e4cc4ba91f15d48$var$load("9jjvO"),
    $4e4cc4ba91f15d48$var$load("i8eeg"),
    $4e4cc4ba91f15d48$var$load("iFdoJ"),
    $4e4cc4ba91f15d48$var$load("bIPPg"),
    $4e4cc4ba91f15d48$var$load("2uVTT"),
    $4e4cc4ba91f15d48$var$load("hhss7"),
    $4e4cc4ba91f15d48$var$load("Wowvf"),
    $4e4cc4ba91f15d48$var$load("4Nzvy"),
    $4e4cc4ba91f15d48$var$load("h3ABO"),
    $4e4cc4ba91f15d48$var$load("kC80R"),
    $4e4cc4ba91f15d48$var$load("7EorR"),
    $4e4cc4ba91f15d48$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("k59GD", function(module, exports) {

let $e9ebc9d871d25e35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9ebc9d871d25e35$var$load("e7ZUf"),
    $e9ebc9d871d25e35$var$load("gL8bn"),
    $e9ebc9d871d25e35$var$load("2YffH"),
    $e9ebc9d871d25e35$var$load("lqFMg"),
    $e9ebc9d871d25e35$var$load("duC9l"),
    $e9ebc9d871d25e35$var$load("ci4aH"),
    $e9ebc9d871d25e35$var$load("hJpvQ"),
    $e9ebc9d871d25e35$var$load("l1nJ9"),
    $e9ebc9d871d25e35$var$load("eBRUf"),
    $e9ebc9d871d25e35$var$load("k8QRJ"),
    $e9ebc9d871d25e35$var$load("43bfx"),
    $e9ebc9d871d25e35$var$load("h4Nf7"),
    $e9ebc9d871d25e35$var$load("7f9Fz"),
    $e9ebc9d871d25e35$var$load("8YSo7"),
    $e9ebc9d871d25e35$var$load("g9CVe"),
    $e9ebc9d871d25e35$var$load("djHM5"),
    $e9ebc9d871d25e35$var$load("eJQji"),
    $e9ebc9d871d25e35$var$load("6wr18"),
    $e9ebc9d871d25e35$var$load("kjZZD"),
    $e9ebc9d871d25e35$var$load("3JSgG"),
    $e9ebc9d871d25e35$var$load("dRpV3"),
    $e9ebc9d871d25e35$var$load("ffEVr"),
    $e9ebc9d871d25e35$var$load("dTsOE"),
    $e9ebc9d871d25e35$var$load("jYUNl"),
    $e9ebc9d871d25e35$var$load("foy8I"),
    $e9ebc9d871d25e35$var$load("jY21r"),
    $e9ebc9d871d25e35$var$load("2vAWg"),
    $e9ebc9d871d25e35$var$load("7cABH"),
    $e9ebc9d871d25e35$var$load("9jjvO"),
    $e9ebc9d871d25e35$var$load("i8eeg"),
    $e9ebc9d871d25e35$var$load("iFdoJ"),
    $e9ebc9d871d25e35$var$load("bIPPg"),
    $e9ebc9d871d25e35$var$load("2uVTT"),
    $e9ebc9d871d25e35$var$load("hhss7"),
    $e9ebc9d871d25e35$var$load("Wowvf"),
    $e9ebc9d871d25e35$var$load("4Nzvy"),
    $e9ebc9d871d25e35$var$load("h3ABO"),
    $e9ebc9d871d25e35$var$load("kC80R"),
    $e9ebc9d871d25e35$var$load("7EorR"),
    $e9ebc9d871d25e35$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("hDPT7", function(module, exports) {

let $cd7e540b4bf6e9d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd7e540b4bf6e9d2$var$load("e7ZUf"),
    $cd7e540b4bf6e9d2$var$load("gL8bn"),
    $cd7e540b4bf6e9d2$var$load("2YffH"),
    $cd7e540b4bf6e9d2$var$load("lqFMg"),
    $cd7e540b4bf6e9d2$var$load("duC9l"),
    $cd7e540b4bf6e9d2$var$load("ci4aH"),
    $cd7e540b4bf6e9d2$var$load("l1nJ9"),
    $cd7e540b4bf6e9d2$var$load("eBRUf"),
    $cd7e540b4bf6e9d2$var$load("k8QRJ"),
    $cd7e540b4bf6e9d2$var$load("43bfx"),
    $cd7e540b4bf6e9d2$var$load("h4Nf7"),
    $cd7e540b4bf6e9d2$var$load("7f9Fz"),
    $cd7e540b4bf6e9d2$var$load("8YSo7"),
    $cd7e540b4bf6e9d2$var$load("g9CVe"),
    $cd7e540b4bf6e9d2$var$load("djHM5"),
    $cd7e540b4bf6e9d2$var$load("eJQji"),
    $cd7e540b4bf6e9d2$var$load("6wr18"),
    $cd7e540b4bf6e9d2$var$load("kjZZD"),
    $cd7e540b4bf6e9d2$var$load("3JSgG"),
    $cd7e540b4bf6e9d2$var$load("dRpV3"),
    $cd7e540b4bf6e9d2$var$load("ffEVr"),
    $cd7e540b4bf6e9d2$var$load("dTsOE"),
    $cd7e540b4bf6e9d2$var$load("jYUNl"),
    $cd7e540b4bf6e9d2$var$load("foy8I"),
    $cd7e540b4bf6e9d2$var$load("jY21r"),
    $cd7e540b4bf6e9d2$var$load("2vAWg"),
    $cd7e540b4bf6e9d2$var$load("7cABH"),
    $cd7e540b4bf6e9d2$var$load("9jjvO"),
    $cd7e540b4bf6e9d2$var$load("i8eeg"),
    $cd7e540b4bf6e9d2$var$load("iFdoJ"),
    $cd7e540b4bf6e9d2$var$load("2uVTT"),
    $cd7e540b4bf6e9d2$var$load("hhss7"),
    $cd7e540b4bf6e9d2$var$load("Wowvf"),
    $cd7e540b4bf6e9d2$var$load("4Nzvy"),
    $cd7e540b4bf6e9d2$var$load("hJpvQ"),
    $cd7e540b4bf6e9d2$var$load("bIPPg"),
    $cd7e540b4bf6e9d2$var$load("lnKog"),
    $cd7e540b4bf6e9d2$var$load("h3ABO"),
    $cd7e540b4bf6e9d2$var$load("kC80R"),
    $cd7e540b4bf6e9d2$var$load("7EorR"),
    $cd7e540b4bf6e9d2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("hO50i", function(module, exports) {

let $cf6afcd630f36443$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf6afcd630f36443$var$load("2YffH"),
    $cf6afcd630f36443$var$load("lqFMg"),
    $cf6afcd630f36443$var$load("duC9l"),
    $cf6afcd630f36443$var$load("ci4aH"),
    $cf6afcd630f36443$var$load("l1nJ9"),
    $cf6afcd630f36443$var$load("eBRUf"),
    $cf6afcd630f36443$var$load("k8QRJ"),
    $cf6afcd630f36443$var$load("43bfx"),
    $cf6afcd630f36443$var$load("h4Nf7"),
    $cf6afcd630f36443$var$load("7f9Fz"),
    $cf6afcd630f36443$var$load("8YSo7"),
    $cf6afcd630f36443$var$load("e7ZUf"),
    $cf6afcd630f36443$var$load("gL8bn"),
    $cf6afcd630f36443$var$load("g9CVe"),
    $cf6afcd630f36443$var$load("djHM5"),
    $cf6afcd630f36443$var$load("eJQji"),
    $cf6afcd630f36443$var$load("6wr18"),
    $cf6afcd630f36443$var$load("kjZZD"),
    $cf6afcd630f36443$var$load("3JSgG"),
    $cf6afcd630f36443$var$load("dRpV3"),
    $cf6afcd630f36443$var$load("ffEVr"),
    $cf6afcd630f36443$var$load("dTsOE"),
    $cf6afcd630f36443$var$load("jYUNl"),
    $cf6afcd630f36443$var$load("foy8I"),
    $cf6afcd630f36443$var$load("jY21r"),
    $cf6afcd630f36443$var$load("2vAWg"),
    $cf6afcd630f36443$var$load("7cABH"),
    $cf6afcd630f36443$var$load("9jjvO"),
    $cf6afcd630f36443$var$load("i8eeg"),
    $cf6afcd630f36443$var$load("iFdoJ"),
    $cf6afcd630f36443$var$load("2uVTT"),
    $cf6afcd630f36443$var$load("hhss7"),
    $cf6afcd630f36443$var$load("Wowvf"),
    $cf6afcd630f36443$var$load("4Nzvy"),
    $cf6afcd630f36443$var$load("hJpvQ"),
    $cf6afcd630f36443$var$load("bIPPg"),
    $cf6afcd630f36443$var$load("lnKog"),
    $cf6afcd630f36443$var$load("h3ABO"),
    $cf6afcd630f36443$var$load("kC80R"),
    $cf6afcd630f36443$var$load("7EorR"),
    $cf6afcd630f36443$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("c9UYr", function(module, exports) {

let $8da28520a563e0e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da28520a563e0e9$var$load("2YffH"),
    $8da28520a563e0e9$var$load("lqFMg"),
    $8da28520a563e0e9$var$load("duC9l"),
    $8da28520a563e0e9$var$load("ci4aH"),
    $8da28520a563e0e9$var$load("l1nJ9"),
    $8da28520a563e0e9$var$load("eBRUf"),
    $8da28520a563e0e9$var$load("k8QRJ"),
    $8da28520a563e0e9$var$load("43bfx"),
    $8da28520a563e0e9$var$load("h4Nf7"),
    $8da28520a563e0e9$var$load("7f9Fz"),
    $8da28520a563e0e9$var$load("8YSo7"),
    $8da28520a563e0e9$var$load("e7ZUf"),
    $8da28520a563e0e9$var$load("gL8bn"),
    $8da28520a563e0e9$var$load("g9CVe"),
    $8da28520a563e0e9$var$load("djHM5"),
    $8da28520a563e0e9$var$load("eJQji"),
    $8da28520a563e0e9$var$load("6wr18"),
    $8da28520a563e0e9$var$load("kjZZD"),
    $8da28520a563e0e9$var$load("3JSgG"),
    $8da28520a563e0e9$var$load("dRpV3"),
    $8da28520a563e0e9$var$load("ffEVr"),
    $8da28520a563e0e9$var$load("dTsOE"),
    $8da28520a563e0e9$var$load("jYUNl"),
    $8da28520a563e0e9$var$load("foy8I"),
    $8da28520a563e0e9$var$load("jY21r"),
    $8da28520a563e0e9$var$load("2vAWg"),
    $8da28520a563e0e9$var$load("7cABH"),
    $8da28520a563e0e9$var$load("9jjvO"),
    $8da28520a563e0e9$var$load("i8eeg"),
    $8da28520a563e0e9$var$load("iFdoJ"),
    $8da28520a563e0e9$var$load("2uVTT"),
    $8da28520a563e0e9$var$load("hhss7"),
    $8da28520a563e0e9$var$load("Wowvf"),
    $8da28520a563e0e9$var$load("4Nzvy"),
    $8da28520a563e0e9$var$load("hJpvQ"),
    $8da28520a563e0e9$var$load("bIPPg"),
    $8da28520a563e0e9$var$load("lnKog"),
    $8da28520a563e0e9$var$load("h3ABO"),
    $8da28520a563e0e9$var$load("kC80R"),
    $8da28520a563e0e9$var$load("7EorR"),
    $8da28520a563e0e9$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("7vQxP", function(module, exports) {

let $57842feaec5b6753$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57842feaec5b6753$var$load("e7ZUf"),
    $57842feaec5b6753$var$load("gL8bn"),
    $57842feaec5b6753$var$load("2YffH"),
    $57842feaec5b6753$var$load("lqFMg"),
    $57842feaec5b6753$var$load("duC9l"),
    $57842feaec5b6753$var$load("ci4aH"),
    $57842feaec5b6753$var$load("hJpvQ"),
    $57842feaec5b6753$var$load("l1nJ9"),
    $57842feaec5b6753$var$load("eBRUf"),
    $57842feaec5b6753$var$load("k8QRJ"),
    $57842feaec5b6753$var$load("43bfx"),
    $57842feaec5b6753$var$load("h4Nf7"),
    $57842feaec5b6753$var$load("7f9Fz"),
    $57842feaec5b6753$var$load("8YSo7"),
    $57842feaec5b6753$var$load("g9CVe"),
    $57842feaec5b6753$var$load("djHM5"),
    $57842feaec5b6753$var$load("eJQji"),
    $57842feaec5b6753$var$load("6wr18"),
    $57842feaec5b6753$var$load("kjZZD"),
    $57842feaec5b6753$var$load("3JSgG"),
    $57842feaec5b6753$var$load("dRpV3"),
    $57842feaec5b6753$var$load("ffEVr"),
    $57842feaec5b6753$var$load("dTsOE"),
    $57842feaec5b6753$var$load("jYUNl"),
    $57842feaec5b6753$var$load("foy8I"),
    $57842feaec5b6753$var$load("jY21r"),
    $57842feaec5b6753$var$load("2vAWg"),
    $57842feaec5b6753$var$load("7cABH"),
    $57842feaec5b6753$var$load("9jjvO"),
    $57842feaec5b6753$var$load("i8eeg"),
    $57842feaec5b6753$var$load("iFdoJ"),
    $57842feaec5b6753$var$load("bIPPg"),
    $57842feaec5b6753$var$load("2uVTT"),
    $57842feaec5b6753$var$load("hhss7"),
    $57842feaec5b6753$var$load("Wowvf"),
    $57842feaec5b6753$var$load("4Nzvy"),
    $57842feaec5b6753$var$load("h3ABO"),
    $57842feaec5b6753$var$load("kC80R"),
    $57842feaec5b6753$var$load("7EorR"),
    $57842feaec5b6753$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("iA4uL", function(module, exports) {

let $d86f13731cf5451d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d86f13731cf5451d$var$load("e7ZUf"),
    $d86f13731cf5451d$var$load("gL8bn"),
    $d86f13731cf5451d$var$load("2YffH"),
    $d86f13731cf5451d$var$load("lqFMg"),
    $d86f13731cf5451d$var$load("duC9l"),
    $d86f13731cf5451d$var$load("ci4aH"),
    $d86f13731cf5451d$var$load("l1nJ9"),
    $d86f13731cf5451d$var$load("eBRUf"),
    $d86f13731cf5451d$var$load("k8QRJ"),
    $d86f13731cf5451d$var$load("43bfx"),
    $d86f13731cf5451d$var$load("h4Nf7"),
    $d86f13731cf5451d$var$load("7f9Fz"),
    $d86f13731cf5451d$var$load("8YSo7"),
    $d86f13731cf5451d$var$load("g9CVe"),
    $d86f13731cf5451d$var$load("djHM5"),
    $d86f13731cf5451d$var$load("eJQji"),
    $d86f13731cf5451d$var$load("6wr18"),
    $d86f13731cf5451d$var$load("kjZZD"),
    $d86f13731cf5451d$var$load("3JSgG"),
    $d86f13731cf5451d$var$load("dRpV3"),
    $d86f13731cf5451d$var$load("ffEVr"),
    $d86f13731cf5451d$var$load("dTsOE"),
    $d86f13731cf5451d$var$load("jYUNl"),
    $d86f13731cf5451d$var$load("foy8I"),
    $d86f13731cf5451d$var$load("jY21r"),
    $d86f13731cf5451d$var$load("2vAWg"),
    $d86f13731cf5451d$var$load("7cABH"),
    $d86f13731cf5451d$var$load("9jjvO"),
    $d86f13731cf5451d$var$load("i8eeg"),
    $d86f13731cf5451d$var$load("iFdoJ"),
    $d86f13731cf5451d$var$load("2uVTT"),
    $d86f13731cf5451d$var$load("hhss7"),
    $d86f13731cf5451d$var$load("Wowvf"),
    $d86f13731cf5451d$var$load("4Nzvy"),
    $d86f13731cf5451d$var$load("hJpvQ"),
    $d86f13731cf5451d$var$load("bIPPg"),
    $d86f13731cf5451d$var$load("lnKog"),
    $d86f13731cf5451d$var$load("h3ABO"),
    $d86f13731cf5451d$var$load("kC80R"),
    $d86f13731cf5451d$var$load("7EorR"),
    $d86f13731cf5451d$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("4mKg6", function(module, exports) {

let $32dd1987ac14d215$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $32dd1987ac14d215$var$load("e7ZUf"),
    $32dd1987ac14d215$var$load("gL8bn"),
    $32dd1987ac14d215$var$load("2YffH"),
    $32dd1987ac14d215$var$load("lqFMg"),
    $32dd1987ac14d215$var$load("duC9l"),
    $32dd1987ac14d215$var$load("ci4aH"),
    $32dd1987ac14d215$var$load("l1nJ9"),
    $32dd1987ac14d215$var$load("eBRUf"),
    $32dd1987ac14d215$var$load("k8QRJ"),
    $32dd1987ac14d215$var$load("43bfx"),
    $32dd1987ac14d215$var$load("h4Nf7"),
    $32dd1987ac14d215$var$load("7f9Fz"),
    $32dd1987ac14d215$var$load("8YSo7"),
    $32dd1987ac14d215$var$load("g9CVe"),
    $32dd1987ac14d215$var$load("djHM5"),
    $32dd1987ac14d215$var$load("eJQji"),
    $32dd1987ac14d215$var$load("6wr18"),
    $32dd1987ac14d215$var$load("kjZZD"),
    $32dd1987ac14d215$var$load("3JSgG"),
    $32dd1987ac14d215$var$load("dRpV3"),
    $32dd1987ac14d215$var$load("ffEVr"),
    $32dd1987ac14d215$var$load("dTsOE"),
    $32dd1987ac14d215$var$load("jYUNl"),
    $32dd1987ac14d215$var$load("foy8I"),
    $32dd1987ac14d215$var$load("jY21r"),
    $32dd1987ac14d215$var$load("2vAWg"),
    $32dd1987ac14d215$var$load("7cABH"),
    $32dd1987ac14d215$var$load("9jjvO"),
    $32dd1987ac14d215$var$load("i8eeg"),
    $32dd1987ac14d215$var$load("iFdoJ"),
    $32dd1987ac14d215$var$load("2uVTT"),
    $32dd1987ac14d215$var$load("hhss7"),
    $32dd1987ac14d215$var$load("Wowvf"),
    $32dd1987ac14d215$var$load("4Nzvy"),
    $32dd1987ac14d215$var$load("hJpvQ"),
    $32dd1987ac14d215$var$load("bIPPg"),
    $32dd1987ac14d215$var$load("lnKog"),
    $32dd1987ac14d215$var$load("h3ABO"),
    $32dd1987ac14d215$var$load("kC80R"),
    $32dd1987ac14d215$var$load("7EorR"),
    $32dd1987ac14d215$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            isAIUnsplashImage: false,
            aiSuggestedUnsplashImages: undefined,
            shouldShowAIUnsplashHeaderToolbar: false,
            shouldShowAIImageAcceptanceFlow: false,
            lastAIGenerationParams: null,
            isCurrentAIFCAutoImage: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setIsAIUnsplashImage = (isAIUnsplashImage)=>this.setState({
                isAIUnsplashImage: isAIUnsplashImage
            });
        this.setAISuggestedUnsplashImages = (aiSuggestedUnsplashImages)=>this.setState({
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
            });
        this.setShouldShowAIUnsplashHeaderToolbar = (shouldShowAIUnsplashHeaderToolbar)=>this.setState({
                shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar
            });
        this.setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow)=>this.setState({
                shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow
            });
        this.setLastAIGenerationParams = (lastAIGenerationParams)=>this.setState({
                lastAIGenerationParams: lastAIGenerationParams
            });
        this.setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage)=>this.setState({
                isCurrentAIFCAutoImage: isCurrentAIFCAutoImage
            });
        this.resetToDefaults = ()=>{
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setIsAIUnsplashImage(false);
            this.setAISuggestedUnsplashImages(undefined);
            this.setShouldShowAIUnsplashHeaderToolbar(false);
            this.setShouldShowAIImageAcceptanceFlow(false);
            this.setLastAIGenerationParams(null);
            this.setIsCurrentAIFCAutoImage(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("gektR", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("4wEOc", function(module, exports) {

var $hGuUS = parcelRequire("hGuUS");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery = (0, $hGuUS.default);
const $17b0e005176b05e7$export$2e6840e38da4c328 = ({ skip: skip = false } = {})=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery, {
        context: {
            single: true
        },
        skip: skip
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};
module.exports["useIsDataClassificationEnabledForOrg"] = $17b0e005176b05e7$export$2e6840e38da4c328;

});

parcelRegister("hGuUS", function(module, exports) {
/**
 * @generated SignedSource<<b0abdf0d5cd8bf05705f2652464b7df5>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe
const $d06bb9e5b53f54be$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isDataClassificationEnabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
            "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
            "metadata": {},
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "operationKind": "query",
            "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
        }
    };
}();
$d06bb9e5b53f54be$var$node.hash = "5fefa316f3ebea3d1e92d59f94b250db";
var $d06bb9e5b53f54be$export$2e2bcd8739ae039 = $d06bb9e5b53f54be$var$node;
module.exports["default"] = $d06bb9e5b53f54be$export$2e2bcd8739ae039;

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");




const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $42omo.useState)(undefined);
    const isProcessingTitleUpdate = (0, $42omo.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $42omo.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!$title:String){updateTitle(contentId:$contentId title:$title){id title links{editui webui}}}`, {
        onCompleted: onMutationComplete,
        onError: setUpdateError
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $cXQmG.default),
        fragmentSpec: (0, $cXQmG.default)
    });
    const updateCache = (0, $42omo.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $42omo.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return;
        }
        try {
            await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
        } catch  {
        // error handled by useMutation result updateError
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestCachedTitle = (0, $42omo.useRef)();
    const processQueue = (0, $42omo.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        let nextTitle = latestCachedTitle.current;
        latestCachedTitle.current = undefined;
        // We keep updating the title until there are no more titles in the cache
        while(!!nextTitle){
            await updateTitle(nextTitle);
            nextTitle = latestCachedTitle.current;
            latestCachedTitle.current = undefined;
        }
        isProcessingTitleUpdate.current = false;
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $42omo.useCallback)(async (title)=>{
        latestCachedTitle.current = title;
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $42omo.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<3a0cc20ba43170d4195e7743f00dc422>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $42omo = parcelRequire("42omo");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");








var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");


var $6mKj3 = parcelRequire("6mKj3");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default)
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default)
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default),
        fragmentArtifact: (0, $fgrom.default)
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default),
        fragmentArtifact: (0, $hm7Pp.default)
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        try {
            const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
            const prevCache = readFragmentInterop({
                id: id
            });
            if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
        } catch  {
        // silently fallback to default typename "KnownUser"
        }
        try {
            const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
            writeFragmentInterop({
                fragmentId: id,
                data: {
                    by: {
                        displayName: displayName,
                        __typename: prevTypename
                    },
                    when: newWhen,
                    __typename: 'Version'
                }
            });
        } catch  {
        // silently fail write to cache
        }
    };
    const updateTimestampCacheWithCallback = (0, $42omo.useCallback)(updateTimestampCache, [
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true)) return updateTimestampCacheWithCallback;
    return updateTimestampCache;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<2ac329da81149c1c3666eddb688657bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<0a1c88ca4a42ad82ed80e88345c91c0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<375bcded8b18381e41f1464677a39a40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<faed0d1cb93aff3affdab8bcefc50ba6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("kSPGK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<744633e989b4d3d02533375405b7463f>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("8ro7U"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $ghftu = parcelRequire("ghftu");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $1cfRh.default)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $h82at.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltip: {
        id: "publish-modal.split-button-tooltip",
        defaultMessage: "Adjust update settings"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("8ro7U", function(module, exports) {

let $62538f66918ad62e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62538f66918ad62e$var$load("2vQEy"),
    $62538f66918ad62e$var$load("e7ZUf"),
    $62538f66918ad62e$var$load("gL8bn"),
    $62538f66918ad62e$var$load("dRpV3"),
    $62538f66918ad62e$var$load("4izLy"),
    $62538f66918ad62e$var$load("6wr18"),
    $62538f66918ad62e$var$load("6HLQW"),
    $62538f66918ad62e$var$load("kahM9"),
    $62538f66918ad62e$var$load("j8Ant"),
    $62538f66918ad62e$var$load("2F69B"),
    $62538f66918ad62e$var$load("kLojH"),
    $62538f66918ad62e$var$load("ivbae"),
    $62538f66918ad62e$var$load("5zDuS"),
    $62538f66918ad62e$var$load("7EorR"),
    $62538f66918ad62e$var$load("ffEVr"),
    $62538f66918ad62e$var$load("hhss7"),
    $62538f66918ad62e$var$load("9jjvO"),
    $62538f66918ad62e$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("l7iY7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $42omo.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible);
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $42omo.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("iXzFq", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId && (0, $6mKj3.expVal)('confluence_fix_expected_contentid_to_be_string', 'isEnabled', false)) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("fG32j", function(module, exports) {

var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder") return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        templateKey: templateKey
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("sD2Tz", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1tes1bs0 _1kt9b3bt _1cs8stnw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor })=>{
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (doPreload) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        doPreload,
        contentId
    ]);
    const onHover = (0, $42omo.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        onMouseEnter: onHover
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("3TgYS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");

var $e8033b5fc56f919b$export$1e5f9e0e1f5f771c = /*#__PURE__*/ function(LocalActivityAction) {
    LocalActivityAction["deleted"] = "deleted";
    LocalActivityAction["viewed"] = "viewed";
    return LocalActivityAction;
}({});
const $e8033b5fc56f919b$export$c008b11c6b6e84c9 = (0, $1P1Tu.createStore)({
    name: 'localActivityStore',
    initialState: {
        localActivity: []
    },
    actions: {
        setLocalActivity: (localActivity)=>({ setState: setState })=>{
                setState({
                    localActivity: [
                        ...localActivity
                    ]
                });
            },
        getLocalActivity: ()=>({ getState: getState })=>{
                return getState().localActivity;
            }
    }
});
const $e8033b5fc56f919b$var$localActivitySelector = (0, $cclHy.createSelector)((state)=>state.localActivity, (localActivity)=>localActivity);
const $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc = (0, $9zUhf.createStateHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9, {
    selector: $e8033b5fc56f919b$var$localActivitySelector
});
const $e8033b5fc56f919b$export$b62470c19b810f2b = (0, $9zUhf.createActionsHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9);
module.exports["LocalActivityAction"] = $e8033b5fc56f919b$export$1e5f9e0e1f5f771c;
module.exports["useLocalActivityCache"] = $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc;
module.exports["useLocalActivityCacheStoreActions"] = $e8033b5fc56f919b$export$b62470c19b810f2b;

});

parcelRegister("jYPbB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3TgYS = parcelRequire("3TgYS");


var $fdNea = parcelRequire("fdNea");

const $62bd2c9093526b74$export$c4f820168ec5144 = ()=>{
    const { getLocalActivity: getLocalActivity, setLocalActivity: setLocalActivity } = (0, $3TgYS.useLocalActivityCacheStoreActions)();
    const track = (0, $42omo.useCallback)((contentId, action)=>{
        (0, $fdNea.trackLocalActivity)({
            contentId: contentId,
            action: action
        }, setLocalActivity, getLocalActivity);
    }, [
        setLocalActivity,
        getLocalActivity
    ]);
    return {
        track: track
    };
};
module.exports["useLocalActivityTracker"] = $62bd2c9093526b74$export$c4f820168ec5144;

});

parcelRegister("fdNea", function(module, exports) {

var $de4za = parcelRequire("de4za");


var $42omo = parcelRequire("42omo");


var $3TgYS = parcelRequire("3TgYS");


var $fFmJj = parcelRequire("fFmJj");

const $5be82f78ca966df2$var$useLocalActivityContentFragment = (0, $de4za.default);
const $5be82f78ca966df2$var$MAX_EVENTS = 100;
const $5be82f78ca966df2$var$contentIdsToBeEvicted = new Set();
const $5be82f78ca966df2$var$isMarkedForEviction = (event)=>$5be82f78ca966df2$var$contentIdsToBeEvicted.has(event.content.id || '');
const $5be82f78ca966df2$export$1b153e31f71ec597 = ({ filters: filters } = {})=>{
    const readLocalActivityContentFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $5be82f78ca966df2$var$useLocalActivityContentFragment
    });
    const dehydratedLocalActivities = (0, $3TgYS.useLocalActivityCache)();
    const localActivities = [];
    for (const event of dehydratedLocalActivities){
        const hydratedEvent = {
            ...event
        };
        try {
            if (event?.content?.id) {
                const contentFragment = readLocalActivityContentFragment({
                    id: `Content:${event.content.id}`
                });
                if (contentFragment) hydratedEvent.content = {
                    ...hydratedEvent.content,
                    ...contentFragment
                };
            }
        } catch  {
        // If the fragment does not exist, don't do anything this event will get filtered out
        }
        localActivities.push(hydratedEvent);
    }
    /**
   * Events which are marked as consistent for all backend APIs can safely be evicted.
   * At the time of writing, there is only 1 supported backend API (Activity Platform),
   * so we can immediately mark the event for eviction.
   *
   * This eviction is "lazy", meaning that the event is *marked* as evicted & filtered from the
   * result set, but not actually removed from memory until `trackLocalActivity` is called.
   */ const markAsConsistent = (0, $42omo.useCallback)((contentId)=>{
        $5be82f78ca966df2$var$contentIdsToBeEvicted.add(contentId);
    }, []);
    const result = {
        viewedEvents: [],
        deletedContentIds: new Set(),
        markAsConsistent: markAsConsistent
    };
    localActivities.forEach((event)=>{
        if (!$5be82f78ca966df2$var$shouldIncludeEvent(event, filters)) return;
        if (event.action === (0, $3TgYS.LocalActivityAction).viewed) result.viewedEvents.push(event);
        else if (event.action === (0, $3TgYS.LocalActivityAction).deleted) result.deletedContentIds.add(event.content.id || '');
    });
    return result;
};
const $5be82f78ca966df2$var$shouldIncludeEvent = (event, filters)=>{
    // Filter events which will be evicted
    if ($5be82f78ca966df2$var$isMarkedForEviction(event)) return false;
    if (!filters) return true;
    return filters.spaceKey === ('space' in event.content ? event.content.space?.key : undefined);
};
const $5be82f78ca966df2$export$3fa173aba6d1fb4b = ({ contentId: contentId, action: action }, setLocalActivity, getLocalActivity)=>{
    /**
   * The Content is dehydrated (i.e. only Content.id is present, not full Content)
   * because we may not know all Content data at track time.
   * The full Content will be hydrated from cache automatically when querying in useLocalActivity
   */ let dehydratedEvents = [];
    try {
        dehydratedEvents = getLocalActivity()?.filter((e)=>!$5be82f78ca966df2$var$isMarkedForEviction(e)).slice(0, $5be82f78ca966df2$var$MAX_EVENTS - 1) || [];
    } catch  {}
    $5be82f78ca966df2$var$contentIdsToBeEvicted.clear();
    const data = {
        localActivity: [
            {
                id: `${contentId}-${action}`,
                action: action,
                timestamp: new Date().toISOString(),
                content: {
                    id: contentId,
                    __typename: 'Content'
                },
                __typename: 'LocalActivityEvent'
            },
            ...dehydratedEvents
        ]
    };
    setLocalActivity(data.localActivity);
};
module.exports["useLocalActivity"] = $5be82f78ca966df2$export$1b153e31f71ec597;
module.exports["trackLocalActivity"] = $5be82f78ca966df2$export$3fa173aba6d1fb4b;

});

parcelRegister("de4za", function(module, exports) {
/**
 * @generated SignedSource<<de5a5e114e312b89a46ea47a834c86ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b7736c1a4cd6fb8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useLocalActivityContentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "emoji-title-draft"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v1 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
            }
        ],
        "type": "Content"
    };
}();
$2b7736c1a4cd6fb8$var$node.hash = "e057d047fb173be62229acfca15ccbce";
var $2b7736c1a4cd6fb8$export$2e2bcd8739ae039 = $2b7736c1a4cd6fb8$var$node;
module.exports["default"] = $2b7736c1a4cd6fb8$export$2e2bcd8739ae039;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
        if (contentMode === 'draft') return false;
        return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
    } else return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("5kqgA", function(module, exports) {

var $awDRb = parcelRequire("awDRb");


var $b07B9 = parcelRequire("b07B9");


var $aX2oa = parcelRequire("aX2oa");


var $5WAcP = parcelRequire("5WAcP");


var $5x3Dm = parcelRequire("5x3Dm");


var $co8T8 = parcelRequire("co8T8");


var $42omo = parcelRequire("42omo");


var $eB56w = parcelRequire("eB56w");

var $a2xFu = parcelRequire("a2xFu");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");

const $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358 = ({ contentId: contentId, contentType: contentType, options: queryOptions = {} })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createPagePropertyMutation, createPagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $co8T8.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const [updatePagePropertyMutation, updatePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5x3Dm.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const [deletePagePropertyMutation, deletePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5WAcP.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const [createBlogPropertyMutation, createBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $aX2oa.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const [updateBlogPropertyMutation, updateBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $b07B9.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const [deleteBlogPropertyMutation, deleteBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $awDRb.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        }
    });
    const updateContentProperty = (0, $42omo.useCallback)(({ propertyKey: propertyKey, propertyValue: propertyValueString, isDelete: isDelete = false, hasExistingProperty: hasExistingProperty = false, options: options = {}, shouldOptimisticResponse: shouldOptimisticResponse = false })=>{
        if (isDelete) {
            if (contentType === 'page') return deletePagePropertyMutation({
                variables: {
                    pageId: (0, $a2xFu.ConfluencePageAri).create({
                        siteId: cloudId,
                        pageId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
            else if (contentType === 'blogpost') return deleteBlogPropertyMutation({
                variables: {
                    blogPostId: (0, $eB56w.ConfluenceBlogpostAri).create({
                        siteId: cloudId,
                        blogpostId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
        } else if (!!propertyValueString) {
            // Property value need to be stringified again before passing to graphql otherwise backend cannot parse it correctly
            const propertyValue = JSON.stringify(propertyValueString);
            if (hasExistingProperty) {
                // When there is existing property, we update it
                if (contentType === 'page') return updatePagePropertyMutation({
                    variables: {
                        pageId: (0, $a2xFu.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return updateBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $eB56w.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            } else {
                // When there is no existing property, we create it
                if (contentType === 'page') return createPagePropertyMutation({
                    variables: {
                        pageId: (0, $a2xFu.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return createBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $eB56w.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            }
        }
    }, [
        createPagePropertyMutation,
        createBlogPropertyMutation,
        updatePagePropertyMutation,
        updateBlogPropertyMutation,
        deletePagePropertyMutation,
        deleteBlogPropertyMutation,
        contentId,
        cloudId,
        contentType
    ]);
    const processUpdateContentPropertyResult = (0, $42omo.useCallback)((result)=>{
        if (result && 'confluence' in result && result.confluence) {
            if ('createPageProperty' in result.confluence) {
                const { createPageProperty: createPageProperty } = result.confluence;
                return {
                    success: createPageProperty?.success,
                    id: createPageProperty?.pageProperty?.id,
                    key: createPageProperty?.pageProperty?.key,
                    value: createPageProperty?.pageProperty?.value,
                    errors: createPageProperty?.errors ? [
                        ...createPageProperty.errors
                    ] : undefined
                };
            }
            if ('createBlogPostProperty' in result.confluence) {
                const { createBlogPostProperty: createBlogPostProperty } = result.confluence;
                return {
                    success: createBlogPostProperty?.success,
                    id: createBlogPostProperty?.blogPostProperty?.id,
                    key: createBlogPostProperty?.blogPostProperty?.key,
                    value: createBlogPostProperty?.blogPostProperty?.value,
                    errors: createBlogPostProperty?.errors ? [
                        ...createBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('updateValuePageProperty' in result.confluence) {
                const { updateValuePageProperty: updateValuePageProperty } = result.confluence;
                return {
                    success: updateValuePageProperty?.success,
                    id: updateValuePageProperty?.pageProperty?.id,
                    key: updateValuePageProperty?.pageProperty?.key,
                    value: updateValuePageProperty?.pageProperty?.value,
                    errors: updateValuePageProperty?.errors ? [
                        ...updateValuePageProperty.errors
                    ] : undefined
                };
            }
            if ('updateValueBlogPostProperty' in result.confluence) {
                const { updateValueBlogPostProperty: updateValueBlogPostProperty } = result.confluence;
                return {
                    success: updateValueBlogPostProperty?.success,
                    id: updateValueBlogPostProperty?.blogPostProperty?.id,
                    key: updateValueBlogPostProperty?.blogPostProperty?.key,
                    value: updateValueBlogPostProperty?.blogPostProperty?.value,
                    errors: updateValueBlogPostProperty?.errors ? [
                        ...updateValueBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('deletePageProperty' in result.confluence) {
                const { deletePageProperty: deletePageProperty } = result.confluence;
                return {
                    success: deletePageProperty?.success,
                    errors: deletePageProperty?.errors ? [
                        ...deletePageProperty.errors
                    ] : undefined
                };
            }
            if ('deleteBlogPostProperty' in result.confluence) {
                const { deleteBlogPostProperty: deleteBlogPostProperty } = result.confluence;
                return {
                    success: deleteBlogPostProperty?.success,
                    errors: deleteBlogPostProperty?.errors ? [
                        ...deleteBlogPostProperty.errors
                    ] : undefined
                };
            }
        }
        return null;
    }, []);
    return {
        updateContentProperty: updateContentProperty,
        processUpdateContentPropertyResult: processUpdateContentPropertyResult,
        updateContentPropertyResult: createPagePropertyResult || updatePagePropertyResult || deletePagePropertyResult || createBlogPropertyResult || updateBlogPropertyResult || deleteBlogPropertyResult
    };
};
module.exports["useUpdateContentProperty"] = $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358;

});

parcelRegister("awDRb", function(module, exports) {
/**
 * @generated SignedSource<<669c4e8aed1e137372ae07e78b583b67>>
 * @relayHash 7ea43002279108ebdaf4bacd5136e32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf
const $070558e2bb126032$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7ea43002279108ebdaf4bacd5136e32c",
            "id": "b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$070558e2bb126032$var$node.hash = "9c55ced69dfdca7b034578bc15733a6a";
var $070558e2bb126032$export$2e2bcd8739ae039 = $070558e2bb126032$var$node;
module.exports["default"] = $070558e2bb126032$export$2e2bcd8739ae039;

});

parcelRegister("b07B9", function(module, exports) {
/**
 * @generated SignedSource<<ccc16b4e8e3f103b27b45eb4840c7453>>
 * @relayHash 83c667f6e4eab61cc7723fc091cb0002
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9
const $22e9015d273a347d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "83c667f6e4eab61cc7723fc091cb0002",
            "id": "83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$22e9015d273a347d$var$node.hash = "580533e46ac660d594c903425683aacb";
var $22e9015d273a347d$export$2e2bcd8739ae039 = $22e9015d273a347d$var$node;
module.exports["default"] = $22e9015d273a347d$export$2e2bcd8739ae039;

});

parcelRegister("aX2oa", function(module, exports) {
/**
 * @generated SignedSource<<b150cebc1d169c9f3fc1f45a8d3842e8>>
 * @relayHash faed0d2f1dd78a502a219a9a5d9dc53b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0
const $fcc85e5ea801be9e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "faed0d2f1dd78a502a219a9a5d9dc53b",
            "id": "d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogCreateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{createBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$fcc85e5ea801be9e$var$node.hash = "1ac5be7a6ec97ac06bb016be27c4c3a0";
var $fcc85e5ea801be9e$export$2e2bcd8739ae039 = $fcc85e5ea801be9e$var$node;
module.exports["default"] = $fcc85e5ea801be9e$export$2e2bcd8739ae039;

});

parcelRegister("5WAcP", function(module, exports) {
/**
 * @generated SignedSource<<93350ef0f4162e1fc36ddd857bc9b84d>>
 * @relayHash ff4d35071121f198fae1a7890dfd8302
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954
const $a12a59c8911be0e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ff4d35071121f198fae1a7890dfd8302",
            "id": "d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954",
            "metadata": {},
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageDeleteMutation($propertyKey:String!,$pageId:ID!){confluence{deletePageProperty(input:{key:$propertyKey,pageId:$pageId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$a12a59c8911be0e2$var$node.hash = "c20456827070d144db3082bf07a8c31a";
var $a12a59c8911be0e2$export$2e2bcd8739ae039 = $a12a59c8911be0e2$var$node;
module.exports["default"] = $a12a59c8911be0e2$export$2e2bcd8739ae039;

});

parcelRegister("5x3Dm", function(module, exports) {
/**
 * @generated SignedSource<<5e967e8242c5a49e9dc459b6209a2476>>
 * @relayHash 3010f6b1356aae10019a1ad07e146372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955
const $c8d393500a85ca00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3010f6b1356aae10019a1ad07e146372",
            "id": "799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955",
            "metadata": {},
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$c8d393500a85ca00$var$node.hash = "4b090e3281dd15c3d9500ac77008df26";
var $c8d393500a85ca00$export$2e2bcd8739ae039 = $c8d393500a85ca00$var$node;
module.exports["default"] = $c8d393500a85ca00$export$2e2bcd8739ae039;

});

parcelRegister("co8T8", function(module, exports) {
/**
 * @generated SignedSource<<79d1dda0623787cec8a9da1b6a4090fc>>
 * @relayHash 775b265500f7bd394ac32842ea15a9b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7
const $7454710a26b8c5f5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "775b265500f7bd394ac32842ea15a9b6",
            "id": "f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7",
            "metadata": {},
            "name": "useUpdateContentPropertyPageCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageCreateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{createPageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$7454710a26b8c5f5$var$node.hash = "787bb4cf02c8a8364865f8c585f8b1ad";
var $7454710a26b8c5f5$export$2e2bcd8739ae039 = $7454710a26b8c5f5$var$node;
module.exports["default"] = $7454710a26b8c5f5$export$2e2bcd8739ae039;

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("lu0E4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $42omo.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("kwrcM"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $h82at.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $1cfRh.default)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("kwrcM", function(module, exports) {

let $ef0be629c08fbe90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef0be629c08fbe90$var$load("6aTYS"),
    $ef0be629c08fbe90$var$load("6wr18"),
    $ef0be629c08fbe90$var$load("ffEVr"),
    $ef0be629c08fbe90$var$load("l8YLV"),
    $ef0be629c08fbe90$var$load("Wowvf"),
    $ef0be629c08fbe90$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("2kB0r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $dAYOx = parcelRequire("dAYOx");


var $40pD8 = parcelRequire("40pD8");

const $6e3699f987da9ca3$var$messages = (0, $h82at.defineMessages)({
    classifyContent: {
        id: "data-classification.ellipsis-classification-menu-item.classify-content",
        defaultMessage: "Classify content"
    }
});
const $6e3699f987da9ca3$export$805becd8a04238d2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { elemBefore: elemBefore } = t0;
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    let t1;
    if ($[0] !== setIsClassificationModalOpen) {
        t1 = ()=>{
            setIsClassificationModalOpen(true);
        };
        $[0] = setIsClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const onClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $6e3699f987da9ca3$var$messages.classifyContent);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== elemBefore || $[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "classify-content",
            onClick: onClick,
            elemBefore: elemBefore
        }, t2);
        $[3] = elemBefore;
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ elemBefore: elemBefore })=>{
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: "classify-content",
        onClick: onClick,
        elemBefore: elemBefore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $6e3699f987da9ca3$var$messages.classifyContent));
};
module.exports["EllipsisClassificationMenuItem"] = $6e3699f987da9ca3$export$805becd8a04238d2;

});

parcelRegister("dfgVG", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d6588355bb2f168c$export$37ee5f1519219257 = (contentId)=>{
    return (0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).EDITOR_REVERTED) === contentId;
};
const $d6588355bb2f168c$export$1c5c21f47c0c866b = (contentId)=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.setItem((0, $1UApO.keys).EDITOR_REVERTED, contentId);
};
const $d6588355bb2f168c$export$75835fd24886e23f = ()=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.removeItem((0, $1UApO.keys).EDITOR_REVERTED);
};
module.exports["checkRevertFlag"] = $d6588355bb2f168c$export$37ee5f1519219257;
module.exports["addRevertFlag"] = $d6588355bb2f168c$export$1c5c21f47c0c866b;
module.exports["removeRevertFlag"] = $d6588355bb2f168c$export$75835fd24886e23f;

});

parcelRegister("l3C2L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("4PsmB"))).ViewChangesDialog
});
module.exports["ViewChangesDialogLoader"] = $ff94b9918380dc5d$export$cc6c027a319af205;

});

parcelRegister("4PsmB", function(module, exports) {

let $3841ed4449494d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3841ed4449494d1e$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("82Ooj", function(module, exports) {

var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $1cfRh.default)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("bkHHE"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $jVylI = parcelRequire("jVylI");


var $9wGTI = parcelRequire("9wGTI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_bfhki8nm",
                __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
                __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("bkHHE", function(module, exports) {

let $84037680763e61db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $84037680763e61db$var$load("i8eeg"),
    $84037680763e61db$var$load("iFdoJ"),
    $84037680763e61db$var$load("f35QR"),
    $84037680763e61db$var$load("eVYW1"),
    $84037680763e61db$var$load("ls0Um"),
    $84037680763e61db$var$load("020xd"),
    $84037680763e61db$var$load("eTBsW"),
    $84037680763e61db$var$load("bYxCZ"),
    $84037680763e61db$var$load("6HBYC"),
    $84037680763e61db$var$load("eDqo1"),
    $84037680763e61db$var$load("lxiFd"),
    $84037680763e61db$var$load("1oiJ6"),
    $84037680763e61db$var$load("huUvS"),
    $84037680763e61db$var$load("8j9XC"),
    $84037680763e61db$var$load("6vhrJ"),
    $84037680763e61db$var$load("fxC6e"),
    $84037680763e61db$var$load("jXx9i"),
    $84037680763e61db$var$load("5tmW9"),
    $84037680763e61db$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("8z0fF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("kgTIA"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $ecnYn.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("kgTIA", function(module, exports) {

let $03cef9e62ed890e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03cef9e62ed890e8$var$load("dlm6q"),
    $03cef9e62ed890e8$var$load("i8eeg"),
    $03cef9e62ed890e8$var$load("iFdoJ"),
    $03cef9e62ed890e8$var$load("5tmW9"),
    $03cef9e62ed890e8$var$load("ajMch"),
    $03cef9e62ed890e8$var$load("6wr18"),
    $03cef9e62ed890e8$var$load("ffEVr"),
    $03cef9e62ed890e8$var$load("kjZZD"),
    $03cef9e62ed890e8$var$load("4izLy"),
    $03cef9e62ed890e8$var$load("6KGrg"),
    $03cef9e62ed890e8$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $h82at.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $1cfRh.default)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence")
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    if (typeof document !== 'undefined' && document.title && !contentTitle) {
        // If contentTitle is empty, we're likely setting a generic title (just siteTitle or siteTitle with space)
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title && !isHomePage) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("3u7PM", function(module, exports) {

var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $1cfRh.default)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("4c4ke", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $bl4QJ = parcelRequire("bl4QJ");


const $6572a38c2b754de3$export$7a3e91558b835213 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G6aNu",
    name: "WatchDialog",
    loader: async ()=>(await (parcelRequire("byYmf"))).WatchDialog,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["WatchDialog"] = $6572a38c2b754de3$export$7a3e91558b835213;

});

parcelRegister("byYmf", function(module, exports) {

let $86b1b07b7c47cfe4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86b1b07b7c47cfe4$var$load("l8YLV"),
    $86b1b07b7c47cfe4$var$load("5dBst"),
    $86b1b07b7c47cfe4$var$load("6wr18"),
    $86b1b07b7c47cfe4$var$load("ffEVr"),
    $86b1b07b7c47cfe4$var$load("7EorR"),
    $86b1b07b7c47cfe4$var$load("cUtrS")
]).then(()=>parcelRequire('bzo9I'));

});

parcelRegister("3dPSK", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $660080b0a61a732e$export$75ba55e1c62d2f65 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
module.exports["useIsWatchDialogEnabled"] = $660080b0a61a732e$export$75ba55e1c62d2f65;

});

parcelRegister("1kaTo", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $8Z1sH = parcelRequire("8Z1sH");


var $2vY2J = parcelRequire("2vY2J");


var $42omo = parcelRequire("42omo");


var $7uLCZ = parcelRequire("7uLCZ");



var $dlky5 = parcelRequire("dlky5");

var $0f701bba444d03b3$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8Z1sH.default)(node, c);
    });
};
var $0f701bba444d03b3$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $2vY2J.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $0f701bba444d03b3$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $dlky5.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $0f701bba444d03b3$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $0f701bba444d03b3$var$removeClass(node, baseClassName);
        if (activeClassName) $0f701bba444d03b3$var$removeClass(node, activeClassName);
        if (doneClassName) $0f701bba444d03b3$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $bDniu.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uLCZ.default), (0, $7Q5yr.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$0f701bba444d03b3$var$CSSTransition.defaultProps = {
    classNames: ''
};
$0f701bba444d03b3$var$CSSTransition.propTypes = {};
var $0f701bba444d03b3$export$2e2bcd8739ae039 = $0f701bba444d03b3$var$CSSTransition;
module.exports["default"] = $0f701bba444d03b3$export$2e2bcd8739ae039;

});

parcelRegister("8Z1sH", function(module, exports) {
$parcel$export(module.exports, "default", () => $68a5278fcaf5b873$export$2e2bcd8739ae039);

var $4VBb5 = parcelRequire("4VBb5");

function $68a5278fcaf5b873$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $4VBb5.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});

parcelRegister("4VBb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $39695305b192572b$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $39695305b192572b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});

parcelRegister("2vY2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d4d0d5605c08ce5$export$2e2bcd8739ae039);
function $1d4d0d5605c08ce5$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $1d4d0d5605c08ce5$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $1d4d0d5605c08ce5$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $1d4d0d5605c08ce5$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $cOrQJ = parcelRequire("cOrQJ");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $dm7Aa = parcelRequire("dm7Aa");


var $eufiU = parcelRequire("eufiU");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $h82at.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $42omo.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $h82at.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("dm7Aa", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("eufiU", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $1P1Tu.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $9zUhf.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $9zUhf.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("5G6sa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $f44739e864265bc9$var$ContentHistoryStore = (0, $1P1Tu.createStore)({
    initialState: {
        wasTransitionedFromEditor: false
    },
    actions: {
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $f44739e864265bc9$export$90587b2a92cba8d5 = (0, $9zUhf.createStateHook)($f44739e864265bc9$var$ContentHistoryStore);
const $f44739e864265bc9$export$9b1a939bc5c5d3b = (0, $9zUhf.createActionsHook)($f44739e864265bc9$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $f44739e864265bc9$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $f44739e864265bc9$export$9b1a939bc5c5d3b;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $9wEpK = parcelRequire("9wEpK");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $h82at.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const handleError = (0, $42omo.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true
    });
    const isTitleAlignmentLoading = networkStatus === (0, $9wEpK.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $9wEpK.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $42omo.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $42omo.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                }
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: data
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        data,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("2MwVI", function(module, exports) {

var $635s2 = parcelRequire("635s2");


var $42omo = parcelRequire("42omo");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $gsf3i = parcelRequire("gsf3i");


var $jMyy4 = parcelRequire("jMyy4");

const $49bfbfa6f9c85bf2$export$ea561d273e8cda71 = "\u2588\u2588\u2588\u2588";
const $49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1 = (title)=>{
    if (!title) return false;
    return title.includes($49bfbfa6f9c85bf2$export$ea561d273e8cda71);
};
const $49bfbfa6f9c85bf2$export$19187316a5e6c180 = ({ contentId: contentId, title: title })=>{
    const { setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId } = (0, $gsf3i.useRedactionsTourActions)();
    const titleMaybeHasRedaction = (0, $42omo.useMemo)(()=>$49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1(title), [
        title
    ]);
    const { data: data, error: redactionsCountError } = (0, $jMyy4.useQueryInterop)((0, $635s2.default), {
        skip: !titleMaybeHasRedaction,
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all'
    });
    // handle 4xx errors
    (0, $42omo.useEffect)(()=>{
        if (redactionsCountError && (0, $aMcHK.isStatusCodeError)(redactionsCountError, '404')) (0, $7Sm4c.markErrorAsHandled)(redactionsCountError);
    }, [
        redactionsCountError
    ]);
    const redactionsCount = data?.singleContent?.redactionMetadataCount ?? 0;
    (0, $42omo.useEffect)(()=>{
        if (contentId && titleMaybeHasRedaction && redactionsCount > 0) setTitleRedactionRenderedForContentId(contentId);
        return ()=>{
            // Cleanup function to reset the title redaction state
            setTitleRedactionRenderedForContentId(null);
        };
    }, [
        contentId,
        titleMaybeHasRedaction,
        redactionsCount,
        setTitleRedactionRenderedForContentId
    ]);
};
module.exports["useTrackTitleRedactionRendered"] = $49bfbfa6f9c85bf2$export$19187316a5e6c180;

});

parcelRegister("635s2", function(module, exports) {
/**
 * @generated SignedSource<<f60c1ffe2d50699deb80b90c30fe1840>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9
const $a51c9ec4f18af0fc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2231280d1a64c0467ba87a246116380",
            "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
            "metadata": {},
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "operationKind": "query",
            "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$a51c9ec4f18af0fc$var$node.hash = "f9a742b4e2840cd061fc6915ae9b6b93";
var $a51c9ec4f18af0fc$export$2e2bcd8739ae039 = $a51c9ec4f18af0fc$var$node;
module.exports["default"] = $a51c9ec4f18af0fc$export$2e2bcd8739ae039;

});

parcelRegister("gjEAi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $44846349058524ee$export$9e2285f96d44792b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "kBUyq",
    name: "ApprovalBanner",
    loader: async ()=>(await (parcelRequire("6rKA3"))).ApprovalBanner
});
module.exports["ApprovalBanner"] = $44846349058524ee$export$9e2285f96d44792b;

});

parcelRegister("6rKA3", function(module, exports) {

let $4b19659c18f941bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b19659c18f941bf$var$load("ivbae"),
    $4b19659c18f941bf$var$load("kLojH"),
    $4b19659c18f941bf$var$load("8gmaR")
]).then(()=>parcelRequire('hbQeG'));

});

parcelRegister("lrMxq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $io723 = parcelRequire("io723");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("9DCke"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("9DCke", function(module, exports) {

let $70457c33644f75db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $70457c33644f75db$var$load("lHACy"),
    $70457c33644f75db$var$load("cKm5l"),
    $70457c33644f75db$var$load("6wr18"),
    $70457c33644f75db$var$load("hVgF8"),
    $70457c33644f75db$var$load("4nxY1"),
    $70457c33644f75db$var$load("1tMby"),
    $70457c33644f75db$var$load("kTdzk"),
    $70457c33644f75db$var$load("hSkfH"),
    $70457c33644f75db$var$load("8Sbjy"),
    $70457c33644f75db$var$load("2O2Xv"),
    $70457c33644f75db$var$load("adH3p"),
    $70457c33644f75db$var$load("hHrTM"),
    $70457c33644f75db$var$load("j6d30"),
    $70457c33644f75db$var$load("fiOV9"),
    $70457c33644f75db$var$load("4dNRa"),
    $70457c33644f75db$var$load("jdmfD"),
    $70457c33644f75db$var$load("736as"),
    $70457c33644f75db$var$load("1ZFzv"),
    $70457c33644f75db$var$load("iK6Gk"),
    $70457c33644f75db$var$load("lGcru"),
    $70457c33644f75db$var$load("1okAQ"),
    $70457c33644f75db$var$load("4rKYa"),
    $70457c33644f75db$var$load("282rq"),
    $70457c33644f75db$var$load("gy5DL"),
    $70457c33644f75db$var$load("7pxAs"),
    $70457c33644f75db$var$load("cEqm7"),
    $70457c33644f75db$var$load("6XCf4"),
    $70457c33644f75db$var$load("5pvpJ"),
    $70457c33644f75db$var$load("ffEVr"),
    $70457c33644f75db$var$load("1qlDN"),
    $70457c33644f75db$var$load("1yVM6"),
    $70457c33644f75db$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("essql", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $4L9ve = parcelRequire("4L9ve");


var $8i27m = parcelRequire("8i27m");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $9SEzS = parcelRequire("9SEzS");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$var$unreadCommentsQuery = (0, $eSUdr.default)`query useUnreadCommentsSetupQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId contentStatus:$contentStatus type:UNRESOLVED depth:ROOT){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved isDangling}}}author{permissionType ...on KnownUser{accountId}}createdAt{value}replies{id author{permissionType ...on KnownUser{accountId}}createdAt{value}location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}}}totalCount}}`;
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { setIsUpdatingUnreadComments: setIsUpdatingUnreadComments, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Get comments data directly from comments-data package (for pages only)
    // This fixes the circular dependency issue
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [], commentsDataMap: legacyCommentsDataMap = {
        inline: {},
        general: {}
    } }, { addNewCommentThreads: addNewCommentThreads }] = (0, $8i27m.useCommentsData)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const legacyQueryResult = (0, $jMyy4.useQueryInterop)($2524304961e9b056$var$unreadCommentsQuery, {
        variables: {
            pageId: pageId || '',
            contentStatus: !isRenderer ? [
                (0, $9SEzS.GraphQLContentStatus).CURRENT,
                (0, $9SEzS.GraphQLContentStatus).DRAFT
            ] : [
                (0, $9SEzS.GraphQLContentStatus).CURRENT
            ]
        },
        skip: !pageId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? !processedCommentsData.isDataProcessed : legacyQueryResult.loading;
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.error : legacyQueryResult.error;
    (0, $42omo.useEffect)(()=>{
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $42omo.useEffect)(()=>{
        if (!error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            setIsUpdatingUnreadComments(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $42omo.useCallback)(()=>{
        setIsUpdatingUnreadComments(false);
    }, [
        setIsUpdatingUnreadComments
    ]);
    const handleUpdateUnreadComments = (0, $42omo.useCallback)(async ()=>{
        if (userId && isUpdatingUnreadComments) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = (()=>{
                // When feature flag is enabled, use data from ProcessedCommentsDataStore
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return processedCommentsData.openComments || [];
                // Legacy path: use data from unreadCommentsQuery
                // Validate that the query was executed for the current page
                if (legacyQueryResult.variables?.pageId !== pageId) return [];
                const filteredNodes = legacyQueryResult.data?.comments?.nodes?.filter((node)=>node !== null) || [];
                if (filteredNodes.length === 0) return [];
                return filteredNodes;
            })();
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback,
                    addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? undefined : addNewCommentThreads
                });
            }
        }
    }, [
        userId,
        isUpdatingUnreadComments,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        legacyQueryResult.variables?.pageId,
        legacyQueryResult.data?.comments?.nodes,
        processedCommentsData.openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback,
        addNewCommentThreads
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined // use dangling callback if content type is a page
    });
    (0, $42omo.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("9nXVV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $42omo.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $42omo.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $42omo.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $42omo.useEffect)(()=>{
        if (!pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("1czFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $42omo.useRef)(new Set());
    const timeoutRef = (0, $42omo.useRef)(null);
    const beforeUnloadHandlerRef = (0, $42omo.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $42omo.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $42omo.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $42omo.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $42omo.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $eSUdr.default)`mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    $170c9bba7ed44542$var$markCommentsAsReadMutation);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $42omo.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("3bH25", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $42omo = parcelRequire("42omo");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $42omo.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $42omo.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $42omo.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - isUpdatingUnreadComments being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || isUpdatingUnreadComments) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        isUpdatingUnreadComments
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("9SEzS", function(module, exports) {
/**
 * @generated SignedSource<<261cad5b30367f2060b0057c0724e8e5>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $6771fdd733157350$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $6771fdd733157350$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["GraphQLContentStatus"] = $6771fdd733157350$export$b634e5de755b7d35;

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $42omo.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("jNGt9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $917iu = parcelRequire("917iu");


var $3HOqx = parcelRequire("3HOqx");


var $dpPtd = parcelRequire("dpPtd");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $dPJCf = parcelRequire("dPJCf");

const $e71baba61e1a588e$var$messages = (0, $h82at.defineMessages)({
    nthUserOnboardingFlagTitle: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.title",
        defaultMessage: "Just in case you missed it"
    },
    nthUserOnboardingFlagContent: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.content",
        defaultMessage: "We've got some handy tips and tricks to help you get started in Confluence."
    },
    nthUserOnboardingFlagAction: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.action",
        defaultMessage: "Check it out"
    },
    nthUserOnboardingFlagLabel: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.label",
        defaultMessage: "Lightbulb"
    }
});
const $e71baba61e1a588e$export$be5b862a7b78a50e = (url)=>{
    // Pattern: /spaces/{spaceKey}/pages/{contentId}/{page-title}
    const match = url.match(/\/spaces\/[^/]+\/pages\/(\d+)/);
    return match ? match[1] : null;
};
const $e71baba61e1a588e$var$DAYS_TO_WAIT_AFTER_ONBOARDING_COMPLETION = 1;
const $e71baba61e1a588e$var$useNthUserOnboardingFlag = ()=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const flagId = 'NTH_USER_ONBOARDING_FLAG';
    const dismissFlag = (0, $42omo.useRef)(null);
    const showNthUserOnboardingFlag = (0, $42omo.useCallback)((nthUserGSPage)=>{
        setOnboardingState({
            key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_FLAG_VIEWED,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewNthUserOnboardingFlag'
            }
        }).fire();
        const handleActionClick = ()=>{
            if (dismissFlag.current) dismissFlag.current();
            push(nthUserGSPage);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'flag',
                    actionSubjectId: flagId,
                    source: 'homepage'
                }
            }).fire();
        };
        dismissFlag.current = showFlag({
            id: flagId,
            testId: 'nth-user-onboarding-flag',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                label: $e71baba61e1a588e$var$messages.nthUserOnboardingFlagLabel.defaultMessage
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagContent),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagAction),
                    onClick: handleActionClick
                }
            ],
            onDismissed: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'dismissed',
                        actionSubject: 'flag',
                        actionSubjectId: flagId,
                        source: 'homepage'
                    }
                }).fire();
            }
        });
    }, [
        showFlag,
        setOnboardingState,
        push,
        flagId,
        createAnalyticsEvent
    ]);
    return {
        showNthUserOnboardingFlag: showNthUserOnboardingFlag
    };
};
const $e71baba61e1a588e$var$NthUserOnboardingFlagInner = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_FLAG_VIEWED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH
    ]);
    const deserializedState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { showNthUserOnboardingFlag: showNthUserOnboardingFlag } = $e71baba61e1a588e$var$useNthUserOnboardingFlag();
    const timestamp = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP];
    const nthUserFlagViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_FLAG_VIEWED];
    const nthUserGSPage = deserializedState[0, $dBcar.IMPROVED_GET_STARTED_NTH_USER_PATH];
    const nthUserOnboardingPageViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_PAGE_VIEWED];
    // Show flag once when all conditions are met
    (0, $42omo.useEffect)(()=>{
        if (!cloudId || !userId) return;
        if (onboardingStateLoading || onboardingStateError || !timestamp || nthUserFlagViewed || nthUserOnboardingPageViewed) return;
        const daysSinceCompletion = (0, $917iu.default)(new Date(), new Date(Number(timestamp)));
        if (daysSinceCompletion < $e71baba61e1a588e$var$DAYS_TO_WAIT_AFTER_ONBOARDING_COMPLETION || !nthUserGSPage) return;
        showNthUserOnboardingFlag(nthUserGSPage);
    }, [
        onboardingStateLoading,
        onboardingStateError,
        nthUserFlagViewed,
        nthUserOnboardingPageViewed,
        nthUserGSPage,
        deserializedState,
        showNthUserOnboardingFlag,
        timestamp,
        cloudId,
        userId
    ]);
    return null;
};
const $e71baba61e1a588e$export$ffbdb4c080ecfc55 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e71baba61e1a588e$var$NthUserOnboardingFlagInner, null));
};
module.exports["extractContentIdFromUrl"] = $e71baba61e1a588e$export$be5b862a7b78a50e;
module.exports["NthUserOnboardingFlag"] = $e71baba61e1a588e$export$ffbdb4c080ecfc55;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $42omo.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $42omo.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $42omo.useCallback)((currentThreadKey)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey) : orderedActiveAnnotations?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $42omo.useCallback)((markerRef)=>{
        if ((pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? footerCommentThreads.length === 0 : true)) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                const createButton = document.querySelector('#create-inline-comment-button');
                // if the disabled attribute is there, and comes back as an empty string, it is disabled.
                // If the disabled attribute is not there, it will come back as null
                const createButtonIsDisabled = createButton?.getAttribute('disabled') === '';
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if ((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? createButtonIsEnabled : !createButtonIsDisabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('renderer-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                if ((0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)) // Same logic as the else statement below, just a shared function now. Gated for extra safety
                (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
                else {
                    openComment.setAttribute('tabIndex', '-1');
                    openComment.focus();
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("fyPYm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $5SaYG = parcelRequire("5SaYG");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $5SaYG.ContentViewedEventQuery),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("5SaYG", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c8189816457a0210$export$4dc4e51ac72e6b33 = (0, $eSUdr.default)`query ContentViewedEventQuery($contentId:ID){content(id:$contentId trigger:"viewed"){nodes{id}}}`;
module.exports["ContentViewedEventQuery"] = $c8189816457a0210$export$4dc4e51ac72e6b33;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("cnSnX"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("cnSnX", function(module, exports) {

let $9041d1d94ad86be6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9041d1d94ad86be6$var$load("6mkG4").then(()=>parcelRequire('6vx1i'));

});

parcelRegister("8amSw", function(module, exports) {
$parcel$export(module.exports, "CustomFooterLoader", () => (parcelRequire("5Kicp")).CustomFooterLoader);
$parcel$export(module.exports, "CUSTOM_HEADER_FOOTER_TYPES", () => (parcelRequire("lvV7v")).CUSTOM_HEADER_FOOTER_TYPES);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $5Kicp = parcelRequire("5Kicp");


var $lvV7v = parcelRequire("lvV7v");


const $b4c0f70deb5f986b$export$c002ebd7506cf24 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3f0hi",
    name: "CustomHeaderFooterLoader",
    loader: async ()=>(await (parcelRequire("lGD7r"))).CustomHeaderFooter
});

const $b4c0f70deb5f986b$export$abd9d7fbad77ffb4 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "gCcak",
    name: "CustomHeaderFooterBackgroundLoader",
    loader: async ()=>(await (parcelRequire("lGD7r"))).CustomHeaderFooter
});
module.exports["CustomHeaderFooterLoader"] = $b4c0f70deb5f986b$export$c002ebd7506cf24;

});

parcelRegister("lGD7r", function(module, exports) {

let $fc9bdd750324835d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc9bdd750324835d$var$load("i4xbo"),
    $fc9bdd750324835d$var$load("bVl1P")
]).then(()=>parcelRequire('hnY2b'));

});

parcelRegister("5Kicp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5569da3fa8611ea0$export$1b96833712e15d56 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "n-Upm",
    name: "CustomFooterLoader",
    loader: async ()=>(await (parcelRequire("lGD7r"))).CustomHeaderFooter
});
module.exports["CustomFooterLoader"] = $5569da3fa8611ea0$export$1b96833712e15d56;

});

parcelRegister("lvV7v", function(module, exports) {
const $f7cada3b80c5d028$export$c16b69b19b9f847 = {
    HEADER: 'header',
    FOOTER: 'footer'
};
module.exports["CUSTOM_HEADER_FOOTER_TYPES"] = $f7cada3b80c5d028$export$c16b69b19b9f847;

});

parcelRegister("4yKPM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $508846ea2a5b6903$export$1c961952eacaae6a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BrZ9o",
    name: "InlineCommentsHighlighterLoader",
    loader: async ()=>(await (parcelRequire("gZ44I"))).InlineCommentsHighlighter
});
module.exports["InlineCommentsHighlighterLoader"] = $508846ea2a5b6903$export$1c961952eacaae6a;

});

parcelRegister("gZ44I", function(module, exports) {

let $c5d581172462133c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5d581172462133c$var$load("i4xbo"),
    $c5d581172462133c$var$load("i8eeg"),
    $c5d581172462133c$var$load("iFdoJ"),
    $c5d581172462133c$var$load("8LtYa"),
    $c5d581172462133c$var$load("iGCP8"),
    $c5d581172462133c$var$load("7EorR"),
    $c5d581172462133c$var$load("9qfB8"),
    $c5d581172462133c$var$load("loqJg"),
    $c5d581172462133c$var$load("cGAab")
]).then(()=>parcelRequire('c2Ip8'));

});

parcelRegister("jhifQ", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $56fbb6365252754d$export$f8c96a5c7f3b43a6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FOCUSED_INLINE_COMMENT_SEGMENT_KEY)
});
const $56fbb6365252754d$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
module.exports["FOCUSED_INLINE_COMMENT_METRIC"] = $56fbb6365252754d$export$f8c96a5c7f3b43a6;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $56fbb6365252754d$export$ac7f79e65475cee7;

});

parcelRegister("39nIX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $io723 = parcelRequire("io723");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("l5G5P"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("l5G5P"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("l5G5P"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("l5G5P"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $9wGTI = parcelRequire("9wGTI");


var $2XqLN = parcelRequire("2XqLN");


var $1cfRh = parcelRequire("1cfRh");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $2XqLN.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r12b0 _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId)
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102ewadc _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hiS1z = parcelRequire("hiS1z");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv6wadc _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $9hlns = parcelRequire("9hlns");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
                "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("l5G5P", function(module, exports) {

let $f5aab760e9d382b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5aab760e9d382b0$var$load("dvUU0"),
    $f5aab760e9d382b0$var$load("cLmw6"),
    $f5aab760e9d382b0$var$load("i8eeg"),
    $f5aab760e9d382b0$var$load("iFdoJ"),
    $f5aab760e9d382b0$var$load("6wr18"),
    $f5aab760e9d382b0$var$load("bfveI"),
    $f5aab760e9d382b0$var$load("lNrIG"),
    $f5aab760e9d382b0$var$load("cKqFC"),
    $f5aab760e9d382b0$var$load("6cnH1"),
    $f5aab760e9d382b0$var$load("h9Ed7"),
    $f5aab760e9d382b0$var$load("lkOIY"),
    $f5aab760e9d382b0$var$load("dI1Cd"),
    $f5aab760e9d382b0$var$load("7EorR"),
    $f5aab760e9d382b0$var$load("ffEVr"),
    $f5aab760e9d382b0$var$load("3JSgG"),
    $f5aab760e9d382b0$var$load("43bid"),
    $f5aab760e9d382b0$var$load("dP7ao"),
    $f5aab760e9d382b0$var$load("8ublV"),
    $f5aab760e9d382b0$var$load("enrPB"),
    $f5aab760e9d382b0$var$load("fnlWy"),
    $f5aab760e9d382b0$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("aXika", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $4zbo1 = parcelRequire("4zbo1");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $2VQ4B = parcelRequire("2VQ4B");


var $io723 = parcelRequire("io723");


var $essql = parcelRequire("essql");


var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");


var $iuaOs = parcelRequire("iuaOs");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData, isEmbeddedPage: isEmbeddedPage })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view'
        }
    });
    const extractDataAndSetPublishedVersion = (0, $42omo.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const contentQueryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: !contentId || !spaceKey,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true
        }
    });
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $42omo.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true)) {
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
            // `documentNeedsUpdate` is set to true whenever we set a new
            // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
            // This useEffect can be cleaned up after v2 is fully rolled out.
            setDocumentNeedsUpdate(false);
        }
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $42omo.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $42omo.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch({
                contentId: contentId,
                timestamp: Date.now()
            });
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    const content = contentQueryResult.data?.content?.nodes?.[0];
    const fabricEditorSupported = contentQueryResult.loading ? null : content?.metadata?.frontend?.fabricEditorSupported ?? null;
    const bodyRepresentation = contentQueryResult.loading ? null : content?.body?.dynamic?.representation ?? null;
    (0, $iuaOs.useContentReloadOnFabricSupportChange)({
        contentId: contentId,
        fabricEditorSupported: fabricEditorSupported,
        bodyRepresentation: bodyRepresentation,
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'commentsDataManager',
        types: [
            (0, $c0urc.ReloadType).comment
        ],
        reload: async ()=>{
            if ((0, $6mKj3.expValEquals)('cc_comments_pubsub_flag_click_observer', 'isEnabled', true) && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        },
        priority: (0, $c0urc.ReloadPriority).background
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        versionOverride: versionOverride,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("article", null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        }))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("9Q3jD", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4uSkp = parcelRequire("4uSkp");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $iPRuY = parcelRequire("iPRuY");

const $fb83eb4a10554029$export$69ad3f5eb9aa63a1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = (error)=>{
            const isTimeoutError = error?.toString().includes("SocketTimeoutException");
            if (isTimeoutError) experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error
            });
            else experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error.message
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const handleTimeoutError = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = (error_0)=>{
            const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith("4");
            if (isUserError) experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error_0.message
            });
            else experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error_0
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
            throw error_0;
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const handleUnexpectedError = t2;
    let t3;
    if ($[4] !== children || $[5] !== contentQueryResult || $[6] !== handleTimeoutError || $[7] !== handleUnexpectedError || $[8] !== route || $[9] !== versionOverride) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPRuY.ContentPrerequisites), {
            route: route,
            contentQueryResult: contentQueryResult,
            versionOverride: versionOverride,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError
        }, children));
        $[4] = children;
        $[5] = contentQueryResult;
        $[6] = handleTimeoutError;
        $[7] = handleUnexpectedError;
        $[8] = route;
        $[9] = versionOverride;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleTimeoutError = (error)=>{
        const isTimeoutError = error?.toString().includes('SocketTimeoutException');
        if (isTimeoutError) experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error
        });
        else experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error.message
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleUnexpectedError = (error_0)=>{
        const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith('4');
        if (isUserError) experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error_0.message
        });
        else experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error_0
        });
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        throw error_0; // Throw to propagate to error boundary - otherwise just shows a blank screen
    };
    // When unauthorized and viewing a restricted page, user is prompted
    // with SuperAdmin gateway
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPRuY.ContentPrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError
    }, children));
};
module.exports["PagePrerequisites"] = $fb83eb4a10554029$export$69ad3f5eb9aa63a1;

});

parcelRegister("4uSkp", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $cTt7H = parcelRequire("cTt7H");


var $1uFM6 = parcelRequire("1uFM6");


var $9xNes = parcelRequire("9xNes");


var $f3euL = parcelRequire("f3euL");


var $ep3mz = parcelRequire("ep3mz");


var $2k9aV = parcelRequire("2k9aV");


var $c4ECQ = parcelRequire("c4ECQ");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lfFzM = parcelRequire("lfFzM");


var $iPPFu = parcelRequire("iPPFu");

function $34641b344ae1099e$export$27cc57004471e91(hasDirectRestrictions, hasPageInheritedRestrictions, hasSpaceRestrictions) {
    // multiple restrictions = at least two.
    const hasMultipleRestrictions = hasDirectRestrictions ? hasPageInheritedRestrictions || hasSpaceRestrictions : hasPageInheritedRestrictions && hasSpaceRestrictions;
    if (hasMultipleRestrictions) return (0, $c4ECQ.RestrictionFrom).MULTIPLE;
    if (hasDirectRestrictions) return (0, $c4ECQ.RestrictionFrom).DIRECT;
    if (hasPageInheritedRestrictions) return (0, $c4ECQ.RestrictionFrom).PAGE_INHERITED;
    if (hasSpaceRestrictions) return (0, $c4ECQ.RestrictionFrom).SPACE;
    return (0, $c4ECQ.RestrictionFrom).NONE;
}
const $34641b344ae1099e$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_CONFIRMATION_PAGE'
};
class $34641b344ae1099e$export$92eba4cf4af6c314 extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.checkConsentToViewPage();
    }
    componentDidUpdate() {
        this.checkConsentToViewPage();
    }
    checkConsentToViewPage() {
        const localStorageValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
        if (!localStorageValue) {
            this.setState({
                restrictedPageViewConfirmed: false
            });
            return;
        }
        // Set the state if it matches so we can skip rendering the confirmation.
        if (String(localStorageValue) === this.props.contentId) this.setState({
            restrictedPageViewConfirmed: true
        });
        else {
            // This means the user is on a different page currently. Can safely
            // delete the entry now so we can render the confirmation again if the
            // former page is accessed again.
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
            this.setState({
                restrictedPageViewConfirmed: false
            });
        }
    }
    render() {
        const { children: children, contentId: contentId } = this.props;
        if (!contentId) // in this case children renders ContentPrerequisites which shows the appropriate 404 page
        return children;
        const { restrictedPageViewConfirmed: restrictedPageViewConfirmed } = this.state;
        if (restrictedPageViewConfirmed) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfFzM.AdminKeyQuery), null, ({ loading: loading, error: error, isSuperAdmin: isSuperAdmin })=>{
            if (loading) return null;
            if (error) throw error;
            if (!isSuperAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $iPPFu.ViewPageGatewayQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: "network-only",
                context: {
                    asSuperAdmin: false
                }
            }, ({ loading: loading, error: error })=>{
                if (loading) return null;
                // render confirmation if the user is accessing a restricted
                // page and has not already confirmed viewing the page
                if (error && !restrictedPageViewConfirmed && (0, $1uFM6.isUnauthorizedError)(error)) return this.renderRestrictedPageConfirmation();
                return children;
            });
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            restrictedPageViewConfirmed: false
        };
        this.onRestrictedPageViewConfirmClick = ()=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED, this.props.contentId);
            // Set the state regardles of localstorage setItem succeeding or not so we
            // can render the page.
            this.setState({
                restrictedPageViewConfirmed: true
            });
        };
        this.renderRestrictedPageConfirmation = ()=>{
            const { contentId: contentId, spaceKey: spaceKey } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2k9aV.RestrictionsCheck), {
                contentId: contentId,
                spaceKey: spaceKey
            }, ({ hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, isSpaceRestricted: isSpaceRestricted, loading: loading, error: error })=>{
                // TODO: handled in upper layer when confluence_restrictions_fix is enabled
                if (loading) return null;
                if (error) throw error;
                const restrictionFromType = $34641b344ae1099e$export$27cc57004471e91(hasDirectViewRestrictions, hasInheritedViewRestrictions, isSpaceRestricted);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xNes.RestrictedPageConfirmation), {
                    restrictionFromType: restrictionFromType,
                    onViewPageClick: this.onRestrictedPageViewConfirmClick
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTt7H.PageLoadEnd), {
                    metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
                    customData: {
                        contentId: contentId,
                        ...$34641b344ae1099e$var$CUSTOM_ATTRIBUTES
                    }
                }));
            });
        };
    }
}
$34641b344ae1099e$export$92eba4cf4af6c314.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
const $34641b344ae1099e$export$35cf1eab48371b15 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageSubscriber), null, (t2)=>{
            const { contentId: contentId, spaceKey: spaceKey } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34641b344ae1099e$export$92eba4cf4af6c314, {
                contentId: contentId,
                spaceKey: spaceKey
            }, children);
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$34641b344ae1099e$export$35cf1eab48371b15.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
module.exports["ViewPageGateway"] = $34641b344ae1099e$export$35cf1eab48371b15;

});

parcelRegister("9xNes", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4667b31838ac7b2c$export$8c5f260af94a9e2e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tXIbI",
    name: "RestrictedPageConfirmation",
    loader: async ()=>(await (parcelRequire("lc1Zh"))).RestrictedPageConfirmation
});
module.exports["RestrictedPageConfirmation"] = $4667b31838ac7b2c$export$8c5f260af94a9e2e;

});

parcelRegister("lc1Zh", function(module, exports) {

let $f6dc429e451ecb75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6dc429e451ecb75$var$load("37xVM").then(()=>parcelRequire('7NZoR'));

});

parcelRegister("2k9aV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $80NaV = parcelRequire("80NaV");


var $fG32j = parcelRequire("fG32j");

const $d8539e55a4f27a93$export$26883b91564da8f7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = (t2)=>{
            const { error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted, loading: spaceRestrictionCheckIsLoading } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80NaV.PageViewRestrictions), null, (t3)=>{
                const { error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, loading: pageViewRestrictionsIsLoading } = t3;
                return children({
                    error: spaceRestrictionCheckError || pageViewRestrictionsError,
                    hasDirectViewRestrictions: hasDirectViewRestrictions,
                    hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                    isSpaceRestricted: isSpaceRestricted,
                    loading: spaceRestrictionCheckIsLoading || pageViewRestrictionsIsLoading || false
                });
            });
        };
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== spaceKey || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
            asSuperAdmin: false,
            spaceKey: spaceKey
        }, t1);
        $[2] = spaceKey;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        asSuperAdmin: false,
        spaceKey: spaceKey
    }, ({ error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted, loading: spaceRestrictionCheckIsLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80NaV.PageViewRestrictions), null, ({ error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, loading: pageViewRestrictionsIsLoading })=>children({
                error: spaceRestrictionCheckError || pageViewRestrictionsError,
                hasDirectViewRestrictions: hasDirectViewRestrictions,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                isSpaceRestricted: isSpaceRestricted,
                loading: spaceRestrictionCheckIsLoading || pageViewRestrictionsIsLoading || false
            })));
module.exports["RestrictionsCheck"] = $d8539e55a4f27a93$export$26883b91564da8f7;

});

parcelRegister("80NaV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jLw6A = parcelRequire("jLw6A");


var $6mKj3 = parcelRequire("6mKj3");

const $ac3796b23ede5ce7$export$6bf9ddef68460137 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PageViewRestrictions(t0) {
    const $ = (0, $frIzR.c)(11);
    const { children: children } = t0;
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    if ((0, $6mKj3.expVal)("confluence_restrictions_fix", "isEnabled", false)) {
        const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
        const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        if (loading) return null;
        let t1;
        if ($[0] !== children || $[1] !== error || $[2] !== hasDirectViewRestrictions || $[3] !== hasInheritedViewRestrictions) {
            t1 = children({
                error: error,
                hasDirectViewRestrictions: hasDirectViewRestrictions,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions
            });
            $[0] = children;
            $[1] = error;
            $[2] = hasDirectViewRestrictions;
            $[3] = hasInheritedViewRestrictions;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    } else {
        let hasDirectViewRestrictions_0;
        let hasInheritedViewRestrictions_0;
        if (!loading) {
            hasDirectViewRestrictions_0 = Boolean(restrictions?.hasViewRestrictions);
            hasInheritedViewRestrictions_0 = Boolean(restrictions?.hasInheritedRestrictions);
        }
        let t1;
        if ($[5] !== children || $[6] !== error || $[7] !== hasDirectViewRestrictions_0 || $[8] !== hasInheritedViewRestrictions_0 || $[9] !== loading) {
            t1 = children({
                error: error,
                hasDirectViewRestrictions: hasDirectViewRestrictions_0,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions_0,
                loading: loading
            });
            $[5] = children;
            $[6] = error;
            $[7] = hasDirectViewRestrictions_0;
            $[8] = hasInheritedViewRestrictions_0;
            $[9] = loading;
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
} : function PageViewRestrictions({ children: children }) {
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
        const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        if (loading) return null;
        return children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions
        });
    } else {
        let hasDirectViewRestrictions_0;
        let hasInheritedViewRestrictions_0;
        if (!loading) {
            hasDirectViewRestrictions_0 = Boolean(restrictions?.hasViewRestrictions);
            hasInheritedViewRestrictions_0 = Boolean(restrictions?.hasInheritedRestrictions);
        }
        return children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions_0,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions_0,
            loading: loading
        });
    }
};
module.exports["PageViewRestrictions"] = $ac3796b23ede5ce7$export$6bf9ddef68460137;

});

parcelRegister("iPPFu", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $db6511a61fa44cc3$export$aaf44510d6f97779 = (0, $eSUdr.default)`query ViewPageGatewayQuery($contentId:ID){content(id:$contentId){nodes{id status}}}`;
module.exports["ViewPageGatewayQuery"] = $db6511a61fa44cc3$export$aaf44510d6f97779;

});

parcelRegister("iPRuY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9inwL = parcelRequire("9inwL");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");



var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $kE2cJ = parcelRequire("kE2cJ");


var $hpnxK = parcelRequire("hpnxK");



var $hNtOj = parcelRequire("hNtOj");


var $dPJCf = parcelRequire("dPJCf");


var $frfjk = parcelRequire("frfjk");


var $gMFJB = parcelRequire("gMFJB");


var $llOcx = parcelRequire("llOcx");


var $jH9vM = parcelRequire("jH9vM");


var $iElL7 = parcelRequire("iElL7");

const $eb18cf4dc4cf4350$var$useContentPrerequisites = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, skip: skip } = t0;
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    const missingContentSSR = undefined;
    const contentQueryResultCheck = (0, $9wGTI.fg)("use_content_query_result_data_error") ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    let t1;
    if ($[0] !== contentId || $[1] !== missingSpaceKey || $[2] !== spaceKey) {
        t1 = {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey
        };
        $[0] = contentId;
        $[1] = missingSpaceKey;
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== skipContentPrerequisites || $[5] !== t1) {
        t2 = {
            errorPolicy: "all",
            variables: t1,
            skip: skipContentPrerequisites
        };
        $[4] = skipContentPrerequisites;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), t2);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentIdLoading: contentIdLoading } = t3;
    const loading = queryLoading || contentIdLoading;
    if ((!data || missingContentId) && loading) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                isLoading: true
            };
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes("SocketTimeoutException");
    if (error && (0, $1uFM6.isUnauthorizedError)(error) || isEmptyContent) {
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
        if (isEmptyContent && true) createAnalyticsEvent({
            type: "sendOperationalEvent",
            data: {
                source: "ContentPrerequisites",
                action: "returnedEmpty",
                actionSubject: "content",
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        let t4;
        if ($[8] !== error) {
            t4 = {
                error: error,
                isRestricted: true
            };
            $[8] = error;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== data?.content?.nodes) {
        t4 = data?.content?.nodes || [];
        $[10] = data?.content?.nodes;
        $[11] = t4;
    } else t4 = $[11];
    const content = t4;
    const shouldHandleErrors = !!error;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(error)) {
        let t5;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                isNotFound: true
            };
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    const wrongSpaceKeyOnSSR = undefined;
    let t5;
    if ($[13] !== error) {
        t5 = error && (0, $hpnxK.isNotFoundSpaceError)(error);
        $[13] = error;
        $[14] = t5;
    } else t5 = $[14];
    const notFoundSpaceError = t5;
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        const t6 = `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`;
        let t7;
        if ($[15] !== expectedSpaceKey || $[16] !== t6) {
            t7 = {
                isRedirect: true,
                redirectSpaceKey: expectedSpaceKey,
                redirectReason: t6
            };
            $[15] = expectedSpaceKey;
            $[16] = t6;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    if (error && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(error);
        let t6;
        if ($[18] !== error) {
            t6 = {
                error: error,
                isTimeoutError: true
            };
            $[18] = error;
            $[19] = t6;
        } else t6 = $[19];
        return t6;
    }
    if (error && handleUnexpectedError) {
        handleUnexpectedError(error);
        let t6;
        if ($[20] !== error) {
            t6 = {
                error: error,
                isUnexpectedError: true
            };
            $[20] = error;
            $[21] = t6;
        } else t6 = $[21];
        return t6;
    }
    let t6;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {};
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : ({ spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, skip: skip })=>{
    // Redirect legacy url which doesn't have spaceKey
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    // Content is considered missing when we attempted to use contentQueryResult but no data
    // is available due to known or unknown errors. This is only applicable for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const missingContentSSR = undefined;
    // We need to check for "data" or "error" existence in contentQueryResult and not just the existence of contentQueryResult,
    // since this object is the query result from Apollo and it might be present but with no data or error such as { variables: fn, refetch: fn }
    const contentQueryResultCheck = (0, $9wGTI.fg)('use_content_query_result_data_error') ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey
        },
        skip: skipContentPrerequisites
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const loading = queryLoading || contentIdLoading;
    if ((!data || missingContentId) && loading) return {
        isLoading: true
    };
    // Known Apollo bug: Errors are not saved within Apollo in-memory cache
    // https://github.com/apollographql/apollo-client/issues/4806. For restricted spaces and pages,
    // the 403 error is subsequently undefined after retrieval attempt. Restricted spaces means
    // content will be null, but the error might be undefined.
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes('SocketTimeoutException');
    if (error && (0, $1uFM6.isUnauthorizedError)(error) || isEmptyContent) {
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isEmptyContent && true) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'ContentPrerequisites',
                action: 'returnedEmpty',
                actionSubject: 'content',
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        return {
            error: error,
            isRestricted: true
        };
    }
    // Catch all for errors, no content and calls that return null/undefined
    // If FF is on, this catches Not Found errors (404) and other errors are handled below
    const content = data?.content?.nodes || [];
    const shouldHandleErrors = !!error;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(error)) return {
        isNotFound: true
    };
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    // Checks for case where old / wrong spacekey is provided causing reload
    // on SSR -> SPA transition once the ContentRedirectQuery resolves.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const wrongSpaceKeyOnSSR = undefined;
    const notFoundSpaceError = error && (0, $hpnxK.isNotFoundSpaceError)(error);
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            isRedirect: true,
            redirectSpaceKey: expectedSpaceKey,
            redirectReason: `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`
        };
    }
    if (error && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(error);
        return {
            error: error,
            isTimeoutError: true
        };
    }
    if (error && handleUnexpectedError) {
        handleUnexpectedError(error);
        return {
            error: error,
            isUnexpectedError: true
        };
    }
    return {};
};
const $eb18cf4dc4cf4350$export$1ff4591c5a23ba79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: t1, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, versionOverride: versionOverride } = t0;
    const passThroughOnLoading = t1 === undefined ? false : t1;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentQueryResult || $[2] !== handleTimeoutError || $[3] !== handleUnexpectedError || $[4] !== spaceKey) {
        t2 = {
            spaceKey: spaceKey,
            contentId: contentId,
            contentQueryResult: contentQueryResult,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError
        };
        $[0] = contentId;
        $[1] = contentQueryResult;
        $[2] = handleTimeoutError;
        $[3] = handleUnexpectedError;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites(t2);
    if (prerequisites.isNotFound) {
        let t3;
        if ($[6] !== contentId || $[7] !== route || $[8] !== spaceKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $frfjk.NotFoundContainer), {
                route: route,
                spaceKey: spaceKey,
                contentId: contentId
            });
            $[6] = contentId;
            $[7] = route;
            $[8] = spaceKey;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    let t3;
    if ($[10] !== children || $[11] !== contentId || $[12] !== isTransition || $[13] !== passThroughOnLoading || $[14] !== prerequisites.error || $[15] !== prerequisites.isLoading || $[16] !== prerequisites.isRedirect || $[17] !== prerequisites.isRestricted || $[18] !== prerequisites.isTimeoutError || $[19] !== prerequisites.redirectReason || $[20] !== prerequisites.redirectSpaceKey || $[21] !== route || $[22] !== spaceKey) {
        t3 = ()=>{
            if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === "view") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
            });
            if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
            if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
            });
            if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
                name: route.name,
                reason: prerequisites.redirectReason,
                params: {
                    contentId: contentId,
                    spaceKey: prerequisites.redirectSpaceKey
                }
            });
            if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iElL7.TimeoutErrorScreen), {
                contentId: contentId,
                spaceKey: spaceKey
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
        };
        $[10] = children;
        $[11] = contentId;
        $[12] = isTransition;
        $[13] = passThroughOnLoading;
        $[14] = prerequisites.error;
        $[15] = prerequisites.isLoading;
        $[16] = prerequisites.isRedirect;
        $[17] = prerequisites.isRestricted;
        $[18] = prerequisites.isTimeoutError;
        $[19] = prerequisites.redirectReason;
        $[20] = prerequisites.redirectSpaceKey;
        $[21] = route;
        $[22] = spaceKey;
        $[23] = t3;
    } else t3 = $[23];
    const getContentComponent = t3;
    let t4;
    if ($[24] !== versionOverride) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jH9vM.ContentRedirect), {
            versionOverride: versionOverride
        });
        $[24] = versionOverride;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== getContentComponent) {
        t5 = getContentComponent();
        $[26] = getContentComponent;
        $[27] = t5;
    } else t5 = $[27];
    let t6;
    if ($[28] !== t4 || $[29] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t5);
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
    } else t6 = $[30];
    return t6;
} : ({ children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: passThroughOnLoading = false, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, versionOverride: versionOverride })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites({
        spaceKey: spaceKey,
        contentId: contentId,
        contentQueryResult: contentQueryResult,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError
    });
    if (prerequisites.isNotFound) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $frfjk.NotFoundContainer), {
        route: route,
        spaceKey: spaceKey,
        contentId: contentId
    });
    const getContentComponent = ()=>{
        if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'view') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
        });
        if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
        if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
        });
        if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: route.name,
            reason: prerequisites.redirectReason,
            params: {
                contentId: contentId,
                spaceKey: prerequisites.redirectSpaceKey
            }
        });
        if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iElL7.TimeoutErrorScreen), {
            contentId: contentId,
            spaceKey: spaceKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jH9vM.ContentRedirect), {
        versionOverride: versionOverride
    }), getContentComponent());
};
function $eb18cf4dc4cf4350$var$getAccessType(error) {
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
}
module.exports["ContentPrerequisites"] = $eb18cf4dc4cf4350$export$1ff4591c5a23ba79;

});

parcelRegister("hpnxK", function(module, exports) {
const $88d658a04ba6cccf$export$bb4f02e6ef6f6e17 = (error)=>error.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $88d658a04ba6cccf$export$bb4f02e6ef6f6e17;

});

parcelRegister("frfjk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $b2p4s = parcelRequire("b2p4s");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $lt6Lx = parcelRequire("lt6Lx");


var $3IBnw = parcelRequire("3IBnw");


var $f9jv7 = parcelRequire("f9jv7");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $wtSEP = parcelRequire("wtSEP");


var $3WD5B = parcelRequire("3WD5B");


var $kE2cJ = parcelRequire("kE2cJ");


var $gMFJB = parcelRequire("gMFJB");

const $4bb6cb1596a8393b$export$32fe640941018446 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { route: route, spaceKey: spaceKey, contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? "";
        $[0] = t1;
    } else t1 = $[0];
    const urlDraftShareId = t1;
    const t2 = contentId ?? "";
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "draft"
        ];
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== t2) {
        t4 = {
            contentId: t2,
            draftShareId: urlDraftShareId,
            status: t3
        };
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE);
    let t6;
    if ($[4] !== t4 || $[5] !== t5) {
        t6 = {
            variables: t4,
            skip: t5,
            fetchPolicy: window.__SSR_RENDERED__ ? "cache-only" : "cache-and-network",
            onError: $4bb6cb1596a8393b$var$_temp
        };
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), t6);
    let t7;
    if ($[7] !== contentId || $[8] !== data?.content?.nodes?.[0]?.links?.webui || $[9] !== data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value || $[10] !== spaceKey) {
        t7 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
            const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === "\"v2\"";
            if (isFabric && draftShareId) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
                    href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: "pages"
                    }, {
                        query: {
                            draftShareId: draftShareId
                        }
                    })
                });
                break bb0;
            }
        }
        $[7] = contentId;
        $[8] = data?.content?.nodes?.[0]?.links?.webui;
        $[9] = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value;
        $[10] = spaceKey;
        $[11] = t7;
    } else t7 = $[11];
    if (t7 !== Symbol.for("react.early_return_sentinel")) return t7;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
            notFound: true
        });
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== route || $[14] !== spaceKey) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, t8, route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WD5B.OverviewNotFound), {
            spaceKey: spaceKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
        $[13] = route;
        $[14] = spaceKey;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ route: route, spaceKey: spaceKey, contentId: contentId })=>{
    // View page URLs inserted by the `/Create Confluence page` extension will include draftShareId
    const urlDraftShareId = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? '';
    /*
   * If we've hit this component, the page may actually be an unpublished draft,
   * if so then redirect to the editor given the user has edit permission
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), {
        variables: {
            contentId: contentId ?? '',
            draftShareId: urlDraftShareId,
            status: [
                'draft'
            ]
        },
        skip: !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE),
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-only' : 'cache-and-network',
        onError: (error)=>{
            if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Query result will include draftShareId if the page is a draft
    const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
    const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === '"v2"';
    if (isFabric && draftShareId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        }, {
            query: {
                draftShareId: draftShareId
            }
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WD5B.OverviewNotFound), {
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
};
function $4bb6cb1596a8393b$var$_temp(error) {
    if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["NotFoundContainer"] = $4bb6cb1596a8393b$export$32fe640941018446;

});

parcelRegister("3WD5B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $122d2f3e6774c3f2$export$df359d26db880cab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AHMpB",
    name: "OverviewNotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("gIFNV"))).OverviewNotFound
});
module.exports["OverviewNotFound"] = $122d2f3e6774c3f2$export$df359d26db880cab;

});

parcelRegister("gIFNV", function(module, exports) {

let $c2c12edfbcd611b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2c12edfbcd611b9$var$load("bn8Oy").then(()=>parcelRequire('bDiji'));

});

parcelRegister("gMFJB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $d38ee66b6872a958$export$ffe4f7ef348542da = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
module.exports["ContentExpansionContainer"] = $d38ee66b6872a958$export$ffe4f7ef348542da;

});

parcelRegister("llOcx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lt6Lx = parcelRequire("lt6Lx");


var $88O8D = parcelRequire("88O8D");


var $6MSEP = parcelRequire("6MSEP");


var $gMFJB = parcelRequire("gMFJB");

const $3d886ddd51b4b1de$export$6af94d617557e778 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $88O8D.LoginIfAnonymous), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
            siteTitleOnly: true
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), props)));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $88O8D.LoginIfAnonymous), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        siteTitleOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), props))));
module.exports["UnauthorizedScreen"] = $3d886ddd51b4b1de$export$6af94d617557e778;

});

parcelRegister("88O8D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $kE2cJ = parcelRequire("kE2cJ");


var $bQm3c = parcelRequire("bQm3c");


var $jEeDd = parcelRequire("jEeDd");

const $d2b0786819b3899c$export$cd1cc7f28314b96a = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    return userId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $jEeDd.getLoginLink)(),
        usePush: (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()
    });
};
module.exports["LoginIfAnonymous"] = $d2b0786819b3899c$export$cd1cc7f28314b96a;

});

parcelRegister("jH9vM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4uNpa = parcelRequire("4uNpa");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $cb6fO = parcelRequire("cb6fO");


var $bFVuH = parcelRequire("bFVuH");

const $5b842fead80f6623$export$2ca6584fed43f61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { versionOverride: versionOverride } = t0;
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey } = t1;
    let t2;
    if ($[0] !== contentId || $[1] !== versionOverride) {
        t2 = {
            contentId: contentId,
            versionOverride: versionOverride
        };
        $[0] = contentId;
        $[1] = versionOverride;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            single: true
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = {
            errorPolicy: "all",
            variables: t2,
            context: t3
        };
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), t4);
    if (loading) return null;
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    let t5;
    if ($[6] !== content || $[7] !== space?.alias || $[8] !== space?.key || $[9] !== title) {
        t5 = content && {
            ...content,
            slug: (0, $cb6fO.generateSlug)(title),
            spaceKey: space?.alias || space?.key,
            createdDate: content?.history?.createdDate
        };
        $[6] = content;
        $[7] = space?.alias;
        $[8] = space?.key;
        $[9] = title;
        $[10] = t5;
    } else t5 = $[10];
    const contentWithSlug = t5;
    let t6;
    if ($[11] !== contentSlug || $[12] !== contentWithSlug || $[13] !== space || $[14] !== spaceKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFVuH.ContentRedirectComponent), {
            contentSlugInUrl: contentSlug,
            contentWithSlug: contentWithSlug,
            space: space,
            spaceKeyInUrl: spaceKey
        });
        $[11] = contentSlug;
        $[12] = contentWithSlug;
        $[13] = space;
        $[14] = spaceKey;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ versionOverride: versionOverride })=>{
    const [{ contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        },
        context: {
            single: true
        }
    });
    if (loading) return null;
    // UnauthorizedError is a special case here since no specific UI are required for it.
    // In case of an UnauthorizedError the data or content are expected to be empty, and
    // ContentRedirectComponent will handle such case properly.
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    const contentWithSlug = content && {
        ...content,
        slug: (0, $cb6fO.generateSlug)(title),
        spaceKey: space?.alias || space?.key,
        createdDate: content?.history?.createdDate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFVuH.ContentRedirectComponent), {
        contentSlugInUrl: contentSlug,
        contentWithSlug: contentWithSlug,
        space: space,
        spaceKeyInUrl: spaceKey
    });
};
module.exports["ContentRedirect"] = $5b842fead80f6623$export$2ca6584fed43f61;

});

parcelRegister("bFVuH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $6HckY = parcelRequire("6HckY");


var $kE2cJ = parcelRequire("kE2cJ");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $3jwuS = parcelRequire("3jwuS");

const $40c3e9fb4beb4b02$export$c859cd2f253879ed = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: t1 } = t0;
    const contentSlugInUrl = t1 === undefined ? "" : t1;
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t2;
    if ($[0] !== contentWithSlug || $[1] !== isLivePage || $[2] !== spaceKeyInUrl) {
        t2 = ()=>{
            if (isLivePage) return false;
            return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
        };
        $[0] = contentWithSlug;
        $[1] = isLivePage;
        $[2] = spaceKeyInUrl;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRedirectIncorrectSpaceKey = t2;
    let t3;
    if ($[4] !== contentSlugInUrl || $[5] !== contentWithSlug?.slug || $[6] !== isLivePage) {
        t3 = ()=>isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || "") !== decodeURIComponent(contentSlugInUrl);
        $[4] = contentSlugInUrl;
        $[5] = contentWithSlug?.slug;
        $[6] = isLivePage;
        $[7] = t3;
    } else t3 = $[7];
    contentWithSlug?.slug;
    const shouldRedirectIncorrectSlug = t3;
    if (!contentWithSlug) return null;
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        let t4;
        if ($[8] !== contentWithSlug || $[9] !== match?.params || $[10] !== routePolicy) {
            t4 = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
            $[8] = contentWithSlug;
            $[9] = match?.params;
            $[10] = routePolicy;
            $[11] = t4;
        } else t4 = $[11];
        const willPushInSelf = t4;
        let t5;
        if ($[12] !== contentWithSlug || $[13] !== willPushInSelf) {
            t5 = willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.SPACE_OVERVIEW).name,
                params: {
                    spaceKey: contentWithSlug.spaceKey,
                    contentId: contentWithSlug.id,
                    contentSlug: contentWithSlug.slug
                }
            }) : null;
            $[12] = contentWithSlug;
            $[13] = willPushInSelf;
            $[14] = t5;
        } else t5 = $[14];
        return t5;
    }
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    let t4;
    if ($[15] !== shouldRedirectIncorrectSpaceKey) {
        t4 = shouldRedirectIncorrectSpaceKey();
        $[15] = shouldRedirectIncorrectSpaceKey;
        $[16] = t4;
    } else t4 = $[16];
    const isIncorrectSpaceKey = t4;
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) {
        const t5 = match?.name;
        const t6 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
        const t7 = match?.params;
        let t8;
        if ($[17] !== contentWithSlug.id || $[18] !== contentWithSlug.slug || $[19] !== contentWithSlug.spaceKey || $[20] !== t7) {
            t8 = {
                ...t7,
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            };
            $[17] = contentWithSlug.id;
            $[18] = contentWithSlug.slug;
            $[19] = contentWithSlug.spaceKey;
            $[20] = t7;
            $[21] = t8;
        } else t8 = $[21];
        const t9 = Boolean(!isIncorrectSlug);
        let t10;
        if ($[22] !== t5 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6HckY.DelayRedirectionOnClient), {
                name: t5,
                reason: t6,
                params: t8,
                skipRouteChange: t9
            });
            $[22] = t5;
            $[23] = t6;
            $[24] = t8;
            $[25] = t9;
            $[26] = t10;
        } else t10 = $[26];
        return t10;
    }
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    const t5 = match?.name;
    const t6 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
    const t7 = match?.params;
    let t8;
    if ($[27] !== contentWithSlug.id || $[28] !== contentWithSlug.slug || $[29] !== contentWithSlug.spaceKey || $[30] !== t7) {
        t8 = {
            ...t7,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        };
        $[27] = contentWithSlug.id;
        $[28] = contentWithSlug.slug;
        $[29] = contentWithSlug.spaceKey;
        $[30] = t7;
        $[31] = t8;
    } else t8 = $[31];
    let t9;
    if ($[32] !== t5 || $[33] !== t6 || $[34] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: t5,
            reason: t6,
            params: t8
        });
        $[32] = t5;
        $[33] = t6;
        $[34] = t8;
        $[35] = t9;
    } else t9 = $[35];
    return t9;
} : ({ contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: contentSlugInUrl = '' })=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldRedirectIncorrectSpaceKey = (0, $42omo.useCallback)(()=>{
        if (isLivePage) /*
       * Live Pages exist on the view page route, but render the Confluence editor
       * The Confluence editor has its own space key redirection logic and move event listeners (via useSpaceKeyWatcher)
       * Consequently this redirection will clash with the redirects from the editor.
       */ return false;
        return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
    }, [
        spaceKeyInUrl,
        contentWithSlug,
        isLivePage
    ]);
    const shouldRedirectIncorrectSlug = (0, $42omo.useCallback)(()=>{
        // When current slug in URL does not match with slug in content ==> slug changed
        // Important to decode when compare because react router decodes the params first
        // so contentSlug will be decoded string
        //
        // Live pages will handle its own redirection logic from content slug
        return isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || '') !== decodeURIComponent(contentSlugInUrl);
    }, [
        contentWithSlug?.slug,
        contentSlugInUrl,
        isLivePage
    ]);
    // Don't redirect if we have insufficient information to successfully redirect the user
    if (!contentWithSlug) return null;
    // Do redirect if we should go back to the Space Home Overview Tab
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        const willPushInSelf = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
        return willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_OVERVIEW).name,
            params: {
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            }
        }) : null;
    }
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    const isIncorrectSpaceKey = shouldRedirectIncorrectSpaceKey();
    // Incorrect slug cannot do redirection in SSR, if there is #anchor fragment in the URL,
    // it will be lost in the redirection, as #anchor fragment is not passed to the server.
    // So we need to do redirection in client side.
    // If the content slug is already fixed in PageState, but URL is incorrect, rewrite URL without
    // triggering route change.
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6HckY.DelayRedirectionOnClient), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        },
        skipRouteChange: Boolean(!isIncorrectSlug)
    });
    // Don't redirect if we otherwise don't need to
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        }
    });
});
module.exports["ContentRedirectComponent"] = $40c3e9fb4beb4b02$export$c859cd2f253879ed;

});

parcelRegister("6HckY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kE2cJ = parcelRequire("kE2cJ");

const $aab50db669fe7470$export$9c627468834548a9 = (props)=>{
    // In client-side rendering, we can directly render the Redirection component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), props);
};
module.exports["DelayRedirectionOnClient"] = $aab50db669fe7470$export$9c627468834548a9;

});

parcelRegister("iElL7", function(module, exports) {

var $lS0xA = parcelRequire("lS0xA");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $inPa6 = parcelRequire("inPa6");


var $8lYIw = parcelRequire("8lYIw");


var $1NBp8 = parcelRequire("1NBp8");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $dc6f00ca158cde35$var$timeoutErrorStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    width: '50%',
    height: '90vh'
});
const $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.500',
    borderRadius: 'radius.large'
});
const $dc6f00ca158cde35$var$headingStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200'
});
const $dc6f00ca158cde35$var$bulletStyles = null;
const $dc6f00ca158cde35$var$i18n = (0, $h82at.defineMessages)({
    heading: {
        id: "content-prerequisites.timeout-error-screen.heading",
        defaultMessage: "Unable to load page"
    },
    resolutionOptions: {
        id: "content-prerequisites.timeout-error-screen.resolution-options",
        defaultMessage: "To resolve this issue, you may want to:"
    },
    reloadPage: {
        id: "content-prerequisites.timeout-error-screen.reload-page",
        defaultMessage: "Reload this page"
    },
    convertToCloudEditor: {
        id: "content-prerequisites.timeout-error-screen.convert-to-cloud-editor",
        defaultMessage: "<EditLink>Return to edit mode</EditLink> and convert to the <SACLink>cloud editor</SACLink> now"
    },
    removeMacroOrBreakPageContent: {
        id: "content-prerequisites.timeout-error-screen.remove-excerpt-macro-or-break-page-content",
        defaultMessage: "Remove one or more excerpt macros, or break this page content into several smaller pages"
    },
    contactAdmin: {
        id: "content-prerequisites.timeout-error-screen.contact-admin",
        defaultMessage: "If this keeps happening, ask your admin to contact <SupportLink>our Support team</SupportLink> and give them the URL of this page."
    }
});
const $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isBlogpost = contentType === 'blogpost';
    const routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $lS0xA.default), {
        variables: {
            contentId: contentId
        }
    });
    const linkParams = (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlogpost ? 'blog' : 'pages'
        }), [
        contentId,
        spaceKey,
        isBlogpost
    ]); // If the editor property is undefined or null, we assume it's TinyMCE even though the missing missing property is not strictly TinyMCE.
    // It's okay to assume this for the purposes of this error screen b/c editor property as null is most likely TinyMCE.
    const editorProperty = data?.singleContent?.properties?.nodes?.[0]?.value;
    const isTinyMCE = !editorProperty || editorProperty === '"v1"';
    (0, $42omo.useEffect)(()=>{
        if (isTinyMCE) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'errorScreen',
                attributes: {
                    customErrorUI: 'tinyMceTimeouts',
                    editorProperty: editorProperty
                }
            }
        })?.fire();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTinyMCE,
        createAnalyticsEvent
    ]);
    if (!isTinyMCE) return null;
    const editHref = routeType.toUrl(linkParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorStyles,
        direction: "column",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $dc6f00ca158cde35$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $dc6f00ca158cde35$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $dc6f00ca158cde35$var$i18n.resolutionOptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        className: (0, $gMc0m.default)([
            "_n3tdpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $dc6f00ca158cde35$var$i18n.reloadPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...$dc6f00ca158cde35$var$i18n.convertToCloudEditor,
        values: {
            SACLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor"
                }, chunks),
            EditLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: editHref
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $dc6f00ca158cde35$var$i18n.removeMacroOrBreakPageContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...$dc6f00ca158cde35$var$i18n.contactAdmin,
        values: {
            SupportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/contact/#/"
                }, chunks)
        }
    }))));
};
module.exports["TimeoutErrorScreen"] = $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e;

});

parcelRegister("lS0xA", function(module, exports) {
/**
 * @generated SignedSource<<058f54da8759daeae3cbdfbeed8c8d8a>>
 * @relayHash c72c86c38eafd81a46c0b3d86969a316
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a
const $82ca62ae3478d21d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c72c86c38eafd81a46c0b3d86969a316",
            "id": "9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a",
            "metadata": {},
            "name": "TimeoutErrorScreenQuery",
            "operationKind": "query",
            "text": "query TimeoutErrorScreenQuery($contentId:ID!){singleContent(id:$contentId){id,properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$82ca62ae3478d21d$var$node.hash = "607b11a2ee268d24f66b7b4f714aa8ae";
var $82ca62ae3478d21d$export$2e2bcd8739ae039 = $82ca62ae3478d21d$var$node;
module.exports["default"] = $82ca62ae3478d21d$export$2e2bcd8739ae039;

});

parcelRegister("2aFNh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $42omo.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("iuaOs", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");

const $53a589a30318add1$export$c86a38251c189bb6 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { contentId: contentId, fabricEditorSupported: fabricEditorSupported, bodyRepresentation: bodyRepresentation, reload: reload } = t0;
    const currentContentId = (0, $42omo.useRef)(null);
    const currentFabricEditorSupportedRef = (0, $42omo.useRef)(null);
    const currentBodyRepresentationRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== bodyRepresentation || $[1] !== contentId || $[2] !== fabricEditorSupported || $[3] !== reload) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_refetch_content_on_fabric_support_chng")) return;
            if (contentId !== currentContentId.current) {
                currentContentId.current = contentId;
                currentFabricEditorSupportedRef.current = fabricEditorSupported;
                currentBodyRepresentationRef.current = bodyRepresentation;
            } else {
                if (fabricEditorSupported === null || currentFabricEditorSupportedRef.current === null || bodyRepresentation === null || currentBodyRepresentationRef.current === null) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                } else if (fabricEditorSupported !== currentFabricEditorSupportedRef.current || bodyRepresentation !== currentBodyRepresentationRef.current) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                    reload();
                }
            }
        };
        t2 = [
            contentId,
            fabricEditorSupported,
            bodyRepresentation,
            reload
        ];
        $[0] = bodyRepresentation;
        $[1] = contentId;
        $[2] = fabricEditorSupported;
        $[3] = reload;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
};
module.exports["useContentReloadOnFabricSupportChange"] = $53a589a30318add1$export$c86a38251c189bb6;

});

parcelRegister("3Klda", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $42omo.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});

parcelRegister("6UMDm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dfgVG = parcelRequire("dfgVG");

var $jNUT6 = parcelRequire("jNUT6");

const $1493c1e4d7d497eb$export$f12106fa80cfd400 = /*#__PURE__*/ (0, $42omo.createContext)({
    editorProperty: '',
    fabricEditorSupported: false,
    isAutoConverted: false,
    queryDataId: ''
});
const $1493c1e4d7d497eb$export$78dcd8ae786efebe = ({ editorProperty: editorProperty, fabricEditorSupported: fabricEditorSupported, isAutoConverted: isAutoConvertedWithNewTinyPages, queryDataId: queryDataId, children: children })=>{
    const isAutoConverted = (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : !editorProperty && fabricEditorSupported;
    const isFabric = editorProperty === 'v2' || ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : isAutoConverted);
    const autoConversionContextValue = (0, $42omo.useMemo)(()=>({
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: isAutoConverted,
            queryDataId: queryDataId
        }), [
        editorProperty,
        fabricEditorSupported,
        isAutoConverted,
        queryDataId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1493c1e4d7d497eb$export$f12106fa80cfd400.Provider, {
        value: autoConversionContextValue
    }, children, !isFabric && queryDataId && (0, $dfgVG.checkRevertFlag)(queryDataId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "auto-editor-conversion-revert-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNUT6.RevertEditorSuccess), null)));
};
const $1493c1e4d7d497eb$export$847684e45bf010db = ()=>(0, $42omo.useContext)($1493c1e4d7d497eb$export$f12106fa80cfd400);
module.exports["AutoConversionByLineContextProvider"] = $1493c1e4d7d497eb$export$78dcd8ae786efebe;
module.exports["useAutoConversionByLineContext"] = $1493c1e4d7d497eb$export$847684e45bf010db;

});

parcelRegister("jNUT6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $7aRa9 = parcelRequire("7aRa9");


var $dfgVG = parcelRequire("dfgVG");

const $1d10088386de9373$var$i18n = (0, $h82at.defineMessages)({
    revertEditorFlagSuccessTitle: {
        id: "editor-conversion.revert-editor.flag.success.title",
        defaultMessage: "Page is reverted to legacy editor"
    },
    revertEditorFlagSuccessBody: {
        id: "editor-conversion.revert-editor.flag.success.body",
        defaultMessage: "Please note, cloud editor features such as better real-time collaboration, smart links, Live Docs, and AI-powered features are not available."
    }
});
const $1d10088386de9373$export$974b18a34ecfb5af = ({ flags: flags })=>{
    (0, $42omo.useEffect)(()=>{
        const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1d10088386de9373$var$i18n.revertEditorFlagSuccessBody);
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1d10088386de9373$var$i18n.revertEditorFlagSuccessTitle),
            description: description,
            isAutoDismiss: true
        });
        (0, $dfgVG.removeRevertFlag)();
    }, [
        flags
    ]);
    return null;
};
const $1d10088386de9373$export$b2e4e7debfeba26 = (0, $7aRa9.withFlags)($1d10088386de9373$export$974b18a34ecfb5af);
module.exports["RevertEditorSuccess"] = $1d10088386de9373$export$b2e4e7debfeba26;

});

parcelRegister("4mihy", function(module, exports) {

var $cJCba = parcelRequire("cJCba");

const $4aa61b5693986156$export$2799e7163d440679 = (createAnalyticsEvent, source, importSource, importDate, contentId, rating, dataFormat, feedback)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'submitted',
            actionSubject: 'survey',
            actionSubjectId: 'importFeedbackSurvey',
            source: source,
            attributes: {
                rating: rating,
                dataFormat: dataFormat,
                feedback: feedback,
                importType: importSource,
                importDate: importDate.toISOString(),
                contentType: (0, $cJCba.getIsWhiteboardSource)(importSource) ? 'whiteboard' : 'page',
                contentId: contentId
            }
        }
    }).fire();
};
module.exports["submitSurveyFeedback"] = $4aa61b5693986156$export$2799e7163d440679;

});

parcelRegister("cJCba", function(module, exports) {
var $ac1d1a087c23a95b$export$ddc693d0d8207b4d = /*#__PURE__*/ function(ImportSource) {
    ImportSource["NOTION"] = "Notion";
    ImportSource["MIRO"] = "Miro";
    ImportSource["MURAL"] = "Mural";
    return ImportSource;
}({});
const $ac1d1a087c23a95b$export$5571cbf5d27f8c0c = (importSource)=>{
    return [
        "Miro",
        "Mural"
    ].map((source)=>source.toLowerCase()).includes(importSource.toLowerCase());
};
const $ac1d1a087c23a95b$export$38afe04e637d5e32 = (importSource)=>{
    const normalizedInput = importSource.toLowerCase();
    for (const source of Object.values($ac1d1a087c23a95b$export$ddc693d0d8207b4d)){
        if (normalizedInput.includes(source.toLowerCase())) return source;
    }
    return undefined;
};
module.exports["ImportSource"] = $ac1d1a087c23a95b$export$ddc693d0d8207b4d;
module.exports["getIsWhiteboardSource"] = $ac1d1a087c23a95b$export$5571cbf5d27f8c0c;
module.exports["getImportSourceEnum"] = $ac1d1a087c23a95b$export$38afe04e637d5e32;

});

parcelRegister("jQob7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $inPa6 = parcelRequire("inPa6");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $6T8v4 = parcelRequire("6T8v4");


var $9EtP6 = parcelRequire("9EtP6");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $9wGTI = parcelRequire("9wGTI");


var $4mihy = parcelRequire("4mihy");


var $54nea = parcelRequire("54nea");


var $cJCba = parcelRequire("cJCba");


var $aUiHE = parcelRequire("aUiHE");

const $3069ee56b74f24de$export$5efdacda4e928df9 = ({ isOpen: isOpen, closeModal: closeModal, importSource: importSource, importDate: importDate, contentId: contentId, onFeedbackSubmit: onFeedbackSubmit })=>{
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const importSourceEnum = (0, $cJCba.getImportSourceEnum)(importSource);
    const NOTION_DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptions)();
    const DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptionsFromSource)(importSourceEnum);
    if (!importSourceEnum && (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback')) return null;
    const onSubmit = (data)=>{
        if (!data['data-format'] || data['data-format'].length === 0) return {
            'data-format': intl.formatMessage((0, $aUiHE.modalFormMessages).selectDataFormatError)
        };
        (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackSurveyModal', importSourceEnum ?? importSource, importDate, contentId, 'negative', // Modal only shown for negative feedback
        data['data-format'].map((option)=>option.value), data['tell-us-about-your-experience']);
        closeModal();
        onFeedbackSubmit();
        showFlag({
            isAutoDismiss: true,
            title: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedTitle),
            description: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: ""
            })
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: closeModal,
        width: "large",
        testId: "import-feedback-modal"
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit,
        id: "feedback-modal-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).requiredFieldsAsterisk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...(0, $aUiHE.modalFormMessages).feedbackText,
        values: {
            source: importSourceEnum
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "data-format",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).dataFormatLabel),
        isRequired: true,
        testId: "data-format-select-field"
    }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            options: (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback') ? DATA_FORMAT_OPTIONS : NOTION_DATA_FORMAT_OPTIONS,
            menuPosition: "fixed",
            isClearable: true,
            isMulti: true,
            clearControlLabel: intl.formatMessage((0, $aUiHE.modalFormMessages).dataFormatClearControlLabel),
            testId: "data-format-select-dropdown"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).dataFormatHelperText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).tellUsAboutYourExperience),
        name: "tell-us-about-your-experience",
        testId: "tell-us-about-your-experience-field",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...fieldProps,
            placeholder: intl.formatMessage((0, $aUiHE.modalFormMessages).tellUsAboutYourExperiencePlaceholder),
            testId: "tell-us-about-your-experience-textarea"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: closeModal,
        testId: "feedback-modal-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).closeButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        type: "submit",
        testId: "feedback-modal-submit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).feedbackButton)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ...formProps,
            id: "feedback-modal-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).requiredFieldsAsterisk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...(0, $aUiHE.modalFormMessages).feedbackText,
            values: {
                source: importSourceEnum
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "data-format",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).dataFormatLabel),
            isRequired: true,
            testId: "data-format-select-field"
        }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
                inputId: id,
                ...rest,
                options: (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback') ? DATA_FORMAT_OPTIONS : NOTION_DATA_FORMAT_OPTIONS,
                menuPosition: "fixed",
                isClearable: true,
                isMulti: true,
                clearControlLabel: intl.formatMessage((0, $aUiHE.modalFormMessages).dataFormatClearControlLabel),
                testId: "data-format-select-dropdown"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).dataFormatHelperText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).tellUsAboutYourExperience),
            name: "tell-us-about-your-experience",
            testId: "tell-us-about-your-experience-field",
            isRequired: true
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                ...fieldProps,
                placeholder: intl.formatMessage((0, $aUiHE.modalFormMessages).tellUsAboutYourExperiencePlaceholder),
                testId: "tell-us-about-your-experience-textarea"
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: closeModal,
            testId: "feedback-modal-close-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).closeButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            type: "submit",
            testId: "feedback-modal-submit-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $aUiHE.modalFormMessages).feedbackButton))))))));
};
module.exports["FeedbackModal"] = $3069ee56b74f24de$export$5efdacda4e928df9;

});

parcelRegister("54nea", function(module, exports) {

var $1cfRh = parcelRequire("1cfRh");


var $cJCba = parcelRequire("cJCba");


var $kyTyD = parcelRequire("kyTyD");


var $3M5DA = parcelRequire("3M5DA");


var $ffmqQ = parcelRequire("ffmqQ");

const $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).mentions,
        value: 'mentions'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).audioEmbeddedLink,
        value: 'audio_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).attachments,
        value: 'attachments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).blockEquation,
        value: 'block_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).breadcrumb,
        value: 'breadcrumb'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).bulletedLists,
        value: 'bulleted_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).button,
        value: 'button'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).callout,
        value: 'callout'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeBlock,
        value: 'code_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeMermaid,
        value: 'code_mermaid'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).twoColumns,
        value: 'two_columns'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).customizedText,
        value: 'customized_text'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).databaseChildPageProperties,
        value: 'database_child_properties'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dates,
        value: 'dates'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dividers,
        value: 'dividers'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).embed,
        value: 'embed'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).emojis,
        value: 'emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headerImages,
        value: 'header_images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headings,
        value: 'headings'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).images,
        value: 'images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).inlineEquation,
        value: 'inline_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).linkToPage,
        value: 'link_to_page'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).numberedLists,
        value: 'numbered_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageComments,
        value: 'page_comments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageEmojis,
        value: 'page_emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).quotes,
        value: 'quotes'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).reminder,
        value: 'reminder'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).staticTables,
        value: 'static_tables'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).syncedBlock,
        value: 'synced_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableCustomization,
        value: 'table_customization'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableData,
        value: 'table_data'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableOfContents,
        value: 'table_of_contents'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).todoList,
        value: 'todo_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleHeading,
        value: 'toggle_heading'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleList,
        value: 'toggle_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).videoEmbeddedLink,
        value: 'video_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).webBookmark,
        value: 'web_bookmark'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).talkTracks,
        value: 'talk_tracks'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).frames,
        value: 'frames'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).jiraCards,
        value: 'jira_cards'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$export$1e5c15dd4d474cfc = ()=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    return $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
const $b21152ef0867f201$export$769861949a982d7a = (importSource)=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let dataFormatOptions;
    switch(importSource){
        case (0, $cJCba.ImportSource).NOTION:
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MIRO:
            dataFormatOptions = $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MURAL:
            dataFormatOptions = $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS;
            break;
        default:
            // Should never happen
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
    }
    return dataFormatOptions.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
module.exports["useDataFormatOptions"] = $b21152ef0867f201$export$1e5c15dd4d474cfc;
module.exports["useDataFormatOptionsFromSource"] = $b21152ef0867f201$export$769861949a982d7a;

});

parcelRegister("kyTyD", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $b8d9cf0582cd5f3a$export$5487dbca878f120b = (0, $h82at.defineMessages)({
    mentions: {
        id: "import-feedback.data-format-options.notion.mentions",
        defaultMessage: "@mentions"
    },
    audioEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.audio-embedded-link",
        defaultMessage: "Audio (embedded link)"
    },
    attachments: {
        id: "import-feedback.data-format-options.notion.attachments",
        defaultMessage: "Attachments"
    },
    blockEquation: {
        id: "import-feedback.data-format-options.notion.block-equation",
        defaultMessage: "Block equation"
    },
    breadcrumb: {
        id: "import-feedback.data-format-options.notion.breadcrumb",
        defaultMessage: "Breadcrumb"
    },
    bulletedLists: {
        id: "import-feedback.data-format-options.notion.bulleted-lists",
        defaultMessage: "Bullet lists"
    },
    button: {
        id: "import-feedback.data-format-options.notion.button",
        defaultMessage: "Button"
    },
    callout: {
        id: "import-feedback.data-format-options.notion.callout",
        defaultMessage: "Callout"
    },
    codeBlock: {
        id: "import-feedback.data-format-options.notion.code-block",
        defaultMessage: "Code block"
    },
    codeMermaid: {
        id: "import-feedback.data-format-options.notion.code-mermaid",
        defaultMessage: "Code - Mermaid (diagram)"
    },
    twoColumns: {
        id: "import-feedback.data-format-options.notion.two-columns",
        defaultMessage: "2 columns"
    },
    customizedText: {
        id: "import-feedback.data-format-options.notion.customized-text",
        defaultMessage: "Customized text"
    },
    databaseChildPageProperties: {
        id: "import-feedback.data-format-options.notion.database-child-page-properties",
        defaultMessage: "Database child page properties"
    },
    dates: {
        id: "import-feedback.data-format-options.notion.dates",
        defaultMessage: "Dates"
    },
    dividers: {
        id: "import-feedback.data-format-options.notion.dividers",
        defaultMessage: "Dividers"
    },
    embed: {
        id: "import-feedback.data-format-options.notion.embed",
        defaultMessage: "Embed (e.g. Figma)"
    },
    emojis: {
        id: "import-feedback.data-format-options.notion.emojis",
        defaultMessage: "Emojis"
    },
    headerImages: {
        id: "import-feedback.data-format-options.notion.header-images",
        defaultMessage: "Header images"
    },
    headings: {
        id: "import-feedback.data-format-options.notion.headings",
        defaultMessage: "Headings"
    },
    images: {
        id: "import-feedback.data-format-options.notion.images",
        defaultMessage: "Images"
    },
    inlineEquation: {
        id: "import-feedback.data-format-options.notion.inline-equation",
        defaultMessage: "Inline equation"
    },
    linkToPage: {
        id: "import-feedback.data-format-options.notion.link-to-page",
        defaultMessage: "Link to page"
    },
    numberedLists: {
        id: "import-feedback.data-format-options.notion.numbered-lists",
        defaultMessage: "Numbered lists"
    },
    pageComments: {
        id: "import-feedback.data-format-options.notion.page-comments",
        defaultMessage: "Page comments"
    },
    pageEmojis: {
        id: "import-feedback.data-format-options.notion.page-emojis",
        defaultMessage: "Page emojis"
    },
    quotes: {
        id: "import-feedback.data-format-options.notion.quotes",
        defaultMessage: "Quotes"
    },
    reminder: {
        id: "import-feedback.data-format-options.notion.reminder",
        defaultMessage: "Reminder"
    },
    staticTables: {
        id: "import-feedback.data-format-options.notion.static-tables",
        defaultMessage: "Static tables"
    },
    syncedBlock: {
        id: "import-feedback.data-format-options.notion.synced-block",
        defaultMessage: "Synced block"
    },
    tableCustomization: {
        id: "import-feedback.data-format-options.notion.table-customization",
        defaultMessage: "Table customization"
    },
    tableData: {
        id: "import-feedback.data-format-options.notion.table-data",
        defaultMessage: "Table data"
    },
    tableOfContents: {
        id: "import-feedback.data-format-options.notion.table-of-contents",
        defaultMessage: "Table of contents"
    },
    todoList: {
        id: "import-feedback.data-format-options.notion.todo-list",
        defaultMessage: "To-Do list"
    },
    toggleHeading: {
        id: "import-feedback.data-format-options.notion.toggle-heading",
        defaultMessage: "Toggle heading"
    },
    toggleList: {
        id: "import-feedback.data-format-options.notion.toggle-list",
        defaultMessage: "Toggle list"
    },
    videoEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.video-embedded-link",
        defaultMessage: "Video (embedded link)"
    },
    webBookmark: {
        id: "import-feedback.data-format-options.notion.web-bookmark",
        defaultMessage: "Web bookmark"
    },
    other: {
        id: "import-feedback.data-format-options.notion.other",
        defaultMessage: "Other"
    }
});
module.exports["notionDataFormatOptionsMessages"] = $b8d9cf0582cd5f3a$export$5487dbca878f120b;

});

parcelRegister("3M5DA", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $78b530d7902d0707$export$c02ae8a2bd2ff74a = (0, $h82at.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.miro.comments",
        defaultMessage: "Comments"
    },
    colors: {
        id: "import-feedback.data-format-options.miro.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.miro.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.miro.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.miro.shapes",
        defaultMessage: "Shapes"
    },
    talkTracks: {
        id: "import-feedback.data-format-options.miro.talk-tracks",
        defaultMessage: "Talk Tracks"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.miro.locked-elements",
        defaultMessage: "Locked Elements"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.miro.sticky-notes",
        defaultMessage: "Sticky notes"
    },
    frames: {
        id: "import-feedback.data-format-options.miro.frames",
        defaultMessage: "Frames"
    },
    borders: {
        id: "import-feedback.data-format-options.miro.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.miro.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.miro.website-embeds",
        defaultMessage: "Website embeds"
    },
    jiraCards: {
        id: "import-feedback.data-format-options.miro.jira-cards",
        defaultMessage: "Jira cards"
    },
    tables: {
        id: "import-feedback.data-format-options.miro.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.miro.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.miro.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.miro.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.miro.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.miro.mind-maps",
        defaultMessage: "Mind maps"
    },
    other: {
        id: "import-feedback.data-format-options.miro.other",
        defaultMessage: "Other"
    }
});
module.exports["miroDataFormatOptionsMessages"] = $78b530d7902d0707$export$c02ae8a2bd2ff74a;

});

parcelRegister("ffmqQ", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $ff44c6ff801bbed9$export$47d9fbb91e8e28a3 = (0, $h82at.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.mural.comments",
        defaultMessage: "Comments"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.mural.sticky-notes",
        defaultMessage: "Sticky Notes"
    },
    borders: {
        id: "import-feedback.data-format-options.mural.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.mural.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.mural.website-embeds",
        defaultMessage: "Website Embeds"
    },
    tables: {
        id: "import-feedback.data-format-options.mural.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.mural.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.mural.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.mural.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.mural.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.mural.mind-maps",
        defaultMessage: "Mind Maps"
    },
    colors: {
        id: "import-feedback.data-format-options.mural.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.mural.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.mural.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.mural.shapes",
        defaultMessage: "Shapes"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.mural.locked-elements",
        defaultMessage: "Locked Elements"
    },
    other: {
        id: "import-feedback.data-format-options.mural.other",
        defaultMessage: "Other"
    }
});
module.exports["muralDataFormatOptionsMessages"] = $ff44c6ff801bbed9$export$47d9fbb91e8e28a3;

});

parcelRegister("aUiHE", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $a14bce3fd3c2a8ba$export$4055a71a6988efc8 = (0, $h82at.defineMessages)({
    modalTitle: {
        id: "import-feedback.feedback-modal.title",
        defaultMessage: "Give feedback on imported content"
    },
    dataFormatHelperText: {
        id: "import-feedback.feedback-modal.data-format-helper-text",
        defaultMessage: "Start typing to get a list of possible matches or press down to select."
    },
    requiredFieldsAsterisk: {
        id: "import-feedback.feedback-modal.required-fields-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    feedbackText: {
        id: "import-feedback.feedback-modal.feedback-text",
        defaultMessage: "This content was imported from {source\t}. Please let us know what issues you found below!"
    },
    dataFormatLabel: {
        id: "import-feedback.feedback-modal.data-format-label",
        defaultMessage: "Data formats with issues"
    },
    dataFormatClearControlLabel: {
        id: "import-feedback.feedback-modal.data-format-clear-control-label",
        defaultMessage: "Clear selected data format"
    },
    tellUsAboutYourExperience: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience",
        defaultMessage: "Tell us about your experience"
    },
    tellUsAboutYourExperiencePlaceholder: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience-placeholder",
        defaultMessage: "Please expand on what could be improved for this imported content."
    },
    feedbackButton: {
        id: "import-feedback.feedback-modal.feedback-button",
        defaultMessage: "Send Feedback"
    },
    closeButton: {
        id: "import-feedback.feedback-modal.close-button",
        defaultMessage: "Cancel"
    },
    selectDataFormatError: {
        id: "import-feedback.feedback-modal.select-data-format-error",
        defaultMessage: "Please select a data format"
    },
    submittedTitle: {
        id: "import-feedback.feedback-modal.submitted-title",
        defaultMessage: "Thanks!"
    },
    submittedDescription: {
        id: "import-feedback.feedback-modal.submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    }
});
module.exports["modalFormMessages"] = $a14bce3fd3c2a8ba$export$4055a71a6988efc8;

});

parcelRegister("aK6zf", function(module, exports) {
const $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY = 'import-source';
const $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY = 'imported-page-modified-date';
const $08986653719b52d0$export$e8d166ad05d55a7e = 90;
const $08986653719b52d0$export$660ec42e439d82e5 = 120000; // 2 minutes
function $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const importedFromProperty = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY);
    return importedFromProperty?.value || undefined;
}
function $08986653719b52d0$export$cccab9e45bf98465(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const originalImportDate = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY)?.value?.replace(/^"|"$/g, '');
    return originalImportDate ? new Date(originalImportDate) : undefined;
}
function $08986653719b52d0$export$f5748926afca39a(contentQueryData) {
    const importedFromProperty = $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData);
    const originalImportDate = $08986653719b52d0$export$cccab9e45bf98465(contentQueryData);
    const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ? new Date(contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate) : undefined;
    if (!originalImportDate || !lastModifiedDate) return false;
    return !!importedFromProperty && $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(originalImportDate) && !$08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, originalImportDate);
}
function $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(importDate) {
    return Date.now() <= importDate.getTime() + $08986653719b52d0$export$e8d166ad05d55a7e * 86400000;
}
function $08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, importDate) {
    return lastModifiedDate.getTime() > importDate.getTime() + $08986653719b52d0$export$660ec42e439d82e5;
}
module.exports["getImportSource"] = $08986653719b52d0$export$d7c17bfc5f552f72;
module.exports["getImportDate"] = $08986653719b52d0$export$cccab9e45bf98465;
module.exports["isImportBannerEnabled"] = $08986653719b52d0$export$f5748926afca39a;

});

parcelRegister("8tF9d", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c08f0377995c9fbd$export$8f5a21cf0975ea0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TAXXG",
    name: "LivePageComponentLoader",
    loader: async ()=>(await (parcelRequire("lbqfc"))).LivePageComponent
});
module.exports["LivePageComponentLoader"] = $c08f0377995c9fbd$export$8f5a21cf0975ea0d;

});

parcelRegister("lbqfc", function(module, exports) {

let $f6befb97e157542b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6befb97e157542b$var$load("e7wVW"),
    $f6befb97e157542b$var$load("1be0X"),
    $f6befb97e157542b$var$load("dVJPu"),
    $f6befb97e157542b$var$load("7wGLD"),
    $f6befb97e157542b$var$load("jplsw"),
    $f6befb97e157542b$var$load("exa5h"),
    $f6befb97e157542b$var$load("iP5i1"),
    $f6befb97e157542b$var$load("jXx9i"),
    $f6befb97e157542b$var$load("5dBst"),
    $f6befb97e157542b$var$load("jY21r"),
    $f6befb97e157542b$var$load("hogcU"),
    $f6befb97e157542b$var$load("2vAWg"),
    $f6befb97e157542b$var$load("7cABH"),
    $f6befb97e157542b$var$load("bYmo7"),
    $f6befb97e157542b$var$load("9jjvO"),
    $f6befb97e157542b$var$load("i8eeg"),
    $f6befb97e157542b$var$load("iFdoJ"),
    $f6befb97e157542b$var$load("77NEU"),
    $f6befb97e157542b$var$load("fJ83T"),
    $f6befb97e157542b$var$load("bIPPg"),
    $f6befb97e157542b$var$load("2uVTT"),
    $f6befb97e157542b$var$load("4izLy"),
    $f6befb97e157542b$var$load("5tmW9"),
    $f6befb97e157542b$var$load("cpQv0"),
    $f6befb97e157542b$var$load("9LW4b"),
    $f6befb97e157542b$var$load("hhss7"),
    $f6befb97e157542b$var$load("fz1VH")
]).then(()=>parcelRequire('egCae'));

});

parcelRegister("cMKmt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3TgYS = parcelRequire("3TgYS");


var $jYPbB = parcelRequire("jYPbB");

const $46239388d4485db7$export$9d6b189b48dfd2fa = ({ contentId: contentId })=>{
    $46239388d4485db7$var$useLocalActivityViewPageTracker(contentId);
    return null;
};
const $46239388d4485db7$var$useLocalActivityViewPageTracker = (contentId)=>{
    const { track: track } = (0, $jYPbB.useLocalActivityTracker)();
    (0, $42omo.useEffect)(()=>{
        track(contentId, (0, $3TgYS.LocalActivityAction).viewed);
    }, [
        track,
        contentId
    ]);
};
module.exports["LocalActivityViewPageTracker"] = $46239388d4485db7$export$9d6b189b48dfd2fa;

});

parcelRegister("kJNMt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $fURMF = parcelRequire("fURMF");

const $0e8eac2a5609c7f2$export$139fec31c31601bb = ({ isSmooth: isSmooth })=>{
    const { getHash: getHash, getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    // we're using refs here to avoid violating the rules
    // of hooks, but still prevent ourselves from
    // scrolling to page start multiple times in case if
    // `RoutesContext` changes unexpectedly -- if that happens,
    // we'll just take the latest context values into account
    // when executing scroll, and ignore everything we've seen
    // prior to that.
    const getHashRef = (0, $42omo.useRef)(getHash);
    const getQueryParamsRef = (0, $42omo.useRef)(getQueryParams);
    getHashRef.current = getHash;
    getQueryParamsRef.current = getQueryParams;
    (0, $42omo.useEffect)(()=>{
        const hash = getHashRef.current();
        const queryParams = getQueryParamsRef.current();
        const queryParamsThatTriggerScroll = [
            'focusedCommentId'
        ];
        const doesPageHaveExplicitScrollTarget = hash.length > 0 || queryParamsThatTriggerScroll.some((paramName)=>Boolean(queryParams[paramName]));
        if (!doesPageHaveExplicitScrollTarget) (0, $fURMF.scrollToPageStart)(isSmooth);
    }, [
        getHashRef,
        getQueryParamsRef,
        isSmooth
    ]);
    return null;
};
module.exports["ScrollToPageStart"] = $0e8eac2a5609c7f2$export$139fec31c31601bb;

});


//# sourceMappingURL=ViewPage.61482eec.js.map
